webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      permissionTypes: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["c" /* permissionTypes */],
      allPermissions: __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["d" /* allPermissions */]
    };
  },
  computed: {
    userPermissions: function userPermissions() {
      return this.$store.getters['user/getPermissionsObject'];
    },
    userId: function userId() {
      return this.$store.getters['user/getId'];
    }
  },
  methods: {
    $_allowedGlobalUpdate: function $_allowedGlobalUpdate() {
      return !!this.userPermissions[this.permissionTypes.UPDATE_GLOBALLY];
    },
    $_allowedGlobalDelete: function $_allowedGlobalDelete() {
      return !!this.userPermissions[this.permissionTypes.DELETE_GLOBALLY];
    },
    $_allowedGlobalOwnContentUpdate: function $_allowedGlobalOwnContentUpdate(item) {
      return !!this.userPermissions[this.permissionTypes.UPDATE_OWN_GLOBALLY] && this.userId === item.user_id;
    },
    $_allowedGlobalOwnContentDelete: function $_allowedGlobalOwnContentDelete(item) {
      return !!this.userPermissions[this.permissionTypes.DELETE_OWN_GLOBALLY] && this.userId === item.user_id;
    },
    $_allowDeleting: function $_allowDeleting(item) {
      return this.$_allowedGlobalDelete() || this.$_allowedGlobalOwnContentDelete(item) || this.$_allowDetecting(this.deletePermissionsIds, this.userPermissions, item);
    },
    $_allowCreating: function $_allowCreating() {
      return this.$_allowedGlobalCreate() || this.$_allowDetecting(this.createPermissionsIds, this.userPermissions);
    },
    $_allowUpdating: function $_allowUpdating(item) {
      return this.$_allowedGlobalUpdate() || this.$_allowedGlobalOwnContentUpdate(item) || this.$_allowDetecting(this.updatePermissionsIds, this.userPermissions, item);
    },
    $_allowDetecting: function $_allowDetecting(actionPermissions, userPermissions, item) {
      if (!actionPermissions || !actionPermissions.length) return true;
      if (!userPermissions) return false;
      var result = false;
      for (var i = 0; i < actionPermissions.length; i++) {
        var actionPermission = actionPermissions[i];
        var permission = userPermissions[actionPermission];
        if (permission && item && permission.name.includes('own')) {
          result = this.userId === item.user_id;
        } else if (permission) {
          result = true;
        }
        if (result) {
          return result;
        }
      }
      return result;
    }
  }
});

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(893),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(825),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(873),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(862),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__(101);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      refs: [],
      terms: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  computed: {
    $_featuredBlocksList: function $_featuredBlocksList() {
      return ['none'].concat(this.$store.state.homeSections);
    }
  },

  methods: {
    $_validate: function $_validate(fields) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */])(fields, this.$_showError);
    },
    $_addDefaultFormData: function $_addDefaultFormData() {
      var postFormData = new FormData();
      var references = { items: this.refs.map(function (item) {
          return { id: item.id, type: item.type };
        }) };
      postFormData.append('published', this.entity.published ? true : '');
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      if (this.entity.summary) postFormData.append('summary', this.entity.summary);
      if (references.items.length) postFormData.append('references', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(references));
      if (this.terms.length) postFormData.append('terms', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.terms.map(function (item) {
        return item.id;
      })));
      return postFormData;
    },
    $_successSave: function $_successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    $_errorSave: function $_errorSave(errorObj) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(errorObj, 'response.data')) {
        var data = errorObj.response.data;

        if (data.errors) {
          var msg = '';
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.errors).map(function (el) {
            return data.errors[el];
          }).forEach(function (el) {
            msg += el.join('\n');
            msg += '\n';
          });
          this.$_showError(msg);
        } else if (data.message) {
          this.$_showError(data.message);
        } else {
          this.$_showError('Error in data saving');
        }
      } else {
        this.$_showError('Error in data saving');
      }
    },
    $_showError: function $_showError(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    $_changeRefs: function $_changeRefs(newRefs) {
      this.refs = newRefs;
    },
    $_changeTerms: function $_changeTerms(newTerms) {
      this.terms = newTerms;
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_accessRights__ = __webpack_require__(100);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      entities: null,
      emptySearch: false,
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      choosenEntities: [],
      publishingPermissionsIds: [101],
      searchPermissionsIds: [230],
      thumbnailsPermissionsIds: [99],
      duplicatesPermissionsIds: [217]
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_accessRights__["a" /* getRightsByIndexName */])(this.$options.name));
  },


  computed: {
    allowPublishing: function allowPublishing() {
      return this.$_allowDetecting(this.publishingPermissionsIds, this.userPermissions);
    },
    allowSearchAdministration: function allowSearchAdministration() {
      return this.$_allowDetecting(this.searchPermissionsIds, this.userPermissions);
    },
    allowRegenerateThumbs: function allowRegenerateThumbs() {
      return this.$_allowDetecting(this.thumbnailsPermissionsIds, this.userPermissions);
    },
    allowManageDuplicates: function allowManageDuplicates() {
      return this.$_allowDetecting(this.duplicatesPermissionsIds, this.userPermissions);
    }
  },

  watch: {
    choosenEntities: {
      handler: function handler() {
        var entitiesOnPage = this.entities.length;
        if (this.choosenEntities.length === entitiesOnPage && !this.$refs.allEntities.checked) {
          this.$refs.allEntities.checked = true;
          return;
        }
        if (this.choosenEntities.length < entitiesOnPage && this.$refs.allEntities.checked) {
          this.$refs.allEntities.checked = false;
        }
      },

      deep: true
    },
    searchQuery: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSource();
    }, 400),
    offset: function offset() {
      this.getSource();
    },
    emptySearch: function emptySearch() {
      this.getSource();
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    $_selectAllEntities: function $_selectAllEntities(event) {
      if (event.target.checked) {
        this.choosenEntities = this.entities.map(function (item) {
          return item.id;
        });
      } else {
        this.choosenEntities = [];
      }
    },
    $_changePublishedBtns: function $_changePublishedBtns(val) {
      var _this = this;

      var _loop = function _loop(i) {
        var id = _this.choosenEntities[i];
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.entities, function (item) {
          return item.id === id;
        }).published = val;
      };

      for (var i = 0; i < this.choosenEntities.length; i += 1) {
        _loop(i);
      }
    },
    $_changePublished: function $_changePublished(published, name, id) {
      var _this2 = this;

      var namespace = this.$store.state.contentTypes.list[name].namespace;

      var $btnLoader = $(this.$refs['publishBtnLoader_' + id]);
      $btnLoader.show();
      if (published) {
        this.$_unpublish(namespace, id).then(function () {
          $btnLoader.hide();
          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this2.entities, function (item) {
            return item.id === id;
          }).published = false;
        }).catch(function (error) {
          $btnLoader.hide();
          console.error('Unpublish error: ', error);
        });
      } else {
        this.$_publish(namespace, id).then(function () {
          $btnLoader.hide();
          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this2.entities, function (item) {
            return item.id === id;
          }).published = true;
          _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
        }).catch(function (error) {
          $btnLoader.hide();
          _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in changing publish status' });
          console.error('Publish error: ', error);
        });
      }
    },
    $_publish: function $_publish(namespace, id) {
      var prefix = this.$config.app_api.prefix;

      return this.$apiHttp.post(prefix + 'content-types/publish?namespace=' + namespace + '&ids=' + id);
    },
    $_unpublish: function $_unpublish(namespace, id) {
      var prefix = this.$config.app_api.prefix;

      return this.$apiHttp.post(prefix + 'content-types/unpublish?namespace=' + namespace + '&ids=' + id);
    },
    $_sendPicks: function $_sendPicks(e, id, namespace) {
      var _this3 = this;

      var $btnLoader = $(this.$refs['pickBtnLoader_' + id]);
      $btnLoader.show();
      var boxValue = Number(e.target.attributes.value.nodeValue);
      this.$_saveRequest(boxValue, e.target.checked, namespace).then(function () {
        $btnLoader.hide();
      }, function (error) {
        $btnLoader.hide();
        console.error('Error in creating request', error);
        _this3.$_errorSave(error);
      });
    },
    $_saveRequest: function $_saveRequest(boxValue, isChecked, namespace) {
      var postFormData = new FormData();
      postFormData.append('alias', namespace);
      postFormData.append('id', boxValue);
      if (isChecked) {
        return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/include', postFormData);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/exclude', postFormData);
    },
    $_regThumb: function $_regThumb(entity, contentTypeName, entityName) {
      var _this4 = this;

      var entityTitle = entity.title ? entity.title : entity.name;
      var $btnRegThumbLoader = $(this.$refs['_regThumbBtnLoader_' + entity.id]);
      $btnRegThumbLoader.show();

      this.$apiHttp.post(this.$config.app_api.prefix + 'content-types/' + contentTypeName + '/regenerate-thumbs/' + entity.id).then(function () {
        console.log('Thumb for ' + entityName + ' ' + entityTitle + ' with ID = ' + entity.id + ' was regenerated');
        $btnRegThumbLoader.hide();
        _this4.$store.commit('notifications/setSuccessNotification', 'Thumb regenerated');
      }).catch(function (error) {
        $btnRegThumbLoader.hide();
        _this4.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in reg. thumb "' + entityTitle + '" ' + entityName });
        console.error('Error in ' + entityName + ' reg. thumb request', error);
      });
    },
    $_deleteEntity: function $_deleteEntity(entity, endpoint, entityName) {
      var _this5 = this;

      var entityTitle = entity.title ? entity.title : entity.name;
      if (window.confirm('Do you really want to delete ' + entityName + ' ' + entityTitle + ' with id = ' + entity.id + '?')) {
        var $btnDeleteLoader = $(this.$refs['deleteBtnLoader_' + entity.id]);
        $btnDeleteLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + endpoint + entity.id).then(function () {
          console.log(entityName + ' ' + entityTitle + ' with ID = ' + entity.id + ' has deleted');
          $btnDeleteLoader.hide();
          _this5.getSource();
          _this5.$store.commit('notifications/setSuccessNotification', 'Deleted');
        }).catch(function (error) {
          $btnDeleteLoader.hide();
          _this5.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting "' + entityTitle + '" ' + entityName });
          console.error('Error in ' + entityName + ' delete request', error);
        });
      }
    },
    $_addToIndexAll: function $_addToIndexAll(entityName) {
      var _this6 = this;

      var $btnLoader = $('.add-to-index-all .btn-loader');
      $btnLoader.show();
      this.$apiHttp.post(this.$config.app_api.prefix + 'search/documents/' + entityName).then(function () {
        _this6.$store.commit('notifications/setSuccessNotification', 'Indeces updated');
        $btnLoader.hide();
      }).catch(function (error) {
        $btnLoader.hide();
        _this6.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in updating index request' });
        console.error('Error in indexing ' + entityName + ' request', error);
      });
    },
    $_addToIndexSingle: function $_addToIndexSingle(entityName, entityId) {
      var _this7 = this;

      var $btnLoader = $('table.entities tr[data-id="' + entityId + '"] .add-to-index-single .btn-loader');
      $btnLoader.show();
      this.$apiHttp.post(this.$config.app_api.prefix + 'search/documents/' + entityName + '/' + entityId).then(function () {
        _this7.$store.commit('notifications/setSuccessNotification', 'Index updated');
        $btnLoader.hide();
      }).catch(function (error) {
        $btnLoader.hide();
        _this7.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in updating index request' });
        console.error('Error in indexing ' + entityName + ' request', error);
      });
    },
    $_regenerateThumbs: function $_regenerateThumbs(entityName, entityTitle) {
      var _this8 = this;

      if (window.confirm('Are you sure you want to start regeneration thumbnail process for ' + entityTitle + '?')) {
        var $btnLoader = $('.regenerate-thumbs .btn-loader');
        $btnLoader.show();
        this.$apiHttp.post(this.$config.app_api.prefix + 'content-types/' + entityName + '/regenerate-thumbs').then(function () {
          _this8.$store.commit('notifications/setSuccessNotification', 'Thumbnails regenerating has started. ');
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          _this8.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in regenerating thumbnails request' });
          console.error('Error in indexing ' + entityName + ' request', error);
        });
      }
    },
    $_changePage: function $_changePage(offset) {
      this.offset = offset;
    },
    $_errorCallback: function $_errorCallback(error) {
      if (this.$refs.spinner) this.$refs.spinner.hide();
      this.entities = [];
      this.total = 0;
      this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting list request' });
      console.error(error);
    },
    $_allowedGlobalCreate: function $_allowedGlobalCreate() {
      var _this9 = this;

      return !!this.userPermissions.find(function (permission) {
        return permission.id === _this9.permissionTypes.CREATE_GLOBALLY;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_validation__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_accessRights__ = __webpack_require__(100);






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      source: null,
      entity: {},
      saveErrorMessage: ''
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_accessRights__["b" /* getRightsByEditName */])(this.$options.name));
  },


  computed: {
    $_coverUrl: function $_coverUrl() {
      if (!this.source) {
        return null;
      }
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    $_coverIsChanged: function $_coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
    $_featuredBlocksList: function $_featuredBlocksList() {
      return ['none'].concat(this.$store.state.homeSections);
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    $_validate: function $_validate(fields) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_validation__["a" /* default */])(fields, this.$_showError);
    },
    $_apadtSource: function $_apadtSource(source) {
      var updatedSource = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, source);
      if (!Object.prototype.hasOwnProperty.call(updatedSource, 'path_alias')) {
        updatedSource.path_alias = {
          path_alias: ''
        };
      }
      if (!Object.prototype.hasOwnProperty.call(updatedSource, 'featured')) {
        updatedSource.featured = {
          section_id: 0,
          featured_body: ''
        };
      }
      return updatedSource;
    },
    $_addDefaultFormData: function $_addDefaultFormData() {
      var postFormData = new FormData();
      var references = {
        items: []
      };
      if (this.entity.loadedReferences && this.entity.loadedReferences.length) {
        references.items = this.entity.loadedReferences.map(function (item) {
          return { id: item.id, type: item.type };
        });
      }
      postFormData.append('published', this.entity.published ? true : '');
      postFormData.append('path_alias', this.entity.path_alias.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      if (Object.prototype.hasOwnProperty.call(this.entity, 'summary')) {
        postFormData.append('summary', this.entity.summary);
      }
      postFormData.append('references', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(references));
      if (this.entity.terms) postFormData.append('terms', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.terms.map(function (item) {
        return item.id;
      })));
      return postFormData;
    },
    $_successSave: function $_successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    $_errorSave: function $_errorSave(errorObj) {
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(errorObj, 'response.data.errors.path_alias') && errorObj.response.data.errors.path_alias.length) {
        this.$_showError(errorObj.response.data.errors.path_alias[0]);
      } else {
        this.$_showError('Error in data saving');
      }
    },
    $_showError: function $_showError(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    $_changeRefs: function $_changeRefs(newRefs) {
      this.entity.loadedReferences = newRefs;
    },
    $_changeTerms: function $_changeTerms(newTerms) {
      this.entity.terms = newTerms;
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    },
    $_coverRestore: function $_coverRestore() {
      this.entity.cover = this.source.cover;
    },
    $_coverRemove: function $_coverRemove() {
      this.entity.cover = null;
    },
    $_deleteEntity: function $_deleteEntity(endpoint) {
      var _this = this;

      if (window.confirm('Do you really want to delete this entity?')) {
        $(this.$refs.deleteBtnLoader).show();
        this.$apiHttp.delete(this.$config.app_api.prefix + endpoint).then(function () {
          var newHash = window.location.hash.split('/');
          newHash.pop();
          newHash.pop();
          window.location.hash = newHash.join('/');
          _this.$parent.getSource();
        }).catch(function (error) {
          $(_this.$refs.deleteBtnLoader).hide();
          _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting entity' });
          console.error(error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_config__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_config__);



var config = {
  app_api: {
    host: "https://alpha.ellenwhite.org",
    prefix: 'api/v1/',
    endpoints: {
      file_upload: 'file-upload'
    }
  },
  egw_dev: undefined,
  recaptchaStorageKey: "6LfJUB8rAAAAADd8g5xvhZSjbtwU7K8x34bHcxYl",
  tokenStorage: {
    name: 'tokenStorage'
  },
  userStorage: {
    name: 'userStorage'
  },
  mainMenu: 'egw_main'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_config___default.a, config);

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      defaultOptions: {
        audio: [],
        audioAlbums: [],
        audioCollections: [],
        df: [],
        docs: [],
        galleries: [],
        locations: [],
        people: [],
        qa: [],
        series: [],
        permissions: []
      },
      defaultOptionsLoaders: {
        permissions: false
      }
    };
  },

  methods: {
    $_getDefaultAudio: function $_getDefaultAudio() {
      var _this = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'content-types/media_audio', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this.defaultOptions.audio = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultAlbums: function $_getDefaultAlbums() {
      var _this2 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this2.defaultOptions.audioAlbums = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultCollections: function $_getDefaultCollections() {
      var _this3 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums/collections', { useCache: true }).then(function (response) {
        _this3.defaultOptions.audioCollections = response.data;
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultDocuments: function $_getDefaultDocuments() {
      var _this4 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'content-types/media_doc', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this4.defaultOptions.docs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultDF: function $_getDefaultDF() {
      var _this5 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/document-files', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this5.defaultOptions.df = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultGalleries: function $_getDefaultGalleries() {
      var _this6 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/image-galleries', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this6.defaultOptions.galleries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultLocations: function $_getDefaultLocations() {
      var _this7 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'locations', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this7.defaultOptions.locations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultPeople: function $_getDefaultPeople() {
      var _this8 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'people', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this8.defaultOptions.people = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultQa: function $_getDefaultQa() {
      var _this9 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'questions-and-answers', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this9.defaultOptions.qa = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultSeries: function $_getDefaultSeries() {
      var _this10 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this10.defaultOptions.series = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },
    $_getDefaultPermissions: function $_getDefaultPermissions() {
      var _this11 = this;

      this.defaultOptionsLoaders.permissions = true;
      this.$apiHttp.get(this.$config.app_api.prefix + 'permissions', { useCache: true }).then(function (response) {
        _this11.defaultOptions.permissions = response.data;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this11.defaultOptionsLoaders.permissions = false;
      });
    }
  }
});

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(887),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPLOADING_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return permissionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploadStatus; });
var CREATE_GLOBALLY = 89;
var UPDATE_GLOBALLY = 91;
var DELETE_GLOBALLY = 93;
var UPDATE_OWN_GLOBALLY = 92;
var DELETE_OWN_GLOBALLY = 94;

var ADMINISTER_BRANCH_OFFICES = 118;

var LOADING = 'loading';
var ERROR = 'error';
var SUCCESS = 'success';
var PAUSE = 'pause';
var ABORTED = 'aborted';

var UPLOADING_FILES = 'EGWWRITINGS_UPLOAD_MANAGER_UPLOADING_FILES';

var permissionTypes = {
  CREATE_GLOBALLY: CREATE_GLOBALLY,
  UPDATE_GLOBALLY: UPDATE_GLOBALLY,
  DELETE_GLOBALLY: DELETE_GLOBALLY,
  UPDATE_OWN_GLOBALLY: UPDATE_OWN_GLOBALLY,
  DELETE_OWN_GLOBALLY: DELETE_OWN_GLOBALLY
};

var allPermissions = {
  ADMINISTER_BRANCH_OFFICES: ADMINISTER_BRANCH_OFFICES
};

var uploadStatus = {
  LOADING: LOADING,
  ERROR: ERROR,
  SUCCESS: SUCCESS,
  PAUSE: PAUSE,
  ABORTED: ABORTED
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  permissionTypes: permissionTypes,
  uploadStatus: uploadStatus,
  UPLOADING_FILES: UPLOADING_FILES
});

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(845),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(584)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(857),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(898),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(961),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URL; });
/* unused harmony export TYPE_OF_SOURCE */
var FILE = 'FILE';
var URL = 'URL';

var TYPE_OF_SOURCE = {
  FILE: FILE,
  URL: URL
};

/* unused harmony default export */ var _unused_webpack_default_export = (TYPE_OF_SOURCE);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contentTypes; });
/* unused harmony export games */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return menu; });
var contentTypes = {
  name: 'Content types',
  url: '/admin/content',
  icon: 'fa fa-file',
  permissions: [89, 90, 91, 92, 93, 94],
  children: [{
    name: 'Articles',
    url: '/admin/content/article',
    icon: 'fa fa-newspaper-o',
    permissions: [104, 105, 106, 107, 108, 109]
  }, {
    name: 'Audio',
    url: '/admin/content/media_audio',
    icon: 'fa fa-music',
    permissions: [181, 182, 183, 184, 185, 186]
  }, {
    name: 'Audio Albums',
    url: '/admin/content/media_audio_album',
    icon: 'fa fa-music',
    permissions: [175, 176, 177, 178, 179, 180]
  }, {
    name: 'Correspondence',
    url: '/admin/content/correspondence',
    icon: 'fa fa-file-text',
    permissions: [120, 121, 122, 123, 124, 125]
  }, {
    name: 'Documents',
    url: '/admin/content/media_doc',
    icon: 'fa fa-file-text',
    permissions: [187, 188, 189, 190, 191, 192]
  }, {
    name: 'Document Files',
    url: '/admin/content/document_files',
    icon: 'fa fa-file-text',
    permissions: [193, 194, 195, 196, 197, 198]
  }, {
    name: 'Events',
    url: '/admin/content/event',
    icon: 'fa fa-newspaper-o',
    permissions: [126, 127, 128, 129, 130, 131]
  }, {
    name: 'FAQ',
    url: '/admin/content/faq',
    icon: 'fa fa-question',
    permissions: [132, 133, 134, 135, 136, 137]
  }, {
    name: 'Issues and Answers',
    url: '/admin/content/issues_and_answers',
    icon: 'fa fa-question',
    permissions: [248, 249, 250, 251, 252, 253]
  }, {
    name: 'Images',
    url: '/admin/content/media_image',
    icon: 'fa fa-picture-o',
    permissions: [157, 158, 159, 160, 161, 162]
  }, {
    name: 'Image Galleries',
    url: '/admin/content/media_image_gallery',
    icon: 'fa fa-picture-o',
    permissions: [151, 152, 153, 154, 155, 156]
  }, {
    name: 'Lessons',
    url: '/admin/content/lesson',
    icon: 'fa fa-newspaper-o',
    permissions: [139, 140, 141, 142, 143, 144]
  }, {
    name: 'Letterbooks',
    url: '/admin/content/book',
    icon: 'fa fa-book',
    permissions: [110, 111, 112, 113, 114, 115]
  }, {
    name: 'Locations',
    url: '/admin/content/location',
    icon: 'fa fa-map-marker',
    permissions: [145, 146, 147, 148, 149, 150]
  }, {
    name: 'News',
    url: '/admin/content/news',
    icon: 'fa fa-newspaper-o',
    permissions: [199, 200, 201, 202, 203, 204]
  }, {
    name: 'Pamphlets',
    url: '/admin/content/pamphlet',
    icon: 'fa fa-file-text',
    permissions: [205, 206, 207, 208, 209, 210]
  }, {
    name: 'People',
    url: '/admin/content/person',
    icon: 'fa fa-users',
    permissions: [211, 212, 213, 214, 215, 216, 217]
  }, {
    name: 'Publications',
    url: '/admin/content/publication',
    icon: 'fa fa-book',
    permissions: [218, 219, 220, 221, 222, 223]
  }, {
    name: 'Topics',
    url: '/admin/content/topic',
    icon: 'fa fa-newspaper-o',
    permissions: [242, 243, 244, 245, 246, 247]
  }, {
    name: 'Q&A',
    url: '/admin/content/questions_and_answers',
    icon: 'fa fa-question',
    permissions: [224, 225, 226, 227, 228, 229]
  }, {
    name: 'Video',
    url: '/admin/content/media_video',
    icon: 'fa fa-video-camera',
    permissions: [169, 170, 171, 172, 173, 174]
  }, {
    name: 'Video Series',
    url: '/admin/content/media_video_series',
    icon: 'fa fa-video-camera',
    permissions: [163, 164, 165, 166, 167, 168]
  }]
};

var games = {
  name: 'Games',
  icon: 'fa fa-file',
  permissions: [254],
  children: [{
    name: 'Puzzle Game',
    url: '/admin/puzzle-game-images',
    icon: 'fa fa-gamepad'
  }, {
    name: 'Memory Game',
    url: '/admin/memory-game-images',
    icon: 'fa fa-gamepad'
  }, {
    name: 'Painting Game',
    url: '/admin/painting-game-images',
    icon: 'fa fa-gamepad'
  }, {
    name: 'Quiz Game',
    url: '/admin/quiz-game-images',
    icon: 'fa fa-gamepad'
  }]
};

var menu = [{
  name: 'Dashboard',
  url: '/admin/dashboard',
  icon: 'icon-speedometer'
}, {
  name: 'Account Settings',
  url: '/admin/account-settings',
  icon: 'fa fa-search'
}, {
  name: 'Dashboard Search',
  url: '/admin/main-search',
  icon: 'fa fa-search',
  permissions: [230]
}, contentTypes, games, {
  name: 'Branch Offices',
  url: '/admin/branch-offices',
  icon: 'fa fa-map-marker',
  permissions: [118, 256]
}, {
  name: 'Featured Content',
  url: '/admin/featured-content',
  icon: 'fa fa-star',
  permissions: [100]
}, {
  name: 'Editors Picks',
  url: '/admin/editors-picks',
  icon: 'fa fa-file',
  permissions: [255]
}, {
  name: 'Users',
  url: '/admin/users',
  icon: 'fa fa-users',
  permissions: [95]
}, {
  name: 'Directors',
  url: '/admin/directors',
  icon: 'fa fa-users',
  permissions: [117]
}, {
  name: 'Staff',
  url: '/admin/staff',
  icon: 'fa fa-users',
  permissions: [116]
}, {
  name: 'Site Pages',
  url: '/admin/site-pages',
  icon: 'fa fa-file',
  permissions: [119]
}, {
  name: 'Roles',
  url: '/admin/roles',
  icon: 'fa fa-users',
  permissions: [96]
}, {
  name: 'Menus',
  url: '/admin/menu',
  icon: 'fa fa-bars',
  permissions: [102]
}, {
  name: 'Public Files',
  url: '/admin/public',
  icon: 'fa fa-file',
  permissions: [103]
}, {
  name: 'Taxonomy',
  url: '/admin/taxonomy/vocabulary',
  icon: 'fa fa-file',
  permissions: [231],
  children: [{
    name: 'Vocabulary',
    url: '/admin/taxonomy/vocabulary',
    icon: 'fa fa-book',
    permissions: [232, 233, 234, 235, 236]
  }, {
    name: 'Terms',
    url: '/admin/taxonomy/terms',
    icon: 'fa fa-book',
    permissions: [237, 238, 239, 240, 241]
  }]
}, {
  name: 'Redirects',
  url: '/admin/redirects',
  icon: 'fa fa-exchange',
  permissions: [98]
}, {
  name: 'Search settings',
  url: '/admin/search',
  icon: 'fa fa-search',
  permissions: [230]
}, {
  name: 'Media',
  url: '/admin/media',
  icon: 'fa fa-caret-square-o-right',
  permissions: [99]
}, {
  name: 'Flowpaper',
  url: '/admin/flowpaper',
  icon: 'fa fa-caret-square-o-right',
  permissions: [138]
}, {
  name: 'Robots settings',
  url: '/admin/robots',
  icon: 'fa fa-android',
  permissions: [97]
}];

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_errors__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_contentTypes__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_notifications__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_corrTypes__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_roles__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_uploadManager__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_memoryGame__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_quizGame__ = __webpack_require__(515);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    errors: __WEBPACK_IMPORTED_MODULE_3__modules_errors__["a" /* default */],
    contentTypes: __WEBPACK_IMPORTED_MODULE_4__modules_contentTypes__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_5__modules_notifications__["a" /* default */],
    corrTypes: __WEBPACK_IMPORTED_MODULE_6__modules_corrTypes__["a" /* default */],
    roles: __WEBPACK_IMPORTED_MODULE_7__modules_roles__["a" /* default */],
    uploadManager: __WEBPACK_IMPORTED_MODULE_8__modules_uploadManager__["a" /* default */],
    memoryGame: __WEBPACK_IMPORTED_MODULE_9__modules_memoryGame__["a" /* default */],
    quizGame: __WEBPACK_IMPORTED_MODULE_10__modules_quizGame__["a" /* default */]
  },

  state: {
    homeSections: ['Ellen White', 'Writings', 'Apps', 'Resources', 'FAQ', 'About', 'Visit']
  },

  mutations: {}
}));

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * @desc jQuery plugin to sort html list also the tree structures
 * @author Vladimír Čamaj
 * @license MIT
 */

(function ($) {
	$.fn.sortableLists = function (options) {
		var jQBody = $('body').css('position', 'relative'),
		    defaults = {
			currElClass: '',
			placeholderClass: '',
			placeholderCss: {
				'position': 'relative',
				'padding': 0
			},
			hintClass: '',
			hintCss: {
				'display': 'none',
				'position': 'relative',
				'padding': 0
			},
			hintWrapperClass: '',
			hintWrapperCss: {},
			baseClass: '',
			baseCss: {
				'position': 'absolute',
				'top': 0 - parseInt(jQBody.css('margin-top')),
				'left': 0 - parseInt(jQBody.css('margin-left')),
				'margin': 0,
				'padding': 0,
				'z-index': 2500
			},
			opener: {
				active: false,
				open: '',
				close: '',
				openerCss: {
					'float': 'left',
					'display': 'inline-block',
					'background-position': 'center center',
					'background-repeat': 'no-repeat'
				},
				openerClass: ''
			},
			listSelector: 'ul',
			listsClass: '',
			listsCss: {},
			insertZone: 50,
			insertZonePlus: false,
			scroll: 20,
			ignoreClass: '',
			isAllowed: function isAllowed(cEl, hint, target) {
				return true;
			},
			onDragStart: function onDragStart(e, cEl) {
				return true;
			},
			onChange: function onChange(cEl) {
				return true;
			},
			complete: function complete(cEl) {
				return true;
			} },
		    setting = $.extend(true, {}, defaults, options),
		    base = $('<' + setting.listSelector + ' />').prependTo(jQBody).attr('id', 'sortableListsBase').css(setting.baseCss).addClass(setting.listsClass + ' ' + setting.baseClass),
		    placeholder = $('<li />').attr('id', 'sortableListsPlaceholder').css(setting.placeholderCss).addClass(setting.placeholderClass),
		    hint = $('<li />').attr('id', 'sortableListsHint').css(setting.hintCss).addClass(setting.hintClass),
		    hintWrapper = $('<' + setting.listSelector + ' />').attr('id', 'sortableListsHintWrapper').addClass(setting.listsClass + ' ' + setting.hintWrapperClass).css(setting.listsCss).css(setting.hintWrapperCss),
		    opener = $('<span />').addClass('sortableListsOpener ' + setting.opener.openerClass).css(setting.opener.openerCss).on('mousedown', function (e) {
			var li = $(this).closest('li');

			if (li.hasClass('sortableListsClosed')) {
				open(li);
			} else {
				close(li);
			}

			return false;
		});

		if (setting.opener.as == 'class') {
			opener.addClass(setting.opener.close);
		} else if (setting.opener.as == 'html') {
			opener.html(setting.opener.close);
		} else {
			opener.css('background-image', 'url(' + setting.opener.close + ')');
			console.error('jQuerySortableLists opener as background image is deprecated. In version 2.0.0 it will be removed. Use html instead please.');
		}

		var state = {
			isDragged: false,
			isRelEFP: null,
			oEl: null,
			rootEl: null,
			cEl: null,
			upScroll: false,
			downScroll: false,
			pX: 0,
			pY: 0,
			cX: 0,
			cY: 0,
			isAllowed: true,
			e: { pageX: 0, pageY: 0, clientX: 0, clientY: 0 },
			doc: $(document),
			win: $(window)
		};

		if (setting.opener.active) {
			if (!setting.opener.open) throw 'Opener.open value is not defined. It should be valid url, html or css class.';
			if (!setting.opener.close) throw 'Opener.close value is not defined. It should be valid url, html or css class.';

			$(this).find('li').each(function () {
				var li = $(this);

				if (li.children(setting.listSelector).length) {
					opener.clone(true).prependTo(li.children('div').first());

					if (!li.hasClass('sortableListsOpen')) {
						close(li);
					} else {
						open(li);
					}
				}
			});
		}

		return this.on('mousedown', function (e) {
			var target = $(e.target);

			if (state.isDragged !== false || setting.ignoreClass && target.hasClass(setting.ignoreClass)) return;
			e.preventDefault();

			var el = target.closest('li'),
			    rEl = $(this);

			if (el[0]) {
				setting.onDragStart(e, el);
				startDrag(e, el, rEl);
			}
		});

		function startDrag(e, el, rEl) {
			state.isDragged = true;

			var elMT = parseInt(el.css('margin-top')),
			    elMB = parseInt(el.css('margin-bottom')),
			    elML = parseInt(el.css('margin-left')),
			    elMR = parseInt(el.css('margin-right')),
			    elXY = el.offset(),
			    elIH = el.innerHeight();

			state.rootEl = {
				el: rEl,
				offset: rEl.offset(),
				rootElClass: rEl.attr('class')
			};

			state.cEl = {
				el: el,
				mT: elMT, mL: elML, mB: elMB, mR: elMR,
				offset: elXY
			};

			state.cEl.xyOffsetDiff = { X: e.pageX - state.cEl.offset.left, Y: e.pageY - state.cEl.offset.top };
			state.cEl.el.addClass('sortableListsCurrent' + ' ' + setting.currElClass);

			el.before(placeholder);

			var placeholderNode = state.placeholderNode = $('#sortableListsPlaceholder');

			el.css({
				'width': el.width(),
				'position': 'absolute',
				'top': elXY.top - elMT,
				'left': elXY.left - elML
			}).prependTo(base);

			placeholderNode.css({
				'display': 'block',
				'height': elIH
			});

			hint.css('height', elIH);

			state.doc.on('mousemove', dragging).on('mouseup', endDrag);
		}

		function dragging(e) {
			if (state.isDragged) {
				var cEl = state.cEl,
				    doc = state.doc,
				    win = state.win;

				if (!e.pageX) {
					setEventPos(e);
				}

				if (doc.scrollTop() > state.rootEl.offset.top - 10 && e.clientY < 50) {
					if (!state.upScroll) {
							setScrollUp(e);
						} else {
						e.pageY = e.pageY - setting.scroll;
						$('html, body').each(function (i) {
							$(this).scrollTop($(this).scrollTop() - setting.scroll);
						});
						setCursorPos(e);
					}
				} else if (doc.scrollTop() + win.height() < state.rootEl.offset.top + state.rootEl.el.outerHeight(false) + 10 && win.height() - e.clientY < 50) {
						if (!state.downScroll) {
							setScrollDown(e);
						} else {
							e.pageY = e.pageY + setting.scroll;
							$('html, body').each(function (i) {
								$(this).scrollTop($(this).scrollTop() + setting.scroll);
							});
							setCursorPos(e);
						}
					} else {
						scrollStop(state);
					}

				state.oElOld = state.oEl;

				cEl.el[0].style.visibility = 'hidden';
				state.oEl = oEl = elFromPoint(e.pageX, e.pageY);
				cEl.el[0].style.visibility = 'visible';

				showHint(e, state);

				setCElPos(e, state);
			}
		}

		function endDrag(e) {
			var cEl = state.cEl,
			    hintNode = $('#sortableListsHint', state.rootEl.el),
			    hintStyle = hint[0].style,
			    targetEl = null,
			    isHintTarget = false,
			    hintWrapperNode = $('#sortableListsHintWrapper');

			if (hintStyle.display == 'block' && hintNode.length && state.isAllowed) {
				targetEl = hintNode;
				isHintTarget = true;
			} else {
				targetEl = state.placeholderNode;
				isHintTarget = false;
			}

			offset = targetEl.offset();

			cEl.el.animate({ left: offset.left - state.cEl.mL, top: offset.top - state.cEl.mT }, 250, function () {
				tidyCurrEl(cEl);

				targetEl.after(cEl.el[0]);
				targetEl[0].style.display = 'none';
				hintStyle.display = 'none';

				hintNode.remove();

				hintWrapperNode.removeAttr('id').removeClass(setting.hintWrapperClass);

				if (hintWrapperNode.length) {
					hintWrapperNode.prev('div').append(opener.clone(true));
				}

				if (isHintTarget) {
					state.placeholderNode.slideUp(150, function () {
						state.placeholderNode.remove();
						tidyEmptyLists();
						setting.onChange(cEl.el);
						setting.complete(cEl.el);
						state.isDragged = false;
					});
				} else {
					state.placeholderNode.remove();
					tidyEmptyLists();
					setting.complete(cEl.el);
					state.isDragged = false;
				}
			});

			scrollStop(state);

			state.doc.unbind("mousemove", dragging).unbind("mouseup", endDrag);
		}

		function setScrollUp(e) {
			if (state.upScroll) return;

			state.upScroll = setInterval(function () {
				state.doc.trigger('mousemove');
			}, 50);
		}

		function setScrollDown(e) {
			if (state.downScroll) return;

			state.downScroll = setInterval(function () {
				state.doc.trigger('mousemove');
			}, 50);
		}

		function setCursorPos(e) {
			state.pY = e.pageY;
			state.pX = e.pageX;
			state.cY = e.clientY;
			state.cX = e.clientX;
		}

		function setEventPos(e) {
			e.pageY = state.pY;
			e.pageX = state.pX;
			e.clientY = state.cY;
			e.clientX = state.cX;
		}

		function scrollStop(state) {
			clearInterval(state.upScroll);
			clearInterval(state.downScroll);

			state.upScroll = state.downScroll = false;
		}

		function setCElPos(e, state) {
			var cEl = state.cEl;

			cEl.el.css({
				'top': e.pageY - cEl.xyOffsetDiff.Y - cEl.mT,
				'left': e.pageX - cEl.xyOffsetDiff.X - cEl.mL
			});
		}

		function elFromPoint(x, y) {
			if (!document.elementFromPoint) return null;

			var isRelEFP = state.isRelEFP;

			if (isRelEFP === null) {
				var s, res;
				if ((s = state.doc.scrollTop()) > 0) {
					isRelEFP = (res = document.elementFromPoint(0, s + $(window).height() - 1)) == null || res.tagName.toUpperCase() == 'HTML';
				}
				if ((s = state.doc.scrollLeft()) > 0) {
					isRelEFP = (res = document.elementFromPoint(s + $(window).width() - 1, 0)) == null || res.tagName.toUpperCase() == 'HTML';
				}
			}

			if (isRelEFP) {
				x -= state.doc.scrollLeft();
				y -= state.doc.scrollTop();
			}

			var el = $(document.elementFromPoint(x, y));

			if (!state.rootEl.el.find(el).length) {
					return null;
				} else if (el.is('#sortableListsPlaceholder') || el.is('#sortableListsHint')) {
					return null;
				} else if (!el.is('li')) {
					el = el.closest('li');
					return el[0] ? el : null;
				} else if (el.is('li')) {
					return el;
				}
		}

		function showHint(e, state) {
			var oEl = state.oEl;

			if (!oEl || !state.oElOld) return;

			var oElH = oEl.outerHeight(false),
			    relY = e.pageY - oEl.offset().top;

			if (setting.insertZonePlus) {
				if (14 > relY) {
						showOnTopPlus(e, oEl, 7 > relY);
					} else if (oElH - 14 < relY) {
						showOnBottomPlus(e, oEl, oElH - 7 < relY);
					}
			} else {
				if (5 > relY) {
						showOnTop(e, oEl);
					} else if (oElH - 5 < relY) {
						showOnBottom(e, oEl);
					}
			}
		}

		function showOnTop(e, oEl) {
			if ($('#sortableListsHintWrapper', state.rootEl.el).length) {
				hint.unwrap();
			}

			if (e.pageX - oEl.offset().left < setting.insertZone) {
				if (oEl.prev('#sortableListsPlaceholder').length) {
					hint.css('display', 'none');
					return;
				}
				oEl.before(hint);
			} else {
					var children = oEl.children(),
					    list = oEl.children(setting.listSelector).first();

					if (list.children().first().is('#sortableListsPlaceholder')) {
						hint.css('display', 'none');
						return;
					}

					if (!list.length) {
						children.first().after(hint);
						hint.wrap(hintWrapper);
					} else {
						list.prepend(hint);
					}

					if (state.oEl) {
						open(oEl);
					}
				}

			hint.css('display', 'block');

			state.isAllowed = setting.isAllowed(state.cEl.el, hint, hint.parents('li').first());
		}

		function showOnTopPlus(e, oEl, outside) {
			if ($('#sortableListsHintWrapper', state.rootEl.el).length) {
				hint.unwrap();
			}

			if (!outside && e.pageX - oEl.offset().left > setting.insertZone) {
				var children = oEl.children(),
				    list = oEl.children(setting.listSelector).first();

				if (list.children().first().is('#sortableListsPlaceholder')) {
					hint.css('display', 'none');
					return;
				}

				if (!list.length) {
					children.first().after(hint);
					hint.wrap(hintWrapper);
				} else {
					list.prepend(hint);
				}

				if (state.oEl) {
					open(oEl);
				}
			} else {
					if (oEl.prev('#sortableListsPlaceholder').length) {
						hint.css('display', 'none');
						return;
					}
					oEl.before(hint);
				}

			hint.css('display', 'block');

			state.isAllowed = setting.isAllowed(state.cEl.el, hint, hint.parents('li').first());
		}

		function showOnBottom(e, oEl) {
			if ($('#sortableListsHintWrapper', state.rootEl.el).length) {
				hint.unwrap();
			}

			if (e.pageX - oEl.offset().left < setting.insertZone) {
				if (oEl.next('#sortableListsPlaceholder').length) {
					hint.css('display', 'none');
					return;
				}
				oEl.after(hint);
			} else {
					var children = oEl.children(),
					    list = oEl.children(setting.listSelector).last();

					if (list.children().last().is('#sortableListsPlaceholder')) {
						hint.css('display', 'none');
						return;
					}

					if (list.length) {
						children.last().append(hint);
					} else {
						oEl.append(hint);
						hint.wrap(hintWrapper);
					}

					if (state.oEl) {
						open(oEl);
					}
				}

			hint.css('display', 'block');

			state.isAllowed = setting.isAllowed(state.cEl.el, hint, hint.parents('li').first());
		}

		function showOnBottomPlus(e, oEl, outside) {
			if ($('#sortableListsHintWrapper', state.rootEl.el).length) {
				hint.unwrap();
			}

			if (!outside && e.pageX - oEl.offset().left > setting.insertZone) {
				var children = oEl.children(),
				    list = oEl.children(setting.listSelector).last();

				if (list.children().last().is('#sortableListsPlaceholder')) {
					hint.css('display', 'none');
					return;
				}

				if (list.length) {
					children.last().append(hint);
				} else {
					oEl.append(hint);
					hint.wrap(hintWrapper);
				}

				if (state.oEl) {
					open(oEl);
				}
			} else {
					if (oEl.next('#sortableListsPlaceholder').length) {
						hint.css('display', 'none');
						return;
					}
					oEl.after(hint);
				}

			hint.css('display', 'block');

			state.isAllowed = setting.isAllowed(state.cEl.el, hint, hint.parents('li').first());
		}

		function open(li) {
			li.removeClass('sortableListsClosed').addClass('sortableListsOpen');
			li.children(setting.listSelector).css('display', 'block');

			var opener = li.children('div').children('.sortableListsOpener').first();

			if (setting.opener.as == 'html') {
				opener.html(setting.opener.close);
			} else if (setting.opener.as == 'class') {
				opener.addClass(setting.opener.close).removeClass(setting.opener.open);
			} else {
				opener.css('background-image', 'url(' + setting.opener.close + ')');
			}
		}

		function close(li) {
			li.removeClass('sortableListsOpen').addClass('sortableListsClosed');
			li.children(setting.listSelector).css('display', 'none');

			var opener = li.children('div').children('.sortableListsOpener').first();

			if (setting.opener.as == 'html') {
				opener.html(setting.opener.open);
			} else if (setting.opener.as == 'class') {
				opener.addClass(setting.opener.open).removeClass(setting.opener.close);
			} else {
				opener.css('background-image', 'url(' + setting.opener.open + ')');
			}
		}

		function tidyCurrEl(cEl) {
			var cElStyle = cEl.el[0].style;

			cEl.el.removeClass(setting.currElClass + ' ' + 'sortableListsCurrent');
			cElStyle.top = '0';
			cElStyle.left = '0';
			cElStyle.position = 'relative';
			cElStyle.width = 'auto';
		}

		function tidyEmptyLists() {
			$(setting.listSelector, state.rootEl.el).each(function (i) {
				if (!$(this).children().length) {
					$(this).prev('div').children('.sortableListsOpener').first().remove();
					$(this).remove();
				}
			});
		}
	};

	$.fn.sortableListsToArray = function (arr, parentId) {
		arr = arr || [];
		var order = 0;

		this.children('li').each(function () {
			var li = $(this),
			    listItem = {},
			    id = li.attr('id');

			if (!id) {
				console.log(li);
				throw 'Previous item in console.log has no id. It is necessary to create the array.';
			}

			listItem.id = id;
			listItem.parentId = parentId;
			listItem.value = li.data('value');
			listItem.order = order;
			arr.push(listItem);
			li.children('ul,ol').sortableListsToArray(arr, id);
			order++;
		});

		return arr;
	};

	$.fn.sortableListsToHierarchy = function () {
		var arr = [],
		    order = 0;

		$(this).children('li').each(function () {
			var li = $(this),
			    listItem = {},
			    id = li.attr('id');

			if (!id) {
				console.log(li);
				throw 'Previous item in console.log has no id. It is necessary to create the array.';
			}
			listItem.id = id;
			listItem.value = li.data('value');
			listItem.order = order;
			arr.push(listItem);
			listItem.children = li.children('ul,ol').sortableListsToHierarchy();
			order++;
		});

		return arr;
	};

	$.fn.sortableListsToString = function (arr, parentId) {
		arr = arr || [];
		parentId = parentId || 'no-parent';

		$(this).children('li').each(function () {
			var li = $(this),
			    id = li.attr('id'),
			    matches = id ? id.match(/(.+)[-=_](.+)/) : null;

			if (!matches) {
				console.log(li);
				throw 'Previous item in console.log has no id or id is not in required format xx_yy, xx-yy or xx=yy. It is necessary to create valid string.';
			}

			arr.push(matches[1] + '[' + matches[2] + ']=' + parentId);
			$(this).children('ul,ol').sortableListsToString(arr, matches[2]);
		});

		return arr.join('&');
	};
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRightsByIndexName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRightsByEditName;
var albums = {
  indexName: 'Albums',
  editName: 'AlbumEdit',
  accessRights: {
    deletePermissionsIds: [179, 180],
    updatePermissionsIds: [177, 178],
    createPermissionsIds: [175]
  }
};
var articles = {
  indexName: 'ArticleList',
  editName: 'ArticleEdit',
  accessRights: {
    deletePermissionsIds: [108, 109],
    updatePermissionsIds: [106, 107],
    createPermissionsIds: [104]
  }
};
var audio = {
  indexName: 'AudioList',
  editName: 'AudioEdit',
  accessRights: {
    deletePermissionsIds: [185, 186],
    updatePermissionsIds: [183, 184],
    createPermissionsIds: [181]
  }
};
var correspondence = {
  indexName: 'CorrespondenceList',
  editName: 'CorrespondenceEdit',
  accessRights: {
    deletePermissionsIds: [124, 125],
    updatePermissionsIds: [122, 123],
    createPermissionsIds: [120]
  }
};
var documentFiles = {
  indexName: 'DocumentFilesList',
  editName: 'DocumentFilesEdit',
  accessRights: {
    deletePermissionsIds: [197, 198],
    updatePermissionsIds: [195, 196],
    createPermissionsIds: [193]
  }
};
var documents = {
  indexName: 'Documents',
  editName: 'DocumentEdit',
  accessRights: {
    deletePermissionsIds: [191, 192],
    updatePermissionsIds: [189, 190],
    createPermissionsIds: [187]
  }
};
var events = {
  indexName: 'Events',
  editName: 'EventEdit',
  accessRights: {
    deletePermissionsIds: [130, 131],
    updatePermissionsIds: [129, 130],
    createPermissionsIds: [127]
  }
};
var faq = {
  indexName: 'FaqList',
  editName: 'FaqEdit',
  accessRights: {
    deletePermissionsIds: [136, 137],
    updatePermissionsIds: [134, 135],
    createPermissionsIds: [132]
  }
};
var gallery = {
  indexName: 'Gallery',
  editName: 'GalleryEdit',
  accessRights: {
    deletePermissionsIds: [155, 156],
    updatePermissionsIds: [153, 154],
    createPermissionsIds: [151]
  }
};
var images = {
  indexName: 'Images',
  editName: 'ImageEdit',
  accessRights: {
    deletePermissionsIds: [161, 162],
    updatePermissionsIds: [159, 160],
    createPermissionsIds: [157]
  }
};
var issuesAndAnswers = {
  indexName: 'IssuesAndAnswersList',
  editName: 'IssuesAndAnswersEdit',
  accessRights: {
    deletePermissionsIds: [228, 229],
    updatePermissionsIds: [226, 227],
    createPermissionsIds: [224]
  }
};
var lessons = {
  indexName: 'Lessons',
  editName: 'LessonEdit',
  accessRights: {
    deletePermissionsIds: [143, 144],
    updatePermissionsIds: [141, 142],
    createPermissionsIds: [139]
  }
};
var letterbooks = {
  indexName: 'Letterbooks',
  editName: 'LetterbookEdit',
  accessRights: {
    deletePermissionsIds: [114, 115],
    updatePermissionsIds: [112, 113],
    createPermissionsIds: [110]
  }
};
var locations = {
  indexName: 'Locations',
  editName: 'LocationEdit',
  accessRights: {
    deletePermissionsIds: [149, 150],
    updatePermissionsIds: [147, 148],
    createPermissionsIds: [145]
  }
};
var news = {
  indexName: 'News',
  editName: 'NewsEdit',
  accessRights: {
    deletePermissionsIds: [203, 204],
    updatePermissionsIds: [201, 202],
    createPermissionsIds: [199]
  }
};
var pamphlets = {
  indexName: 'PamphletList',
  editName: 'PamphletEdit',
  accessRights: {
    deletePermissionsIds: [209, 210],
    updatePermissionsIds: [207, 208],
    createPermissionsIds: [205]
  }
};
var people = {
  indexName: 'People',
  editName: 'PersonEdit',
  accessRights: {
    deletePermissionsIds: [215, 216],
    updatePermissionsIds: [213, 214],
    createPermissionsIds: [211]
  }
};
var publication = {
  indexName: 'Publications',
  editName: 'PublicationEdit',
  accessRights: {
    deletePermissionsIds: [222, 223],
    updatePermissionsIds: [220, 221],
    createPermissionsIds: [218]
  }
};
var qa = {
  indexName: 'QaList',
  editName: 'QaEdit',
  accessRights: {
    deletePermissionsIds: [228, 229],
    updatePermissionsIds: [226, 227],
    createPermissionsIds: [224]
  }
};
var topics = {
  indexName: 'Topics',
  editName: 'TopicEdit',
  accessRights: {
    deletePermissionsIds: [246, 247],
    updatePermissionsIds: [244, 245],
    createPermissionsIds: [242]
  }
};
var video = {
  indexName: 'VideoList',
  editName: 'VideoEdit',
  accessRights: {
    deletePermissionsIds: [173, 174],
    updatePermissionsIds: [171, 172],
    createPermissionsIds: [169]
  }
};
var videoSeries = {
  indexName: 'VideoSeriesList',
  editName: 'VideoSeriesEdit',
  accessRights: {
    deletePermissionsIds: [167, 168],
    updatePermissionsIds: [165, 166],
    createPermissionsIds: [163]
  }
};
var puzzleGame = {
  indexName: 'PuzzleImageIndex',
  editName: 'PuzzleImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254]
  }
};
var memoryGame = {
  indexName: 'MemoryImageList',
  editName: 'MemoryImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254]
  }
};
var paintingGame = {
  indexName: 'PaintingImageList',
  editName: 'PaintingImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254]
  }
};
var quizGame = {
  indexName: 'QuizImageList',
  editName: 'QuizImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254]
  }
};
var editorsPicks = {
  indexName: '',
  editName: '',
  accessRights: {
    deletePermissionsIds: [255],
    updatePermissionsIds: [255],
    createPermissionsIds: [255]
  }
};
var rightsArray = [albums, articles, audio, correspondence, documentFiles, documents, events, faq, gallery, images, issuesAndAnswers, lessons, letterbooks, locations, news, pamphlets, people, publication, qa, topics, video, videoSeries, puzzleGame, memoryGame, quizGame, paintingGame, editorsPicks];
function getRightsByIndexName(indexName) {
  var rights = rightsArray.find(function (item) {
    return item.indexName === indexName;
  });
  if (!rights) {
    return {};
  }
  return rights.accessRights;
}
function getRightsByEditName(editName) {
  var rights = rightsArray.find(function (item) {
    return item.editName === editName;
  });
  if (!rights) {
    return {};
  }
  return rights.accessRights;
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
  getRightsByIndexName: getRightsByIndexName,
  getRightsByEditName: getRightsByEditName
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validate = function validate(fields, showError) {
  var invalidPathRegEx = new RegExp('[^A-Za-z0-9_-]');
  var validateEmail = function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  for (var i = 0; i < fields.length; i += 1) {
    var _fields$i = fields[i],
        type = _fields$i.type,
        name = _fields$i.name,
        value = _fields$i.value,
        maxLength = _fields$i.maxLength,
        minLength = _fields$i.minLength;


    if (type === 'required' && !value) {
      showError(name + ' field is required');
      return false;
    }
    if (type === 'maxLength' && value.length > maxLength) {
      showError(name + ' field length should be less then ' + maxLength);
      return false;
    }
    if (type === 'minLength' && value.length < minLength) {
      showError(name + ' field length should be less then ' + minLength);
      return false;
    }
    if (type === 'email' && value && !validateEmail(value)) {
      showError(name + ' field is must be valid');
      return false;
    }
    if (type === 'path' && value && value.match(invalidPathRegEx)) {
      showError('Path Alias should content only letters, digits and symbols -, _');
      return false;
    }
  }
  return true;
};

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_games_memory_personType__ = __webpack_require__(519);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      entity: {
        title: '',
        quotes: [],
        memory_image: null,
        ref_id: 0,
        is_person: false
      },
      source: {
        title: '',
        quotes: [],
        memory_image: null,
        ref_id: 0,
        is_person: false
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false,
      personTypes: __WEBPACK_IMPORTED_MODULE_3__views_games_memory_personType__["a" /* default */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    images: 'memoryGame/imageList'
  })),

  methods: {
    addQuote: function addQuote() {
      this.entity.quotes.push({
        text: ''
      });
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    },
    onDeleteQuote: function onDeleteQuote(index) {
      this.entity.quotes.splice(index, 1);
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      entity: {
        title: '',
        quotes: [],
        painting_image: null
      },
      source: {
        title: '',
        quotes: [],
        painting_image: null
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false
    };
  },


  methods: {
    addQuote: function addQuote() {
      if (!this.entity.quotes) {
        this.entity.quotes = [];
      }
      this.entity.quotes.push({
        text: ''
      });
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    },
    onDeleteQuote: function onDeleteQuote(index) {
      if (!this.entity.quotes) {
        return;
      }
      this.entity.quotes.splice(index, 1);
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_games_puzzles_presets__ = __webpack_require__(520);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      entity: {
        title: '',
        levels: {},
        quotes: [],
        image: null,
        default_level: null,
        puzzle: {
          public_url: ''
        }
      },
      source: {
        title: '',
        levels: {},
        quotes: [],
        image: null,
        default_level: null,
        puzzle: {
          public_url: ''
        }
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false,
      presets: __WEBPACK_IMPORTED_MODULE_3__views_games_puzzles_presets__["a" /* default */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    images: 'memoryGame/imageList'
  })),

  methods: {
    addQuote: function addQuote() {
      this.entity.quotes.push({
        text: ''
      });
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    },
    onDeleteQuote: function onDeleteQuote(index) {
      this.entity.quotes.splice(index, 1);
      this.entity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.entity);
      this.entity.quotes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.entity.quotes));
    },
    makeOptions: function makeOptions(preset) {
      var options = [];
      if (!this.$refs.uploader) {
        return options;
      }
      var baseAmounts = preset.baseAmounts;

      var img = this.$refs.uploader.$refs.imageBoxImg;
      var naturalWidth = img.naturalWidth,
          naturalHeight = img.naturalHeight;

      var heightDivWidth = naturalHeight / naturalWidth;
      var widthDivHeight = naturalWidth / naturalHeight;
      baseAmounts.forEach(function (amount) {
        var xAmount = void 0;
        var yAmount = void 0;
        if (heightDivWidth > 1) {
          xAmount = Math.round(Math.sqrt(amount) / heightDivWidth);
          yAmount = Math.round(xAmount * heightDivWidth);
        } else {
          yAmount = Math.ceil(Math.sqrt(amount) / widthDivHeight);
          xAmount = Math.ceil(yAmount * widthDivHeight);
        }
        var resultAmount = xAmount * yAmount;
        if (resultAmount >= 10 && resultAmount <= 350) {
          options.push({
            xAmount: xAmount,
            yAmount: yAmount,
            text: xAmount * yAmount + ' pieces (' + xAmount + ' by width, ' + yAmount + ' by height)',
            type: preset.type
          });
        }
      });
      options = this.filterDuplicates(options, function (item) {
        return item.xAmount;
      });
      return options;
    },
    filterDuplicates: function filterDuplicates(array, predicate) {
      var newArr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(array));
      for (var i = 0; i < array.length - 1; i++) {
        for (var j = i + 1; j < array.length; j++) {
          var curr = array[i];
          var next = array[j];
          if (predicate(curr) === predicate(next)) {
            var index = newArr.indexOf(next);
            if (index !== -1) {
              newArr.splice(index, 1);
            }
          }
        }
      }
      return newArr;
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(42);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      entity: {
        question: '',
        answer: false,
        explanation: '',
        more_info: '',
        link: ''
      },
      source: {
        question: '',
        answer: false,
        explanation: '',
        more_info: '',
        link: ''
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    images: 'quizGame/imageList'
  }))
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TITLE: 'TITLE',
  BODY: 'BODY',
  ID: 'ID',
  URL: 'URL'
});

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(858),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2beb46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(992),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(914),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(899),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(940),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(921),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var apiHttp = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://alpha.ellenwhite.org"
});

/* harmony default export */ __webpack_exports__["a"] = (apiHttp);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Full__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__containers_Full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_content_Index__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_content_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_content_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Dashboard__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mainSearch_DashboardSearch__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_mainSearch_DashboardSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_mainSearch_DashboardSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Search__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Robots__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Robots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Robots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_flowpaper_Index__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_flowpaper_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_flowpaper_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_featuredContent_Index__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_featuredContent_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_featuredContent_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_publicFiles_Index__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_publicFiles_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_publicFiles_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_content_publication_Index__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_content_publication_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_content_publication_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_content_publication_Edit__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_content_publication_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_content_publication_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_content_publication_New__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_content_publication_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_content_publication_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_content_correspondence_Index__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_content_correspondence_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_content_correspondence_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_content_correspondence_Edit__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_content_correspondence_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_content_correspondence_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_content_correspondence_New__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_content_correspondence_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_content_correspondence_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_content_people_Index__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_content_people_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_content_people_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_content_people_Duplicates__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_content_people_Duplicates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_content_people_Duplicates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_content_people_Edit__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_content_people_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_content_people_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_content_people_New__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_content_people_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_content_people_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_content_news_Index__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_content_news_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_content_news_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_content_news_Edit__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_content_news_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_content_news_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_content_news_New__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_content_news_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_content_news_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_content_articles_Index__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_content_articles_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_content_articles_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_content_articles_Edit__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_content_articles_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_content_articles_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_content_articles_New__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_content_articles_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_content_articles_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_content_lessons_Index__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_content_lessons_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_content_lessons_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_content_lessons_Edit__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_content_lessons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_content_lessons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_content_lessons_New__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_content_lessons_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_content_lessons_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_content_locations_Index__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_content_locations_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_content_locations_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_content_locations_Edit__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_content_locations_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_content_locations_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_content_locations_New__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_content_locations_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_content_locations_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_content_letterbooks_Index__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_content_letterbooks_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_content_letterbooks_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_content_letterbooks_Edit__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_content_letterbooks_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_content_letterbooks_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_content_letterbooks_New__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_content_letterbooks_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_content_letterbooks_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_content_events_Index__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_content_events_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__views_content_events_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_content_events_Edit__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_content_events_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__views_content_events_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_content_events_New__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_content_events_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__views_content_events_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_content_issuesAndAnswers_Index__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_content_issuesAndAnswers_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__views_content_issuesAndAnswers_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_content_issuesAndAnswers_Edit__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_content_issuesAndAnswers_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__views_content_issuesAndAnswers_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_content_issuesAndAnswers_New__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_content_issuesAndAnswers_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__views_content_issuesAndAnswers_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_content_images_Index__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_content_images_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__views_content_images_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_content_images_Edit__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_content_images_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__views_content_images_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_content_images_New__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_content_images_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__views_content_images_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_content_gallery_Index__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_content_gallery_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__views_content_gallery_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_content_gallery_New__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_content_gallery_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__views_content_gallery_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_content_gallery_Edit__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_content_gallery_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__views_content_gallery_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_content_gallery_ManageImages__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_content_gallery_ManageImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__views_content_gallery_ManageImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_content_gallery_AddImages__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_content_gallery_AddImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__views_content_gallery_AddImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_content_documents_Index__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_content_documents_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__views_content_documents_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_content_documents_Edit__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_content_documents_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__views_content_documents_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_content_documents_New__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_content_documents_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__views_content_documents_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_content_documentFiles_Index__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_content_documentFiles_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__views_content_documentFiles_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_content_documentFiles_Edit__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_content_documentFiles_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__views_content_documentFiles_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_content_documentFiles_New__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_content_documentFiles_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__views_content_documentFiles_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_content_documentFiles_ManageDocs__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_content_documentFiles_ManageDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__views_content_documentFiles_ManageDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_content_documentFiles_AddDocs__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_content_documentFiles_AddDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__views_content_documentFiles_AddDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_content_audio_Index__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_content_audio_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__views_content_audio_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_content_audio_Edit__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_content_audio_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__views_content_audio_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_content_audio_New__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_content_audio_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__views_content_audio_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_content_albums_Index__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_content_albums_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__views_content_albums_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_content_albums_Edit__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_content_albums_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__views_content_albums_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_content_albums_New__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_content_albums_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__views_content_albums_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_content_albums_ManageTracks__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_content_albums_ManageTracks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__views_content_albums_ManageTracks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_content_albums_OrderTracks__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_content_albums_OrderTracks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__views_content_albums_OrderTracks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_content_albums_AddTracks__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_content_albums_AddTracks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__views_content_albums_AddTracks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_content_video_Index__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_content_video_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__views_content_video_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_content_video_Edit__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_content_video_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__views_content_video_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_content_video_New__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_content_video_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__views_content_video_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_content_videoSeries_Index__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_content_videoSeries_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__views_content_videoSeries_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_content_videoSeries_Edit__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_content_videoSeries_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__views_content_videoSeries_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_content_videoSeries_New__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_content_videoSeries_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__views_content_videoSeries_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_content_videoSeries_ManageVideos__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_content_videoSeries_ManageVideos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__views_content_videoSeries_ManageVideos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_content_videoSeries_OrderVideos__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_content_videoSeries_OrderVideos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__views_content_videoSeries_OrderVideos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_content_videoSeries_AddVideos__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_content_videoSeries_AddVideos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__views_content_videoSeries_AddVideos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_content_pamphlets_Index__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_content_pamphlets_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__views_content_pamphlets_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_content_pamphlets_Edit__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_content_pamphlets_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__views_content_pamphlets_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_content_pamphlets_New__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_content_pamphlets_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__views_content_pamphlets_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_content_topics_Index__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_content_topics_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__views_content_topics_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_content_topics_Edit__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_content_topics_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__views_content_topics_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_content_topics_New__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_content_topics_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__views_content_topics_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_content_faq_Index__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_content_faq_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__views_content_faq_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_content_faq_Edit__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_content_faq_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__views_content_faq_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_content_faq_New__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_content_faq_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__views_content_faq_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_taxonomy_vocabulary_Index__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_taxonomy_vocabulary_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__views_taxonomy_vocabulary_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_taxonomy_vocabulary_Edit__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_taxonomy_vocabulary_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__views_taxonomy_vocabulary_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_taxonomy_vocabulary_New__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_taxonomy_vocabulary_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__views_taxonomy_vocabulary_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_taxonomy_vocabulary_TermsOrder__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_taxonomy_vocabulary_TermsOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__views_taxonomy_vocabulary_TermsOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_taxonomy_terms_Index__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_taxonomy_terms_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__views_taxonomy_terms_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_taxonomy_terms_Edit__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_taxonomy_terms_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__views_taxonomy_terms_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_taxonomy_terms_New__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_taxonomy_terms_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__views_taxonomy_terms_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_media_Index__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_media_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__views_media_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_menu_Index__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_menu_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__views_menu_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_menu_New__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_menu_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__views_menu_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_menu_Edit__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_menu_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__views_menu_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_staff_Index__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_staff_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__views_staff_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_staff_Edit__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_staff_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__views_staff_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_staff_New__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_staff_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__views_staff_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_directors_Index__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_directors_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__views_directors_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_directors_Edit__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_directors_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__views_directors_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_directors_New__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_directors_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__views_directors_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_branchOffices_Index__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_branchOffices_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__views_branchOffices_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_branchOffices_Edit__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_branchOffices_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__views_branchOffices_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_branchOffices_New__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_branchOffices_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__views_branchOffices_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_sitePages_Index__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_sitePages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__views_sitePages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_sitePages_Edit__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_sitePages_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__views_sitePages_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_sitePages_New__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_sitePages_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__views_sitePages_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_redirects_Index__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_redirects_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__views_redirects_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_redirects_Edit__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_redirects_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__views_redirects_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_redirects_New__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_redirects_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__views_redirects_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_users_Index__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_users_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__views_users_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_users_Edit__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_users_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__views_users_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_users_New__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_users_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__views_users_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_roles_Index__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_roles_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__views_roles_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_roles_Edit__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_roles_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__views_roles_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_roles_New__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_roles_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__views_roles_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_content_qa_Index__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_content_qa_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__views_content_qa_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_content_qa_Edit__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_content_qa_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__views_content_qa_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_content_qa_New__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_content_qa_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__views_content_qa_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_content_qa_ManageDocs__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_content_qa_ManageDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__views_content_qa_ManageDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_content_qa_AddDocs__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_content_qa_AddDocs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__views_content_qa_AddDocs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_games_puzzles_Index__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_games_puzzles_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__views_games_puzzles_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_games_puzzles_New__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_games_puzzles_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__views_games_puzzles_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_games_puzzles_Edit__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_games_puzzles_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__views_games_puzzles_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_games_memory_Index__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_games_memory_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__views_games_memory_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_games_memory_New__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_games_memory_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__views_games_memory_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_games_memory_Edit__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_games_memory_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__views_games_memory_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_games_painting_Index__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_games_painting_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__views_games_painting_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_games_painting_New__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_games_painting_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__views_games_painting_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_games_painting_Edit__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_games_painting_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__views_games_painting_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_games_quiz_Index__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_games_quiz_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__views_games_quiz_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_games_quiz_New__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_games_quiz_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__views_games_quiz_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_games_quiz_Edit__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_games_quiz_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__views_games_quiz_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_editorsPicks_EditorsPicksList_vue__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_editorsPicks_EditorsPicksList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__views_editorsPicks_EditorsPicksList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_editorsPicks_EditorsPicksEditArticles_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_editorsPicks_EditorsPicksEditArticles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__views_editorsPicks_EditorsPicksEditArticles_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_editorsPicks_EditorsPicksEditFAQ_vue__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_editorsPicks_EditorsPicksEditFAQ_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__views_editorsPicks_EditorsPicksEditFAQ_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_editorsPicks_EditorsPicksEditDocuments_vue__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_editorsPicks_EditorsPicksEditDocuments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__views_editorsPicks_EditorsPicksEditDocuments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_unauthorizedPages_Login__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_unauthorizedPages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__views_unauthorizedPages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_unauthorizedPages_TwoFactorAuthentication__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_unauthorizedPages_TwoFactorAuthentication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__views_unauthorizedPages_TwoFactorAuthentication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_unauthorizedPages_RequestResetPassword__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_unauthorizedPages_RequestResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__views_unauthorizedPages_RequestResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_unauthorizedPages_ResetPassword__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_unauthorizedPages_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__views_unauthorizedPages_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_accountSettings_Index__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_accountSettings_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__views_accountSettings_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_accountSettings_Google2FA_Google2FA__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_accountSettings_Google2FA_Google2FA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__views_accountSettings_Google2FA_Google2FA__);





























































































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_141__views_unauthorizedPages_Login___default.a,
    meta: {
      dontNeedAuth: true
    }
  }, {
    path: '/two-factor-authentication',
    name: 'TwoFactorAuthentication',
    component: __WEBPACK_IMPORTED_MODULE_142__views_unauthorizedPages_TwoFactorAuthentication___default.a,
    meta: {
      dontNeedAuth: true
    }
  }, {
    path: '/password/reset',
    name: 'RequestResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_143__views_unauthorizedPages_RequestResetPassword___default.a,
    meta: {
      dontNeedAuth: true
    }
  }, {
    path: '/password/reset/:token',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_144__views_unauthorizedPages_ResetPassword___default.a,
    meta: {
      dontNeedAuth: true
    }
  }, {
    path: '/admin',
    redirect: '/admin/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__containers_Full___default.a,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__views_Dashboard___default.a
    }, {
      path: 'account-settings',
      name: 'Account Settings',
      component: __WEBPACK_IMPORTED_MODULE_145__views_accountSettings_Index___default.a
    }, {
      path: 'account-settings/set-up-google2fa',
      name: 'Set Up Google2FA',
      component: __WEBPACK_IMPORTED_MODULE_146__views_accountSettings_Google2FA_Google2FA___default.a
    }, {
      path: 'main-search',
      name: 'Dashboard Search',
      component: __WEBPACK_IMPORTED_MODULE_8__views_mainSearch_DashboardSearch___default.a,
      meta: {
        permissions: [230]
      }
    }, {
      path: 'search',
      name: 'Search settings',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Search___default.a,
      meta: {
        permissions: [230]
      }
    }, {
      path: 'robots',
      name: 'Robots settings',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Robots___default.a,
      meta: {
        permissions: [97]
      }
    }, {
      path: 'redirects',
      name: 'Redirects',
      component: __WEBPACK_IMPORTED_MODULE_111__views_redirects_Index___default.a,
      meta: {
        permissions: [98]
      },
      children: [{
        path: 'edit/:id',
        name: 'RedirectsEdit',
        component: __WEBPACK_IMPORTED_MODULE_112__views_redirects_Edit___default.a
      }, {
        path: 'new',
        name: 'RedirectsNew',
        component: __WEBPACK_IMPORTED_MODULE_113__views_redirects_New___default.a
      }]
    }, {
      path: 'featured-content',
      name: 'featuredContent',
      component: __WEBPACK_IMPORTED_MODULE_12__views_featuredContent_Index___default.a,
      meta: {
        permissions: [100]
      }
    }, {
      path: 'flowpaper',
      name: 'Flowpaper',
      component: __WEBPACK_IMPORTED_MODULE_11__views_flowpaper_Index___default.a,
      meta: {
        permissions: [138]
      }
    }, {
      path: 'roles',
      name: 'Roles',
      component: __WEBPACK_IMPORTED_MODULE_117__views_roles_Index___default.a,
      meta: {
        permissions: [96]
      },
      children: [{
        path: 'edit/:id',
        name: 'RolesEdit',
        component: __WEBPACK_IMPORTED_MODULE_118__views_roles_Edit___default.a
      }, {
        path: 'new',
        name: 'RolesNew',
        component: __WEBPACK_IMPORTED_MODULE_119__views_roles_New___default.a
      }]
    }, {
      path: 'users',
      name: 'Users',
      component: __WEBPACK_IMPORTED_MODULE_114__views_users_Index___default.a,
      meta: {
        permissions: [95]
      },
      children: [{
        path: 'edit/:id',
        name: 'UsersEdit',
        component: __WEBPACK_IMPORTED_MODULE_115__views_users_Edit___default.a
      }, {
        path: 'new',
        name: 'UsersNew',
        component: __WEBPACK_IMPORTED_MODULE_116__views_users_New___default.a
      }]
    }, {
      path: 'media',
      name: 'Media',
      component: __WEBPACK_IMPORTED_MODULE_95__views_media_Index___default.a,
      meta: {
        permissions: [99]
      }
    }, {
      path: 'menu',
      name: 'Menu',
      component: __WEBPACK_IMPORTED_MODULE_96__views_menu_Index___default.a,
      meta: {
        permissions: [102]
      },
      children: [{
        path: 'edit/:id',
        name: 'MenuEdit',
        component: __WEBPACK_IMPORTED_MODULE_98__views_menu_Edit___default.a
      }, {
        path: 'new',
        name: 'MenuNew',
        component: __WEBPACK_IMPORTED_MODULE_97__views_menu_New___default.a
      }]
    }, {
      path: 'public',
      name: 'PublicFiles',
      component: __WEBPACK_IMPORTED_MODULE_13__views_publicFiles_Index___default.a,
      meta: {
        permissions: [103]
      }
    }, {
      path: 'staff',
      name: 'Staff',
      component: __WEBPACK_IMPORTED_MODULE_99__views_staff_Index___default.a,
      meta: {
        permissions: [116]
      },
      children: [{
        path: 'edit/:id',
        name: 'StaffEdit',
        component: __WEBPACK_IMPORTED_MODULE_100__views_staff_Edit___default.a
      }, {
        path: 'new',
        name: 'StaffNew',
        component: __WEBPACK_IMPORTED_MODULE_101__views_staff_New___default.a
      }]
    }, {
      path: 'directors',
      name: 'Directors',
      component: __WEBPACK_IMPORTED_MODULE_102__views_directors_Index___default.a,
      meta: {
        permissions: [117]
      },
      children: [{
        path: 'edit/:id',
        name: 'DirectorsEdit',
        component: __WEBPACK_IMPORTED_MODULE_103__views_directors_Edit___default.a
      }, {
        path: 'new',
        name: 'DirectorsNew',
        component: __WEBPACK_IMPORTED_MODULE_104__views_directors_New___default.a
      }]
    }, {
      path: 'branch-offices',
      name: 'BranchOffices',
      component: __WEBPACK_IMPORTED_MODULE_105__views_branchOffices_Index___default.a,
      meta: {
        permissions: [118, 256]
      },
      children: [{
        path: 'edit/:id',
        name: 'BranchOfficesEdit',
        component: __WEBPACK_IMPORTED_MODULE_106__views_branchOffices_Edit___default.a
      }, {
        path: 'new',
        name: 'BranchOfficesNew',
        component: __WEBPACK_IMPORTED_MODULE_107__views_branchOffices_New___default.a
      }]
    }, {
      path: 'site-pages',
      name: 'SitePages',
      component: __WEBPACK_IMPORTED_MODULE_108__views_sitePages_Index___default.a,
      meta: {
        permissions: [119]
      },
      children: [{
        path: 'edit/:id',
        name: 'SitePagesEdit',
        component: __WEBPACK_IMPORTED_MODULE_109__views_sitePages_Edit___default.a
      }, {
        path: 'new',
        name: 'SitePagesNew',
        component: __WEBPACK_IMPORTED_MODULE_110__views_sitePages_New___default.a
      }]
    }, {
      path: 'taxonomy',
      name: 'Taxonomy',
      component: __WEBPACK_IMPORTED_MODULE_6__views_content_Index___default.a,
      meta: {
        permissions: [231]
      },
      children: [{
        path: 'vocabulary',
        name: 'Vocabulary',
        component: __WEBPACK_IMPORTED_MODULE_88__views_taxonomy_vocabulary_Index___default.a,
        meta: {
          permissions: [232, 233, 234, 235, 236]
        },
        children: [{
          path: 'edit/:id',
          name: 'VocabularyEdit',
          component: __WEBPACK_IMPORTED_MODULE_89__views_taxonomy_vocabulary_Edit___default.a
        }, {
          path: 'new',
          name: 'VocabularyNew',
          component: __WEBPACK_IMPORTED_MODULE_90__views_taxonomy_vocabulary_New___default.a
        }, {
          path: 'order/:id',
          name: 'VocabularyOrder',
          component: __WEBPACK_IMPORTED_MODULE_91__views_taxonomy_vocabulary_TermsOrder___default.a
        }]
      }, {
        path: 'terms',
        name: 'Terms',
        component: __WEBPACK_IMPORTED_MODULE_92__views_taxonomy_terms_Index___default.a,
        meta: {
          permissions: [237, 238, 239, 240, 241]
        },
        children: [{
          path: 'edit/:id',
          name: 'TermsEdit',
          component: __WEBPACK_IMPORTED_MODULE_93__views_taxonomy_terms_Edit___default.a
        }, {
          path: 'new',
          name: 'TermsNew',
          component: __WEBPACK_IMPORTED_MODULE_94__views_taxonomy_terms_New___default.a
        }]
      }]
    }, {
      path: 'content',
      name: 'Content',
      component: __WEBPACK_IMPORTED_MODULE_6__views_content_Index___default.a,
      meta: {
        permissions: [89, 90, 91, 92, 93, 94]
      },
      children: [{
        path: 'article',
        name: 'ArticleList',
        component: __WEBPACK_IMPORTED_MODULE_27__views_content_articles_Index___default.a,
        meta: {
          permissions: [104, 105, 106, 107, 108, 109]
        },
        children: [{
          path: 'edit/:id',
          name: 'ArticleEdit',
          component: __WEBPACK_IMPORTED_MODULE_28__views_content_articles_Edit___default.a
        }, {
          path: 'new',
          name: 'ArticlesNew',
          component: __WEBPACK_IMPORTED_MODULE_29__views_content_articles_New___default.a
        }]
      }, {
        path: 'book',
        name: 'LetterbookList',
        component: __WEBPACK_IMPORTED_MODULE_36__views_content_letterbooks_Index___default.a,
        meta: {
          permissions: [110, 111, 112, 113, 114, 115]
        },
        children: [{
          path: 'edit/:id',
          name: 'LetterbookEdit',
          component: __WEBPACK_IMPORTED_MODULE_37__views_content_letterbooks_Edit___default.a
        }, {
          path: 'new',
          name: 'LetterbookNew',
          component: __WEBPACK_IMPORTED_MODULE_38__views_content_letterbooks_New___default.a
        }]
      }, {
        path: 'correspondence',
        name: 'CorrespondenceList',
        component: __WEBPACK_IMPORTED_MODULE_17__views_content_correspondence_Index___default.a,
        meta: {
          permissions: [120, 121, 122, 123, 124, 125]
        },
        children: [{
          path: 'edit/:id',
          name: 'CorrespondenceEdit',
          component: __WEBPACK_IMPORTED_MODULE_18__views_content_correspondence_Edit___default.a
        }, {
          path: 'new',
          name: 'CorrespondenceNew',
          component: __WEBPACK_IMPORTED_MODULE_19__views_content_correspondence_New___default.a
        }]
      }, {
        path: 'document_files',
        name: 'DocumentFilesList',
        component: __WEBPACK_IMPORTED_MODULE_56__views_content_documentFiles_Index___default.a,
        meta: {
          permissions: [193, 194, 195, 196, 197, 198]
        },
        children: [{
          path: 'edit/:id',
          name: 'DocumentFilesEdit',
          component: __WEBPACK_IMPORTED_MODULE_57__views_content_documentFiles_Edit___default.a
        }, {
          path: 'manage-docs/:id',
          name: 'DocumentFilesManageDocs',
          component: __WEBPACK_IMPORTED_MODULE_59__views_content_documentFiles_ManageDocs___default.a
        }, {
          path: 'add-docs/:id',
          name: 'DocumentFilesAddDocs',
          component: __WEBPACK_IMPORTED_MODULE_60__views_content_documentFiles_AddDocs___default.a
        }, {
          path: 'new',
          name: 'DocumentFilesNew',
          component: __WEBPACK_IMPORTED_MODULE_58__views_content_documentFiles_New___default.a
        }]
      }, {
        path: 'event',
        name: 'EventList',
        component: __WEBPACK_IMPORTED_MODULE_39__views_content_events_Index___default.a,
        meta: {
          permissions: [126, 127, 128, 129, 130, 131]
        },
        children: [{
          path: 'edit/:id',
          name: 'EventEdit',
          component: __WEBPACK_IMPORTED_MODULE_40__views_content_events_Edit___default.a
        }, {
          path: 'new',
          name: 'EventNew',
          component: __WEBPACK_IMPORTED_MODULE_41__views_content_events_New___default.a
        }]
      }, {
        path: 'faq',
        name: 'FaqList',
        component: __WEBPACK_IMPORTED_MODULE_85__views_content_faq_Index___default.a,
        meta: {
          permissions: [132, 133, 134, 135, 136, 137]
        },
        children: [{
          path: 'edit/:id',
          name: 'FaqEdit',
          component: __WEBPACK_IMPORTED_MODULE_86__views_content_faq_Edit___default.a
        }, {
          path: 'new',
          name: 'FaqNew',
          component: __WEBPACK_IMPORTED_MODULE_87__views_content_faq_New___default.a
        }]
      }, {
        path: 'lesson',
        name: 'LessonList',
        component: __WEBPACK_IMPORTED_MODULE_30__views_content_lessons_Index___default.a,
        meta: {
          permissions: [139, 140, 141, 142, 143, 144]
        },
        children: [{
          path: 'edit/:id',
          name: 'LessonEdit',
          component: __WEBPACK_IMPORTED_MODULE_31__views_content_lessons_Edit___default.a
        }, {
          path: 'new',
          name: 'LessonNew',
          component: __WEBPACK_IMPORTED_MODULE_32__views_content_lessons_New___default.a
        }]
      }, {
        path: 'location',
        name: 'LocationList',
        component: __WEBPACK_IMPORTED_MODULE_33__views_content_locations_Index___default.a,
        meta: {
          permissions: [145, 146, 147, 148, 149, 150]
        },
        children: [{
          path: 'edit/:id',
          name: 'LocationEdit',
          component: __WEBPACK_IMPORTED_MODULE_34__views_content_locations_Edit___default.a
        }, {
          path: 'new',
          name: 'LocationNew',
          component: __WEBPACK_IMPORTED_MODULE_35__views_content_locations_New___default.a
        }]
      }, {
        path: 'media_audio',
        name: 'AudioList',
        component: __WEBPACK_IMPORTED_MODULE_61__views_content_audio_Index___default.a,
        meta: {
          permissions: [181, 182, 183, 184, 185, 186]
        },
        children: [{
          path: 'edit/:id',
          name: 'AudioEdit',
          component: __WEBPACK_IMPORTED_MODULE_62__views_content_audio_Edit___default.a
        }, {
          path: 'new',
          name: 'AudioNew',
          component: __WEBPACK_IMPORTED_MODULE_63__views_content_audio_New___default.a
        }]
      }, {
        path: 'media_audio_album',
        name: 'AlbumList',
        component: __WEBPACK_IMPORTED_MODULE_64__views_content_albums_Index___default.a,
        meta: {
          permissions: [175, 176, 177, 178, 179, 180]
        },
        children: [{
          path: 'edit/:id',
          name: 'AlbumEdit',
          component: __WEBPACK_IMPORTED_MODULE_65__views_content_albums_Edit___default.a
        }, {
          path: 'manage-tracks/:id',
          name: 'AlbumManageTracks',
          component: __WEBPACK_IMPORTED_MODULE_67__views_content_albums_ManageTracks___default.a
        }, {
          path: 'order-tracks/:id',
          name: 'AlbumOrderTracks',
          component: __WEBPACK_IMPORTED_MODULE_68__views_content_albums_OrderTracks___default.a
        }, {
          path: 'add-tracks/:id',
          name: 'AlbumAddTracks',
          component: __WEBPACK_IMPORTED_MODULE_69__views_content_albums_AddTracks___default.a
        }, {
          path: 'new',
          name: 'AlbumNew',
          component: __WEBPACK_IMPORTED_MODULE_66__views_content_albums_New___default.a
        }]
      }, {
        path: 'media_doc',
        name: 'DocumentList',
        component: __WEBPACK_IMPORTED_MODULE_53__views_content_documents_Index___default.a,
        meta: {
          permissions: [187, 188, 189, 190, 191, 192]
        },
        children: [{
          path: 'edit/:id',
          name: 'DocumentEdit',
          component: __WEBPACK_IMPORTED_MODULE_54__views_content_documents_Edit___default.a
        }, {
          path: 'new',
          name: 'DocumentNew',
          component: __WEBPACK_IMPORTED_MODULE_55__views_content_documents_New___default.a
        }]
      }, {
        path: 'issues_and_answers',
        name: 'IssuesAndAnswersList',
        component: __WEBPACK_IMPORTED_MODULE_42__views_content_issuesAndAnswers_Index___default.a,
        meta: {
          permissions: [248, 249, 250, 251, 252, 253]
        },
        children: [{
          path: 'edit/:id',
          name: 'IssuesAndAnswersEdit',
          component: __WEBPACK_IMPORTED_MODULE_43__views_content_issuesAndAnswers_Edit___default.a
        }, {
          path: 'new',
          name: 'IssuesAndAnswersNew',
          component: __WEBPACK_IMPORTED_MODULE_44__views_content_issuesAndAnswers_New___default.a
        }]
      }, {
        path: 'media_image',
        name: 'ImageList',
        component: __WEBPACK_IMPORTED_MODULE_45__views_content_images_Index___default.a,
        meta: {
          permissions: [157, 158, 159, 160, 161, 162]
        },
        children: [{
          path: 'edit/:id',
          name: 'ImageEdit',
          component: __WEBPACK_IMPORTED_MODULE_46__views_content_images_Edit___default.a
        }, {
          path: 'new',
          name: 'ImageNew',
          component: __WEBPACK_IMPORTED_MODULE_47__views_content_images_New___default.a
        }]
      }, {
        path: 'media_image_gallery',
        name: 'GalleryList',
        component: __WEBPACK_IMPORTED_MODULE_48__views_content_gallery_Index___default.a,
        meta: {
          permissions: [151, 152, 153, 154, 155, 156]
        },
        children: [{
          path: 'edit/:id',
          name: 'GalleryEdit',
          component: __WEBPACK_IMPORTED_MODULE_50__views_content_gallery_Edit___default.a
        }, {
          path: 'manage-images/:id',
          name: 'GalleryManageImages',
          component: __WEBPACK_IMPORTED_MODULE_51__views_content_gallery_ManageImages___default.a
        }, {
          path: 'add-images/:id',
          name: 'GalleryAddImages',
          component: __WEBPACK_IMPORTED_MODULE_52__views_content_gallery_AddImages___default.a
        }, {
          path: 'new',
          name: 'GalleryNew',
          component: __WEBPACK_IMPORTED_MODULE_49__views_content_gallery_New___default.a
        }]
      }, {
        path: 'media_video',
        name: 'VideoList',
        component: __WEBPACK_IMPORTED_MODULE_70__views_content_video_Index___default.a,
        meta: {
          permissions: [169, 170, 171, 172, 173, 174]
        },
        children: [{
          path: 'edit/:id',
          name: 'VideoEdit',
          component: __WEBPACK_IMPORTED_MODULE_71__views_content_video_Edit___default.a
        }, {
          path: 'new',
          name: 'VideoNew',
          component: __WEBPACK_IMPORTED_MODULE_72__views_content_video_New___default.a
        }]
      }, {
        path: 'media_video_series',
        name: 'VideoSeriesList',
        component: __WEBPACK_IMPORTED_MODULE_73__views_content_videoSeries_Index___default.a,
        meta: {
          permissions: [163, 164, 165, 166, 167, 168]
        },
        children: [{
          path: 'edit/:id',
          name: 'VideoSeriesEdit',
          component: __WEBPACK_IMPORTED_MODULE_74__views_content_videoSeries_Edit___default.a
        }, {
          path: 'manage-videos/:id',
          name: 'VideoSeriesManageVideos',
          component: __WEBPACK_IMPORTED_MODULE_76__views_content_videoSeries_ManageVideos___default.a
        }, {
          path: 'order-videos/:id',
          name: 'VideoSeriesOrderVideos',
          component: __WEBPACK_IMPORTED_MODULE_77__views_content_videoSeries_OrderVideos___default.a
        }, {
          path: 'add-videos/:id',
          name: 'VideoSeriesAddVideos',
          component: __WEBPACK_IMPORTED_MODULE_78__views_content_videoSeries_AddVideos___default.a
        }, {
          path: 'new',
          name: 'VideoSeriesNew',
          component: __WEBPACK_IMPORTED_MODULE_75__views_content_videoSeries_New___default.a
        }]
      }, {
        path: 'news',
        name: 'NewsList',
        component: __WEBPACK_IMPORTED_MODULE_24__views_content_news_Index___default.a,
        meta: {
          permissions: [199, 200, 201, 202, 203, 204]
        },
        children: [{
          path: 'edit/:id',
          name: 'NewsEdit',
          component: __WEBPACK_IMPORTED_MODULE_25__views_content_news_Edit___default.a
        }, {
          path: 'new',
          name: 'NewsNew',
          component: __WEBPACK_IMPORTED_MODULE_26__views_content_news_New___default.a
        }]
      }, {
        path: 'pamphlet',
        name: 'PamphletList',
        component: __WEBPACK_IMPORTED_MODULE_79__views_content_pamphlets_Index___default.a,
        meta: {
          permissions: [205, 206, 207, 208, 209, 210]
        },
        children: [{
          path: 'edit/:id',
          name: 'PamphletEdit',
          component: __WEBPACK_IMPORTED_MODULE_80__views_content_pamphlets_Edit___default.a
        }, {
          path: 'new',
          name: 'PamphletNew',
          component: __WEBPACK_IMPORTED_MODULE_81__views_content_pamphlets_New___default.a
        }]
      }, {
        path: 'person',
        name: 'PersonList',
        component: __WEBPACK_IMPORTED_MODULE_20__views_content_people_Index___default.a,
        meta: {
          permissions: [211, 212, 213, 214, 215, 216, 217]
        },
        children: [{
          path: 'edit/:id',
          name: 'PersonEdit',
          component: __WEBPACK_IMPORTED_MODULE_22__views_content_people_Edit___default.a
        }, {
          path: ':id/duplicates',
          name: 'PersonDuplicates',
          component: __WEBPACK_IMPORTED_MODULE_21__views_content_people_Duplicates___default.a
        }, {
          path: 'new',
          name: 'PersonNew',
          component: __WEBPACK_IMPORTED_MODULE_23__views_content_people_New___default.a
        }]
      }, {
        path: 'publication',
        name: 'PublicationList',
        component: __WEBPACK_IMPORTED_MODULE_14__views_content_publication_Index___default.a,
        meta: {
          permissions: [218, 219, 220, 221, 222, 223]
        },
        children: [{
          path: 'edit/:id',
          name: 'PublicationEdit',
          component: __WEBPACK_IMPORTED_MODULE_15__views_content_publication_Edit___default.a
        }, {
          path: 'new',
          name: 'PublicationNew',
          component: __WEBPACK_IMPORTED_MODULE_16__views_content_publication_New___default.a
        }]
      }, {
        path: 'questions_and_answers',
        name: 'QaList',
        component: __WEBPACK_IMPORTED_MODULE_120__views_content_qa_Index___default.a,
        meta: {
          permissions: [224, 225, 226, 227, 228, 229]
        },
        children: [{
          path: 'edit/:id',
          name: 'QaEdit',
          component: __WEBPACK_IMPORTED_MODULE_121__views_content_qa_Edit___default.a
        }, {
          path: 'new',
          name: 'QaNew',
          component: __WEBPACK_IMPORTED_MODULE_122__views_content_qa_New___default.a
        }, {
          path: 'manage-docs/:id',
          name: 'QaManageDocs',
          component: __WEBPACK_IMPORTED_MODULE_123__views_content_qa_ManageDocs___default.a
        }, {
          path: 'add-docs/:id',
          name: 'QaAddDocs',
          component: __WEBPACK_IMPORTED_MODULE_124__views_content_qa_AddDocs___default.a
        }]
      }, {
        path: 'topic',
        name: 'TopicList',
        component: __WEBPACK_IMPORTED_MODULE_82__views_content_topics_Index___default.a,
        meta: {
          permissions: [242, 243, 244, 245, 246, 247]
        },
        children: [{
          path: 'edit/:id',
          name: 'TopicEdit',
          component: __WEBPACK_IMPORTED_MODULE_83__views_content_topics_Edit___default.a
        }, {
          path: 'new',
          name: 'TopicNew',
          component: __WEBPACK_IMPORTED_MODULE_84__views_content_topics_New___default.a
        }]
      }]
    }, {
      path: 'puzzle-game-images',
      name: 'Puzzle Game',
      component: __WEBPACK_IMPORTED_MODULE_125__views_games_puzzles_Index___default.a,
      meta: {
        permissions: [254]
      },
      children: [{
        path: 'new',
        name: 'Add Puzzle Image',
        component: __WEBPACK_IMPORTED_MODULE_126__views_games_puzzles_New___default.a
      }, {
        path: 'edit/:id',
        name: 'Edit Puzzle Image',
        component: __WEBPACK_IMPORTED_MODULE_127__views_games_puzzles_Edit___default.a
      }]
    }, {
      path: 'memory-game-images',
      name: 'Memory Game',
      component: __WEBPACK_IMPORTED_MODULE_128__views_games_memory_Index___default.a,
      meta: {
        permissions: [254]
      },
      children: [{
        path: 'new',
        name: 'Add Memory Image',
        component: __WEBPACK_IMPORTED_MODULE_129__views_games_memory_New___default.a,
        props: true
      }, {
        path: 'edit/:id',
        name: 'Edit Memory Image',
        component: __WEBPACK_IMPORTED_MODULE_130__views_games_memory_Edit___default.a,
        props: true
      }]
    }, {
      path: 'painting-game-images',
      name: 'Painting Game',
      component: __WEBPACK_IMPORTED_MODULE_131__views_games_painting_Index___default.a,
      meta: {
        permissions: [254]
      },
      children: [{
        path: 'new',
        name: 'Add Painting Image',
        component: __WEBPACK_IMPORTED_MODULE_132__views_games_painting_New___default.a,
        props: true
      }, {
        path: 'edit/:id',
        name: 'Edit Painting Image',
        component: __WEBPACK_IMPORTED_MODULE_133__views_games_painting_Edit___default.a,
        props: true
      }]
    }, {
      path: 'quiz-game-images',
      name: 'Quiz Game',
      component: __WEBPACK_IMPORTED_MODULE_134__views_games_quiz_Index___default.a,
      meta: {
        permissions: [254]
      },
      children: [{
        path: 'new',
        name: 'Add Quiz Image',
        component: __WEBPACK_IMPORTED_MODULE_135__views_games_quiz_New___default.a,
        props: true
      }, {
        path: 'edit/:id',
        name: 'Edit Quiz Image',
        component: __WEBPACK_IMPORTED_MODULE_136__views_games_quiz_Edit___default.a,
        props: true
      }]
    }, {
      path: 'editors-picks',
      name: 'Editors Picks',
      component: __WEBPACK_IMPORTED_MODULE_137__views_editorsPicks_EditorsPicksList_vue___default.a,
      meta: {
        permissions: [255]
      },
      children: [{
        path: 'edit-articles',
        name: 'Editors Picks Edit Articles',
        component: __WEBPACK_IMPORTED_MODULE_138__views_editorsPicks_EditorsPicksEditArticles_vue___default.a
      }, {
        path: 'edit-faq',
        name: 'Editors Picks Edit FAQ',
        component: __WEBPACK_IMPORTED_MODULE_139__views_editorsPicks_EditorsPicksEditFAQ_vue___default.a
      }, {
        path: 'edit-documents',
        name: 'Editors Picks Edit Documents',
        component: __WEBPACK_IMPORTED_MODULE_140__views_editorsPicks_EditorsPicksEditDocuments_vue___default.a
      }]
    }]
  }, {
    path: '*',
    redirect: localStorage.getItem('tokenStorage') ? '/admin/dashboard' : '/login'
  }]
});

router.beforeEach(function (to, from, next) {
  document.getElementsByTagName('html')[0].scrollTop = 0;

  if (to.matched.some(function (record) {
    return record.meta.permissions;
  })) {
    var metaPermissions = to.matched.reduce(function (accumulator, currentValue) {
      if (currentValue.meta.permissions) {
        return accumulator.concat(currentValue.meta.permissions);
      }
      return accumulator;
    }, []);
    var permissions = [];
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.info && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.info.roles) {
      permissions = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters['user/getPermissions'];
    } else {
      try {
        var user = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userStorage.name));
        var permissionsArrs = user.roles.map(function (role) {
          return role.permissions;
        });
        for (var i = 0; i < permissionsArrs.length; i += 1) {
          permissions = permissions.concat(permissionsArrs[i]);
        }
      } catch (error) {
        permissions = [];
      }
    }
    permissions = permissions.map(function (item) {
      return item.id;
    });
    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.xor(permissions, metaPermissions).length === permissions.length + metaPermissions.length) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('notifications/setDangerNotification', 'Access denied!');
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(947),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(894),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(896),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(590)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6087e34a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(815),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(837),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1011)));

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1013)));

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1014)));

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1019)));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: {
      type: String,
      default: ''
    }
  },

  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      var newVal = item;
      if (newVal.meta && newVal.meta.label) {
        newVal = newVal.meta && newVal.meta.label;
      }
      if (newVal.name) {
        newVal = newVal.name;
      }
      return newVal;
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppFooter',

  methods: {
    getYear: function getYear() {
      var date = new Date();
      return date.getFullYear();
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_uploadManager_UploadManager__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_uploadManager_UploadManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_uploadManager_UploadManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navbar__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Navbar__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppHeader',

  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_1__Navbar___default.a,
    UploadManager: __WEBPACK_IMPORTED_MODULE_0__views_uploadManager_UploadManager___default.a
  },

  methods: {
    click: function click() {},
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_components_modals_MenuItem__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_components_modals_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__global_components_modals_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_modals_TermItem__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_modals_TermItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_modals_TermItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_modals_SelectelUpload__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_modals_SelectelUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_modals_SelectelUpload__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modals',

  components: {
    MenuItemModal: __WEBPACK_IMPORTED_MODULE_0__global_components_modals_MenuItem___default.a,
    TermItemModal: __WEBPACK_IMPORTED_MODULE_1__global_components_modals_TermItem___default.a,
    SelectelUploadModal: __WEBPACK_IMPORTED_MODULE_2__global_components_modals_SelectelUpload___default.a
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Navbar',

  created: function created() {
    this._navbar = true;
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Notifications',

  data: function data() {
    return {
      notifications: {
        danger: '',
        warning: '',
        success: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.notifications.success;
    }, function (newVal) {
      _this.notifications.success = newVal;
      if (newVal) _this.clearSuccess();
    }, { deep: true });
    this.$store.watch(function (state) {
      return state.notifications.warning;
    }, function (newVal) {
      _this.notifications.warning = newVal;
      if (newVal) _this.clearWarning();
    }, { deep: true });
    this.$store.watch(function (state) {
      return state.notifications.danger;
    }, function (newVal) {
      _this.notifications.danger = newVal;
      if (newVal) _this.clearDanger();
    }, { deep: true });
  },


  methods: {
    closeDanger: function closeDanger() {
      this.$store.commit('notifications/setDangerNotification', '');
    },
    closeWarning: function closeWarning() {
      this.$store.commit('notifications/setWarningNotification', '');
    },
    closeSuccess: function closeSuccess() {
      this.$store.commit('notifications/setSuccessNotification', '');
    },

    clearDanger: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.$store.commit('notifications/setDangerNotification', '');
    }, 7000),
    clearWarning: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.$store.commit('notifications/setWarningNotification', '');
    }, 7000),
    clearSuccess: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.$store.commit('notifications/setSuccessNotification', '');
    }, 7000)
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_menu__ = __webpack_require__(69);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',

  data: function data() {
    return {
      menu: __WEBPACK_IMPORTED_MODULE_1__helpers_menu__["b" /* menu */]
    };
  },

  computed: {
    userPermissions: function userPermissions() {
      return this.$store.getters['user/getPermissions'];
    }
  },

  methods: {
    checkAccess: function checkAccess(li) {
      var permissionsArr = li.permissions || [];
      if (li.children) {
        for (var i = 0; i < li.children.length; i += 1) {
          if (li.children[i].permissions) {
            permissionsArr = permissionsArr.concat(li.children[i].permissions);
          }
        }
      }
      if (!permissionsArr.length) return true;
      var xorPermissions = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.xor(permissionsArr, this.userPermissions.map(function (item) {
        return item.id;
      }));
      return xorPermissions.length !== permissionsArr.length + this.userPermissions.length;
    },
    checkNestedAccess: function checkNestedAccess(li, parentLi) {
      var permissionsArr = li.permissions || [];
      if (parentLi.permissions) permissionsArr = permissionsArr.concat(parentLi.permissions);
      if (!permissionsArr.length) return true;
      var xorPermissions = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.xor(permissionsArr, this.userPermissions.map(function (item) {
        return item.id;
      }));
      return xorPermissions.length !== permissionsArr.length + this.userPermissions.length;
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    signOut: function signOut() {
      localStorage.setItem('tokenStorage', '');
      this.$store.commit('user/storeAccessToken', '');
      this.$store.commit('user/setInfo', '');
      window.location.href = '/#/login';
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modals__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Modals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Notifications__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(13);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Full',

  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_Footer___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb___default.a,
    Modals: __WEBPACK_IMPORTED_MODULE_4__components_Modals___default.a,
    Notifications: __WEBPACK_IMPORTED_MODULE_5__components_Notifications___default.a
  },

  computed: {
    list: function list() {
      return this.$route.matched;
    }
  },

  created: function created() {
    var _this = this;

    var meta = this.$route.meta;

    if (Object.prototype.hasOwnProperty.call(meta, 'dontNeedAuth') && meta.dontNeedAuth) return;

    if (!localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].tokenStorage.name) || !localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userStorage.name)) {
      this.$logout();
    } else {
      try {
        var user = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userStorage.name));
        var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].tokenStorage.name));
        this.$store.commit('user/setInfo', user);
        this.$store.commit('user/storeAccessToken', token);

        this.$assignAxiosHeaders(token.access_token);
      } catch (error) {
        this.$logout();
      }

      this.$apiHttp(this.$config.app_api.prefix + 'content-types/').then(function (response) {
        _this.$store.commit('contentTypes/setContentTypesList', response.data);
      }).catch(function (error) {
        console.error('Error in get content types query', error);
      });
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    entityType: {
      type: String,
      default: ''
    },
    choosenEntities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showIndexBtn: {
      type: Boolean,
      default: false
    },
    unpublishEmptyEndpoint: {
      type: String,
      default: ''
    }
  },

  methods: {
    deleteEntities: function deleteEntities() {
      var _this = this;

      if (window.confirm('Do you really want to delete these entities?')) {
        var postFormData = new FormData();
        var prefix = this.$config.app_api.prefix;

        var $loader = $(this.$refs.bulkDeleteLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (var i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(prefix + 'content-types/bulk-delete', postFormData).then(function () {
          _this.$emit('clearChoosenEntities');
          $loader.hide();
          _this.$parent.getSource();
        }).catch(function (error) {
          $loader.hide();
          console.error('Bulk delete error', error);
        });
      }
    },
    addToIndex: function addToIndex() {
      var _this2 = this;

      var postFormData = new FormData();
      var prefix = this.$config.app_api.prefix;

      var $loader = $(this.$refs.bulkSearchIndexLoader);
      for (var i = 0; i < this.choosenEntities.length; i += 1) {
        postFormData.append('ids[]', this.choosenEntities[i]);
      }
      $loader.show();
      this.$apiHttp.post(prefix + 'search/documents/' + this.entityType, postFormData).then(function () {
        _this2.$emit('clearChoosenEntities');
        $loader.hide();
      }).catch(function (error) {
        $loader.hide();
        console.error('Bulk delete error', error);
      });
    },
    publish: function publish() {
      var _this3 = this;

      if (window.confirm('Do you really want to publish these entities?')) {
        var postFormData = new FormData();
        var prefix = this.$config.app_api.prefix;

        var $loader = $(this.$refs.bulkPublishLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (var i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(prefix + 'content-types/publish', postFormData).then(function () {
          _this3.$emit('changePublishedBtns', true);
          _this3.$emit('clearChoosenEntities');
          $loader.hide();
        }).catch(function (error) {
          $loader.hide();
          console.error('Bulk publish error', error);
        });
      }
    },
    unpublish: function unpublish() {
      var _this4 = this;

      if (window.confirm('Do you really want to unpublish these entities?')) {
        var postFormData = new FormData();
        var prefix = this.$config.app_api.prefix;

        var $loader = $(this.$refs.bulkUnpublishLoader);
        postFormData.append('namespace', this.$store.state.contentTypes.list[this.entityType].namespace);
        for (var i = 0; i < this.choosenEntities.length; i += 1) {
          postFormData.append('ids[]', this.choosenEntities[i]);
        }
        $loader.show();
        this.$apiHttp.post(prefix + 'content-types/unpublish', postFormData).then(function () {
          _this4.$emit('changePublishedBtns', false);
          _this4.$emit('clearChoosenEntities');
          $loader.hide();
        }).catch(function (error) {
          $loader.hide();
          console.error('Bulk unpublish error', error);
        });
      }
    },
    unpublishEmpty: function unpublishEmpty() {
      if (window.confirm('Do you really want to delete empty entities?')) {
        var $loader = $(this.$refs.unpublishEmptyLoader);
        $loader.show();
        this.$apiHttp.post('' + this.$config.app_api.prefix + this.unpublishEmptyEndpoint).then(function () {
          $loader.hide();
        }).catch(function (error) {
          $loader.hide();
          console.error('Bulk unpublish error', error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '200px'
    },
    language: {
      type: String,
      default: 'en'
    },
    extraplugins: {
      type: String,
      default: ''
    }
  },

  beforeUpdate: function beforeUpdate() {
    var ckeditorId = this.id;
    if (this.value !== window.CKEDITOR.instances[ckeditorId].getData()) {
      window.CKEDITOR.instances[ckeditorId].setData(this.value);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var ckeditorId = this.id;

    window.CKEDITOR.plugins.addExternal('brclear', '/static/js/ckeditor/plugins/brclear/plugin.js');

    window.CKEDITOR.replace(ckeditorId, {
      language: 'en',

      toolbar: [{ name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, { name: 'colors', items: ['TextColor', 'BGColor'] }, { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'brclear'] }, '/', { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting'] }, { name: 'links', items: ['Link', 'Unlink'] }, { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] }, { name: 'insert', items: ['Image', 'Table', 'HorizontalRule'] }, { name: 'tools', items: ['Maximize'] }, { name: 'editing', items: ['Scayt'] }, { name: 'document', items: ['Source'] }],

      extraAllowedContent: 'h3{clear};h2{line-height};h2 h3{margin-left,margin-top};*{clear}',

      extraPlugins: 'format,font,colorbutton,justify,uploadimage,brclear',
      uploadUrl: '/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',

      filebrowserUploadUrl: this.$config.app_api.host + 'wysiwyg/upload-image',


      height: this.height
    });

    window.CKEDITOR.instances[ckeditorId].setData(this.value);

    window.CKEDITOR.instances[ckeditorId].on('change', function () {
      var ckeditorData = window.CKEDITOR.instances[ckeditorId].getData();
      if (ckeditorData !== _this.value) {
        _this.$emit('input', ckeditorData);
      }
    });
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'MM/dd/yyyy'
    },
    disabledDaysOfWeek: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    width: {
      type: String,
      default: ''
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: navigator.language
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    iconsFont: {
      type: String,
      default: 'glyphicon'
    }
  },

  data: function data() {
    return {
      currDate: new Date(),
      dateRange: [],
      decadeRange: [],
      displayDayView: false,
      displayMonthView: false,
      displayYearView: false,
      val: this.value,
      text: {
        daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        limit: 'Limit reached ({{limit}} items max).',
        loading: 'Loading...',
        minLength: 'Min. Length',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        notSelected: 'Nothing Selected',
        required: 'Required',
        search: 'Search',
        selected: '{{count}} selected'
      }
    };
  },


  computed: {
    preBtnClasses: function preBtnClasses() {
      return 'datepicker-preBtn ' + this.iconsFont + ' ' + this.iconsFont + '-chevron-left';
    },
    nextBtnClasses: function nextBtnClasses() {
      return 'datepicker-nextBtn ' + this.iconsFont + ' ' + this.iconsFont + '-chevron-right';
    },
    disabledDaysArray: function disabledDaysArray() {
      return this.disabledDaysOfWeek.map(function (d) {
        return parseInt(d, 10);
      });
    }
  },

  watch: {
    currDate: function currDate() {
      this.getDateRange();
    },
    format: function format() {
      this.val = this.stringify(this.currDate);
    },
    val: function val(_val) {
      this.$emit('input', _val);
    },
    value: function value(val) {
      if (this.val !== val) {
        this.val = val;
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$emit('child-created', this);
    this.currDate = this.val ? this.parse(this.val) : this.parse(new Date());
    this._blur = function (e) {
      if (!_this.$el.contains(e.target)) {
        _this.close();
      }
    };
    window.addEventListener('click', this._blur);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('click', this._blur);
  },


  methods: {
    close: function close() {
      this.displayDayView = false;
      this.displayMonthView = false;
      this.displayYearView = false;
    },
    inputClick: function inputClick() {
      this.currDate = this.parse(this.val) || this.parse(new Date());
      if (this.displayMonthView || this.displayYearView) {
        this.displayDayView = false;
      } else {
        this.displayDayView = !this.displayDayView;
      }
    },
    preNextDecadeClick: function preNextDecadeClick(flag) {
      var year = this.currDate.getFullYear();
      var months = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 10, months, date);
      } else {
        this.currDate = new Date(year + 10, months, date);
      }
    },
    preNextMonthClick: function preNextMonthClick(flag) {
      var year = this.currDate.getFullYear();
      var month = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        var preMonth = this.getYearMonth(year, month - 1);
        this.currDate = new Date(preMonth.year, preMonth.month, date);
      } else {
        var nextMonth = this.getYearMonth(year, month + 1);
        this.currDate = new Date(nextMonth.year, nextMonth.month, date);
      }
    },
    preNextYearClick: function preNextYearClick(flag) {
      var year = this.currDate.getFullYear();
      var months = this.currDate.getMonth();
      var date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 1, months, date);
      } else {
        this.currDate = new Date(year + 1, months, date);
      }
    },
    yearSelect: function yearSelect(year) {
      this.displayYearView = false;
      this.displayMonthView = true;
      this.currDate = new Date(year, this.currDate.getMonth(), this.currDate.getDate());
    },
    daySelect: function daySelect(day) {
      if (day.sclass === 'datepicker-item-disable') return;
      this.currDate = day.date;
      this.val = this.stringify(this.currDate);
      this.displayDayView = false;
    },
    switchMonthView: function switchMonthView() {
      this.displayDayView = false;
      this.displayMonthView = true;
    },
    switchDecadeView: function switchDecadeView() {
      this.displayMonthView = false;
      this.displayYearView = true;
    },
    monthSelect: function monthSelect(index) {
      this.displayMonthView = false;
      this.displayDayView = true;
      this.currDate = new Date(this.currDate.getFullYear(), index, this.currDate.getDate());
    },
    getYearMonth: function getYearMonth(year, month) {
      var obj = { year: year, month: month };
      if (month > 11) {
        obj.year += 1;
        obj.month = 0;
      } else if (month < 0) {
        obj.year -= 1;
        obj.month = 11;
      }
      return obj;
    },
    stringifyDecadeHeader: function stringifyDecadeHeader(date) {
      var yearStr = date.getFullYear().toString();
      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0;
      var lastYearOfDecade = parseInt(firstYearOfDecade, 10) + 10;
      return firstYearOfDecade + '-' + lastYearOfDecade;
    },
    stringifyDayHeader: function stringifyDayHeader(date) {
      return this.text.months[date.getMonth()] + ' ' + date.getFullYear();
    },
    parseMonth: function parseMonth(date) {
      return this.text.months[date.getMonth()];
    },
    stringifyYearHeader: function stringifyYearHeader(date) {
      return date.getFullYear();
    },
    stringify: function stringify(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.format;

      var newDate = date;
      if (!newDate) newDate = this.parse();
      if (!newDate) return '';
      var year = newDate.getFullYear();
      var month = newDate.getMonth() + 1;
      var day = newDate.getDate();
      var monthName = this.parseMonth(newDate);
      return format.replace(/yyyy/g, year).replace(/yy/g, year).replace(/MMMM/g, monthName).replace(/MMM/g, monthName.substring(0, 3)).replace(/MM/g, ('0' + month).slice(-2)).replace(/M(?!a)/g, month).replace(/dd/g, ('0' + day).slice(-2)).replace(/d/g, day);
    },
    parse: function parse(str) {
      var newStr = str;
      if (!newStr && !this.val) {
        return new Date();
      }
      if (newStr === undefined || newStr === null) newStr = this.val;
      var date = newStr.length === 10 && (this.format === 'dd-MM-yyyy' || this.format === 'dd/MM/yyyy') ? new Date(newStr.substring(6, 10), newStr.substring(3, 5) - 1, newStr.substring(0, 2)) : new Date(newStr);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(date.getFullYear()) ? new Date() : date;
    },
    getDayCount: function getDayCount(year, month) {
      var dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (month === 1) {
        if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) {
          return 29;
        }
      }
      return dict[month];
    },
    getDateRange: function getDateRange() {
      this.dateRange = [];
      this.decadeRange = [];
      var time = {
        year: this.currDate.getFullYear(),
        month: this.currDate.getMonth(),
        day: this.currDate.getDate()
      };
      var yearStr = time.year.toString();
      var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0 - 1;
      for (var i = 0; i < 12; i += 1) {
        this.decadeRange.push({
          text: firstYearOfDecade + i
        });
      }

      var currMonthFirstDay = new Date(time.year, time.month, 1);
      var firstDayWeek = currMonthFirstDay.getDay() + 1;
      if (firstDayWeek === 0) {
        firstDayWeek = 7;
      }
      var dayCount = this.getDayCount(time.year, time.month);
      if (firstDayWeek > 1) {
        var preMonth = this.getYearMonth(time.year, time.month - 1);
        var prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month);
        for (var _i = 1; _i < firstDayWeek; _i += 1) {
          var dayText = prevMonthDayCount - firstDayWeek + _i + 1;
          var date = new Date(preMonth.year, preMonth.month, dayText);
          var sclass = 'datepicker-item-gray';
          if (this.disabledDaysArray.indexOf(date.getDay()) > -1) {
            sclass = 'datepicker-item-disable';
          }
          this.dateRange.push({ text: dayText, date: date, sclass: sclass });
        }
      }

      for (var _i2 = 1; _i2 <= dayCount; _i2 += 1) {
        var _date = new Date(time.year, time.month, _i2);
        var _sclass = '';
        if (this.disabledDaysArray.indexOf(_date.getDay()) > -1) {
          _sclass = 'datepicker-item-disable';
        }
        if (_i2 === time.day && _date.getFullYear() === time.year && _date.getMonth() === time.month) {
          _sclass = 'datepicker-dateRange-item-active';
        }
        this.dateRange.push({ text: _i2, date: _date, sclass: _sclass });
      }

      if (this.dateRange.length < 42) {
        var nextMonthNeed = 42 - this.dateRange.length;
        var nextMonth = this.getYearMonth(time.year, time.month + 1);

        for (var _i3 = 1; _i3 <= nextMonthNeed; _i3 += 1) {
          var _date2 = new Date(nextMonth.year, nextMonth.month, _i3);
          var _sclass2 = 'datepicker-item-gray';
          if (this.disabledDaysArray.indexOf(_date2.getDay()) > -1) {
            _sclass2 = 'datepicker-item-disable';
          }
          this.dateRange.push({ text: _i3, date: _date2, sclass: _sclass2 });
        }
      }
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    emptySearch: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    showEmpty: function showEmpty() {
      this.$emit('showEmpty');
    },
    showAll: function showAll() {
      this.$emit('showAll');
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    content: {
      type: Object,
      required: true
    }
  },

  methods: {
    attachFile: function attachFile() {
      this.$emit('attach-file', this.content.url);
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__File__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    File: __WEBPACK_IMPORTED_MODULE_0__File___default.a
  },

  props: {
    content: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    attachFile: function attachFile(url) {
      this.$emit('attach-file', url);
    },
    bdlClick: function bdlClick(event) {
      event.preventDefault();
      this.isOpen = !this.isOpen;
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectelUploader__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectelUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SelectelUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VideoQualityUploader__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VideoQualityUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__VideoQualityUploader__);











var SUCCESS = __WEBPACK_IMPORTED_MODULE_4__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    SelectelUploader: __WEBPACK_IMPORTED_MODULE_5__SelectelUploader___default.a,
    VideoQualityUploader: __WEBPACK_IMPORTED_MODULE_6__VideoQualityUploader___default.a
  },

  props: {
    dropzoneOptions: {
      type: Object,
      default: function _default() {
        return {
          url: '/'
        };
      }
    },
    defaultFile: {
      type: Object,
      default: null
    },
    defaultFiles: {
      type: Object,
      default: null
    },
    pathPrefix: {
      type: String,
      default: ''
    },
    checkType: {
      type: String,
      default: 'media_video'
    },
    vimeo: {
      type: String,
      default: ''
    },
    youtube: {
      type: String,
      default: ''
    },
    uploadingFile: {
      type: Object,
      default: null
    },
    uploadedFilesDictionary: {
      type: Object,
      default: null
    },
    startType: {
      type: String,
      default: 'file'
    }
  },

  data: function data() {
    return {
      uploadType: 'file',
      fileLink: '',
      file: null,
      linkStatus: null,
      lastCheckedLink: '',
      showSelectelList: false,
      selectelList: null,
      selectelLoading: false,
      youtubeLink: '',
      vimeoLink: '',
      qualityArray: [144, 240, 360, 480, 720, 1080]
    };
  },

  watch: {
    uploadType: function uploadType() {
      this.emitInput();
    },
    fileLink: function fileLink() {
      this.emitInput();
    },
    youtubeLink: function youtubeLink() {
      this.emitInput();
    },
    vimeoLink: function vimeoLink() {
      this.emitInput();
    },
    uploadingFile: function uploadingFile(val) {
      if (!this.$refs) return;
      if (!val) return;
      if (val.status === SUCCESS) {
        var dropzone = this.$refs.dropzone;

        dropzone.removeAllFiles();
        dropzone.manuallyAddFile(val.file, '' + this.$config.app_api.host + this.$config.app_api.prefix + '\n          /media/video/' + this.$route.params.id + '/file');
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        this.file = val.file;
      }
    },
    uploadedFilesDictionary: function uploadedFilesDictionary(val) {
      var _this = this;

      if (val) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).forEach(function (quality) {
          var dropzone = _this.$refs['dropzone' + quality];
          if (dropzone) {
            dropzone[0].removeAllFiles();
            dropzone[0].manuallyAddFile(val[quality]);
          }
        });
      }
    }
  },

  created: function created() {
    this.uploadType = this.startType;
    this.youtubeLink = this.youtube;
    this.vimeoLink = this.vimeo;
  },
  mounted: function mounted() {
    $(document).on('click', this.blurPopup);
    if (this.currentFile) {
      this.$refs.dropzone.manuallyAddFile(this.currentFile, '' + this.$config.app_api.host + this.$config.app_api.prefix + '\n        /media/video/' + this.$route.params.id + '/file');
    }
    if (this.defaultFile) {
      this.manuallyAddFile();
    }
    this.getSelectelFiles();
    this.emitInput();
  },
  beforeDestroy: function beforeDestroy() {
    $(document).off('click', this.blurPopup);
  },


  methods: {
    getSelectelFiles: function getSelectelFiles() {
      var _this2 = this;

      this.selectelLoading = true;
      this.$apiHttp.get(this.$config.app_api.prefix + 'selectel?prefix=' + this.pathPrefix).then(function (response) {
        _this2.selectelList = response.data;
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this2.selectelLoading = false;
      });
    },
    blurPopup: function blurPopup(e) {
      if (!$(e.target).hasClass('file-uploader__folder') && !$(e.target).parents('.file-uploader__folder').length) {
        this.showSelectelList = false;
      }
    },
    manuallyAddFile: function manuallyAddFile() {
      var file = {
        file: {
          name: this.defaultFile.file_name,
          size: this.defaultFile.size
        },
        url: this.defaultFile.public_url,
        thumb: this.defaultFile.thumbnail || 'static/img/file-thumb.jpg'
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.defaultFile.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    checkLink: function checkLink() {
      var _this3 = this;

      if (!this.fileLink) return;
      if (this.lastCheckedLink === this.fileLink) return;
      this.linkStatus = 'loading';
      this.lastCheckedLink = this.fileLink;
      var postFormData = new FormData();
      postFormData.append('selectel_file_url', this.fileLink);
      postFormData.append('content_type', this.checkType);
      this.$apiHttp.post(this.$config.app_api.prefix + 'selectel/check-link', postFormData).then(function () {
        _this3.linkStatus = 'ok';
      }).catch(function () {
        _this3.linkStatus = 'error';
      });
    },
    fileChanged: function fileChanged() {
      var _$refs$dropzone$dropz = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.$refs.dropzone.dropzone.files, 1);

      this.file = _$refs$dropzone$dropz[0];

      this.$el.querySelectorAll('.file-uploader__input').forEach(function (item) {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = true;
      this.uploadType = 'file';
      this.emitInput();
    },
    onContentChange: function onContentChange(filesDictionary) {
      this.$el.querySelectorAll('.file-uploader__input').forEach(function (item) {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = true;
      this.uploadType = 'file';
      this.filesDictionary = filesDictionary;
      this.emitInput();
    },
    emitInput: function emitInput() {
      this.$emit('input', {
        uploadType: this.uploadType,
        fileLink: this.fileLink,
        file: this.file,
        filesDictionary: this.filesDictionary,
        youtube: this.youtubeLink,
        vimeo: this.vimeoLink
      });
    },
    attachFile: function attachFile(url) {
      this.showSelectelList = false;
      this.fileLink = url;
    },
    onFileuploaderClicked: function onFileuploaderClicked(event) {
      this.$el.querySelectorAll('.file-uploader__input').forEach(function (item) {
        item.childNodes[0].checked = false;
      });
      this.$el.querySelector('.file-uploader__dropzone').childNodes[0].checked = false;
      var target = event.currentTarget;
      target.childNodes[0].checked = true;
      this.uploadType = target.childNodes[0].value;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__File__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectelUploader',
  components: {
    File: __WEBPACK_IMPORTED_MODULE_0__File___default.a
  },
  props: {
    fileLink: {
      type: String,
      default: ''
    },
    selectelList: {
      type: Object,
      default: null
    },
    linkStatus: {
      type: String,
      default: ''
    },
    selectelLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showSelectelList: false
    };
  },
  methods: {
    attachFile: function attachFile(url) {
      this.$emit('file-attached', url);
      this.showSelectelList = false;
    },
    checkLink: function checkLink() {
      this.$emit('blur');
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectelUploader__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectelUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectelUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(68);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoQualityUploader',

  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    SelectelUploader: __WEBPACK_IMPORTED_MODULE_3__SelectelUploader___default.a
  },

  props: {
    checkType: {
      type: String,
      required: true
    },
    dropzoneOptions: {
      type: Object,
      required: true
    },
    qualityArray: {
      type: Array,
      default: function _default() {
        return [144, 240, 360, 480, 720, 1080];
      }
    },
    selectelList: {
      type: Object,
      default: null
    },
    selectelLoading: {
      type: Boolean,
      default: false
    },
    defaultFiles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadedFiles: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      filesDictionary: {
        144: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        },
        240: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        },
        360: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        },
        480: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        },
        720: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        },
        1080: {
          type: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
          file: null,
          url: '',
          linkStatus: '',
          lastCheckedLink: ''
        }
      },
      FILE: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */],
      URL: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* URL */]
    };
  },

  watch: {
    defaultFiles: {
      handler: function handler() {
        this.manuallyAddFiles();
      },

      deep: true
    },
    uploadedFiles: function uploadedFiles(val) {
      var _this = this;

      if (val) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).forEach(function (quality) {
          var dropzone = _this.$refs['dropzone' + quality];
          if (dropzone) {
            dropzone[0].removeAllFiles();
            dropzone[0].manuallyAddFile(val[quality]);
          }
        });
      }
    }
  },

  mounted: function mounted() {
    if (this.defaultFiles && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.defaultFiles).length) {
      this.manuallyAddFiles();
    }
  },


  methods: {
    videoAdded: function videoAdded(file, quality) {
      this.filesDictionary[quality].file = file;
      this.emitChange();
    },
    videoRemoved: function videoRemoved(file, quality) {
      this.filesDictionary[quality].file = null;
      this.emitChange();
    },
    checkLink: function checkLink(quality) {
      var _this2 = this;

      var _filesDictionary$qual = this.filesDictionary[quality],
          url = _filesDictionary$qual.url,
          lastCheckedLink = _filesDictionary$qual.lastCheckedLink;

      if (!url) return;
      if (lastCheckedLink === url) return;
      this.filesDictionary[quality].linkStatus = 'loading';
      this.filesDictionary[quality].lastCheckedLink = url;
      var postFormData = new FormData();
      postFormData.append('selectel_file_url_' + quality, url);
      postFormData.append('content_type', this.checkType);
      this.$apiHttp.post(this.$config.app_api.prefix + 'selectel/check-link', postFormData).then(function () {
        _this2.filesDictionary[quality].linkStatus = 'ok';
      }).catch(function () {
        _this2.filesDictionary[quality].linkStatus = 'error';
      });
    },
    attachFile: function attachFile(url, quality) {
      this.filesDictionary[quality].url = url;
      this.checkLink(quality);
    },
    manuallyAddFiles: function manuallyAddFiles() {
      var _this3 = this;

      this.qualityArray.forEach(function (quality) {
        var item = _this3.defaultFiles[+quality];
        if (!item) return;
        var newFile = {
          file: {
            name: item.file_name,
            size: item.size
          },
          url: item.url,
          thumb: item.thumbnail
        };
        var dropzone = _this3.$refs['dropzone' + quality][0];
        dropzone.removeAllFiles();
        dropzone.manuallyAddFile(newFile.file, newFile.url);
        if (!item.mime_type.match(/image.*/)) {
          $('#files-uploader-' + quality + ' .dz-preview').last().find('.dz-image img').attr('src', newFile.thumb);
        }
      });
    },
    onSelectelUploaderClick: function onSelectelUploaderClick(quality) {
      this.filesDictionary[quality].type = __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* URL */];
      this.emitChange();
    },
    onFileUploaderClick: function onFileUploaderClick(quality) {
      this.filesDictionary[quality].type = __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* FILE */];
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('content-change', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filesDictionary));
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageUploader',

  props: {
    uploadedImgUrl: {
      type: String,
      default: null
    },
    remoteUrl: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      imageExist: false,
      imageIsLoading: false,
      imageChanged: false
    };
  },


  watch: {
    uploadedImgUrl: function uploadedImgUrl() {
      if (this.uploadedImgUrl) {
        this.imageExist = true;
        $(this.$refs.imageBoxImg).attr('src', '' + this.uploadedImgUrl);
      }
    }
  },

  mounted: function mounted() {
    if (this.uploadedImgUrl) {
      this.imageExist = true;
      $(this.$refs.imageBoxImg).attr('src', '' + this.uploadedImgUrl);
    }
  },


  methods: {
    chooseFileTrigger: function chooseFileTrigger() {
      $(this.$refs.imageUploader).click();
    },
    returnOldImage: function returnOldImage() {
      document.querySelector('.image-uploader__input-hidden').value = '';
      $(this.$refs.imageBoxImg).attr('src', this.uploadedImgUrl);
      this.$emit('returnedOldFile');
      this.imageExist = true;
      this.imageChanged = false;
    },
    removeImage: function removeImage() {
      document.querySelector('.image-uploader__input-hidden').value = '';
      $(this.$refs.imageBoxImg).attr('src', '');
      this.imageExist = false;
      this.imageChanged = true;
      if (this.uploadedImgUrl) {
        this.$emit('existingFileRemoved');
      } else {
        this.$emit('changeFile', null);
      }
    },
    changeFile: function changeFile() {
      this.imageExist = true;
      this.imageChanged = true;
      if (this.$refs.imageUploader.files.length) {
        this.$emit('changeFile', this.$refs.imageUploader.files[0]);
        if (this.remoteUrl) {
          this.remoteUpload(this.$refs.imageUploader.files[0]);
        } else {
          this.readInputImage();
        }
      }
    },
    remoteUpload: function remoteUpload(file) {
      var _this = this;

      var fileData = new FormData();
      fileData.append('image', file);
      this.imageIsLoading = true;
      this.$http.post(this.remoteUrl, fileData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token
        }
      }).then(function (response) {
        _this.$emit('remoteSuccess', response);
        _this.readInputImage();
        _this.imageExist = true;
        _this.imageIsLoading = false;
      }).catch(function (error) {
        console.error('error in remoteUpload request', error);
        _this.imageIsLoading = false;
      });
    },
    readInputImage: function readInputImage() {
      var $component = $(this.$el);
      var input = $component.find('input[type="file"]')[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          $component.find('.image-uploader__box img').attr('src', e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'label'
    },
    defaultOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchFunction: {
      type: Function,
      default: function _default() {}
    },

    value: {}
  },

  data: function data() {
    return {
      options: [],
      valueData: [],
      searchQuery: '',
      searchRequestId: null
    };
  },


  watch: {
    value: {
      handler: function handler(newVal) {
        this.valueData = newVal;
      },

      deep: true
    },
    valueData: {
      handler: function handler() {
        this.$emit('input', this.valueData);
      },

      deep: true
    },
    defaultOptions: {
      handler: function handler() {
        if (!this.searchQuery) {
          this.options = this.defaultOptions;
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.valueData = this.value;
    this.options = this.defaultOptions;
    this.$watch(function () {
      return _this.$refs.multiselect.search;
    }, function (val) {
      _this.searchQuery = val;
      if (!val) {
        _this.options = _this.defaultOptions;
        _this.$refs.multiselect.toggleLoading(false);
      }
    });
  },


  methods: {
    onSearch: function onSearch(search, loading) {
      loading(true);
      this.searchRequestId = Math.random();
      this.searchFunction(loading, search, this, this.searchRequestId);
    },
    clearValues: function clearValues() {
      this.valueData = [];
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OpenOnSiteButton',
  props: {
    sourceRoute: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      linkMessage: 'Open on site'
    };
  },
  methods: {
    formLink: function formLink() {
      var itemRoute = this.sourceRoute || '';
      if (itemRoute[0] === '/') {
        itemRoute = itemRoute.substring(1);
      }
      return '' + this.$config.app_api.host + itemRoute;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    total: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 25
    },
    offset: {
      type: Number,
      default: 0
    },
    pageRange: {
      type: Number,
      default: 3
    },
    maxPages: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      pageInput: 1
    };
  },


  computed: {
    currentPage: function currentPage() {
      return this.offset / this.size + 1;
    },
    pages: function pages() {
      var pages = [];

      for (var i = this.rangeStart; i <= this.rangeEnd; i += 1) {
        pages.push(i);
      }

      return pages;
    },
    rangeStart: function rangeStart() {
      var start = this.currentPage - this.pageRange;

      return start > 0 ? start : 1;
    },
    rangeEnd: function rangeEnd() {
      var end = this.currentPage + this.pageRange;

      return end < this.totalPages ? end : this.totalPages;
    },
    totalPages: function totalPages() {
      var pageAmount = Math.ceil(this.total / this.size);

      if (this.maxPages !== 0 && pageAmount > this.maxPages) {
        return this.maxPages;
      }
      return pageAmount;
    },
    nextPage: function nextPage() {
      return this.currentPage + 1;
    },
    prevPage: function prevPage() {
      return this.currentPage - 1;
    }
  },

  methods: {
    hasFirst: function hasFirst() {
      return this.rangeStart !== 1;
    },
    hasLast: function hasLast() {
      return this.rangeEnd < this.totalPages;
    },
    hasPrev: function hasPrev() {
      return this.currentPage > 1;
    },
    hasNext: function hasNext() {
      return this.currentPage < this.totalPages;
    },
    changePage: function changePage(page) {
      var newOffset = (page - 1) * this.size;
      this.pageInput = page;
      this.$emit('page-changed', newOffset);
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Referencer',

  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a
  },

  props: {
    alreadyChoosenRefs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      refType: null,
      refEntityOptions: [],
      refEntity: null,
      choosenRefs: []
    };
  },


  computed: {
    refTypeOptions: function refTypeOptions() {
      var _this = this;

      var array = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(this.$store.state.contentTypes.list, function (item, key) {
        array.push({
          label: _this.snakeToTitle(key),
          key: key
        });
      });
      return array;
    }
  },

  watch: {
    refType: function refType() {
      this.refEntityOptions = [];
      this.refEntity = null;
      if (this.$refs.refEntityModel) {
        this.$refs.refEntityModel.onEscape();
      }
    }
  },

  mounted: function mounted() {
    this.choosenRefs = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.alreadyChoosenRefs);
  },


  methods: {
    snakeToTitle: function snakeToTitle(str) {
      return str.split('_').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      }).join(' ');
    },
    onEntitySearch: function onEntitySearch(search, loading) {
      loading(true);
      this.entitySearch(loading, search, this, this.refType.key);
    },

    entitySearch: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (loading, search, vm, contentType) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.host + vm.$config.app_api.prefix + 'content-types/' + contentType, {
        params: {
          search_string: escape(search)
        }
      }).then(function (response) {
        var newDataArr = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forIn(response.data, function (value, key) {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.refEntityOptions = newDataArr;
        loading(false);
      }).catch(function (reject) {
        console.error(reject);
      });
    }, 350),
    addRef: function addRef() {
      for (var i = 0; i < this.refEntity.length; i += 1) {
        this.refEntity[i].type = this.refType.key;
        this.choosenRefs.push(this.refEntity[i]);
      }
      this.refEntity = null;
      this.refEntityOptions = [];
      this.refType = null;
      this.$emit('changeRefs', this.choosenRefs);
    },
    deleteRef: function deleteRef(el) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.choosenRefs, function (item) {
        return item.id === el.id && el.type === item.type;
      });
      this.$forceUpdate();
      this.$emit('changeRefs', this.choosenRefs);
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'label'
    },
    defaultOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchFunction: {
      type: Function,
      default: function _default() {}
    },

    value: {}
  },

  data: function data() {
    return {
      options: [],
      valueData: null,
      searchQuery: '',
      searchRequestId: null
    };
  },


  watch: {
    value: {
      handler: function handler(newVal) {
        this.valueData = newVal;
      },

      deep: true
    },
    valueData: {
      handler: function handler() {
        this.$emit('input', this.valueData);
      },

      deep: true
    },
    defaultOptions: {
      handler: function handler() {
        if (!this.searchQuery) {
          this.options = this.defaultOptions;
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.valueData = this.value;
    this.options = this.defaultOptions;
    this.$watch(function () {
      return _this.$refs.multiselect.search;
    }, function (val) {
      _this.searchQuery = val;
      if (!val) {
        _this.options = _this.defaultOptions;
        _this.$refs.multiselect.toggleLoading(false);
      }
    });
  },


  methods: {
    onSearch: function onSearch(search, loading) {
      loading(true);
      this.searchRequestId = Math.random();
      this.searchFunction(loading, search, this, this.searchRequestId);
    },
    clearValues: function clearValues() {
      this.valueData = null;
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    src: {
      type: String,
      default: '/static/img/file-thumb.jpg'
    }
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var img = new Image();
    img.onerror = function () {
      img.src = '/static/img/file-thumb.jpg';
    };
    img.onload = function () {
      $(_this.$el).find('img.load').remove();
      $(_this.$el).append(img);
    };
    img.src = this.src;
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var MIN_WAIT = 500;
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      type: String,
      default: 'md'
    },
    text: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      active: false
    };
  },

  computed: {
    spinnerSize: function spinnerSize() {
      return this.size ? 'spinner-' + this.size : 'spinner-sm';
    }
  },

  created: function created() {
    this._body = document.querySelector('body');
    this._bodyOverflow = this._body.style.overflowY || '';
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this._spinnerAnimation);
    this._body.style.overflowY = this._bodyOverflow;
  },


  methods: {
    getMinWait: function getMinWait() {
      var nowTime = new Date().getTime();
      if (!this._started) return MIN_WAIT;
      var startedTime = this._started.getTime();
      return nowTime - startedTime < MIN_WAIT ? MIN_WAIT - parseInt(nowTime - startedTime, 10) : 0;
    },
    show: function show(options) {
      if (options && options.text) {
        this.text = options.text;
      }
      if (options && options.size) {
        this.size = options.size;
      }
      if (options && options.fixed) {
        this.fixed = options.fixed;
      }

      this._body.style.overflowY = 'hidden';

      this._started = new Date();
      this.active = true;
      this.$root.$emit('shown::spinner');
    },
    hide: function hide() {
      var _this = this;

      this._spinnerAnimation = setTimeout(function () {
        _this.active = false;
        _this._body.style.overflowY = _this._bodyOverflow;
        _this.$root.$emit('hidden::spinner');
      }, this.getMinWait());
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermsEditor',

  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default.a
  },

  props: {
    alreadyChoosenTerms: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      newTerm: {
        vocabulariesOptions: [],
        vocabulary: null,
        termsOptions: [],
        terms: []
      },
      choosen: {
        terms: [],
        vocabularies: []
      },
      vocabulariesOptionsDefault: [],
      termsLoading: false
    };
  },


  watch: {
    'newTerm.vocabulary': function newTermVocabulary() {
      this.newTerm.termsOptions = [];
      this.newTerm.terms = [];
      if (this.$refs.refTermsModel) {
        this.$refs.refTermsModel.onEscape();
      };
      this.getDefaultTerms();
    },
    'choosen.terms': function choosenTerms(newVal) {
      if (newVal && newVal.length) {
        var vocabulariesList = [];
        for (var i = 0; i < newVal.length; i += 1) {
          vocabulariesList.push({
            id: newVal[i].vocabularyId,
            name: newVal[i].vocabularyName
          });
        }
        this.choosen.vocabularies = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqBy(vocabulariesList, 'id');
      }
    }
  },

  mounted: function mounted() {
    this.getDefaultVocabularies();

    if (this.alreadyChoosenTerms && this.alreadyChoosenTerms.length) {
      for (var i = 0; i < this.alreadyChoosenTerms.length; i += 1) {
        var obj = {
          id: this.alreadyChoosenTerms[i].id,
          name: this.alreadyChoosenTerms[i].name,
          vocabularyId: this.alreadyChoosenTerms[i].vocabulary_id,
          vocabularyName: this.alreadyChoosenTerms[i].vocabulary.name
        };
        this.choosen.terms.push(obj);
      }
    };
  },


  methods: {
    vocabularySearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'vocabularies?search_string=' + escape(search)).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (reject) {
        loading(false);
        console.error(reject);
      });
    }, 350),
    getDefaultVocabularies: function getDefaultVocabularies() {
      var _this = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this.vocabulariesOptionsDefault = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (reject) {
        console.error(reject);
      });
    },
    getDefaultTerms: function getDefaultTerms() {
      var _this2 = this;

      this.termsLoading = true;
      var VOC_ID = this.newTerm.vocabulary.id;
      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies/' + VOC_ID + '/terms', { useCache: true }).then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this2.newTerm.termsOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        _this2.termsLoading = false;
      }).catch(function (reject) {
        console.error(reject);
        _this2.termsLoading = false;
      });
    },
    onTermsSearch: function onTermsSearch(search, loading) {
      loading(true);
      this.termsSearch(loading, search, this);
    },

    termsSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.host + vm.$config.app_api.prefix + 'terms', {
        params: {
          vid: vm.newTerm.vocabulary.id,
          search_string: escape(search)
        }
      }).then(function (response) {
        var newDataArr = [];
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(response.data, function (value, key) {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.newTerm.termsOptions = newDataArr;
        loading(false);
      }).catch(function (reject) {
        loading(false);
        console.error(reject);
      });
    }, 350),
    addNewTerms: function addNewTerms() {
      var _this3 = this;

      var _loop = function _loop(i) {
        var obj = {
          id: _this3.newTerm.terms[i].id,
          name: _this3.newTerm.terms[i].name,
          vocabularyId: _this3.newTerm.vocabulary.id,
          vocabularyName: _this3.newTerm.vocabulary.name
        };
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(_this3.choosen.terms, function (item) {
          return item.id === obj.id;
        }) === -1) {
          _this3.choosen.terms.push(obj);
        }
      };

      for (var i = 0; i < this.newTerm.terms.length; i += 1) {
        _loop(i);
      }
      this.newTerm.terms = [];
      this.getDefaultTerms();
      this.newTerm.termsOptions = [];

      this.$emit('changeTerms', this.choosen.terms);
    },
    deleteTerm: function deleteTerm(elemId) {
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.choosen.terms, function (item) {
        return item.id === elemId;
      });
      this.$forceUpdate();
      this.$emit('changeTerms', this.choosen.terms);
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModalMenuItem',

  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a
  },

  data: function data() {
    return {
      source: null,
      entity: {
        id: null,
        order: null,
        parent_id: null,
        title: null,
        url: '',
        tooltip: null,
        target: '_self',
        route: null,
        routeName: null,
        hidden: false,
        image: null,
        parameters: null,
        path_alias: null
      },
      spot: null,
      action: 'new',
      selectOptions: [],
      errorMessage: ''
    };
  },


  computed: {
    routeName: function routeName() {
      var _this = this;

      if (!this.entityTypesList.length) return null;
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.entityTypesList, function (e) {
        return e.value === _this.entity.route;
      }).name;
    },
    entityTypesList: function entityTypesList() {
      var list = this.$store.state.contentTypes.list;

      if (list.length === 0) return [];
      var collection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(list).map(function (e) {
        return {
          name: e,
          value: list[e].route.item
        };
      });
      return collection;
    },
    imageIsChanged: function imageIsChanged() {
      if (!this.source.image) {
        return !!this.entity.image;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(this.entity.image) && this.entity.image.id === this.source.image.id) {
        return false;
      }
      return true;
    }
  },

  watch: {
    'entity.route': function entityRoute() {
      this.selectOptions = [];
      if (!this.source) return;
      if (this.entity.route === this.source.route) {
        this.entity.parameters = {
          id: this.source.parameters.id,
          title: this.source.parameters._title || this.source.parameters.text || this.source.parameters.title
        };
      } else {
        this.entity.parameters = null;
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    $(this.$el).find('input[data-validation="true"]').change(function () {
      $(this).parents('.form-group').removeClass('error');
    });

    this.$root.$on('menuItemSetParams', function (content, action) {
      _this2.source = content;
      _this2.entity.id = content.id;
      _this2.entity.parent_id = content.parent_id;
      _this2.entity.order = content.order;
      _this2.entity.title = content.title;
      _this2.entity.url = content.url || '';
      _this2.entity.tooltip = content.tooltip;
      _this2.entity.target = content.target ? content.target : '_self';
      _this2.entity.image = content.image;
      _this2.entity.path_alias = content.path_alias ? content.path_alias.path_alias : '';
      _this2.entity.hidden = !!content.hidden;
      if (content.route) {
        _this2.entity.route = content.route;
      }
      if (content.parameters) {
        _this2.entity.parameters = {
          id: content.parameters.id,
          title: content.parameters._title || content.parameters.text || content.parameters.title
        };
      }

      _this2.spot = content.spot;
      _this2.action = action;

      $(_this2.$el).modal('show');
    });

    $(this.$el).on('hidden.bs.modal', function () {
      _this2.source = null;

      _this2.entity.id = null;
      _this2.entity.parent_id = null;
      _this2.entity.order = null;
      _this2.entity.title = null;
      _this2.entity.url = '';
      _this2.entity.tooltip = null;
      _this2.entity.route = null;
      _this2.entity.parameters = null;
      _this2.entity.image = null;
      _this2.entity.target = '_self';
      _this2.entity.path_alias = null;
      _this2.entity.hidden = false;

      _this2.spot = null;

      _this2.errorMessage = '';
    });
  },
  destroyed: function destroyed() {
    $('.modal-backdrop').remove();
    this.$root.$off('menuItemSetParams');
  },


  methods: {
    vueSelectOnSearch: function vueSelectOnSearch(search, loading) {
      loading(true);
      this.vueSelectSearch(loading, search, this);
    },

    vueSelectSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'content-types/' + vm.routeName, {
        params: {
          search_string: escape(search)
        }
      }).then(function (response) {
        var newDataArr = [];
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forIn(response.data, function (value, key) {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.selectOptions = newDataArr;
        loading(false);
      }).catch(function (error) {
        console.error(error);
      });
    }, 350),
    imageChange: function imageChange(file) {
      this.entity.image = file;
    },
    imageReturnedOld: function imageReturnedOld() {
      this.entity.image = this.source.image;
    },
    imageRemove: function imageRemove() {
      this.entity.image = null;
    },
    formIsValide: function formIsValide() {
      if (!this.entity.title) {
        this.errorMessage = 'Field title is required';
        return false;
      }
      return true;
    },
    saveChanges: function saveChanges() {
      if (!this.formIsValide()) return;
      if (this.action === 'new') {
        this.saveNew();
      } else if (this.action === 'edit') {
        this.saveExisting();
      }
    },
    preSave: function preSave() {
      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('target', this.entity.target);
      postFormData.append('order', this.entity.order);
      postFormData.append('tooltip', this.entity.tooltip ? this.entity.tooltip : '');
      postFormData.append('url', this.entity.url);
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('hidden', this.entity.hidden);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);
      if (this.entity.route) postFormData.append('route', this.entity.route);
      if (this.entity.parameters) {
        postFormData.append('parameters', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          id: this.entity.parameters.id,
          _title: this.entity.parameters.title
        }));
      }
      return postFormData;
    },
    updateImageRequest: function updateImageRequest() {
      var prefix = this.$config.app_api.prefix;

      var postFormData = new FormData();
      postFormData.append('image', this.entity.image);
      return this.$apiHttp.post(prefix + 'menu/' + this.source.menu_id + '/menu-items/' + this.entity.id + '/image', postFormData);
    },
    deleteImageRequest: function deleteImageRequest() {
      var prefix = this.$config.app_api.prefix;

      return this.$apiHttp.delete(prefix + 'menu/' + this.source.menu_id + '/menu-items/' + this.entity.id + '/image');
    },
    saveExistingRequest: function saveExistingRequest(postFormData) {
      var prefix = this.$config.app_api.prefix;

      return this.$apiHttp.post(prefix + 'menu/' + this.source.menu_id + '/menu-items/' + this.entity.id, postFormData);
    },
    successSaveExistingCallback: function successSaveExistingCallback(newContent, image) {
      this.$root.$emit('menuItemSaveExistingSuccess', newContent, image);
      $(this.$el).find('.btn-loader').hide();
      $(this.$el).modal('hide');
    },
    errorSaveExistingCallback: function errorSaveExistingCallback() {
      $(this.$el).find('.btn-loader').hide();
      this.errorMessage = 'Changes did not saved. There are some problems with server.';
    },
    saveExisting: function saveExisting() {
      var _this3 = this;

      var postFormData = this.preSave();
      if (!this.imageIsChanged) {
        this.saveExistingRequest(postFormData).then(function (response) {
          _this3.successSaveExistingCallback(response.data, _this3.entity.image);
        }).catch(function () {
          _this3.errorSaveExistingCallback();
        });
      } else if (this.entity.image) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all([this.updateImageRequest(), this.saveExistingRequest(postFormData)]).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function (image, entity) {
          if (Math.round(image.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.successSaveExistingCallback(entity.data, image.data);
          } else {
            _this3.errorSaveExistingCallback();
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all([this.deleteImageRequest(), this.saveExistingRequest(postFormData)]).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function (image, entity) {
          if (Math.round(image.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.successSaveExistingCallback(entity.data);
          } else {
            _this3.errorSaveExistingCallback();
          }
        }));
      }
    },
    saveNew: function saveNew() {
      var _this4 = this;

      var postFormData = this.preSave();
      if (this.entity.image) postFormData.append('image', this.entity.image);
      this.$apiHttp.post(this.$config.app_api.prefix + 'menu/' + this.source.menu_id + '/menu-items?with[]=image', postFormData).then(function (response) {
        _this4.$root.$emit('menuItemSaveNewSuccess', response.data, _this4.spot);
        $(_this4.$el).find('.btn-loader').hide();
        $(_this4.$el).modal('hide');
      }).catch(function (error) {
        $(_this4.$el).find('.btn-loader').hide();
        _this4.errorMessage = 'Item did not created. There are some problems with server.';
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      files: [],
      directory: '/',
      newFolder: '',
      errorMessage: '',
      foldersList: ''
    };
  },

  watch: {
    files: function files() {
      this.errorMessage = '';
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$root.$on('updateSelectelFolders', function (foldersList) {
      _this.foldersList = foldersList;
    });

    $(this.$el).on('hidden.bs.modal', function () {
      _this.$refs.selectelUploadFile.value = '';
      _this.directory = '/';
      _this.newFolder = '';

      _this.errorMessage = '';
    });
  },


  methods: {
    changeFile: function changeFile(e) {
      if (e.currentTarget.files.length) {
        this.files = e.currentTarget.files;
      } else {
        this.files = [];
      }
    },
    upload: function upload() {
      if (this.files.length) {
        $(this.$refs.saveBtnLoader).show();
        var dir = '';
        if (this.directory === 'new') {
          dir = this.newFolder;
        } else if (this.directory !== '/') {
          dir = this.directory + '/' + this.newFolder;
        } else {
          dir = this.directory;
        }
        var _$config$app_api = this.$config.app_api,
            prefix = _$config$app_api.prefix,
            host = _$config$app_api.host;

        var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].tokenStorage.name));
        this.$store.dispatch('uploadManager/startUpload', {
          apiHost: host,
          apiPrefix: prefix,
          files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files)),
          token: token,
          dir: dir,
          is_public_file: true
        });
        $(this.$refs.saveBtnLoader).hide();
        $(this.$el).modal('hide');
      } else {
        this.errorMessage = 'Please, upload files';
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModalTermItem',

  data: function data() {
    return {
      entity: {
        id: null,
        weight: null,
        parent_id: null,
        vocabulary_id: null,
        name: null
      },
      spot: null,
      action: 'new',
      errorMessage: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    $(this.$el).find('input[data-validation="true"]').change(function () {
      $(this).parents('.form-group').removeClass('error');
    });

    this.$root.$on('termItemSetParams', function (content, action) {
      _this.entity.id = content.id;
      _this.entity.parent_id = content.parent_id;
      _this.entity.weight = content.weight;
      _this.entity.name = content.name;
      _this.entity.vocabulary_id = content.vocabulary_id;

      _this.spot = content.spot;
      _this.action = action;

      $(_this.$el).modal('show');
    });

    $(this.$el).on('hidden.bs.modal', function () {
      _this.entity.id = null;
      _this.entity.parent_id = null;
      _this.entity.weight = null;
      _this.entity.name = null;
      _this.entity.vocabulary_id = null;

      _this.spot = null;

      _this.errorMessage = '';
    });
  },
  destroyed: function destroyed() {
    $('.modal-backdrop').remove();
    this.$root.$off('termItemSetParams');
  },


  methods: {
    formIsValide: function formIsValide() {
      if (!this.entity.name) {
        this.errorMessage = 'Field title is required';
        return false;
      }
      return true;
    },
    saveChanges: function saveChanges() {
      if (!this.formIsValide()) return;
      if (this.action === 'new') {
        this.saveNew();
      } else if (this.action === 'edit') {
        this.saveExisting();
      }
    },
    saveExisting: function saveExisting() {
      var _this2 = this;

      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('weight', this.entity.weight);
      postFormData.append('vid', this.entity.vocabulary_id);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);

      this.$apiHttp.post(this.$config.app_api.prefix + 'terms/' + this.entity.id, postFormData).then(function () {
        _this2.$root.$emit('termItemSaveExistingSuccess', _this2.entity);
        $(_this2.$el).find('.btn-loader').hide();
        $(_this2.$el).modal('hide');
      }).catch(function (error) {
        $(_this2.$el).find('.btn-loader').hide();
        _this2.errorMessage = 'Changes did not saved. There are some problems with server.';
        console.error(error);
      });
    },
    saveNew: function saveNew() {
      var _this3 = this;

      var postFormData = new FormData();
      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      postFormData.append('name', this.entity.name);
      postFormData.append('weight', this.entity.weight);
      postFormData.append('vid', this.entity.vocabulary_id);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);

      this.$apiHttp.post(this.$config.app_api.prefix + 'terms', postFormData).then(function (response) {
        _this3.entity.id = response.data.id;
        var newContent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this3.entity);
        var newSpot = _this3.spot;
        newContent.url = response.data.url;
        _this3.$root.$emit('termItemSaveNewSuccess', newContent, newSpot);
        $(_this3.$el).find('.btn-loader').hide();
        $(_this3.$el).modal('hide');
      }).catch(function (error) {
        $(_this3.$el).find('.btn-loader').hide();
        _this3.errorMessage = 'Item did not created. There are some problems with server.';
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_menu__ = __webpack_require__(69);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',

  data: function data() {
    return {
      menu: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', {
    userPermissions: 'getPermissions'
  })),
  mounted: function mounted() {
    this.menu = this.filterMenuItemsByUserPermissions(__WEBPACK_IMPORTED_MODULE_2__helpers_menu__["b" /* menu */], this.userPermissions);
  },

  methods: {
    filterMenuItemsByUserPermissions: function filterMenuItemsByUserPermissions(menuItems, permissions) {
      return menuItems.filter(function (menuItem) {
        var itemPermissions = menuItem.permissions;

        var userRights = permissions.map(function (item) {
          return item.id;
        });
        if (!itemPermissions) {
          return true;
        }
        return itemPermissions.reduce(function (hasPermission, perm) {
          return userRights.includes(perm) || hasPermission;
        }, false);
      });
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RobotsSettings',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      source: {},
      entity: {}
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.data) {
        this.$_errorSave('Robots file content field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'get-robots-txt').then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        console.error('Error in get single article query', error);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('text', this.entity.data);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'save-robots-txt', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave('Error in data saving');
        console.error('Error in create article query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',

  data: function data() {
    return {
      types: null
    };
  },


  watch: {
    offset: function offset() {
      this.getSource();
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    getSource: function getSource() {
      var _this = this;

      var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.reload-source .btn-loader');
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'search/indices/egw').then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.types = response.data.egw;
        $btnLoader.hide();
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        $btnLoader.hide();
        console.error(error);
      });
    },
    reloadSource: function reloadSource() {
      var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.reload-source .btn-loader');
      $btnLoader.show();
      this.getSource();
    },
    updateIndexForType: function updateIndexForType(type) {
      if (window.confirm('Do yo really want to update search index for all ' + type)) {
        var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.entities tr[data-type="' + type + '"] .btn-primary .btn-loader');
        $btnLoader.show();
        this.$apiHttp.post(this.$config.app_api.prefix + 'search/documents/' + type).then(function () {
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          console.error(error);
        });
      }
    },
    deleteIndexForType: function deleteIndexForType(type) {
      if (window.confirm('Do yo really want to delete search index for ' + type)) {
        var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.entities tr[data-type="' + type + '"] .btn-danger .btn-loader');
        $btnLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + 'search/documents/' + type).then(function () {
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          console.error(error);
        });
      }
    },
    updateIndexForAll: function updateIndexForAll() {
      if (window.confirm('Do yo really want to update search index for all entities')) {
        var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.update-index-all .btn-loader');
        $btnLoader.show();
        this.$apiHttp.post(this.$config.app_api.prefix + 'search/indices/egw').then(function () {
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          console.error(error);
        });
      }
    },
    deleteIndexForAll: function deleteIndexForAll() {
      if (window.confirm('Do yo really want to delete search index for all entities')) {
        var $btnLoader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.delete-index-all .btn-loader');
        $btnLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + 'search/indices/egw').then(function () {
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          console.error(error);
        });
      }
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DisableGoogle2FA',

  data: function data() {
    return {
      password: '',
      loading: false
    };
  },

  methods: {
    isFormValid: function isFormValid() {
      if (!this.password) {
        this.$emit('getErrors', 'Please pass Current Password field.');
        return false;
      }
      return true;
    },
    disableGoogle2fa: function disableGoogle2fa() {
      var _this = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      var postFormData = new FormData();
      postFormData.append('password', this.password);
      this.$apiHttp.post('' + this.$config.app_api.host + this.$config.app_api.prefix + '2fa/disable', postFormData).then(function (response) {
        if (response.data.success) {
          _this.$emit('getErrors', null);
          var newValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, JSON.parse(localStorage.getItem(_this.$config.userStorage.name)), {
            google2fa_enabled: false
          });
          localStorage.setItem(_this.$config.userStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newValue));
          _this.$store.commit('user/setGoogle2faInfo', false);
          _this.$emit('resetSecretKey');
        }
      }).catch(function (e) {
        if (e.response) {
          _this.$emit('getErrors', e.response.data.message);
        } else {
          _this.$emit('getErrors', e.message);
          console.log('Error', e.message);
        }
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnableGoogle2FA',

  props: {
    secretKey: {
      type: String,
      required: true
    },
    qrCode: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      code: '',
      loading: false
    };
  },

  methods: {
    isFormValid: function isFormValid() {
      if (!this.code) {
        this.$emit('getErrors', 'Please pass Authenticator Code field.');
        return false;
      }
      return true;
    },
    enableGoogle2fa: function enableGoogle2fa() {
      var _this = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      var postFormData = new FormData();
      postFormData.append('secret', this.code);
      this.$apiHttp.post('' + this.$config.app_api.host + this.$config.app_api.prefix + '2fa/enable', postFormData).then(function (response) {
        if (response.data.success) {
          _this.$emit('getErrors', null);
          var newValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, JSON.parse(localStorage.getItem(_this.$config.userStorage.name)), {
            google2fa_enabled: true
          });
          localStorage.setItem(_this.$config.userStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newValue));
          _this.$store.commit('user/setGoogle2faInfo', true);
        }
      }).catch(function (e) {
        if (e.response) {
          _this.$emit('getErrors', e.response.data.message);
        } else {
          _this.$emit('getErrors', e.message);
          console.log('Error', e.message);
        }
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnableGoogle2FA__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnableGoogle2FA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EnableGoogle2FA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisableGoogle2FA__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisableGoogle2FA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DisableGoogle2FA__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Google2FA',

  components: {
    EnableGoogle2FA: __WEBPACK_IMPORTED_MODULE_2__EnableGoogle2FA___default.a,
    DisableGoogle2FA: __WEBPACK_IMPORTED_MODULE_3__DisableGoogle2FA___default.a
  },

  data: function data() {
    return {
      secret_key: null,
      qr_code: null,
      loading: false,
      errors: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('user', ['getGoogle2faInfo'])),

  methods: {
    generateSecret: function generateSecret() {
      var _this = this;

      if (this.loading) return;
      this.loading = true;
      this.$apiHttp.post('' + this.$config.app_api.host + this.$config.app_api.prefix + '2fa/generate-secret').then(function (response) {
        if (response.data.secret_key) {
          _this.errors = null;
          _this.secret_key = response.data.secret_key;
          _this.qr_code = response.data.qr_code;
        }
      }).catch(function (e) {
        _this.errors = e.message;
        console.error(e.message);
      }).finally(function () {
        _this.loading = false;
      });
    },
    setErrors: function setErrors(val) {
      this.errors = val;
    },
    resetSecretKey: function resetSecretKey() {
      this.secret_key = null;
      this.qr_code = null;
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountSettings'
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sections_About_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sections_About_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sections_About_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sections_Contacts_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sections_Contacts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__sections_Contacts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections_news_notes_Index_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sections_news_notes_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sections_news_notes_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections_announcements_Index_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections_announcements_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sections_announcements_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sections_MainPage_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sections_MainPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__sections_MainPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sections_CenterPage_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sections_CenterPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sections_CenterPage_vue__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BranchOfficesEdit',

  components: {
    About: __WEBPACK_IMPORTED_MODULE_2__sections_About_vue___default.a,
    Contacts: __WEBPACK_IMPORTED_MODULE_3__sections_Contacts_vue___default.a,
    News: __WEBPACK_IMPORTED_MODULE_4__sections_news_notes_Index_vue___default.a,
    Announcements: __WEBPACK_IMPORTED_MODULE_5__sections_announcements_Index_vue___default.a,

    MainPage: __WEBPACK_IMPORTED_MODULE_6__sections_MainPage_vue___default.a,
    CenterPage: __WEBPACK_IMPORTED_MODULE_7__sections_CenterPage_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      activetab: 1,
      source: null,
      entity: {}
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.domain) {
        this.$_showError('Abbreviation of Title must be valid');
        return false;
      }
      if (this.entity.contacts.director_email && !validateEmail(this.entity.contacts.director_email)) {
        this.$_showError('Director Email must be valid');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'branch-offices/' + this.$route.params.id, {
        params: {
          with: ['news_notes', 'announcements', 'images']
        }
      }).then(function (response) {
        var newResponse = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (newResponse.location == null) {
          newResponse.location = {
            lat: null,
            lng: null
          };
        }

        newResponse.contacts.phone1 = newResponse.contacts.phone['0'];
        newResponse.contacts.phone2 = newResponse.contacts.phone['1'];
        newResponse.contacts.fax1 = newResponse.contacts.fax['0'];
        newResponse.contacts.fax2 = newResponse.contacts.fax['1'];
        newResponse.contacts.email1 = newResponse.contacts.email['0'];
        newResponse.contacts.email2 = newResponse.contacts.email['1'];
        _this.source = newResponse;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(newResponse);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        console.error(error);
        _this.$store.dispatch('notifications/setHttpError', {
          error: error,
          text: 'Error in getting data request'
        });
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      });
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BranchOffices',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  computed: {
    userPermissions: function userPermissions() {
      return this.$store.getters['user/getPermissionsObject'];
    },
    allowedToCreateAndDelete: function allowedToCreateAndDelete() {
      return !!this.userPermissions[this.allPermissions.ADMINISTER_BRANCH_OFFICES];
    }
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchQuery = encodeURI(this.searchQuery);
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;

      this.$apiHttp.get(this.$config.app_api.prefix + 'branch-offices?search_string=' + searchQuery + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var branchOfficesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete branchOfficesArr.meta;
          _this.entities = branchOfficesArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    },
    typeOptions: function typeOptions(type) {
      switch (type) {
        case 'main_office':
          return 'Main Office';
        case 'branch_office':
          return 'Branch Office';
        case 'research_center':
          return 'Research Center';
        default:
          return 'Branch Office';
      }
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BranchOfficesNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: '',
        domain: '',
        local_institution: '',
        type: 'branch_office',
        library: '',
        address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: ''
        },
        mail_address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: ''
        },
        alt_address: {
          country: '',
          state: '',
          city: '',
          zip: '',
          street1: '',
          street2: ''
        },
        contacts: {
          director_name: '',
          director_email: '',
          phone1: '',
          phone2: '',
          fax1: '',
          fax2: '',
          email1: '',
          email2: '',
          website: ''
        },
        location: {
          gmap_link: '',
          lat: null,
          lng: null
        }
      },
      mapCenter: {
        lat: 0,
        lng: 0
      },
      mapZoom: 2,
      typeOptions: {
        main_office: 'Main Office',
        branch_office: 'Branch Office',
        research_center: 'Research Center'
      }
    };
  },


  computed: {
    entityMapCenter: function entityMapCenter() {
      if (this.entity.location === undefined || this.entity.location.lat == null || this.entity.location.lng == null) {
        return {
          lat: 0,
          lng: 0
        };
      }
      return {
        lat: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.location.lat),
        lng: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.location.lng)
      };
    }
  },

  mounted: function mounted() {
    $('.card-collapse').click(function () {
      var $body = $(this).parents('.card').children('.card-body');
      if ($body.hasClass('collapse')) {
        $body.slideDown(function () {
          $(this).removeClass('collapse');
        });
      } else {
        $body.slideUp(function () {
          $(this).addClass('collapse');
        });
      }
    });
  },
  destroyed: function destroyed() {
    $('.card-collapse').off('click');
  },


  methods: {
    mapClick: function mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    },
    isEntityValid: function isEntityValid() {
      function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.domain) {
        this.$_showError('Abbreviation of Title must be valid');
        return false;
      }
      if (this.entity.contacts.director_email && !validateEmail(this.entity.contacts.director_email)) {
        this.$_showError('Office Email must be valid');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      var faxes = [];
      var phones = [];
      var emails = [];
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      if (this.entity.local_institution) postFormData.append('local_institution', this.entity.local_institution);
      if (this.entity.library) postFormData.append('library', this.entity.library);
      postFormData.append('address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.address));
      postFormData.append('mail_address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.mail_address));
      postFormData.append('alt_address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.alt_address));
      if (this.entity.contacts.phone1) phones.push(this.entity.contacts.phone1);
      if (this.entity.contacts.phone2) phones.push(this.entity.contacts.phone2);
      if (this.entity.contacts.fax1) faxes.push(this.entity.contacts.fax1);
      if (this.entity.contacts.fax2) faxes.push(this.entity.contacts.fax2);
      if (this.entity.contacts.email1) emails.push(this.entity.contacts.email1);
      if (this.entity.contacts.email2) emails.push(this.entity.contacts.email2);
      postFormData.append('contacts', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        director_name: this.entity.contacts.director_name,
        director_email: this.entity.contacts.director_email,
        phone: phones,
        fax: faxes,
        email: emails,
        website: this.entity.contacts.website
      }));
      postFormData.append('location', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.location));

      return this.$apiHttp.post(this.$config.app_api.prefix + 'branch-offices', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/branch-offices/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create office query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(13);











var SUCCESS = __WEBPACK_IMPORTED_MODULE_5__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BranchAbout',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },

  props: {
    entity: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      typeOptions: {
        main_office: 'Main Office',
        branch_office: 'Branch Office',
        research_center: 'Research Center'
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      },
      uploadedFiles: [],
      files: [],
      toDeleteFiles: [],

      errorMessage: '',
      errorErrors: ''
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'branch_office/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.initCollapse();
    this.getSource();
  },
  destroyed: function destroyed() {
    $(document).off('click', '.card-collapse');
  },


  methods: {
    initCollapse: function initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        var $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },
    getSource: function getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.images.length; i += 1) {
        var _file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size
          },
          url: this.entity.images[i].public_url
        };
        this.$refs.dropzone.manuallyAddFile(_file.file, _file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var fileIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(this.entity.images, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);

      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.address));
      postFormData.append('mail_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.mail_address));
      postFormData.append('alt_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.alt_address));
      postFormData.append('contacts', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.contacts));
      postFormData.append('location', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.location));
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));

      return this.$apiHttp.post(this.$config.app_api.prefix + 'branch-offices/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].tokenStorage.name));

      if (this.toDeleteFiles.length) {
        var _loop = function _loop(i) {
          _this.$apiHttp.delete('' + _this.$config.app_api.host + _this.$config.app_api.prefix + 'branch-offices/' + _this.$route.params.id + '/images/' + _this.toDeleteFiles[i]).then(function () {
            _this.entity.files.splice(i, 1);
            _this.files = _this.files.filter(function (item) {
              return file !== item;
            });
          }).catch(function (error) {
            console.error('error in delete file in site page request - ', error);
          });
        };

        for (var i = 0; i < this.toDeleteFiles.length; i += 1) {
          _loop(i);
        }
      }

      this.saveRequest().then(function () {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this.$route.params.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: 'branch_office'
          });
          vm.files = [];
        }
      }).catch(function (error) {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(13);













var SUCCESS = __WEBPACK_IMPORTED_MODULE_5__helpers_constants__["b" /* uploadStatus */].SUCCESS;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CenterPage',
  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],
  props: {
    entity: {
      type: Object,
      default: function _default() {}
    },
    source: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },
      files: [],
      uploadedFiles: [],
      toDeleteFiles: []
    };
  },

  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'branch_office/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    },
    sourceMapData: function sourceMapData() {
      if (this.entity.location === undefined || this.entity.location.lat == null || this.entity.location.lng == null) {
        return {
          center: {
            lat: 0,
            lng: 0
          },
          zoom: 2
        };
      }
      return {
        center: {
          lat: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.location.lat),
          lng: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.location.lng)
        },
        zoom: 13
      };
    },
    entityMapCenter: function entityMapCenter() {
      if (this.entity.location === undefined || this.entity.location.lat == null || this.entity.location.lng == null) {
        return {
          lat: 0,
          lng: 0
        };
      }
      return {
        lat: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.location.lat),
        lng: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.location.lng)
      };
    }
  },
  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.getSource();
  },

  methods: {
    getAnnouncements: function getAnnouncements() {
      var _this = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'announcements', {
        params: {
          with: ['pdf', 'cover', 'branch']
        }
      }).then(function (response) {
        console.log(response.data);
        var newResponse = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        _this.source = newResponse;
        _this.entity = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newResponse);
      }).catch(function (error) {
        console.error(error);
        _this.$store.dispatch('notifications/setHttpError', {
          error: error,
          text: 'Error in getting data request'
        });
      });
    },
    getNewsNotes: function getNewsNotes() {
      var _this2 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'news-notes', {
        params: {
          with: ['pdf', 'cover', 'branch']
        }
      }).then(function (response) {
        console.log(response.data);
        var newResponse = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        _this2.source = newResponse;
        _this2.entity = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newResponse);
      }).catch(function (error) {
        console.error(error);
        _this2.$store.dispatch('notifications/setHttpError', {
          error: error,
          text: 'Error in getting data request'
        });
      });
    },
    getSource: function getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.images.length; i += 1) {
        var file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size
          },
          url: this.entity.images[i].public_url
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var fileIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(this.entity.images, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.address));
      postFormData.append('mail_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.mail_address));
      postFormData.append('alt_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.alt_address));
      postFormData.append('contacts', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.contacts));
      postFormData.append('location', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.location));
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));
      return this.$apiHttp.post(this.$config.app_api.prefix + 'branch-offices/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].tokenStorage.name));
      if (this.toDeleteFiles.length) {
        var _loop = function _loop(i) {
          _this3.$apiHttp.delete('' + _this3.$config.app_api.host + _this3.$config.app_api.prefix + 'branch-offices/' + _this3.$route.params.id + '/images/' + _this3.toDeleteFiles[i]).then(function () {
            _this3.entity.files.splice(i, 1);
          }).catch(function (error) {
            console.error('error in delete file in site page request - ', error);
          });
        };

        for (var i = 0; i < this.toDeleteFiles.length; i += 1) {
          _loop(i);
        }
      }
      this.saveRequest().then(function () {
        $('.btn-success .btn-loader').hide();
        _this3.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          _this3.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this3.$route.params.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: 'branch_office'
          });
          vm.files = [];
        }
      }).catch(function (error) {
        $('.btn-success .btn-loader').hide();
        _this3.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    },
    mapClick: function mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    source: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    entity: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    sourceMapData: function sourceMapData() {
      if (this.source.location === undefined || this.source.location.lat == null || this.source.location.lng == null) {
        return {
          center: {
            lat: 0,
            lng: 0
          },
          zoom: 2
        };
      }
      return {
        center: {
          lat: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.source.location.lat),
          lng: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.source.location.lng)
        },
        zoom: 13
      };
    },
    entityMapCenter: function entityMapCenter() {
      if (this.entity.location === undefined || this.entity.location.lat == null || this.entity.location.lng == null) {
        return {
          lat: 0,
          lng: 0
        };
      }
      return {
        lat: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.location.lat),
        lng: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.location.lng)
      };
    }
  },
  mounted: function mounted() {
    this.initCollapse();
  },
  destroyed: function destroyed() {
    $(document).off('click', '.card-collapse');
  },

  methods: {
    mapClick: function mapClick(event) {
      this.entity.location.lat = event.latLng.lat();
      this.entity.location.lng = event.latLng.lng();
    },
    setOldGeocode: function setOldGeocode() {
      this.entity.location.lat = this.source.location.lat;
      this.entity.location.lng = this.source.location.lng;
    },
    initCollapse: function initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        var $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      var faxes = [];
      var phones = [];
      var emails = [];
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      postFormData.append('address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.address.address));
      postFormData.append('mail_address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.address.mail_address));
      postFormData.append('alt_address', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.address.alt_address));
      if (this.entity.contacts.phone1) phones.push(this.entity.contacts.phone1);
      if (this.entity.contacts.phone2) phones.push(this.entity.contacts.phone2);
      if (this.entity.contacts.fax1) faxes.push(this.entity.contacts.fax1);
      if (this.entity.contacts.fax2) faxes.push(this.entity.contacts.fax2);
      if (this.entity.contacts.email1) emails.push(this.entity.contacts.email1);
      if (this.entity.contacts.email2) emails.push(this.entity.contacts.email2);
      postFormData.append('contacts', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        director_name: this.entity.contacts.director_name,
        director_email: this.entity.contacts.director_email,
        phone: phones,
        fax: faxes,
        email: emails,
        website: this.entity.contacts.website
      }));
      postFormData.append('location', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.location));
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));
      return this.$apiHttp.post(this.$config.app_api.prefix + 'branch-offices/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      this.saveRequest().then(function () {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setSuccessNotification', 'Success!');
      }).catch(function (error) {
        _this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(13);













var SUCCESS = __WEBPACK_IMPORTED_MODULE_5__helpers_constants__["b" /* uploadStatus */].SUCCESS;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainPage',
  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],
  props: {
    entity: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },
      saveErrorMessage: '',
      files: [],
      uploadedFiles: [],
      toDeleteFiles: [],
      noteShown: true
    };
  },

  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'branch_office/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'branch_office');
    },
    socialsExist: function socialsExist() {
      return Boolean(this.entity.boxes.box4.socials.facebook) || Boolean(this.entity.boxes.box4.socials.instagram) || Boolean(this.entity.boxes.box4.socials.twitter) || Boolean(this.entity.boxes.box4.socials.pinterest) || Boolean(this.entity.boxes.box4.socials.youtube1) || Boolean(this.entity.boxes.box4.socials.youtube2) || Boolean(this.entity.boxes.box4.socials.youtube3);
    },
    isImagesSliderSelected: function isImagesSliderSelected() {
      return !!(this.entity.boxes.box1.show_images_slider || this.entity.boxes.box3.show_images_slider || this.entity.boxes.box4.show_images_slider);
    },
    isAnnouncementsSelected: function isAnnouncementsSelected() {
      return !!(this.entity.boxes.box3.show_announcements || this.entity.boxes.box4.show_announcements);
    }
  },
  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.initCollapse();
    this.getSource();
  },
  destroyed: function destroyed() {
    $(document).off('click', '.card-collapse');
  },

  methods: {
    initCollapse: function initCollapse() {
      $(document).on('click', '.card-collapse', function () {
        var $body = $(this).parents('.card').children('.card-body');
        if ($body.hasClass('collapse')) {
          $body.slideDown(function () {
            $(this).removeClass('collapse');
          });
        } else {
          $body.slideUp(function () {
            $(this).addClass('collapse');
          });
        }
      });
    },
    getSource: function getSource() {
      if (this.entity.images) {
        this.manuallyAddFiles();
      }
    },
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.images.length; i += 1) {
        var file = {
          file: {
            name: this.entity.images[i].file_name,
            size: this.entity.images[i].size
          },
          url: this.entity.images[i].public_url
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.images[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var fileIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(this.entity.images, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('domain', this.entity.domain);
      postFormData.append('type', this.entity.type);
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('local_institution', this.entity.local_institution ? this.entity.local_institution : '');
      postFormData.append('library', this.entity.library ? this.entity.library : '');
      if (this.entity.description) {
        postFormData.append('description', this.entity.description);
      }
      postFormData.append('published', this.entity.published || false);
      postFormData.append('address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.address));
      postFormData.append('mail_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.mail_address));
      postFormData.append('alt_address', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.address.alt_address));
      postFormData.append('contacts', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.contacts));
      postFormData.append('location', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.location));
      postFormData.append('sections', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.sections));
      postFormData.append('boxes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.boxes));
      return this.$apiHttp.post(this.$config.app_api.prefix + 'branch-offices/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].tokenStorage.name));
      if (this.toDeleteFiles.length) {
        var _loop = function _loop(i) {
          _this.$apiHttp.delete('' + _this.$config.app_api.host + _this.$config.app_api.prefix + 'branch-offices/' + _this.$route.params.id + '/images/' + _this.toDeleteFiles[i]).then(function () {
            _this.entity.files.splice(i, 1);
          }).catch(function (error) {
            console.error('error in delete file in site page request - ', error);
          });
        };

        for (var i = 0; i < this.toDeleteFiles.length; i += 1) {
          _loop(i);
        }
      }
      this.saveRequest().then(function () {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setSuccessNotification', 'Success!');
        $('.saving-alerts .alert-success').show();
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this.$route.params.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: 'branch_office'
          });
          vm.files = [];
        }
      }).catch(function (error) {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setDangerNotification', 'Error!');
        console.error('Error in update branch office query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);
















var SUCCESS = __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditAnnouncement',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],

  props: {
    itemToEdit: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      source: null,
      entity: {},

      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },

      files: [],
      uploadedFiles: [],
      toDeleteFile: null
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'announcement/' + this.itemToEdit.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.itemToEdit.id, 'announcement');
    },
    $_coverUrl: function $_coverUrl() {
      if (!this.source) {
        return null;
      }
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    $_coverIsChanged: function $_coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'announcements/' + this.itemToEdit.id, {
        params: {
          with: ['pdf', 'cover', 'branch']
        }
      }).then(function (response) {
        _this.source = response.data;
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        if (_this.entity.pdf) {
          setTimeout(_this.manuallyAddFiles, 100);
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting article request' });
        console.error('Error in get single article query', error);
      });
    },
    manuallyAddFiles: function manuallyAddFiles() {
      var file = {
        file: {
          name: this.entity.pdf.file_name,
          size: this.entity.pdf.size
        },
        url: this.entity.pdf.public_url,
        thumb: this.entity.pdf.thumbnail
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.pdf.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      this.toDeleteFile = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);
      if (this.entity.body) {
        postFormData.append('body', this.entity.body);
      }
      if (this.entity.publish_date) {
        postFormData.append('publish_date', this.entity.publish_date);
      }
      if (this.entity.unpublish_date) {
        postFormData.append('unpublish_date', this.entity.unpublish_date);
      }

      return this.$apiHttp.post(this.$config.app_api.prefix + 'announcements/' + this.entity.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      var vm = this;

      if (this.toDeleteFile) {
        this.$apiHttp.delete('' + this.$config.app_api.host + this.$config.app_api.prefix + 'announcements/' + this.entity.id + '/pdf').then(function () {
          _this2.entity.files = [];
        }).catch(function (error) {
          console.error('error in delete file in site page request - ', error);
        });
      }

      var dispatchStartUpload = function dispatchStartUpload(contentType) {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this2.entity.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: contentType
          });
          vm.files = [];
        }
      };

      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function (response) {
          $('.btn-success .btn-loader').hide();
          _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
          dispatchStartUpload(response.data.content_type);
        }).then(function () {
          _this2.$emit('changeMode');
        }).catch(function (error) {
          $('.btn-success .btn-loader').hide();
          _this2.$_errorSave(error);
          console.error('Error in update announcement query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            $('.btn-success .btn-loader').hide();
            _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
            dispatchStartUpload(entity.data.content_type);
            _this2.$emit('changeMode');
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            $('.btn-success .btn-loader').hide();
            _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
            dispatchStartUpload(entity.data.content_type);
            _this2.$emit('changeMode');
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    },
    $_coverRestore: function $_coverRestore() {
      this.entity.cover = this.source.cover;
    },
    $_coverRemove: function $_coverRemove() {
      this.entity.cover = null;
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'announcements/' + this.entity.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'announcements/' + this.entity.id + '/cover');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_vue__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__New_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__New_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__New_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Announcements',
  components: {
    Edit: __WEBPACK_IMPORTED_MODULE_5__Edit_vue___default.a,
    New: __WEBPACK_IMPORTED_MODULE_6__New_vue___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],
  data: function data() {
    return {
      mode: 1,
      itemToEdit: null,
      entities: []
    };
  },

  methods: {
    editItem: function editItem(item) {
      this.mode = 2;
      this.itemToEdit = item;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'announcements', {
        params: {
          with: ['pdf', 'cover'],
          branch_id: this.$route.params.id
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete newDataArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
            return newDataArr[e];
          });

          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    setMode: function setMode() {
      this.mode = 1;
      this.getSource();
    },
    setModeOnCreate: function setModeOnCreate() {
      this.mode = 1;
      this.getSource();
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(13);














var SUCCESS = __WEBPACK_IMPORTED_MODULE_5__helpers_constants__["b" /* uploadStatus */].SUCCESS;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewAnnouncement',
  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],
  data: function data() {
    return {
      entity: {
        title: '',
        body: '',
        publish_date: new Date().toISOString().slice(0, 10),
        unpublish_date: '',
        cover: null
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },
      files: [],
      uploadedFiles: [],
      toDeleteFiles: []
    };
  },

  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'announcements/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'announcements');
    }
  },
  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.getSource();
  },

  methods: {
    getSource: function getSource() {},
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var fileIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.entity.images, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);
      postFormData.append('body', this.entity.body);
      postFormData.append('publish_date', this.entity.publish_date);
      postFormData.append('unpublish_date', this.entity.unpublish_date);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'announcements', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].tokenStorage.name));
      var dispatchStartUpload = function dispatchStartUpload(contentType, entityId) {
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: contentType
          });
          vm.files = [];
        }
      };
      this.saveRequest().then(function (response) {
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setSuccessNotification', 'Success!');
        dispatchStartUpload(response.data.content_type, response.data.id);
        if (_this.entity.cover) {
          _this.saveCoverRequest(response.data.id);
        }
      }).then(function () {
        _this.$emit('changeModeOnCreate');
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in update announcement note query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest(entityId) {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      this.$apiHttp.post(this.$config.app_api.prefix + 'announcements/' + entityId + '/cover', postFormData);
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);















var SUCCESS = __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["b" /* uploadStatus */].SUCCESS;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditNewsNotes',
  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],
  props: {
    itemToEdit: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      source: null,
      entity: {},
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },
      files: [],
      uploadedFiles: [],
      toDeleteFile: null
    };
  },

  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'news_note/' + this.itemToEdit.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.itemToEdit.id, 'news_note');
    },
    $_coverUrl: function $_coverUrl() {
      if (!this.source) {
        return null;
      }
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    $_coverIsChanged: function $_coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    }
  },
  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {
    this.getSource();
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'news-notes/' + this.itemToEdit.id, {
        params: {
          with: ['pdf', 'cover', 'branch']
        }
      }).then(function (response) {
        _this.source = response.data;
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        if (_this.entity.pdf) {
          setTimeout(_this.manuallyAddFiles, 100);
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', {
          error: error,
          text: 'Error in getting news notes request'
        });
        console.error('Error in get single news note query', error);
      });
    },
    manuallyAddFiles: function manuallyAddFiles() {
      var file = {
        file: {
          name: this.entity.pdf.file_name,
          size: this.entity.pdf.size
        },
        url: this.entity.pdf.public_url,
        thumb: this.entity.pdf.thumbnail
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.pdf.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      this.toDeleteFile = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);
      if (this.entity.body) {
        postFormData.append('body', this.entity.body);
      }
      if (this.entity.publish_date) {
        postFormData.append('publish_date', this.entity.publish_date);
      }
      if (this.entity.unpublish_date) {
        postFormData.append('unpublish_date', this.entity.unpublish_date);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'news-notes/' + this.entity.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      var vm = this;
      if (this.toDeleteFile) {
        this.$apiHttp.delete('' + this.$config.app_api.host + this.$config.app_api.prefix + 'news-notes/' + this.entity.id + '/pdf').then(function () {
          _this2.entity.files = [];
        }).catch(function (error) {
          console.error('error in delete file in site page request - ', error);
        });
      }
      var dispatchStartUpload = function dispatchStartUpload(contentType) {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this2.entity.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: contentType
          });
          vm.files = [];
        }
      };
      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function (response) {
          $('.btn-success .btn-loader').hide();
          _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
          dispatchStartUpload(response.data.content_type);
        }).then(function () {
          _this2.$emit('changeMode');
        }).catch(function (error) {
          $('.btn-success .btn-loader').hide();
          _this2.$_errorSave(error);
          console.error('Error in update news note query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            $('.btn-success .btn-loader').hide();
            _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
            dispatchStartUpload(entity.data.content_type);
            _this2.$emit('changeMode');
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            $('.btn-success .btn-loader').hide();
            _this2.$store.commit('notifications/setSuccessNotification', 'Success!');
            dispatchStartUpload(entity.data.content_type);
            _this2.$emit('changeMode');
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    },
    $_coverRestore: function $_coverRestore() {
      this.entity.cover = this.source.cover;
    },
    $_coverRemove: function $_coverRemove() {
      this.entity.cover = null;
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'news-notes/' + this.entity.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'news-notes/' + this.entity.id + '/cover');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__New_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__New_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__New_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',
  components: {
    Edit: __WEBPACK_IMPORTED_MODULE_5__Edit_vue___default.a,
    New: __WEBPACK_IMPORTED_MODULE_6__New_vue___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],
  data: function data() {
    return {
      mode: 1,
      itemToEdit: null,
      entities: []
    };
  },

  methods: {
    editItem: function editItem(item) {
      this.mode = 2;
      this.itemToEdit = item;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'news-notes', {
        params: {
          with: ['pdf', 'cover'],
          branch_id: this.$route.params.id
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete newDataArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
            return newDataArr[e];
          });

          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    setMode: function setMode() {
      this.mode = 1;
      this.getSource();
    },
    setModeOnCreate: function setModeOnCreate() {
      this.mode = 1;
      this.getSource();
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(13);















var SUCCESS = __WEBPACK_IMPORTED_MODULE_5__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewNewsNotes',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: '',
        body: '',
        publish_date: new Date().toISOString().slice(0, 10),
        unpublish_date: '',
        cover: null
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048
      },

      files: [],
      uploadedFiles: [],
      toDeleteFiles: [],

      itemId: null
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'news-notes/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'news-notes');
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    getSource: function getSource() {},
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var fileIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.entity.images, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.images[fileIndex].id;
      this.toDeleteFiles.push(fileId);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);

      postFormData.append('body', this.entity.body);
      postFormData.append('publish_date', this.entity.publish_date);
      postFormData.append('unpublish_date', this.entity.unpublish_date);

      return this.$apiHttp.post(this.$config.app_api.prefix + 'news-notes', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].tokenStorage.name));

      var dispatchStartUpload = function dispatchStartUpload(contentType, entityId) {
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: contentType
          });
          vm.files = [];
        }
      };

      this.saveRequest().then(function (response) {
        _this.itemId = response.data.id;
        $('.btn-success .btn-loader').hide();
        _this.$store.commit('notifications/setSuccessNotification', 'Success!');
        dispatchStartUpload(response.data.content_type, response.data.id);
        if (_this.entity.cover) {
          _this.saveCoverRequest(response.data.id);
        }
      }).then(function () {
        _this.$emit('changeModeOnCreate');
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.log(error.response.data.errors);
      });
    },
    saveCoverRequest: function saveCoverRequest(entityId) {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      this.$apiHttp.post(this.$config.app_api.prefix + 'news-notes/' + entityId + '/cover', postFormData);
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_menu__ = __webpack_require__(69);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppContent',

  data: function data() {
    return {
      contentTypes: __WEBPACK_IMPORTED_MODULE_0__helpers_menu__["a" /* contentTypes */]
    };
  },

  computed: {
    isContentPage: function isContentPage() {
      return this.$route.path === '/admin/content';
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SmartImage__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SmartImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_SmartImage__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlbumAddTracks',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'smart-image': __WEBPACK_IMPORTED_MODULE_2__global_components_SmartImage___default.a
  },

  data: function data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceTracks: [],
      selectedTracks: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSourceTracks();
    }, 400),
    offset: function offset() {
      this.getSourceTracks();
    }
  },

  mounted: function mounted() {
    this.getSourceTracks();
  },


  methods: {
    shortTitle: function shortTitle(title) {
      if (title.length > 30) {
        return title.slice(0, 30) + '...';
      }
      return title;
    },
    addTrack: function addTrack(track) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.selectedTracks, function (item) {
        return track.id === item.id;
      });
      if (index === -1) {
        this.selectedTracks.push(track);
      }
    },
    deleteTrack: function deleteTrack(track) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.selectedTracks, function (item) {
        return item.id === track.id;
      });
      this.$forceUpdate();
    },
    getSourceTracks: function getSourceTracks() {
      var _this = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.sourceSpinner) {
            _this.$refs.sourceSpinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var tracksArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete tracksArr.meta;
          _this.sourceTracks = tracksArr;
        }
      }).catch(function (error) {
        if (_this.$refs.sourceSpinner) {
          _this.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    isEntityValid: function isEntityValid() {
      if (!this.selectedTracks.length) {
        this.errorSave('You should choose at least one audio track');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      for (var i = 0; i < this.selectedTracks.length; i += 1) {
        postFormData.append('ids[]', this.selectedTracks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id + '/attach/tracks', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.successSave();
        _this2.selectedTracks = [];
        _this2.$forceUpdate();
      }).catch(function (error) {
        _this2.errorSave('Error in data saving');
        console.error('Error in add tracks to audio album query', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__ = __webpack_require__(4);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlbumEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      coverWithoutChanges: true
    };
  },
  mounted: function mounted() {
    this.$_getDefaultCollections();
  },


  methods: {
    collectionSearch: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/audio-albums/collections?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        context.options = response.data;
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    $_coverChange: function $_coverChange(file) {
      this.coverWithoutChanges = false;
      this.entity.cover = file;
    },
    coverRemove: function coverRemove() {
      this.entity.cover = null;
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Collection', value: this.entity.collection, type: 'required' }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'cover', 'path_alias', 'collection', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting album request' });
        console.log('Error in get audio album query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id + '/cover', postFormData);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('collection', this.entity.collection ? this.entity.collection.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (this.entity.cover && !this.coverWithoutChanges) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update audio album query', error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Albums',

  components: {
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a,
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */]],
  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var albumsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete albumsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(albumsArr).map(function (e) {
            return albumsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlbumManageTracks',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      tracks: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getTracks();
    }, 400),
    offset: function offset() {
      this.getTracks();
    }
  },

  mounted: function mounted() {
    this.getTracks();
  },


  methods: {
    getTracks: function getTracks() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id + '/tracks', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var tracksArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete tracksArr.meta;
          tracksArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tracksArr).map(function (item) {
            return tracksArr[item];
          });
          if (!searchString) {
            _this.tracks = _this.orderByWeight(tracksArr);
          } else {
            _this.tracks = tracksArr;
          }
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    orderByWeight: function orderByWeight(arr) {
      return arr.sort(function (a, b) {
        var weightA = a.weight ? +a.weight : 0;
        var weightB = b.weight ? +b.weight : 0;
        if (weightA > weightB) {
          return 1;
        }
        return -1;
      });
    },
    deleteAudioTrack: function deleteAudioTrack(track) {
      var _this2 = this;

      if (window.confirm('Do you really want to detach audio track ' + track.title + ' with id = ' + track.id + '?')) {
        var postFormData = new FormData();
        var $btnDeleteLoader = $('table.entities tr[data-id="' + track.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        postFormData.append('ids[]', track.id);
        this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id + '/detach/tracks', postFormData).then(function () {
          $btnDeleteLoader.hide();
          _this2.getTracks();
        }).catch(function (error) {
          console.error('Error in detach audio track request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_DefaultOptionsRequests__ = __webpack_require__(14);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlbumNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        cover: null,
        collection: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultCollections();
  },


  methods: {
    collectionSearch: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/audio-albums/collections?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        context.options = response.data;
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Collection', value: this.entity.collection, type: 'required' }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('cover', this.entity.cover);
      if (this.entity.collection) postFormData.append('collection', this.entity.collection.id);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio-albums', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/media_audio_album/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create audio album query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slicksort__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slicksort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slicksort__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AlbumOrderTracks',

  components: {
    SlickItem: __WEBPACK_IMPORTED_MODULE_0_vue_slicksort__["SlickItem"],
    SlickList: __WEBPACK_IMPORTED_MODULE_0_vue_slicksort__["SlickList"]
  },

  data: function data() {
    return {
      tracks: [],
      saveErrorMessage: 'Error in data saving'
    };
  },
  mounted: function mounted() {
    this.getTracks();
  },


  methods: {
    getTracks: function getTracks() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio-albums/' + this.$route.params.id + '/tracks', {
        params: {
          nonpaginated: true
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.tracks = _this.orderByWeight(response.data);
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    orderByWeight: function orderByWeight(arr) {
      return arr.sort(function (a, b) {
        var weightA = a.weight ? +a.weight : 0;
        var weightB = b.weight ? +b.weight : 0;
        if (weightA > weightB) {
          return 1;
        }
        return -1;
      });
    },
    save: function save() {
      var _this2 = this;

      $(this.$refs.saveBtnLoader).show();
      for (var i = 0; i < this.tracks.length; i += 1) {
        this.tracks[i].weight = i;
      }
      this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio/' + this.$route.params.id + '/tracks/bulk-update', {
        items: this.tracks
      }).then(function () {
        $(_this2.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-success').show();
      }).catch(function (error) {
        $(_this2.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-danger').show();
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(13);
















var SUCCESS = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleEdit',

  components: {
    'open-on-site': __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      },
      uploadedFiles: [],
      files: []
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'files[]',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'articles/' + this.$route.params.id + '/files',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'article');
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');

            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  methods: {
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.files.length; i += 1) {
        var file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileAdded: function fileAdded(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      var fileIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.entity.files, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.files[fileIndex].id;
      this.$apiHttp.delete(this.$config.app_api.prefix + 'articles/' + this.$route.params.id + '/files/' + fileId).then(function () {
        _this.entity.files.splice(fileIndex, 1);
        _this.files = _this.files.filter(function (item) {
          return file !== item;
        });
      }).catch(function (err) {
        console.error('error in delete file in site page request - ', err);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Body', value: this.entity.body, type: 'required' }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'articles/' + this.$route.params.id, {
        params: {
          with: ['references', 'files', 'cover', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this2.source, 'cover')) {
          _this2.source.cover = null;
        }
        _this2.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        setTimeout(_this2.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting article request' });
        console.error('Error in get single article query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'articles/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'articles/' + this.$route.params.id + '/cover');
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      var entity = this.entity;

      postFormData.append('title', entity.title);
      postFormData.append('body', entity.body);
      postFormData.append('featured', entity.featured.section_id ? entity.featured.section_id : '');
      postFormData.append('featured_body', entity.featured.featured_body ? entity.featured.featured_body : '');
      return this.$apiHttp.post(this.$config.app_api.prefix + 'articles/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].tokenStorage.name));
      var vm = this;
      var entityId = this.$route.params.id;
      var dispatchStartUpload = function dispatchStartUpload(contentType) {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: contentType
          });
          vm.files = [];
        }
      };
      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function (response) {
          _this3.$_successSave();
          dispatchStartUpload(response.data.content_type);
        }).catch(function (error) {
          _this3.$_errorSave(error);
          console.error('Error in update article query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'articles' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var articlesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete articlesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(articlesArr).map(function (e) {
            return articlesArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(13);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        files: [],
        cover: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 50,
        maxFilesize: 100,
        addRemoveLinks: true,
        accept: function accept() {}
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Body', value: this.entity.body, type: 'required' }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    filesChanged: function filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.files.length) {
        postFormData.append('chunkedFile', true);
      }
      if (this.entity.cover) postFormData.append('cover', this.entity.cover);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'articles', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var files = this.entity.files;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: response.data.content_type
          });
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/article/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create article query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_CommonPageMixin__ = __webpack_require__(4);
















var SUCCESS = __WEBPACK_IMPORTED_MODULE_7__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudioEdit',

  components: {
    FileUploader: __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      currentFile: null,
      uploadedFile: null,
      audioFile: null,
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'audio/*'
      }
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token
        },
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'media/audio/' + this.$route.params.id + '/file',
        paramName: 'mediaFile',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFile: function uploadingFile() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_audio');
    }
  },

  watch: {
    uploadingFile: {
      handler: function handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedFile = val.file;
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultAlbums();
    this.$_getDefaultDocuments();
  },


  methods: {
    albumSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/audio-albums?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    transcriptionSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/documents?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio/' + this.$route.params.id, {
        params: {
          with: ['references', 'mediaFile', 'album', 'terms', 'path_alias', 'transcription', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        if (_this.entity.mediaFile) {
          setTimeout(_this.manuallyAddFiles, 100);
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting audio request' });
        console.error(error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.audioFile.uploadType === 'url' && this.audioFile.fileLink) {
        postFormData.append('selectel_file_url', this.audioFile.fileLink);
      }
      postFormData.append('album_id', this.entity.album ? +this.entity.album.id : '');
      postFormData.append('transcription', this.entity.transcription ? this.entity.transcription.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _audioFile = this.audioFile,
          file = _audioFile.file,
          uploadType = _audioFile.uploadType;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].tokenStorage.name));
      var currentFile = this.currentFile;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var entityId = this.$route.params.id;
      var vm = this;
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (!file) return;
        var isFileChanged = file.name !== (currentFile ? currentFile.name : '');
        if (isFileChanged && uploadType === 'file') {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
          vm.currentFile = file;
        }
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update article query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudioList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    validateUrl: function validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/audio' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var audioArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete audioArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(audioArr).map(function (e) {
            return audioArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_DefaultOptionsRequests__ = __webpack_require__(14);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudioNew',

  components: {
    FileUploader: __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_SelectRemote___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    var _this = this;

    return {
      audioFile: null,
      entity: {
        title: null,
        date: '',
        body: null,
        summary: null,
        mediaFile: null,
        album: null,
        transcription: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'audio/*',
        autoProcessQueue: false,
        addRemoveLinks: true,
        accept: function accept(file, done) {
          var filesArray = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this.$refs.fileUploader.$refs.dropzone.files, function (item) {
            return item.status !== 'error';
          });
          if (filesArray.length > 1) {
            done('You can upload 1 file maximum');
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultAlbums();
    this.$_getDefaultDocuments();
  },


  methods: {
    albumSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/audio-albums?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    transcriptionSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/documents?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      var audioFile = this.audioFile;

      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }];
      if (audioFile.uploadType === 'url') {
        filelds.push({ name: 'Audio file', value: audioFile.fileLink, type: 'required' });
      } else {
        filelds.push({ name: 'Audio file', value: audioFile.file, type: 'required' });
      }
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.audioFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      } else {
        postFormData.append('selectel_file_url', this.audioFile.fileLink);
      }
      if (this.entity.album) postFormData.append('album_id', +this.entity.album.id);
      if (this.entity.transcription) postFormData.append('transcription', +this.entity.transcription.id);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/audio', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _audioFile = this.audioFile,
          file = _audioFile.file,
          uploadType = _audioFile.uploadType;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (file && uploadType === 'file') {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
        }
        _this2.$parent.getSource();
        window.location.hash = '#/admin/content/media_audio/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this2.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_CommonPageMixin__ = __webpack_require__(4);



















var SUCCESS = __WEBPACK_IMPORTED_MODULE_10__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CorrespondenceEdit',

  components: {
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_7__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'application/pdf'
      },
      pdf: null,
      uploadedPdf: null
    };
  },


  computed: {
    corrTypesList: function corrTypesList() {
      return this.$store.state.corrTypes.list;
    },
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token
        },
        paramName: 'pdf',

        url: '/',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        autoProcessQueue: false,
        addRemoveLinks: true,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFile: function uploadingFile() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'correspondence');
    }
  },

  watch: {
    uploadingFile: {
      handler: function handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedPdf = val.file;
          this.$refs.dropzone.manuallyAddFile(val.file);
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultLocations();
    this.$_getDefaultPeople();
  },


  methods: {
    formatCorrType: function formatCorrType(type) {
      return type.replace(/_/g, ' ');
    },

    locationSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'locations?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        loading(false);
        var entities = response.data;
        delete entities.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(entities).map(function (e) {
          return entities[e];
        });
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    personSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'people?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        loading(false);
        var entities = response.data;
        delete entities.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(entities).map(function (e) {
          return entities[e];
        });
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    manuallyAddFiles: function manuallyAddFiles() {
      var file = {
        file: {
          name: this.entity.pdf.file_name,
          size: this.entity.pdf.size
        },
        url: this.entity.pdf.public_url,
        thumb: this.entity.pdf.thumbnail
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.pdf.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileAdded: function fileAdded(file) {
      this.pdf = file;
    },
    fileRemoved: function fileRemoved() {
      var _this = this;

      this.$apiHttp.delete(this.$config.app_api.prefix + 'correspondence/' + this.$route.params.id + '/pdf').then(function () {
        _this.pdf = null;
      }).catch(function (error) {
        console.error('error in delete pdf in correspondence request - ', error);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Type', value: this.entity.title, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'correspondence/' + this.$route.params.id, {
        params: {
          with: ['references', 'pdf', 'receiversCollection', 'sendersCollection', 'senderLocation', 'receiverLocation', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        _this2.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        if (_this2.entity.pdf) {
          setTimeout(_this2.manuallyAddFiles, 100);
        }
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting correspondence request' });
        console.error('Error in get single correspondence query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('text', this.entity.text ? this.entity.text : '');
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('type', this.entity.type);
      if (this.entity.receiver_location) postFormData.append('receiver_location', this.entity.receiver_location.id);
      if (this.entity.sender_location) postFormData.append('sender_location', this.entity.sender_location.id);
      for (var i = 0; i < this.entity.senders.length; i += 1) {
        postFormData.append('senders[]', this.entity.senders[i].id);
      }
      for (var _i = 0; _i < this.entity.receivers.length; _i += 1) {
        postFormData.append('receivers[]', this.entity.receivers[_i].id);
      }
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'correspondence/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].tokenStorage.name));
      var vm = this;
      var pdf = this.pdf;

      var entityId = this.$route.params.id;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var currFileName = this.entity.pdf ? this.entity.pdf.file_name : '';
      if (!currFileName) {
        currFileName = this.uploadedPdf ? this.uploadedPdf.name : '';
      }
      this.saveRequest().then(function (response) {
        _this3.$_successSave();
        if (pdf && pdf.name !== currFileName) {
          _this3.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [pdf],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
          vm.uploadedPdf = pdf;
        }
      }).catch(function (error) {
        _this3.$_errorSave(error);
        console.error('Error in update correspondence query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CorrespondenceList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      publishChoosenCorrType: 'je_white_letters',
      filterChoosenCorrType: ''
    };
  },

  computed: {
    corrTypes: function corrTypes() {
      return this.$store.state.corrTypes.list;
    }
  },

  methods: {
    validateUrl: function validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    changeCorrTypePublished: function changeCorrTypePublished(published) {
      if (window.confirm('Are you sure?')) {
        var $loader = published ? $(this.$refs.publishGroupLoader) : $(this.$refs.unpublishGroupLoader);
        $loader.show();
        this.$apiHttp.post(this.$config.app_api.prefix + 'correspondence/change-publishing-status', {
          status: published ? 1 : 0,
          type: this.publishChoosenCorrType
        }).then(function () {
          $loader.hide();
        }).catch(function (error) {
          $loader.hide();
          console.error('Error in publishing/unpublishing corr type', error);
        });
      }
    },
    changeFilterChoosenCorrType: function changeFilterChoosenCorrType() {
      this.offset = 0;
      this.getSource();
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'correspondence' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page,
          type: this.filterChoosenCorrType ? this.filterChoosenCorrType : ''
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var correspondenceArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete correspondenceArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(correspondenceArr).map(function (e) {
            return correspondenceArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    },
    parsedCorrType: function parsedCorrType(str) {
      return str.replace(/_/g, ' ');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__ = __webpack_require__(14);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CorrespondenceNew',

  components: {
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_6__global_components_SelectRemote___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    var _this = this;

    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        text: null,
        date: null,
        type: null,
        receivers: [],
        senders: [],
        receivers_location: null,
        senders_location: null,
        pdf: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        addRemoveLinks: true,
        acceptedFiles: 'application/',
        autoProcessQueue: false,
        accept: function accept(file, done) {
          var filesArray = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.$refs.dropzone.dropzone.files, function (item) {
            return item.status !== 'error';
          });
          if (filesArray.length > 1) {
            done('You can upload 1 file maximum');
          }
        }
      }
    };
  },


  computed: {
    corrTypesList: function corrTypesList() {
      return this.$store.state.corrTypes.list;
    }
  },

  mounted: function mounted() {
    this.$_getDefaultPeople();
    this.$_getDefaultLocations();
  },


  methods: {
    formatCorrType: function formatCorrType(type) {
      return type.replace(/_/g, ' ');
    },

    locationSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'locations?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        loading(false);
        var entities = response.data;
        delete entities.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(entities).map(function (e) {
          return entities[e];
        });
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    personSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'people?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        loading(false);
        var entities = response.data;
        delete entities.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(entities).map(function (e) {
          return entities[e];
        });
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Type', value: this.entity.title, type: 'required' }]);
    },
    fileChanged: function fileChanged() {
      var filesArray = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$refs.dropzone.dropzone.files, function (item) {
        return item.status !== 'error';
      });

      var _filesArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(filesArray, 1);

      this.entity.pdf = _filesArray[0];
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.entity.text) postFormData.append('text', this.entity.text);
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.type) postFormData.append('type', this.entity.type);
      if (this.entity.pdf) postFormData.append('chunkedFile', true);
      if (this.entity.receivers_location) postFormData.append('receiver_location', this.entity.receivers_location.id);
      if (this.entity.senders_location) postFormData.append('sender_location', this.entity.senders_location.id);
      if (this.entity.senders) {
        for (var i = 0; i < this.entity.senders.length; i += 1) {
          postFormData.append('senders[]', this.entity.senders[i].id);
        }
      }
      if (this.entity.receivers) {
        for (var _i = 0; _i < this.entity.receivers.length; _i += 1) {
          postFormData.append('receivers[]', this.entity.receivers[_i].id);
        }
      }
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'correspondence', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var file = this.$refs.dropzone.dropzone.files[0];
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (file) {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
        }
        _this2.$parent.getSource();
        window.location.hash = '#/admin/content/correspondence/edit/' + response.data.id;
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in create correspondence query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentFilesAddDocs',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceDocs: [],
      selectedDocs: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSourceDocs();
    }, 400),
    offset: function offset() {
      this.getSourceDocs();
    }
  },

  mounted: function mounted() {
    this.getSourceDocs();
  },


  methods: {
    shortTitle: function shortTitle(title) {
      if (title.length > 30) {
        return title.slice(0, 30) + '...';
      }
      return title;
    },
    addDoc: function addDoc(doc) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.selectedDocs, function (item) {
        return doc.id === item.id;
      });
      if (index === -1) {
        this.selectedDocs.push(doc);
      }
    },
    deleteDoc: function deleteDoc(doc) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.selectedDocs, function (item) {
        return item.id === doc.id;
      });
      this.$forceUpdate();
    },
    getSourceDocs: function getSourceDocs() {
      var _this = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.sourceSpinner) {
            _this.$refs.sourceSpinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var docsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete docsArr.meta;
          _this.sourceDocs = docsArr;
        }
      }).catch(function (error) {
        if (_this.$refs.sourceSpinner) {
          _this.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    isEntityValid: function isEntityValid() {
      if (!this.selectedDocs.length) {
        this.errorSave('You should choose at least one document');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      for (var i = 0; i < this.selectedDocs.length; i += 1) {
        postFormData.append('ids[]', this.selectedDocs[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/document-files/' + this.$route.params.id + '/attach/media-docs', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.successSave();
        _this2.selectedDocs = [];
        _this2.$forceUpdate();
      }).catch(function (error) {
        _this2.errorSave('Error in data saving');
        console.error('Error in add docs to document files query', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentFilesEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'File Number', value: this.entity.file_number, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/document-files/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting DF request' });
        console.error('Error in get single document files query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('file_number', this.entity.file_number);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/document-files/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update document files query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentFilesList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/document-files' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var documentFilesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete documentFilesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(documentFilesArr).map(function (e) {
            return documentFilesArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentFilesManageDocs',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      docs: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getDocs();
    }, 400),
    offset: function offset() {
      this.getDocs();
    }
  },

  mounted: function mounted() {
    this.getDocs();
  },


  methods: {
    getDocs: function getDocs() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/document-files/' + this.$route.params.id + '/media-docs', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var docsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete docsArr.meta;
          _this.docs = docsArr;
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    deleteMediaDoc: function deleteMediaDoc(doc) {
      var _this2 = this;

      if (window.confirm('Do you really want to detach document ' + doc.title + ' with id = ' + doc.id + '?')) {
        var postFormData = new FormData();
        var $btnDeleteLoader = $('table.entities tr[data-id="' + doc.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        postFormData.append('ids[]', doc.id);
        this.$apiHttp.post(this.$config.app_api.prefix + 'media/document-files/' + this.$route.params.id + '/detach/media-docs', postFormData).then(function () {
          console.log('Document ' + doc.title + ' with ID = ' + doc.id + ' has detached');
          $btnDeleteLoader.hide();
          _this2.getDocs();
        }).catch(function (error) {
          console.error('Error in detach document request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentFilesNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        file_number: null,
        published: true,
        featured: 0,
        featuredBody: '',
        seo_title: '',
        seo_description: '',
        path_alias: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'File Number', value: this.entity.file_number, type: 'required' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('file_number', this.entity.file_number);
      postFormData.append('published', this.entity.published ? true : '');
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/document-files', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/document_files/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create documentFiles query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_CommonPageMixin__ = __webpack_require__(4);



















var SUCCESS = __WEBPACK_IMPORTED_MODULE_10__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentEdit',

  components: {
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_9__global_components_OpenOnSiteButton___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_8__global_components_Datepicker___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 2048
      },
      saveErrorMessage: '',
      file: null,
      uploadedFile: null
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'media',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'media/documents/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFile: function uploadingFile() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_doc');
    }
  },

  watch: {
    uploadingFile: {
      handler: function handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          var dropzone = this.$refs.dropzone;

          dropzone.removeAllFiles();
          dropzone.manuallyAddFile(val.file, '/');
          this.uploadedFile = val.file;
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultDF();
    this.$_getDefaultPeople();
    this.$_getDefaultQa();
  },


  methods: {
    docFilesSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/document-files?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    qaSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'questions-and-answers?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    peopleSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'people?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    manuallyAddFiles: function manuallyAddFiles() {
      var file = {
        file: {
          name: this.entity.mediaFile.file_name,
          size: this.entity.mediaFile.size
        },
        url: this.entity.mediaFile.public_url,
        thumb: this.entity.mediaFile.thumbnail
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.mediaFile.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileAdded: function fileAdded(file) {
      this.file = file;
    },
    fileRemoved: function fileRemoved() {
      this.file = null;
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents/' + this.$route.params.id, {
        params: {
          with: ['references', 'mediaFile', 'terms', 'path_alias', 'document_files', 'author', 'receiver', 'questions_and_answers', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        if (_this.entity.mediaFile) setTimeout(_this.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting document request' });
        console.log('Error in get document query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('text', this.entity.text ? this.entity.text : '');
      postFormData.append('summary', this.entity.summary ? this.entity.summary : '');
      for (var i = 0; i < this.entity.document_files.length; i += 1) {
        postFormData.append('document_files_ids[]', this.entity.document_files[i].id);
      }
      for (var _i = 0; _i < this.entity.questions_and_answers.length; _i += 1) {
        postFormData.append('questions_and_answers[]', this.entity.questions_and_answers[_i].id);
      }
      if (this.entity.date) postFormData.append('date', this.entity.date);
      postFormData.append('author_id', this.entity.author ? this.entity.author.id : '');
      postFormData.append('receiver_id', this.entity.receiver ? this.entity.receiver.id : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/documents/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var uploadedFile = this.uploadedFile,
          file = this.file;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var vm = this;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (file && !file.manuallyAdded && uploadedFile !== file) {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this2.$route.params.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
          vm.uploadedFile = file;
        }
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update document query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Documents',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      id: 0,
      alias: ''
    };
  },


  methods: {
    validateUrl: function validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var documentsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete documentsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(documentsArr).map(function (e) {
            return documentsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__ = __webpack_require__(14);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentNew',

  components: {
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_4__global_components_MultiselectRemote___default.a,
    'select-remote': __WEBPACK_IMPORTED_MODULE_5__global_components_SelectRemote___default.a,
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_9__global_components_Datepicker___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    var _this = this;

    return {
      entity: {
        title: null,
        body: null,
        text: null,
        summary: null,
        media: null,
        document_files: [],
        questions_and_answers: [],
        seo_title: '',
        seo_description: '',
        date: null,
        author: null,
        receiver: null,
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFilesize: 2048,
        maxFiles: 100,
        addRemoveLinks: true,
        acceptedFiles: 'application/*',
        autoProcessQueue: false,
        accept: function accept(file, done) {
          var filesArray = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.$refs.dropzone.dropzone.files, function (item) {
            return item.status !== 'error';
          });
          if (filesArray.length > 1) {
            done('You can upload 1 file maximum');
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultDF();
    this.$_getDefaultPeople();
    this.$_getDefaultQa();
  },


  methods: {
    docFilesSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/document-files?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    qaSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'questions-and-answers?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    peopleSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'people?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'File', value: this.entity.media, type: 'required' }]);
    },
    fileChanged: function fileChanged() {
      var filesArray = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$refs.dropzone.dropzone.files, function (item) {
        return item.status !== 'error';
      });

      var _filesArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(filesArray, 1);

      this.entity.media = _filesArray[0];
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('text', this.entity.text ? this.entity.text : '');
      postFormData.append('summary', this.entity.summary ? this.entity.summary : '');

      postFormData.append('chunkedFile', true);
      for (var i = 0; i < this.entity.document_files.length; i += 1) {
        postFormData.append('document_files_ids[]', this.entity.document_files[i].id);
      }
      for (var _i = 0; _i < this.entity.questions_and_answers.length; _i += 1) {
        postFormData.append('questions_and_answers[]', this.entity.questions_and_answers[_i].id);
      }
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.author) postFormData.append('author_id', this.entity.author.id);
      if (this.entity.receiver) postFormData.append('receiver_id', this.entity.receiver.id);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/documents', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var file = this.$refs.dropzone.dropzone.files[0];
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (file) {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token: token,
            contentType: response.data.content_type
          });
        }
        _this2.$parent.getSource();
        window.location.hash = '#/admin/content/media_doc/edit/' + response.data.id;
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in create document query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__ = __webpack_require__(4);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EventEdit',

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.body) {
        this.$_showError('Body field is required');
        return false;
      }
      if (this.entity.date_start && this.entity.date_end && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.entity.date_start).isAfter(this.entity.date_end)) {
        this.$_showError('Start date must be earlier then finish date or equal');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'events/' + this.$route.params.id, {
        params: {
          with: ['references', 'cover', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting event request' });
        console.error('Error in get single event query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'events/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'events/' + this.$route.params.id + '/cover');
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      var entity = this.entity;

      postFormData.append('title', entity.title);
      postFormData.append('body', entity.body);
      postFormData.append('date_start', entity.date_start ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(entity.date_start).format('YYYY-MM-DD') : '');
      postFormData.append('date_end', entity.date_end ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(entity.date_end).format('YYYY-MM-DD') : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'events/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update event query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Events',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'events' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var eventsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete eventsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(eventsArr).map(function (e) {
            return eventsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EventNew',

  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        date_start: null,
        date_end: null,
        body: null,
        summary: null,
        cover: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.body) {
        this.$_showError('Body field is required');
        return false;
      }
      if (this.entity.date_start && this.entity.date_end && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.entity.date_start).isAfter(this.entity.date_end)) {
        this.$_showError('Start date must be earlier then finish date or equal');
        return false;
      }
      if (this.entity.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.date_start) postFormData.append('date_start', this.entity.date_start);
      if (this.entity.date_end) postFormData.append('date_end', this.entity.date_end);
      if (this.entity.cover) postFormData.append('cover', this.entity.cover);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'events', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/event/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create event query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaqEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'faq/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting faq request' });
        console.error('Error in get single faq query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'faq/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update faq query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaqList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'faq' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var faqArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete faqArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(faqArr).map(function (e) {
            return faqArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaqNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        body: null,
        summary: null,
        featured: false,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'faq', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/faq/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create faq query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GalleryAddImages',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceImages: [],
      selectedImages: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSourceImages();
    }, 400),
    offset: function offset() {
      this.getSourceImages();
    }
  },

  mounted: function mounted() {
    this.getSourceImages();
  },


  methods: {
    shortTitle: function shortTitle(title) {
      if (title.length > 30) {
        return title.slice(0, 30) + '...';
      }
      return title;
    },
    addImage: function addImage(image) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.selectedImages, function (item) {
        return image.id === item.id;
      });
      if (index === -1) {
        this.selectedImages.push(image);
      }
    },
    deleteImage: function deleteImage(image) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.selectedImages, function (item) {
        return item.id === image.id;
      });
      this.$forceUpdate();
    },
    getSourceImages: function getSourceImages() {
      var _this = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/images?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.sourceSpinner) {
            _this.$refs.sourceSpinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var imagesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete imagesArr.meta;
          _this.sourceImages = imagesArr;
        }
      }).catch(function (error) {
        if (_this.$refs.sourceSpinner) {
          _this.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    isEntityValid: function isEntityValid() {
      if (!this.selectedImages.length) {
        this.errorSave('You should choose at least one image');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      for (var i = 0; i < this.selectedImages.length; i += 1) {
        postFormData.append('ids[]', this.selectedImages[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id + '/attach/images', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.successSave();
        _this2.selectedImages = [];
        _this2.$forceUpdate();
      }).catch(function (error) {
        _this2.errorSave('Error in data saving');
        console.error('Error in create add images to gallery query', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__ = __webpack_require__(4);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GalleryEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'cover', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting gallery request' });
        console.error('Error in get image gallery query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id + '/cover', postFormData);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (this.entity.cover && this.$_coverIsChanged) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }, function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update image gallery query', error);
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update image gallery query', error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Gallery',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/image-galleries' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var imageGalleriesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete imageGalleriesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(imageGalleriesArr).map(function (e) {
            return imageGalleriesArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GalleryManageImages',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      images: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getImages();
    }, 400),
    offset: function offset() {
      this.getImages();
    }
  },

  mounted: function mounted() {
    this.getImages();
  },


  methods: {
    getImages: function getImages() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id + '/images', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var imagesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete imagesArr.meta;
          _this.images = imagesArr;
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    deleteImage: function deleteImage(image) {
      var _this2 = this;

      if (window.confirm('Do you really want to detach Image ' + image.title + ' with id = ' + image.id + '?')) {
        var $btnDeleteLoader = $('table.entities tr[data-id="' + image.id + '"] .btn-danger .btn-loader');
        var postFormData = new FormData();
        $btnDeleteLoader.show();
        postFormData.append('ids[]', image.id);
        this.$apiHttp.post(this.$config.app_api.prefix + 'media/image-galleries/' + this.$route.params.id + '/detach/images', postFormData).then(function () {
          console.log('Image Galleries ' + image.title + ' with ID = ' + image.id + ' has detached');
          $btnDeleteLoader.hide();
          _this2.getImages();
        }).catch(function (error) {
          console.error('Error in detach image request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GalleryNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        cover: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('cover', this.entity.cover);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/image-galleries', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/media_image_gallery/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create image gallery query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_CommonPageMixin__ = __webpack_require__(4);


















var SUCCESS = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageEdit',

  components: {
    'open-on-site': __WEBPACK_IMPORTED_MODULE_7__global_components_OpenOnSiteButton___default.a,
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_3__global_components_MultiselectRemote___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default.a,
    FileUploader: __WEBPACK_IMPORTED_MODULE_2__global_components_FileUploader_Index___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      uploadedFile: null,
      imageFile: null,
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 512
      }
    };
  },

  computed: {
    mediaFileIsChanged: function mediaFileIsChanged() {
      if (!this.source.mediaFile) {
        return !!this.entity.mediaFile;
      }
      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(this.entity.mediaFile) && this.entity.mediaFile.id === this.source.mediaFile.id) {
        return false;
      }
      return true;
    },
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'mediaFile',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'media/images/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFile: function uploadingFile() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'media_image');
    }
  },

  watch: {
    uploadingFile: {
      handler: function handler(val) {
        if (this.uploadingFile && this.uploadingFile.status === SUCCESS) {
          this.uploadedFile = val.file;
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultGalleries();
  },


  methods: {
    galleriesSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/image-galleries?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    mediaFileChange: function mediaFileChange(file) {
      this.entity.mediaFile = file;
    },
    mediaFileRemove: function mediaFileRemove() {
      this.entity.mediaFile = null;
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/images/' + this.$route.params.id, {
        params: {
          with: ['references', 'mediaFile', 'galleries', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'mediaFile')) {
          _this.source.mediaFile = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting image request' });
        console.error('Error in get image query', error);
      });
    },
    saveMediaFileRequest: function saveMediaFileRequest() {
      var postFormData = new FormData();
      postFormData.append('media', this.entity.mediaFile);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/images/' + this.$route.params.id + '/file', postFormData);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.imageFile.uploadType === 'url' && this.imageFile.fileLink) {
        postFormData.append('selectel_file_url', this.imageFile.fileLink);
      }
      for (var i = 0; i < this.entity.galleries.length; i += 1) {
        postFormData.append('gallery_ids[]', this.entity.galleries[i].id);
      }
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/images/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var _imageFile = this.imageFile,
          file = _imageFile.file,
          uploadType = _imageFile.uploadType;
      var uploadedFile = this.uploadedFile;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (file && uploadType === 'file' && !file.manuallyAdded && file !== uploadedFile) {
          _this2.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: _this2.$route.params.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
          _this2.uploadedFile = file;
        }
      }, function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update image query', error);
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update image query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Images',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/images' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var imagesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete imagesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(imagesArr).map(function (e) {
            return imagesArr[e];
          });
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    deleteEntity: function deleteEntity(entity) {
      var _this2 = this;

      if (window.confirm('Do you really want to delete  ' + entity.title + ' with id = ' + entity.id + '?')) {
        var $btnDeleteLoader = $('table.entities tr[data-id="' + entity.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        this.$apiHttp.delete('' + this.$config.app_api.prefix + entity.id).then(function () {
          console.log('Image ' + entity.title + ' with ID = ' + entity.id + ' has deleted');
          $btnDeleteLoader.hide();
          _this2.getSourceFetchPolicy = 'network-only';
          _this2.getSource();
        }).catch(function (error) {
          _this2.$_errorCallback(error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_DefaultOptionsRequests__ = __webpack_require__(14);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageNew',

  components: {
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_2__global_components_MultiselectRemote___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a,
    FileUploader: __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_Index___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        date: null,
        body: null,
        summary: null,
        media: null,
        galleries: [],
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: false,
        featuredBody: ''
      },
      imageFile: null,
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 2048,
        addRemoveLinks: true,
        acceptedFiles: 'image/*',
        autoProcessQueue: false,
        accept: function accept() {}
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultGalleries();
  },


  methods: {
    galleriesSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/image-galleries?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.imageFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      } else {
        postFormData.append('selectel_file_url', this.imageFile.fileLink);
      }
      for (var i = 0; i < this.entity.galleries.length; i += 1) {
        postFormData.append('gallery_ids[]', this.entity.galleries[i].id);
      }
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/images', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _imageFile = this.imageFile,
          file = _imageFile.file,
          uploadType = _imageFile.uploadType;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this.$_successSave();
        if (file && uploadType === 'file') {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/media_image/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create image query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesAndAnswersEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'issues-and-answers/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting I&A request' });
        console.error('Error in get single I&A query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'issues-and-answers/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update I&A query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesAndAnswersList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'issues-and-answers' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var issuesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete issuesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(issuesArr).map(function (e) {
            return issuesArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IssuesAndAnswersNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'issues-and-answers', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/issues_and_answers/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create Issues And Answers entity', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_CommonPageMixin__ = __webpack_require__(4);


















var SUCCESS = __WEBPACK_IMPORTED_MODULE_9__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonEdit',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default.a,
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      },
      uploadedFiles: [],
      files: []
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'files[]',

        url: '/',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'lesson');
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultDocuments();
    this.$_getDefaultAudio();
  },


  methods: {
    documentSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'content-types/media_doc?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    audioSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'content-types/media_audio?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.files.length; i += 1) {
        var file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      var fileIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(this.entity.files, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.files[fileIndex].id;
      this.$apiHttp.delete(this.$config.app_api.prefix + 'lessons/' + this.$route.params.id + '/files/' + fileId).then(function () {
        _this.entity.files.splice(fileIndex, 1);
        _this.files = _this.files.filter(function (item) {
          return file !== item;
        });
      }).catch(function (error) {
        console.error('error in delete file in site page request - ', error);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'lessons/' + this.$route.params.id, {
        params: {
          with: ['references', 'files', 'terms', 'path_alias', 'audio', 'lesson_plans', 'teachers_keys', 'activities', 'books', 'chapter_study_guides', 'coloring_sheets', 'overviews', 'featured']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        _this2.entity = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        setTimeout(_this2.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting lesson request' });
        console.error('Error in get single lesson query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      for (var i = 0; i < this.entity.audio.length; i += 1) {
        postFormData.append('audio[]', this.entity.audio[i].id);
      }
      for (var _i = 0; _i < this.entity.activities.length; _i += 1) {
        postFormData.append('activities[]', this.entity.activities[_i].id);
      }
      for (var _i2 = 0; _i2 < this.entity.teachers_keys.length; _i2 += 1) {
        postFormData.append('teachers_keys[]', this.entity.teachers_keys[_i2].id);
      }
      for (var _i3 = 0; _i3 < this.entity.lesson_plans.length; _i3 += 1) {
        postFormData.append('lesson_plans[]', this.entity.lesson_plans[_i3].id);
      }
      for (var _i4 = 0; _i4 < this.entity.overviews.length; _i4 += 1) {
        postFormData.append('overviews[]', this.entity.overviews[_i4].id);
      }
      for (var _i5 = 0; _i5 < this.entity.books.length; _i5 += 1) {
        postFormData.append('books[]', this.entity.books[_i5].id);
      }
      for (var _i6 = 0; _i6 < this.entity.chapter_study_guides.length; _i6 += 1) {
        postFormData.append('chapter_study_guides[]', this.entity.chapter_study_guides[_i6].id);
      }
      for (var _i7 = 0; _i7 < this.entity.coloring_sheets.length; _i7 += 1) {
        postFormData.append('coloring_sheets[]', this.entity.coloring_sheets[_i7].id);
      }
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'lessons/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var vm = this;
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      var entityId = this.$route.params.id;
      this.saveRequest().then(function (response) {
        _this3.$_successSave();
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: response.data.content_type
          });
        }
        vm.files = [];
      }).catch(function (error) {
        _this3.$_errorSave(error);
        console.error('Error in update lesson query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Lessons',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'lessons' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var lessonsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete lessonsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lessonsArr).map(function (e) {
            return lessonsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_DefaultOptionsRequests__ = __webpack_require__(14);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LessonNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default.a,
    'multiselect-remote': __WEBPACK_IMPORTED_MODULE_5__global_components_MultiselectRemote___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        files: [],
        audio: [],
        activities: [],
        teachers_keys: [],
        lesson_plans: [],
        overviews: [],
        books: [],
        chapter_study_guides: [],
        coloring_sheets: [],
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 50,
        maxFilesize: 100,
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept: function accept() {}
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultDocuments();
    this.$_getDefaultAudio();
  },


  methods: {
    documentSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'content-types/media_doc?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    audioSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'content-types/media_audio?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    filesChanged: function filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);

      if (this.entity.files.length) {
        postFormData.append('chunkedFile', true);
      }
      for (var i = 0; i < this.entity.audio.length; i += 1) {
        postFormData.append('audio[]', this.entity.audio[i].id);
      }
      for (var _i = 0; _i < this.entity.activities.length; _i += 1) {
        postFormData.append('activities[]', this.entity.activities[_i].id);
      }
      for (var _i2 = 0; _i2 < this.entity.teachers_keys.length; _i2 += 1) {
        postFormData.append('teachers_keys[]', this.entity.teachers_keys[_i2].id);
      }
      for (var _i3 = 0; _i3 < this.entity.lesson_plans.length; _i3 += 1) {
        postFormData.append('lesson_plans[]', this.entity.lesson_plans[_i3].id);
      }
      for (var _i4 = 0; _i4 < this.entity.overviews.length; _i4 += 1) {
        postFormData.append('overviews[]', this.entity.overviews[_i4].id);
      }
      for (var _i5 = 0; _i5 < this.entity.books.length; _i5 += 1) {
        postFormData.append('books[]', this.entity.books[_i5].id);
      }
      for (var _i6 = 0; _i6 < this.entity.chapter_study_guides.length; _i6 += 1) {
        postFormData.append('chapter_study_guides[]', this.entity.chapter_study_guides[_i6].id);
      }
      for (var _i7 = 0; _i7 < this.entity.coloring_sheets.length; _i7 += 1) {
        postFormData.append('coloring_sheets[]', this.entity.coloring_sheets[_i7].id);
      }
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'lessons', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var files = this.entity.files;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        if (files && files.length) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: response.data.content_type
          });
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/lesson/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create lesson query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_CommonPageMixin__ = __webpack_require__(4);















var SUCCESS = __WEBPACK_IMPORTED_MODULE_7__helpers_constants__["b" /* uploadStatus */].SUCCESS,
    ERROR = __WEBPACK_IMPORTED_MODULE_7__helpers_constants__["b" /* uploadStatus */].ERROR;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LetterbookEdit',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'application/pdf'
      },
      pdf: null,
      pdfText: null,
      uploadedPdf: null,
      uploadedPdfText: null
    };
  },


  computed: {
    dropzoneOptionsPdf: function dropzoneOptionsPdf() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'pdf',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'letterbooks/' + this.$route.params.id + '/pdf',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        addRemoveLinks: true,
        autoProcessQueue: false
      };
    },
    dropzoneOptionsPdfText: function dropzoneOptionsPdfText() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'pdf_text',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'letterbooks/' + this.$route.params.id + '/pdf-text',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: this.dropzoneSettings.acceptedFiles,
        addRemoveLinks: true,
        autoProcessQueue: false
      };
    },
    uploadingPdf: function uploadingPdf() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'book', 'pdf');
    },
    uploadingPdfText: function uploadingPdfText() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'book', 'pdf_text');
    }
  },
  watch: {
    uploadingPdf: {
      handler: function handler(val) {
        if (val && val.status === SUCCESS) {
          this.uploadedPdf = val.file;
          this.$refs.dropzonePdf.removeAllFiles();
          this.$refs.dropzonePdf.manuallyAddFile(val.file, '/');
          $('#pdf-uploader .dz-preview').find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      },

      deep: true
    },
    uploadingPdfText: {
      handler: function handler(val) {
        if (val && val.status === SUCCESS) {
          this.uploadedPdfText = val.file;
          this.$refs.dropzonePdfText.removeAllFiles();
          this.$refs.dropzonePdfText.manuallyAddFile(val.file, '/');
          $('#pdf-text-uploader .dz-preview').find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
        }
      },

      deep: true
    }
  },
  methods: {
    manuallyAddPdf: function manuallyAddPdf() {
      if (this.entity.pdf) {
        var file = {
          file: {
            name: this.entity.pdf.file_name,
            size: this.entity.pdf.size
          },
          url: this.entity.pdf.public_url,
          thumb: this.entity.pdf.thumbnail
        };
        this.$refs.dropzonePdf.manuallyAddFile(file.file, file.url);
        if (!this.entity.pdf.mime_type.match(/image.*/)) {
          $('#pdf-uploader .dz-preview').find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    manuallyAddPdfText: function manuallyAddPdfText() {
      if (this.entity.pdf_text) {
        var file = {
          file: {
            name: this.entity.pdf_text.file_name,
            size: this.entity.pdf_text.size
          },
          url: this.entity.pdf_text.public_url,
          thumb: this.entity.pdf_text.thumbnail
        };
        this.$refs.dropzonePdfText.manuallyAddFile(file.file, file.url);
        if (!this.entity.pdf_text.mime_type.match(/image.*/)) {
          $('#pdf-text-uploader .dz-preview').find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    pdfAdded: function pdfAdded(file) {
      this.pdf = file;
    },
    pdfRemoved: function pdfRemoved() {
      this.pdf = null;
    },
    pdfTextAdded: function pdfTextAdded(file) {
      this.pdfText = file;
    },
    pdfTextRemoved: function pdfTextRemoved() {
      this.pdfText = null;
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'letterbooks/' + this.$route.params.id, {
        params: {
          with: ['references', 'pdf', 'pdf_text', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        setTimeout(_this.manuallyAddPdf, 100);
        setTimeout(_this.manuallyAddPdfText, 100);
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting book request' });
        console.error('Error in get single letterbook query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'letterbooks/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].tokenStorage.name));
      var pdf = this.pdf,
          pdfText = this.pdfText,
          uploadedPdf = this.uploadedPdf,
          uploadedPdfText = this.uploadedPdfText,
          $apiHttp = this.$apiHttp;

      var entityId = this.$route.params.id;
      var vm = this;
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var dispatchStartUpload = function dispatchStartUpload(file, contentType, fileType) {
        _this2.$store.dispatch('uploadManager/startUpload', {
          apiHost: host,
          apiPrefix: prefix,
          entityId: entityId,
          files: [file],
          token: token,
          contentType: contentType,
          acceptedFiles: acceptedFiles,
          file_type: fileType
        });
      };
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        if (!pdf) {
          $apiHttp.delete(prefix + 'letterbooks/' + entityId + '/pdf');
        } else if (!pdf.manuallyAdded && pdf !== uploadedPdf) {
          dispatchStartUpload(pdf, response.data.content_type, 'pdf');
          vm.uploadedPdf = pdf;
        }
        if (!pdfText) {
          $apiHttp.delete(prefix + 'letterbooks/' + entityId + '/pdf-text');
        } else if (!pdfText.manuallyAdded && pdfText !== uploadedPdfText) {
          dispatchStartUpload(pdfText, response.data.content_type, 'pdf_text');
          vm.uploadedPdfText = pdfText;
        }
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update letterbook query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Letterbooks',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'letterbooks' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var letterbooksArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete letterbooksArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(letterbooksArr).map(function (e) {
            return letterbooksArr[e];
          });
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    deleteEntity: function deleteEntity(entity) {
      var _this2 = this;

      if (window.confirm('Do you really want to delete Letterbook ' + entity.title + ' with id = ' + entity.id + '?')) {
        var $btnDeleteLoader = $('table.entities tr[data-id="' + entity.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        this.$apiHttp.delete('' + this.$config.app_api.prefix + entity.id).then(function () {
          console.log('Letterbook ' + entity.title + ' with ID = ' + entity.id + ' has deleted');
          $btnDeleteLoader.hide();
          _this2.getSource();
        }).catch(function (error) {
          _this2.$_errorCallback(error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LetterbookNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_4__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        date: null,
        pdf: null,
        pdf_text: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        addRemoveLinks: true,
        acceptedFiles: 'application/pdf',
        autoProcessQueue: false,
        accept: function accept() {}
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    pdfChanged: function pdfChanged() {
      var _$refs$dropzonePdf$dr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.$refs.dropzonePdf.dropzone.files, 1);

      this.entity.pdf = _$refs$dropzonePdf$dr[0];
    },
    pdfTextChanged: function pdfTextChanged() {
      var _$refs$dropzonePdfTex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.$refs.dropzonePdfText.dropzone.files, 1);

      this.entity.pdf_text = _$refs$dropzonePdfTex[0];
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.pdf || this.entity.pdf_text) postFormData.append('chunkedFile', true);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'letterbooks', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var dispatchStartUpload = function dispatchStartUpload(contentType, entityId, file, type) {
        _this.$store.dispatch('uploadManager/startUpload', {
          apiHost: host,
          apiPrefix: prefix,
          entityId: entityId,
          files: [file],
          token: token,
          contentType: contentType,
          acceptedFiles: acceptedFiles,
          file_type: type
        });
      };
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        var _response$data = response.data,
            contentType = _response$data.content_type,
            entityId = _response$data.id;

        if (_this.entity.pdf) {
          dispatchStartUpload(contentType, entityId, _this.entity.pdf, 'pdf');
        }
        if (_this.entity.pdf_text) {
          dispatchStartUpload(contentType, entityId, _this.entity.pdf_text, 'pdf_text');
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/book/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create Letterbook query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  computed: {
    sourceMapData: function sourceMapData() {
      if (!this.source.geocode || this.source.geocode.lat == null || this.source.geocode.lon == null) {
        return {
          center: {
            lat: 0,
            lng: 0
          },
          zoom: 2
        };
      }
      return {
        center: {
          lat: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.source.geocode.lat),
          lng: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.source.geocode.lon)
        },
        zoom: 13
      };
    },
    entityMapCenter: function entityMapCenter() {
      if (this.entity.geocode === undefined || this.entity.geocode.lat == null || this.entity.geocode.lon == null) {
        return {
          lat: 0,
          lng: 0
        };
      }
      return {
        lat: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.geocode.lat),
        lng: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.geocode.lon)
      };
    }
  },
  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Description', value: this.entity.description, type: 'required' }, { name: 'Email', value: this.entity.contacts.email, type: 'email' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'locations/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'contacts') || !response.data.contacts) {
          _this.source.contacts = {};
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (response.data.geocode === null) {
          _this.entity.geocode = { lat: null, lon: null };
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting location request' });
        console.error(error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      var entity = this.entity;

      postFormData.append('title', entity.title);
      postFormData.append('description', entity.description ? entity.description : '');
      postFormData.append('country', entity.address.country ? entity.address.country : '');
      postFormData.append('state', entity.address.state ? entity.address.state : '');
      postFormData.append('city', entity.address.city ? entity.address.city : '');
      postFormData.append('address', entity.address.address ? entity.address.address : '');
      postFormData.append('postal_code', entity.address.postal_code ? entity.address.postal_code : '');
      postFormData.append('organisation_name', entity.address.organisation_name ? entity.address.organisation_name : '');
      postFormData.append('fax', entity.contacts.fax ? entity.contacts.fax : '');
      postFormData.append('email', entity.contacts.email ? entity.contacts.email : '');
      postFormData.append('phone', entity.contacts.phone ? entity.contacts.phone : '');
      postFormData.append('website', entity.contacts.website ? entity.contacts.website : '');
      postFormData.append('lat', entity.geocode.lat ? entity.geocode.lat : '');
      postFormData.append('lon', entity.geocode.lon ? entity.geocode.lon : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'locations/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update location query', error);
      });
    },
    mapClick: function mapClick(event) {
      this.entity.geocode.lat = event.latLng.lat();
      this.entity.geocode.lon = event.latLng.lng();
    },
    setOldGeocode: function setOldGeocode() {
      this.entity.geocode.lat = this.source.geocode.lat;
      this.entity.geocode.lon = this.source.geocode.lon;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Locations',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'locations' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var locationsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete locationsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(locationsArr).map(function (e) {
            return locationsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LocationNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        description: null,
        address: {
          country: null,
          state: null,
          city: null,
          address: null,
          postal_code: null,
          organisation_name: null
        },
        contacts: {
          fax: null,
          email: null,
          phone: null,
          website: null
        },
        geocode: {
          lat: null,
          lon: null
        },
        path_alias: '',
        seo_title: '',
        seo_description: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      mapCenter: {
        lat: 0,
        lng: 0
      },
      mapZoom: 2
    };
  },


  computed: {
    entityMapCenter: function entityMapCenter() {
      if (this.entity.geocode === undefined || this.entity.geocode.lat == null || this.entity.geocode.lon == null) {
        return {
          lat: 0,
          lng: 0
        };
      }
      return {
        lat: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.geocode.lat),
        lng: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.geocode.lon)
      };
    }
  },

  methods: {
    mapClick: function mapClick(event) {
      this.entity.geocode.lat = event.latLng.lat();
      this.entity.geocode.lon = event.latLng.lng();
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Description', value: this.entity.description, type: 'required' }, { name: 'Email', value: this.entity.contacts.email, type: 'email' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      var entity = this.entity;

      postFormData.append('title', entity.title);
      postFormData.append('description', entity.description);
      if (entity.address.country) postFormData.append('country', entity.address.country);
      if (entity.address.state) postFormData.append('state', entity.address.state);
      if (entity.address.city) postFormData.append('city', entity.address.city);
      if (entity.address.address) postFormData.append('address', entity.address.address);
      if (entity.address.postal_code) postFormData.append('postal_code', entity.address.postal_code);
      if (entity.address.organisation_name) postFormData.append('organisation_name', entity.address.organisation_name);
      if (entity.contacts.fax) postFormData.append('fax', entity.contacts.fax);
      if (entity.contacts.email) postFormData.append('email', entity.contacts.email);
      if (entity.contacts.phone) postFormData.append('phone', entity.contacts.phone);
      if (entity.contacts.website) postFormData.append('website', entity.contacts.website);
      if (entity.geocode.lat) postFormData.append('lat', entity.geocode.lat);
      if (entity.geocode.lon) postFormData.append('lon', entity.geocode.lon);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'locations', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/location/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create location query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_CommonPageMixin__ = __webpack_require__(4);

















var SUCCESS = __WEBPACK_IMPORTED_MODULE_9__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsEdit',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_6__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_7__global_components_TermsEditor___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_5__global_components_Datepicker___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_8__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      },
      uploadedFiles: [],
      files: []
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'files[]',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'news/' + this.$route.params.id + '/files',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'news');
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        this.uploadedFiles = val.filter(function (file) {
          return file.status === SUCCESS;
        }).map(function (file) {
          return file.file;
        });
        var dropzone = this.$refs.dropzone;

        if (dropzone) {
          this.uploadedFiles.forEach(function (file) {
            return dropzone.removeFile(file);
          });
          this.uploadedFiles.forEach(function (file) {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },

      deep: true
    }
  },

  methods: {
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.files.length; i += 1) {
        var file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileAdded: function fileAdded(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      var fileIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.entity.files, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      if (fileIndex === -1) return;
      var fileId = this.entity.files[fileIndex].id;
      this.$apiHttp.delete(this.$config.app_api.prefix + 'news/' + this.$route.params.id + '/files/' + fileId).then(function () {
        _this.entity.files.splice(fileIndex, 1);
        _this.files = _this.files.filter(function (item) {
          return file !== item;
        });
      }).catch(function (error) {
        console.error('error in delete file in site page request - ', error);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Title', value: this.entity.title, type: 'minLength', maxLength: 3 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }, { name: 'Body', value: this.entity.body, type: 'minLength', maxLength: 10 }, { name: 'Date', value: this.entity.date, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'news/' + this.$route.params.id, {
        params: {
          with: ['references', 'cover', 'files', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this2.source, 'cover')) {
          _this2.source.cover = null;
        }
        _this2.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        setTimeout(_this2.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting news request' });
        console.error('Error in get single news query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'news/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'news/' + this.$route.params.id + '/cover');
    },
    saveRequest: function saveRequest() {
      var entity = this.entity;

      var postFormData = this.$_addDefaultFormData();

      postFormData.append('title', entity.title);
      postFormData.append('body', entity.body);
      postFormData.append('date', entity.date);
      postFormData.append('short_title', entity.teaser.short_title ? entity.teaser.short_title : '');
      postFormData.append('featured', entity.featured.section_id ? entity.featured.section_id : '');
      postFormData.append('featured_body', entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'news/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var files = this.files.filter(function (file) {
        return !file.manuallyAdded;
      });
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var entityId = this.$route.params.id;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tokenStorage.name));
      var vm = this;
      var dispatchStartUpload = function dispatchStartUpload(contentType) {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: contentType
          });
          vm.files = [];
        }
      };
      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function (response) {
          _this3.$_successSave();
          dispatchStartUpload(response.data.content_type);
        }).catch(function (error) {
          _this3.$_errorSave(error);
          console.error('Error in update news query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'News',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'news' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var newsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete newsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newsArr).map(function (e) {
            return newsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__ = __webpack_require__(10);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_5__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_6__global_components_TermsEditor___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        date: null,
        files: [],
        cover: null,
        summary: null,
        short_title: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 50,
        maxFilesize: 100,
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept: function accept() {}
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Title', value: this.entity.title, type: 'minLength', maxLength: 3 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }, { name: 'Body', value: this.entity.body, type: 'minLength', maxLength: 10 }, { name: 'Date', value: this.entity.date, type: 'required' }]);
    },
    filesChanged: function filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    $_coverChange: function $_coverChange(file) {
      this.entity.cover = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('date', this.entity.date);
      if (this.entity.short_title) postFormData.append('short_title', this.entity.short_title);

      if (this.entity.files.length > 0) {
        postFormData.append('chunkedFile', true);
      }
      postFormData.append('cover', this.entity.cover);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'news', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var files = this.entity.files;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tokenStorage.name));
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        if (files && files.length > 0) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(files)),
            token: token,
            contentType: response.data.content_type
          });
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/news/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create news query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__ = __webpack_require__(4);














var SUCCESS = __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PamphletEdit',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 100
      },
      file: null,
      uploadedFile: null
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'pdf',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'pamphlets/' + this.$route.params.id + '/pdf',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFile: function uploadingFile() {
      var getUploadingStruct = this.$store.getters['uploadManager/getUploadByEntityId'];
      if (!getUploadingStruct) {
        return null;
      }
      return getUploadingStruct(this.$route.params.id, 'pamphlet');
    }
  },

  watch: {
    uploadingFile: {
      handler: function handler(val) {
        if (val && val.status === SUCCESS) {
          this.uploadedFile = val.file;
          this.$refs.dropzone.removeAllFiles();
          this.$refs.dropzone.manuallyAddFile(val.file, '/');
        }
      },

      deep: true
    }
  },

  methods: {
    manuallyAddFiles: function manuallyAddFiles() {
      if (this.entity.pdf) {
        var file = {
          file: {
            name: this.entity.pdf.file_name,
            size: this.entity.pdf.size
          },
          url: this.entity.pdf.public_url,
          thumb: this.entity.pdf.thumbnail
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.pdf.mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileAdded: function fileAdded(file) {
      this.files.push(file);
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      this.$apiHttp.delete(this.$config.app_api.prefix + 'pamphlets/' + this.$route.params.id + '/pdf/').then(function () {
        _this.entity.pdf = null;
        _this.files.filter(function (item) {
          return item !== file;
        });
      }).catch(function (error) {
        console.error('error in delete pdf in pamphlet request - ', error);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'pamphlets/' + this.$route.params.id, {
        params: {
          with: ['references', 'pdf', 'terms', 'path_alias']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        _this2.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        setTimeout(_this2.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting pamphlet request' });
        console.error('Error in get single pamphlet query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);

      if (this.file) {
        postFormData.append('chunkedFile', true);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'pamphlets/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;
      var file = this.file,
          uploadedFile = this.uploadedFile;

      var entityId = this.$route.params.id;
      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this3.$_successSave();
        if (file && !file.manuallyAdded && file !== uploadedFile) {
          _this3.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: entityId,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
          _this3.uploadedFile = file;
        }
      }).catch(function (error) {
        _this3.$_errorSave(error);
        console.error('Error in update pamphlet query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__ = __webpack_require__(4);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PamphletList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'pamphlets?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var pamphletsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete pamphletsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(pamphletsArr).map(function (e) {
            return pamphletsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PamphletNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        file: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept: function accept() {}
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    fileAdded: function fileAdded(file) {
      this.entity.file = file;
    },
    fileRemoved: function fileRemoved() {
      this.entity.file = null;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.file) postFormData.append('chunkedFile', true);

      return this.$apiHttp.post(this.$config.app_api.prefix + 'pamphlets', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var file = this.entity.file;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this.$_successSave();
        if (file) {
          _this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token: token,
            acceptedFiles: acceptedFiles,
            contentType: response.data.content_type
          });
        }
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/pamphlet/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create pamphlet query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonDuplicates',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      people: null,
      selectedEntities: [],
      saveErrorMessage: ''
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSource();
    }, 400),
    offset: function offset() {
      this.getSource();
    }
  },

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'people/' + this.$route.params.id + '/duplicates', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var peopleArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete peopleArr.meta;
          _this.people = peopleArr;
          _this.selectedEntities = [];
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    mergeItem: function mergeItem(item) {
      var _this2 = this;

      if (window.confirm('Do you really want to merge this persons?')) {
        $('.saving-alerts .alert').hide();
        var $mergeBtnLoader = $('.entities tr[data-id="' + item.id + '"] .btn-merge .btn-loader');
        $mergeBtnLoader.show();
        this.mergeRequest([item.id]).then(function () {
          _this2.successSave($mergeBtnLoader);
        }).catch(function (error) {
          console.error(error);
          _this2.errorSave('Server Error', $mergeBtnLoader);
        });
      }
    },
    mergeItems: function mergeItems() {
      var _this3 = this;

      if (window.confirm('Do you really want to merge this persons?')) {
        $('.saving-alerts .alert').hide();
        var $mergeBtnLoader = $('.btn-merge-all .btn-loader');
        $mergeBtnLoader.show();
        this.mergeRequest(this.selectedEntities).then(function () {
          _this3.successSave($mergeBtnLoader);
        }).catch(function (error) {
          console.error(error);
          _this3.errorSave('Server Error', $mergeBtnLoader);
        });
      }
    },
    mergeRequest: function mergeRequest(itemsArray) {
      return this.$apiHttp.post(this.$config.app_api.prefix + 'people/' + this.$route.params.id + '/merge', { ids: itemsArray });
    },
    successSave: function successSave($btnLoader) {
      this.$parent.getSource();
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
      $btnLoader.hide();
      this.getSource();
    },
    errorSave: function errorSave(errorMessage, $btnLoader) {
      $btnLoader.hide();
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__ = __webpack_require__(4);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_3__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_4__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_5__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_6__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      genderOptions: {
        none: null,
        male: true,
        female: false
      }
    };
  },


  computed: {
    avatarUrl: function avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged: function avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    }
  },

  methods: {
    changeAvatar: function changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore: function avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove: function avatarRemove() {
      this.entity.avatar = null;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'people/' + this.$route.params.id, {
        params: {
          with: ['references', 'avatar', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
          _this.source.avatar = null;
        }
        if (!Object.prototype.hasOwnProperty.call(response.data, 'position')) {
          _this.source.position = { degree: null, institution: null };
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting person request' });
        console.error('Error in get single article query', error);
      });
    },
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.death_date !== null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.entity.birthday_date).isAfter(this.entity.death_date)) {
        this.$_showError('Birth date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.marriage_date !== null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.entity.birthday_date).isAfter(this.entity.marriage_date)) {
        this.$_showError('Birth date cant be more than marriage date');
        this.saveErrorMessage = 'Birth date cant be more than marriage date';
        return false;
      }
      if (this.entity.marriage_date !== null && this.entity.death_date !== null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.entity.marriage_date).isAfter(this.entity.death_date)) {
        this.$_showError('Marriage date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.marriage_date !== null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.entity.birthday_date).isAfter(this.entity.marriage_date)) {
        this.$_showError('Birth date cant be less than marriage date');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('id', this.entity.id);
      postFormData.append('title', this.entity.title);
      postFormData.append('bio', this.entity.bio ? this.entity.bio : '');
      postFormData.append('gender', this.entity.gender ? this.entity.gender : '');
      postFormData.append('birthday_date', this.entity.birthday_date ? this.entity.birthday_date : '');
      postFormData.append('death_date', this.entity.death_date ? this.entity.death_date : '');
      postFormData.append('marriage_date', this.entity.marriage_date ? this.entity.marriage_date : '');
      postFormData.append('full_name', this.entity.name.full_name ? this.entity.name.full_name : '');
      postFormData.append('last_name', this.entity.name.last_name ? this.entity.name.last_name : '');
      postFormData.append('first_name', this.entity.name.first_name ? this.entity.name.first_name : '');
      postFormData.append('maiden_name', this.entity.name.maiden_name ? this.entity.name.maiden_name : '');
      postFormData.append('middle_name', this.entity.name.middle_name ? this.entity.name.middle_name : '');
      postFormData.append('generic_name', this.entity.name.generic_name ? this.entity.name.generic_name : '');
      postFormData.append('salutation', this.entity.name.salutation ? this.entity.name.salutation : '');
      postFormData.append('suffix', this.entity.name.suffix ? this.entity.name.suffix : '');
      postFormData.append('degree', this.entity.position.degree ? this.entity.position.degree : '');
      postFormData.append('institution', this.entity.position.institution ? this.entity.position.institution : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'people/' + this.$route.params.id, postFormData);
    },
    saveAvatarRequest: function saveAvatarRequest() {
      var postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'people/' + this.$route.params.id + '/avatar', postFormData);
    },
    deleteAvatarRequest: function deleteAvatarRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'people/' + this.$route.params.id + '/avatar');
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update person query', error);
        });
      } else if (!this.entity.avatar) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'People',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'people' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var peopleArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete peopleArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(peopleArr).map(function (e) {
            return peopleArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PersonNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      genderOptions: {
        none: null,
        male: true,
        female: false
      },
      entity: {
        title: null,
        bio: null,
        gender: null,
        birthday_date: null,
        death_date: null,
        marriage_date: null,
        position: {
          degree: null,
          institution: null
        },
        name: {
          full_name: '',
          last_name: '',
          first_name: '',
          middle_name: '',
          maiden_name: '',
          generic_name: '',
          salutation: '',
          suffix: ''
        },
        avatar: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  watch: {
    'entity.name.salutation': function entityNameSalutation() {
      this.generateFullName();
    },
    'entity.name.first_name': function entityNameFirst_name() {
      this.generateFullName();
    },
    'entity.name.middle_name': function entityNameMiddle_name() {
      this.generateFullName();
    },
    'entity.name.last_name': function entityNameLast_name() {
      this.generateFullName();
    },
    'entity.name.maiden_name': function entityNameMaiden_name() {
      this.generateFullName();
    },
    'entity.name.suffix': function entityNameSuffix() {
      this.generateFullName();
    }
  },

  methods: {
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.death_date !== null && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.entity.birthday_date).isAfter(this.entity.death_date)) {
        this.$_showError('Birth date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.marriage_date !== null && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.entity.birthday_date).isAfter(this.entity.marriage_date)) {
        this.$_showError('Birth date cant be more than marriage date');
        this.saveErrorMessage = 'Birth date cant be more than marriage date';
        return false;
      }
      if (this.entity.marriage_date !== null && this.entity.death_date !== null && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.entity.marriage_date).isAfter(this.entity.death_date)) {
        this.$_showError('Marriage date cant be more than death date');
        return false;
      }
      if (this.entity.birthday_date !== null && this.entity.marriage_date !== null && __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.entity.birthday_date).isAfter(this.entity.marriage_date)) {
        this.$_showError('Birth date cant be less than marriage date');
        return false;
      }
      if (this.entity.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.bio) postFormData.append('bio', this.entity.bio);
      if (this.entity.birthday_date) postFormData.append('birthday_date', this.entity.birthday_date);
      if (this.entity.death_date) postFormData.append('death_date', this.entity.death_date);
      if (this.entity.marriage_date) postFormData.append('marriage_date', this.entity.marriage_date);
      if (this.entity.gender) postFormData.append('gender', this.entity.gender);
      if (this.entity.name.full_name) postFormData.append('full_name', this.entity.name.full_name);
      if (this.entity.name.last_name) postFormData.append('last_name', this.entity.name.last_name);
      if (this.entity.name.first_name) postFormData.append('first_name', this.entity.name.first_name);
      if (this.entity.name.maiden_name) postFormData.append('maiden_name', this.entity.name.maiden_name);
      if (this.entity.name.middle_name) postFormData.append('middle_name', this.entity.name.middle_name);
      if (this.entity.name.generic_name) postFormData.append('generic_name', this.entity.name.generic_name);
      if (this.entity.name.salutation) postFormData.append('salutation', this.entity.name.salutation);
      if (this.entity.name.suffix) postFormData.append('suffix', this.entity.name.suffix);
      if (this.entity.position.degree) postFormData.append('degree', this.entity.position.degree);
      if (this.entity.position.institution) postFormData.append('institution', this.entity.position.institution);
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'people', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/person/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in person update migration', error);
        _this.$_errorSave(error);
      });
    },
    avatarUploaded: function avatarUploaded(file) {
      this.entity.avatar = file;
    },
    generateFullName: function generateFullName() {
      var _entity$name = this.entity.name,
          salutation = _entity$name.salutation,
          first_name = _entity$name.first_name,
          middle_name = _entity$name.middle_name,
          last_name = _entity$name.last_name,
          maiden_name = _entity$name.maiden_name,
          suffix = _entity$name.suffix;

      this.entity.name.full_name = salutation + ' ' + first_name + ' ' + middle_name + ' ' + last_name + ' ' + maiden_name + ' ' + suffix;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PublicationEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_3__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_4__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'publications/' + this.$route.params.id, {
        params: {
          with: ['references', 'cover', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting publication request' });
        console.error('Error in get single publication query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'publications/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'publications/' + this.$route.params.id + '/cover');
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      postFormData.append('date', this.entity.date ? this.entity.date : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'publications/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.$_coverIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update publication query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Publications',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'publications' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var publicationsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete publicationsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(publicationsArr).map(function (e) {
            return publicationsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PublicationNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_2__global_components_Datepicker___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        date: null,
        body: null,
        summary: null,
        cover: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    filesChanged: function filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.cover) {
        postFormData.append('cover', this.entity.cover);
      }
      if (this.entity.date) {
        postFormData.append('date', this.entity.date);
      }
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'publications', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/publication/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create publication query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QaAddDocs',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceDocs: [],
      selectedDocs: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSourceDocs();
    }, 400),
    offset: function offset() {
      this.getSourceDocs();
    }
  },

  mounted: function mounted() {
    this.getSourceDocs();
  },


  methods: {
    shortTitle: function shortTitle(title) {
      if (title.length > 30) {
        return title.slice(0, 30) + '...';
      }
      return title;
    },
    addDoc: function addDoc(doc) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.selectedDocs, function (item) {
        return doc.id === item.id;
      });
      if (index === -1) {
        this.selectedDocs.push(doc);
      }
    },
    deleteDoc: function deleteDoc(doc) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.selectedDocs, function (item) {
        return item.id === doc.id;
      });
      this.$forceUpdate();
    },
    getSourceDocs: function getSourceDocs() {
      var _this = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.sourceSpinner) {
            _this.$refs.sourceSpinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var docsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete docsArr.meta;
          _this.sourceDocs = docsArr;
        }
      }).catch(function (error) {
        if (_this.$refs.sourceSpinner) {
          _this.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    isEntityValid: function isEntityValid() {
      if (!this.selectedDocs.length) {
        this.errorSave('You should choose at least one document');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      for (var i = 0; i < this.selectedDocs.length; i += 1) {
        postFormData.append('ids[]', this.selectedDocs[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id + '/attach/media-docs', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.successSave();
        _this2.selectedDocs = [];
        _this2.$forceUpdate();
      }).catch(function (error) {
        _this2.errorSave('Error in data saving');
        console.error('Error in add docs to qa query', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QaEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting qa request' });
        console.error('Error in get single QA query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id + '/cover');
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.file_number) postFormData.append('file_number', this.entity.file_number);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update pamphlet query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QaList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'questions-and-answers' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var qaArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete qaArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(qaArr).map(function (e) {
            return qaArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QaManageDocs',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      docs: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getDocs();
    }, 400),
    offset: function offset() {
      this.getDocs();
    }
  },

  mounted: function mounted() {
    this.getDocs();
  },


  methods: {
    getDocs: function getDocs() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id + '/media-docs', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var docsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete docsArr.meta;
          _this.docs = docsArr;
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    deleteMediaDoc: function deleteMediaDoc(doc) {
      var _this2 = this;

      if (window.confirm('Do you really want to detach document ' + doc.title + ' with id = ' + doc.id + '?')) {
        var postFormData = new FormData();
        var $btnDeleteLoader = $('table.entities tr[data-id="' + doc.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        postFormData.append('ids[]', doc.id);
        this.$apiHttp.post(this.$config.app_api.prefix + 'questions-and-answers/' + this.$route.params.id + '/detach/media-docs', postFormData).then(function () {
          console.log('Document ' + doc.title + ' with ID = ' + doc.id + ' has detached');
          $btnDeleteLoader.hide();
          _this2.getDocs();
        }).catch(function (error) {
          console.error('Error in detach document request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QaNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        file_number: '',
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.entity.file_number) postFormData.append('file_number', this.entity.file_number);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'questions-and-answers', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/questions_and_answers/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create QA query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopicEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'topics/' + this.$route.params.id, {
        params: {
          with: ['references', 'terms', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting topic request' });
        console.error('Error in get single topic query', error);
      });
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    saveEntityRequest: function saveEntityRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'topics/' + this.$route.params.id, postFormData);
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveEntityRequest().then(function () {
        _this2.$_successSave();
      }, function (error) {
        console.error('Error in topic update migration', error);
        _this2.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topics',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'topics' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var topicsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete topicsArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(topicsArr).map(function (e) {
            return topicsArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopicNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }, { name: 'Body', value: this.entity.body, type: 'required' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'topics', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/topic/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in topic create migration', error);
        _this.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_CommonPageMixin__ = __webpack_require__(4);




















var SUCCESS = __WEBPACK_IMPORTED_MODULE_11__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoEdit',

  components: {
    'select-remote': __WEBPACK_IMPORTED_MODULE_7__global_components_SelectRemote___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_10__global_components_OpenOnSiteButton___default.a,
    FileUploader: __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_8__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_9__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      videoFile: {
        uploadType: 'file',
        fileLink: '',
        file: null,
        filesDictionary: {}
      },
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 10240
      },
      uploadedFilesDictionary: {},
      defaultFiles: {},
      qualityArray: [144, 240, 360, 480, 720, 1080]
    };
  },


  computed: {
    startVideoType: function startVideoType() {
      if (!this.source) return 'file';
      if (this.source.vimeo_link && this.source.vimeo_link.active) return 'vimeo';
      if (this.source.youtube_link && this.source.youtube_link.active) return 'youtube';
      return 'file';
    },
    coverUrl: function coverUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    coverIsChanged: function coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'mediaFile',
        autoProcessQueue: false,
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'media/video/' + this.$route.params.id + '/file',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'video/*,video/x-matroska,.mkv',
        addRemoveLinks: true,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    uploadingFiles: function uploadingFiles() {
      var getUploadsList = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadsList) {
        return [];
      }
      return getUploadsList(this.$route.params.id, 'media_video').filter(function (item) {
        return item.status === SUCCESS;
      });
    }
  },

  watch: {
    uploadingFiles: {
      handler: function handler(val) {
        var _this = this;

        if (val.length) {
          val.forEach(function (file) {
            _this.uploadedFilesDictionary[file.quality] = file.file;
            _this.uploadedFilesDictionary = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.uploadedFilesDictionary);
          });
        }
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.$_getDefaultSeries();
    this.uploadedFilesDictionary = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.videoFile.filesDictionary);
  },


  methods: {
    seriesSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/video-series?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    changeCover: function changeCover(file) {
      this.entity.cover = file;
    },
    coverRestore: function coverRestore() {
      this.entity.cover = this.source.cover;
    },
    coverRemove: function coverRemove() {
      this.entity.cover = null;
    },
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id, {
        params: {
          with: ['terms', 'references', 'mediaFile', 'path_alias', 'cover', 'series', 'featured', 'video_144_p', 'video_240_p', 'video_360_p', 'video_480_p', 'video_720_p', 'video_1080_p']
        }
      }).then(function (response) {
        _this2.source = _this2.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this2.source, 'cover')) {
          _this2.source.cover = null;
        }
        _this2.entity = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(_this2.source);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.qualityArray.forEach(function (quality) {
          var item = _this2.entity['video_' + quality + '_p'];
          if (item) {
            _this2.defaultFiles[quality] = item;
          }
        });
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting video request' });
        console.error('Error in get single video query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('series_id', this.entity.series ? this.entity.series.id : '');
      var filesDictionary = this.videoFile.filesDictionary;

      if (this.videoFile.youtube) {
        postFormData.append('youtube_link', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          link: this.videoFile.youtube,
          active: this.videoFile.uploadType === 'youtube'
        }));
      } else {
        postFormData.append('youtube_link', '');
      }
      if (this.videoFile.vimeo) {
        postFormData.append('vimeo_link', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          link: this.videoFile.vimeo,
          active: this.videoFile.uploadType === 'vimeo'
        }));
      } else {
        postFormData.append('vimeo_link', '');
      }
      this.qualityArray.forEach(function (quality) {
        if (filesDictionary[quality].type === __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__["a" /* URL */] && filesDictionary[quality].linkStatus === 'ok') {
          postFormData.append('selectel_file_url_' + quality, filesDictionary[quality].url);
        }
      });
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id, postFormData);
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id + '/cover', postFormData);
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id + '/cover');
    },
    saveMediaFileRequest: function saveMediaFileRequest() {
      var postFormData = new FormData();
      if (this.videoFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id + '/file', postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var filesDictionary = this.videoFile.filesDictionary;
      var uploadedFilesDictionary = this.uploadedFilesDictionary;

      var dicKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filesDictionary);
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      var dispatchStartUpload = function dispatchStartUpload(contentType) {
        if (dicKeys.length && filesDictionary) {
          dicKeys.forEach(function (quality) {
            if (!filesDictionary[quality]) {
              return;
            }
            var _filesDictionary$qual = filesDictionary[quality],
                type = _filesDictionary$qual.type,
                file = _filesDictionary$qual.file;

            if (!file || type !== __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__["b" /* FILE */]) {
              return;
            }
            var selectedName = file.name;
            var uploadedName = void 0;
            if (uploadedFilesDictionary[quality]) {
              uploadedName = uploadedFilesDictionary[quality].name;
            }
            if (!(file instanceof File) || selectedName === uploadedName) {
              return;
            }
            _this3.$store.dispatch('uploadManager/startUpload', {
              apiHost: host,
              apiPrefix: prefix,
              entityId: _this3.$route.params.id,
              files: [file],
              token: token,
              acceptedFiles: acceptedFiles,
              contentType: contentType,
              quality: quality
            });
            uploadedFilesDictionary[quality] = filesDictionary[quality];
          });
        }
      };
      if (!this.coverIsChanged) {
        this.saveRequest().then(function (response) {
          _this3.$_successSave();
          dispatchStartUpload(response.data.content_type);
        }).catch(function (error) {
          _this3.$_errorSave(error);
          console.error('Error in update video query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_4_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      videoSeries: [],
      selectedVideoSeries: [],
      selectStatus: ''
    };
  },
  mounted: function mounted() {
    this.getVideoSeries();
  },


  methods: {
    validateUrl: function validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var videoArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete videoArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(videoArr).map(function (e) {
            return videoArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    },
    getVideoSeries: function getVideoSeries() {
      var _this2 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series?nonpaginated=true').then(function (response) {
        _this2.videoSeries = response.data;
      }).catch(function (error) {
        console.error('Error in loading video series', error);
      });
    },
    selectVideoSeries: function selectVideoSeries(video_id, video_series) {
      var $btnLoader = $(this.$refs['videoSeriesBtnLoader_' + video_id]);
      $btnLoader.show();
      var postFormData = new FormData();
      postFormData.append('ids[]', video_id);
      this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series/' + video_series.id + '/attach-videos', postFormData).then(function () {
        $btnLoader.hide();
      }).catch(function (error) {
        $btnLoader.hide();
        console.error('Error in creating request', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoNew',

  components: {
    'select-remote': __WEBPACK_IMPORTED_MODULE_4__global_components_SelectRemote___default.a,
    FileUploader: __WEBPACK_IMPORTED_MODULE_5__global_components_FileUploader_Index___default.a,
    referencer: __WEBPACK_IMPORTED_MODULE_7__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_8__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      videoFile: null,
      entity: {
        title: null,
        body: null,
        summary: null,
        mediaFile: null,
        cover: null,
        series: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 10240,
        addRemoveLinks: true,
        autoProcessQueue: false,
        acceptedFiles: 'video/*,video/x-matroska,.mkv',
        accept: function accept() {}
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultSeries();
  },


  methods: {
    seriesSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'media/video-series?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (error) {
        loading(false);
        console.error(error);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      var videoFile = this.videoFile;

      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }];
      if (videoFile.uploadType === 'url') {
        filelds.push({ name: 'File', value: videoFile.fileLink, type: 'required' });
      } else if (videoFile.uploadType === 'file') {
        filelds.push({ name: 'File', value: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(videoFile.filesDictionary).length, type: 'required' });
      } else if (videoFile.uploadType === 'youtube') {
        filelds.push({ name: 'File', value: videoFile.youtube, type: 'required' });
      } else if (videoFile.uploadType === 'vimeo') {
        filelds.push({ name: 'File', value: videoFile.vimeo, type: 'required' });
      }
      return this.$_validate(filelds);
    },
    coverUploaded: function coverUploaded(file) {
      this.entity.cover = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.body) postFormData.append('body', this.entity.body);
      if (this.videoFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      }
      var filesDictionary = this.videoFile.filesDictionary;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filesDictionary).forEach(function (quality) {
        if (filesDictionary[quality].type === __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__["a" /* URL */] && filesDictionary[quality].linkStatus === 'ok') {
          postFormData.append('selectel_file_url_' + quality, filesDictionary[quality].url);
        }
      });
      if (this.videoFile.youtube) {
        postFormData.append('youtube_link', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          link: this.videoFile.youtube,
          active: this.videoFile.uploadType === 'youtube'
        }));
      }
      if (this.videoFile.vimeo) {
        postFormData.append('vimeo_link', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          link: this.videoFile.vimeo,
          active: this.videoFile.uploadType === 'vimeo'
        }));
      }
      postFormData.append('cover', this.entity.cover);
      if (this.entity.series) postFormData.append('series_id', this.entity.series.id);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      var filesDictionary = this.videoFile.filesDictionary;
      var _$config$app_api = this.$config.app_api,
          prefix = _$config$app_api.prefix,
          host = _$config$app_api.host;

      var token = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].tokenStorage.name));
      var acceptedFiles = this.dropzoneOptions.acceptedFiles;

      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        if (filesDictionary) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filesDictionary).forEach(function (quality) {
            var _filesDictionary$qual = filesDictionary[quality],
                type = _filesDictionary$qual.type,
                file = _filesDictionary$qual.file;

            if (type !== __WEBPACK_IMPORTED_MODULE_6__global_components_FileUploader_constants__["b" /* FILE */] || !file) {
              return;
            }
            _this.$store.dispatch('uploadManager/startUpload', {
              apiHost: host,
              apiPrefix: prefix,
              entityId: response.data.id,
              files: [file],
              token: token,
              acceptedFiles: acceptedFiles,
              contentType: response.data.content_type,
              quality: quality
            });
          });
        }
        window.location.hash = '#/admin/content/media_video/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create video query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesAddVideos',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  data: function data() {
    return {
      searchProcessId: null,
      searchQuery: '',
      total: 0,
      perPage: 0,
      offset: 0,
      sourceVideos: [],
      selectedVideos: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getSourceVideos();
    }, 400),
    offset: function offset() {
      this.getSourceVideos();
    }
  },

  mounted: function mounted() {
    this.getSourceVideos();
  },


  methods: {
    shortTitle: function shortTitle(title) {
      if (title.length > 30) {
        return title.slice(0, 30) + '...';
      }
      return title;
    },
    addVideo: function addVideo(video) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.selectedVideos, function (item) {
        return video.id === item.id;
      });
      if (index === -1) {
        this.selectedVideos.push(video);
      }
    },
    deleteVideo: function deleteVideo(video) {
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(this.selectedVideos, function (item) {
        return item.id === video.id;
      });
      this.$forceUpdate();
    },
    getSourceVideos: function getSourceVideos() {
      var _this = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video', {
        params: {
          search_string: searchString,
          page: page,
          with: ['cover']
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.sourceSpinner) {
            _this.$refs.sourceSpinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var videosArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete videosArr.meta;
          _this.sourceVideos = videosArr;
        }
      }).catch(function (error) {
        if (_this.$refs.sourceSpinner) {
          _this.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    isEntityValid: function isEntityValid() {
      if (!this.selectedVideos.length) {
        this.errorSave('You should choose at least one video');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      for (var i = 0; i < this.selectedVideos.length; i += 1) {
        postFormData.append('ids[]', this.selectedVideos[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id + '/attach-videos', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.successSave();
        _this2.selectedVideos = [];
        _this2.$forceUpdate();
      }).catch(function (error) {
        _this2.errorSave('Error in data saving');
        console.error('Error in add videos to series query', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__ = __webpack_require__(4);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesEdit',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_2__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_3__global_components_TermsEditor___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' }]);
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id, {
        params: {
          with: ['terms', 'references', 'cover', 'path_alias', 'featured']
        }
      }).then(function (response) {
        _this.source = _this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(_this.source, 'cover')) {
          _this.source.cover = null;
        }
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.source);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting video series request' });
        console.error('Error in get video series query', error);
      });
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id + '/cover', postFormData);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (this.entity.cover && this.$_coverIsChanged) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update video series query', error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    BulkBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_BulkBtns___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_4__global_components_EmptyBtns___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_5__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series' + (this.emptySearch ? '/show-empty' : ''), {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var videoSeriesArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete videoSeriesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(videoSeriesArr).map(function (e) {
            return videoSeriesArr[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesManageVideos',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },

  data: function data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      videos: [],
      saveErrorMessage: 'Error in data saving'
    };
  },


  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getVideos();
    }, 400),
    offset: function offset() {
      this.getVideos();
    }
  },

  mounted: function mounted() {
    this.getVideos();
  },


  methods: {
    getVideos: function getVideos() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id + '/videos', {
        params: {
          search_string: searchString,
          page: page,
          with: ['cover']
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var videosArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete videosArr.meta;
          _this.videos = videosArr;
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    detachVideo: function detachVideo(video) {
      var _this2 = this;

      if (window.confirm('Do you really want to detach Video ' + video.title + ' with id = ' + video.id + '?')) {
        var $btnDeleteLoader = $('table.entities tr[data-id="' + video.id + '"] .btn-danger .btn-loader');
        var postFormData = new FormData();
        $btnDeleteLoader.show();
        postFormData.append('ids[]', video.id);
        this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id + '/detach-videos', postFormData).then(function () {
          $btnDeleteLoader.hide();
          _this2.getVideos();
        }).catch(function (error) {
          console.error('Error in detach video request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Referencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesNew',

  components: {
    referencer: __WEBPACK_IMPORTED_MODULE_1__global_components_Referencer___default.a,
    terms: __WEBPACK_IMPORTED_MODULE_2__global_components_TermsEditor___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        cover: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      return this.$_validate([{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 }, { name: 'Path Alias', value: this.entity.path_alias, type: 'path' }]);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('cover', this.entity.cover);
      if (this.entity.featured) postFormData.append('featured', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'media/video-series', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/content/media_video_series/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create video series query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slicksort__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slicksort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slicksort__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoSeriesOrderVideos',

  components: {
    SlickItem: __WEBPACK_IMPORTED_MODULE_2_vue_slicksort__["SlickItem"],
    SlickList: __WEBPACK_IMPORTED_MODULE_2_vue_slicksort__["SlickList"]
  },

  data: function data() {
    return {
      tracks: [],
      saveErrorMessage: 'Error in data saving'
    };
  },
  mounted: function mounted() {
    this.getVideos();
  },


  methods: {
    getVideos: function getVideos() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/video-series/' + this.$route.params.id + '/videos', {
        params: {
          nonpaginated: true
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        var videoArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete videoArr.meta;
        _this.tracks = _this.orderByWeight(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(videoArr).map(function (e) {
          return videoArr[e];
        }));
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        console.error(error);
      });
    },
    orderByWeight: function orderByWeight(arr) {
      return arr.sort(function (a, b) {
        var weightA = a.weight ? +a.weight : 0;
        var weightB = b.weight ? +b.weight : 0;
        if (weightA > weightB) {
          return 1;
        }
        return -1;
      });
    },
    save: function save() {
      var _this2 = this;

      $(this.$refs.saveBtnLoader).show();
      for (var i = 0; i < this.tracks.length; i += 1) {
        this.tracks[i].weight = i;
      }
      this.$apiHttp.post(this.$config.app_api.prefix + 'media/video/' + this.$route.params.id + '/videos/bulk-update', {
        items: this.tracks
      }).then(function () {
        $(_this2.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-success').show();
      }).catch(function (error) {
        $(_this2.$refs.saveBtnLoader).hide();
        $('.saving-alerts .alert-danger').show();
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DirectorsEdit',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      source: null,
      entity: {}
    };
  },


  computed: {
    avatarUrl: function avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged: function avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    }
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'directors/' + this.$route.params.id + '?with[]=avatar').then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
          _this.source.avatar = null;
          _this.entity.avatar = null;
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting director request' });
        console.error(error);
      });
    },
    isEntityValid: function isEntityValid() {
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.order) {
        this.$_showError('Order field is required');
        return false;
      }
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      return true;
    },
    changeAvatar: function changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore: function avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove: function avatarRemove() {
      this.entity.avatar = null;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('email', this.entity.email);
      postFormData.append('description', this.entity.description ? this.entity.description : '');
      postFormData.append('order', this.entity.order);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'directors/' + this.$route.params.id, postFormData);
    },
    saveAvatarRequest: function saveAvatarRequest() {
      var postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'directors/' + this.$route.params.id + '/avatar', postFormData);
    },
    deleteAvatarRequest: function deleteAvatarRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'directors/' + this.$route.params.id + '/avatar');
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update directors query', error);
        });
      } else if (!this.entity.avatar) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DirectorsList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'directors?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var directorsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete directorsArr.meta;
          _this.entities = directorsArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DirectorsNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        description: null,
        avatar: null,
        seo_title: '',
        seo_description: '',
        email: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      return true;
    },
    isEmailEntityValid: function isEmailEntityValid() {
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      return true;
    },
    avatarUploaded: function avatarUploaded(file) {
      this.entity.avatar = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('email', this.entity.email);
      if (this.entity.description) postFormData.append('description', this.entity.description);
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'directors', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.isEmailEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/directors/edit/' + response.data.id;
      }).catch(function (error) {
        console.error('Error in directors create query', error);
        _this.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Pager__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorsPicksEdit',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default.a
  },

  data: function data() {
    return {
      picks: [],
      selectedPicksSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      unpickedSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      saveErrorMessage: 'Error in data saving',
      searchQuery: '',
      isLoading: false,
      total: 0,
      offset: 0,
      perPage: null
    };
  },


  computed: {
    selectedPicks: function selectedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.selectedPicksSet);
    },
    unpickedPicks: function unpickedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.unpickedSet);
    },
    emptySearch: function emptySearch() {
      return !!this.searchQuery;
    },
    filteredPicks: function filteredPicks() {
      var _this = this;

      var arr = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.picks));
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.remove(arr, function (item) {
        if (_this.selectedPicks.find(function (pick) {
          return pick.id === item.id;
        })) {
          return true;
        }
        return false;
      });
      return arr;
    }
  },

  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getPicks();
    }, 400),
    offset: function offset() {
      this.getPicks();
    }
  },

  mounted: function mounted() {
    this.getPicksAndSelectedData();
  },


  methods: {
    addEditorsPick: function addEditorsPick(pick) {
      this.selectedPicksSet.add(pick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      var unpickedPick = this.unpickedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (unpickedPick) {
        this.unpickedSet.delete(unpickedPick);
        this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
      }
    },
    deleteEditorsPick: function deleteEditorsPick(pick) {
      var selectedPick = this.selectedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (!selectedPick) {
        return;
      }
      this.selectedPicksSet.delete(selectedPick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      this.unpickedSet.add(pick);
      this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
    },
    getPicks: function getPicks() {
      var _this2 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'articles', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this2.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data);
          _this2.total = response.data.meta.pagination.total;
          _this2.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this2.picks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(picks).map(function (e) {
            return picks[e];
          });
        }
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    getPicksAndSelectedData: function getPicksAndSelectedData() {
      var _this3 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'articles', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data));
          _this3.total = response.data.meta.pagination.total;
          _this3.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this3.picks = picks;
        }
        return _this3.$apiHttp.get(_this3.$config.app_api.prefix + 'editors-picks?type=article');
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          _this3.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(response.data);
        }
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    unpickRequest: function unpickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'article');
      for (var i = 0; i < this.unpickedPicks.length; i += 1) {
        postFormData.append('ids[]', this.unpickedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/unpick', postFormData);
    },
    pickRequest: function pickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'article');
      for (var i = 0; i < this.selectedPicks.length; i += 1) {
        postFormData.append('ids[]', this.selectedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/pick', postFormData);
    },
    save: function save() {
      var _this4 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var promises = [];
      if (this.unpickedPicks.length) {
        promises.push(this.unpickRequest());
      }
      if (this.selectedPicks.length) {
        promises.push(this.pickRequest());
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this4.successSave();
        _this4.$forceUpdate();
      }).catch(function (error) {
        _this4.errorSave('Error in data saving');
        console.error('Error in saving picks for articles', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    onPageChanged: function onPageChanged(offset) {
      this.offset = offset;
    },
    adaptText: function adaptText(text) {
      if (!text) {
        return text;
      }
      var fixedText = text.replace(/<[^>]*>/gm, '');
      if (fixedText.length > 253) {
        return fixedText.substring(0, 250) + '...';
      }
      return fixedText;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Pager__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorsPicksEdit',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default.a
  },

  data: function data() {
    return {
      picks: [],
      selectedPicksSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      unpickedSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      saveErrorMessage: 'Error in data saving',
      searchQuery: '',
      isLoading: false,
      total: 0,
      offset: 0,
      perPage: null
    };
  },


  computed: {
    selectedPicks: function selectedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.selectedPicksSet);
    },
    unpickedPicks: function unpickedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.unpickedSet);
    },
    emptySearch: function emptySearch() {
      return !!this.searchQuery;
    },
    filteredPicks: function filteredPicks() {
      var _this = this;

      var arr = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.picks));
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.remove(arr, function (item) {
        if (_this.selectedPicks.find(function (pick) {
          return pick.id === item.id;
        })) {
          return true;
        }
        return false;
      });
      return arr;
    }
  },

  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getPicks();
    }, 400),
    offset: function offset() {
      this.getPicks();
    }
  },

  mounted: function mounted() {
    this.getPicksAndSelectedData();
  },


  methods: {
    addEditorsPick: function addEditorsPick(pick) {
      this.selectedPicksSet.add(pick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      var unpickedPick = this.unpickedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (unpickedPick) {
        this.unpickedSet.delete(unpickedPick);
        this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
      }
    },
    deleteEditorsPick: function deleteEditorsPick(pick) {
      var selectedPick = this.selectedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (!selectedPick) {
        return;
      }
      this.selectedPicksSet.delete(selectedPick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      this.unpickedSet.add(pick);
      this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
    },
    getPicks: function getPicks() {
      var _this2 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this2.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data);
          _this2.total = response.data.meta.pagination.total;
          _this2.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this2.picks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(picks).map(function (e) {
            return picks[e];
          });
        }
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    getPicksAndSelectedData: function getPicksAndSelectedData() {
      var _this3 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'media/documents', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data));
          _this3.total = response.data.meta.pagination.total;
          _this3.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this3.picks = picks;
        }
        return _this3.$apiHttp.get(_this3.$config.app_api.prefix + 'editors-picks?type=media_doc');
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          _this3.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(response.data);
        }
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    unpickRequest: function unpickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'media_doc');
      for (var i = 0; i < this.unpickedPicks.length; i += 1) {
        postFormData.append('ids[]', this.unpickedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/unpick', postFormData);
    },
    pickRequest: function pickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'media_doc');
      for (var i = 0; i < this.selectedPicks.length; i += 1) {
        postFormData.append('ids[]', this.selectedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/pick', postFormData);
    },
    save: function save() {
      var _this4 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var promises = [];
      if (this.unpickedPicks.length) {
        promises.push(this.unpickRequest());
      }
      if (this.selectedPicks.length) {
        promises.push(this.pickRequest());
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this4.successSave();
        _this4.$forceUpdate();
      }).catch(function (error) {
        _this4.errorSave('Error in data saving');
        console.error('Error in saving picks for media/documents', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    onPageChanged: function onPageChanged(offset) {
      this.offset = offset;
    },
    adaptText: function adaptText(text) {
      if (!text) {
        return text;
      }
      var fixedText = text.replace(/<[^>]*>/gm, '');
      if (fixedText.length > 253) {
        return fixedText.substring(0, 250) + '...';
      }
      return fixedText;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Pager__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorsPicksEdit',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_7__global_components_Pager___default.a
  },

  data: function data() {
    return {
      picks: [],
      selectedPicksSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      unpickedSet: new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(),
      saveErrorMessage: 'Error in data saving',
      searchQuery: '',
      isLoading: false,
      total: 0,
      offset: 0,
      perPage: null
    };
  },


  computed: {
    selectedPicks: function selectedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.selectedPicksSet);
    },
    filteredPicks: function filteredPicks() {
      var _this = this;

      var arr = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.picks));
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.remove(arr, function (item) {
        if (_this.selectedPicks.find(function (pick) {
          return pick.id === item.id;
        })) {
          return true;
        }
        return false;
      });
      return arr;
    },
    unpickedPicks: function unpickedPicks() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(this.unpickedSet);
    },
    emptySearch: function emptySearch() {
      return !!this.searchQuery;
    }
  },

  watch: {
    searchQuery: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {
      this.offset = 0;
      this.getPicks();
    }, 400),
    offset: function offset() {
      this.getPicks();
    }
  },

  mounted: function mounted() {
    this.getPicksAndSelectedData();
  },


  methods: {
    addEditorsPick: function addEditorsPick(pick) {
      this.selectedPicksSet.add(pick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      var unpickedPick = this.unpickedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (unpickedPick) {
        this.unpickedSet.delete(unpickedPick);
        this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
      }
    },
    deleteEditorsPick: function deleteEditorsPick(pick) {
      var selectedPick = this.selectedPicks.find(function (item) {
        return item.id === pick.id;
      });
      if (!selectedPick) {
        return;
      }
      this.selectedPicksSet.delete(selectedPick);
      this.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.selectedPicksSet);
      this.unpickedSet.add(pick);
      this.unpickedSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(this.unpickedSet);
    },
    getPicks: function getPicks() {
      var _this2 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'faq', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this2.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data);
          _this2.total = response.data.meta.pagination.total;
          _this2.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this2.picks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(picks).map(function (e) {
            return picks[e];
          });
        }
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this2.$refs.sourceSpinner) {
          _this2.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    getPicksAndSelectedData: function getPicksAndSelectedData() {
      var _this3 = this;

      if (this.$refs.sourceSpinner) {
        this.$refs.sourceSpinner.show();
      }
      var searchProcessId = Math.random();
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'faq', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          var picks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(response.data));
          _this3.total = response.data.meta.pagination.total;
          _this3.perPage = response.data.meta.pagination.per_page;
          delete picks.meta;
          _this3.picks = picks;
        }
        return _this3.$apiHttp.get(_this3.$config.app_api.prefix + 'editors-picks?type=faq');
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          _this3.selectedPicksSet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(response.data);
        }
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.sourceSpinner) {
          _this3.$refs.sourceSpinner.hide();
        }
        console.error(error);
      });
    },
    changePage: function changePage(offset) {
      this.offset = offset;
    },
    unpickRequest: function unpickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'faq');
      for (var i = 0; i < this.unpickedPicks.length; i += 1) {
        postFormData.append('ids[]', this.unpickedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/unpick', postFormData);
    },
    pickRequest: function pickRequest() {
      var postFormData = new FormData();
      postFormData.append('alias', 'faq');
      for (var i = 0; i < this.selectedPicks.length; i += 1) {
        postFormData.append('ids[]', this.selectedPicks[i].id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'editors-picks/pick', postFormData);
    },
    save: function save() {
      var _this4 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      var promises = [];
      if (this.unpickedPicks.length) {
        promises.push(this.unpickRequest());
      }
      if (this.selectedPicks.length) {
        promises.push(this.pickRequest());
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        _this4.successSave();
        _this4.$forceUpdate();
      }).catch(function (error) {
        _this4.errorSave('Error in data saving');
        console.error('Error in saving picks for articles', error);
      });
    },
    successSave: function successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    errorSave: function errorSave(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },
    onPageChanged: function onPageChanged(offset) {
      this.offset = offset;
    },
    adaptText: function adaptText(text) {
      if (!text) {
        return text;
      }
      var fixedText = text.replace(/<[^>]*>/gm, '');
      if (fixedText.length > 253) {
        return fixedText.substring(0, 250) + '...';
      }
      return fixedText;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorsPicksList',

  data: function data() {
    return {
      picks: [{
        id: 0,
        type: 'articles',
        name: 'Articles',
        url: '/admin/editors-picks/edit-articles'
      }, {
        id: 1,
        type: 'faq',
        name: 'FAQ',
        url: '/admin/editors-picks/edit-faq'
      }, {
        id: 2,
        type: 'media_doc',
        name: 'Documents',
        url: '/admin/editors-picks/edit-documents'
      }]
    };
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_1_vue_select___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      required: true
    },
    contentProps: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      newUrlLoader: false,
      newContentLoader: false,
      currentContent: [],
      newContentUrl: '',
      contentType: null,
      contentEntityOptions: [],
      contentEntity: null,
      saveUrlErrorMessage: ''
    };
  },

  computed: {
    contentTypeOptions: function contentTypeOptions() {
      var _this = this;

      var array = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(this.$store.state.contentTypes.list, function (item, key) {
        array.push({
          label: _this.snakeToTitle(key),
          key: key
        });
      });
      return array;
    }
  },

  watch: {
    contentType: function contentType() {
      this.contentEntityOptions = [];
      this.contentEntity = null;
      if (this.$refs.contentEntityModel) {
        this.$refs.contentEntityModel.onEscape();
      }
    },
    contentProps: function contentProps(val) {
      this.currentContent = val;
    },
    loading: function loading(val) {
      if (this.$refs.spinner) {
        if (val) {
          this.$refs.spinner.show();
        } else {
          this.$refs.spinner.hide();
        }
      }
    }
  },

  mounted: function mounted() {
    this.currentContent = this.contentProps;
    if (this.$refs.spinner && this.loading) {
      this.$refs.spinner.show();
    }
  },


  methods: {
    snakeToTitle: function snakeToTitle(str) {
      return str.split('_').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      }).join(' ');
    },
    dettachContent: function dettachContent(content) {
      var _this2 = this;

      if (window.confirm('Do you really want to make article with id "' + content.id + '" non featured?')) {
        var $btnLoader = $('#article' + content.id + ' .btn-danger .btn-loader');
        $btnLoader.show();
        var contentList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.currentContent);
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(contentList, function (item) {
          return item.id === content.id && item.type === content.type;
        });

        this.$apiHttp.post(this.$config.app_api.prefix + 'featured-content/unfeature', {
          block_id: this.id,
          alias: content.type,
          id: content.id
        }).then(function () {
          _this2.currentContent = contentList;
          $btnLoader.hide();
        }).catch(function (error) {
          $btnLoader.hide();
          _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in unfeaturing content request' });
          console.error(error);
        });
      }
    },
    addContent: function addContent() {
      var _this3 = this;

      if (this.newContentLoader) return;
      this.newContentLoader = true;
      this.$apiHttp.post(this.$config.app_api.prefix + 'featured-content/feature', {
        section_id: this.id,
        alias: this.contentType.key,
        id: this.contentEntity.id
      }).then(function (response) {
        _this3.contentEntity = null;
        _this3.newContentLoader = false;
        var _response$data = response.data,
            id = _response$data.id,
            type = _response$data.type;

        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this3.currentContent, function (item) {
          return item.id === id && item.type === type;
        })) {
          _this3.currentContent.push(response.data);
        }
      }).catch(function (error) {
        _this3.newContentLoader = false;
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in adding content request' });
        console.error(error);
      });
    },
    addNewUrl: function addNewUrl() {
      var _this4 = this;

      if (this.newUrlLoader) return;
      this.saveUrlErrorMessage = '';
      this.newUrlLoader = true;
      this.$apiHttp.post(this.$config.app_api.prefix + 'featured-content/feature-by-url', {
        section_id: this.id,
        url: this.newContentUrl
      }).then(function (response) {
        _this4.newContentUrl = '';
        _this4.newUrlLoader = false;
        var _response$data2 = response.data,
            id = _response$data2.id,
            type = _response$data2.type;

        if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this4.currentContent, function (item) {
          return item.id === id && item.type === type;
        })) {
          _this4.currentContent.push(response.data);
        }
      }).catch(function (error) {
        var errorText = '';
        _this4.newUrlLoader = false;
        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.has(error, 'response.data.message') && error.response.data.message) {
          errorText = error.response.data.message;
        } else {
          errorText = 'Server error';
        }
        _this4.saveUrlErrorMessage = errorText;
        _this4.$store.dispatch('notifications/setHttpError', { error: error, text: errorText });
        console.error(error);
      });
    },
    onEntitySearch: function onEntitySearch(search, loading) {
      loading(true);
      this.entitySearch(loading, search, this, this.contentType.key);
    },

    entitySearch: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (loading, search, vm, contentType) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.host + vm.$config.app_api.prefix + 'content-types/' + contentType, {
        params: {
          search_string: escape(search)
        }
      }).then(function (response) {
        var newDataArr = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forIn(response.data, function (value, key) {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.contentEntityOptions = newDataArr;
        loading(false);
      }).catch(function (reject) {
        console.error(reject);
      });
    }, 350)
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeSection__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HomeSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HomeSection__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaturedArticles',

  components: {
    'home-section': __WEBPACK_IMPORTED_MODULE_1__HomeSection___default.a
  },

  data: function data() {
    return {
      contentList: [],
      isLoading: false
    };
  },


  computed: {
    sectionsList: function sectionsList() {
      return this.$store.state.homeSections;
    }
  },

  mounted: function mounted() {
    this.getFeaturedArticles();
  },


  methods: {
    getFeaturedArticles: function getFeaturedArticles() {
      var _this = this;

      this.isLoading = true;
      this.$apiHttp.get(this.$config.app_api.prefix + 'featured-content').then(function (response) {
        _this.contentList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        _this.isLoading = false;
      }).catch(function (error) {
        _this.isLoading = false;
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting list request' });
        console.log('Error in getting featured articles request ', error);
      });
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Flowpaper',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  watch: {
    'filters.status': function filtersStatus() {
      this.getSource();
    },
    'filters.disk': function filtersDisk() {
      this.getSource();
    },
    'filters.model_type': function filtersModel_type() {
      this.getSource();
    }
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.host + 'api/v1/flowpaper/documents', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var docs = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete docs.meta;
          _this.entities = docs;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_MemoryGameMixin__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MemoryImageEdit',

  components: {
    MemoryQuote: __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_MemoryGameMixin__["a" /* default */]],

  mounted: function mounted() {
    this.getSource();
  },
  data: function data() {
    return {
      selected_ref_id: {},
      entity: {
        reference: {
          title: ''
        }
      }
    };
  },


  computed: {
    vsGame: function vsGame() {
      return {
        'display-selected-tag': this.selected_ref_id.title != '' && this.selected_ref_id.title != undefined,
        'hide-selected-tag': this.selected_ref_id.title == undefined
      };
    }
  },

  methods: {
    isEntityValid: function isEntityValid() {
      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }];
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      postFormData.append('is_person', this.entity.is_person ? 1 : 0);
      if (this.selected_ref_id.id) {
        postFormData.append('ref_id', this.selected_ref_id.id);
      } else {
        postFormData.append('ref_id', this.entity.ref_id);
      }
      if (this.entity.memory_image) {
        this.saveImage();
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/memory/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this.$_successSave();
        _this.$parent.getSource();
      }, function (error) {
        console.error('Error in audio create request', error);
        _this.$_errorSave(error);
      });
    },
    saveImage: function saveImage() {
      var postFormData = new FormData();
      postFormData.append('media_image', this.entity.memory_image);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/memory/' + this.$route.params.id + '/image', postFormData);
    },
    coverChange: function coverChange(file) {
      var _this2 = this;

      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = function () {
          _this2.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.memory_image = file;
        return;
      }
      this.imageSelected = false;
    },
    getSource: function getSource() {
      var _this3 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var formData = new FormData();
      formData.append('with[]', 'image');
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/memory/' + this.$route.params.id).then(function (response) {
        var source = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        var clone = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(source);
        _this3.source = source;
        _this3.entity = clone;
        if (_this3.entity.reference == undefined) {
          _this3.entity.reference = {};
          _this3.entity.reference.quotes = [];
        };
        if (_this3.entity.quotes == null) {
          _this3.entity.quotes = [];
        }
        if (_this3.entity.ref_id == null) {
          _this3.entity.reference.title = 'No image chosen ...';
        };
        if (!_this3.images.length) {
          return _this3.getAllImages();
        }
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        return null;
      }).then(function (response) {
        if (!response) {
          return;
        }
        var memoryImages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        var images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
        _this3.$store.dispatch('memoryGame/setImages', images);
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting puzzle image request' });
        console.error('Error in get single document files query', error);
      });
    },
    getAllImages: function getAllImages() {
      return this.$apiHttp.get(this.$config.app_api.prefix + 'games/memory', {
        params: {
          nonpaginated: true
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MemoryImageList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      images: []
    };
  },

  methods: {
    adaptUrl: function adaptUrl(url) {
      if (!url) {
        return null;
      }
      if (url[0] === '/') {
        return url.substring(1);
      }
      return url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/memory', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.total = response.data.meta.pagination.total;
        _this.perPage = response.data.meta.pagination.per_page;
        var memoryImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        _this.images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MemoryQuote',
  props: {
    number: {
      type: Number,
      required: true
    },
    quote: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteQuote: function deleteQuote() {
      this.$emit('deleteQuote', this.number);
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_MemoryGameMixin__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MemoryImageNew',

  components: {
    MemoryQuote: __WEBPACK_IMPORTED_MODULE_6__MemoryQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_MemoryGameMixin__["a" /* default */]],

  mounted: function mounted() {
    var _this = this;

    if (!this.images.length) {
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.getAllImages().then(function (response) {
        var memoryImages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        var images = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
        _this.$store.dispatch('memoryGame/setImages', images);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      });
    }
  },


  methods: {
    isEntityValid: function isEntityValid() {
      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Image', value: this.entity.memory_image, type: 'required' }];
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      postFormData.append('is_person', this.entity.is_person ? 1 : 0);
      postFormData.append('memory_image', this.entity.memory_image);
      if (this.entity.ref_id) {
        postFormData.append('ref_id', this.entity.ref_id);
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/memory', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        _this2.$parent.getSource();
        window.location.hash = '#/admin/memory-game-images/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this2.$_errorSave(error);
      });
    },
    coverChange: function coverChange(file) {
      var _this3 = this;

      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = function () {
          _this3.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.memory_image = file;
        return;
      }
      this.imageSelected = false;
    },
    getAllImages: function getAllImages() {
      return this.$apiHttp.get(this.$config.app_api.prefix + 'games/memory', {
        params: {
          nonpaginated: true
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_PaintingGameMixin__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaintingImageEdit',

  components: {
    PaintingQuote: __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_PaintingGameMixin__["a" /* default */]],

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    isEntityValid: function isEntityValid() {
      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }];
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      if (this.entity.painting_image) {
        this.saveImage();
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/painting/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this.$_successSave();
        _this.$parent.getSource();
      }, function (error) {
        console.error('Error in audio create request', error);
        _this.$_errorSave(error);
      });
    },
    saveImage: function saveImage() {
      var postFormData = new FormData();
      postFormData.append('painting_image', this.entity.painting_image);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/painting/' + this.$route.params.id + '/image', postFormData);
    },
    coverChange: function coverChange(file) {
      var _this2 = this;

      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = function () {
          _this2.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.painting_image = file;
        return;
      }
      this.imageSelected = false;
    },
    getSource: function getSource() {
      var _this3 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var formData = new FormData();
      formData.append('with[]', 'image');
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/painting/' + this.$route.params.id).then(function (response) {
        var source = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        var clone = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(source);
        _this3.source = source;
        _this3.entity = clone;
        if (!_this3.entity.quotes) {
          _this3.entity.quotes = [];
        }
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        return null;
      }).then(function (response) {
        if (!response) {
          return;
        }
        var paintingImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete paintingImages.meta;
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting painting image request' });
        console.error('Error in get single document files query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaintingImageList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      images: []
    };
  },

  methods: {
    adaptUrl: function adaptUrl(url) {
      if (!url) {
        return null;
      }
      if (url[0] === '/') {
        return url.substring(1);
      }
      return url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/painting', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.total = response.data.meta.pagination.total;
        _this.perPage = response.data.meta.pagination.per_page;
        var paintingImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete paintingImages.meta;
        _this.images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(paintingImages).map(function (e) {
          return paintingImages[e];
        });
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_PaintingGameMixin__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaintingImageNew',

  components: {
    PaintingQuote: __WEBPACK_IMPORTED_MODULE_5__PaintingQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_PaintingGameMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }, { name: 'Image', value: this.entity.painting_image, type: 'required' }];
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      postFormData.append('painting_image', this.entity.painting_image);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/painting', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/painting-game-images/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this.$_errorSave(error);
      });
    },
    coverChange: function coverChange(file) {
      var _this2 = this;

      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = function () {
          _this2.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.painting_image = file;
        return;
      }
      this.imageSelected = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaintingQuote',
  props: {
    number: {
      type: Number,
      required: true
    },
    quote: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteQuote: function deleteQuote() {
      this.$emit('deleteQuote', this.number);
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_PuzzleGameMixin__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PuzzleImageEdit',

  components: {
    PuzzleQuote: __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_PuzzleGameMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      var _this = this;

      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }];
      this.presets.forEach(function (preset) {
        filelds.push({ name: preset.title, value: _this.entity.levels[preset.type], type: 'required' });
      });
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('levels', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.levels));
      postFormData.append('puzzle', this.entity.image);
      postFormData.append('default_level', this.entity.default_level);
      if (this.entity.quotes.length) {
        postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/puzzles/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        _this2.$parent.getSource();
        window.location.hash = '#/admin/puzzle-game-images/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this2.$_errorSave(error);
      });
    },
    coverChange: function coverChange(file) {
      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = this.loadHandler;
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.image = file;
        return;
      }
      this.imageSelected = false;
    },
    loadHandler: function loadHandler() {
      this.imageLoaded = true;
      if (this.$refs.spinner) {
        this.$refs.spinner.hide();
      }
    },
    getSource: function getSource() {
      var _this3 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/puzzles/' + this.$route.params.id).then(function (response) {
        var source = _this3.$_apadtSource(response.data);
        var clone = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(source);
        _this3.source = source;
        _this3.entity = clone;
        if (!_this3.entity.quotes) {
          _this3.entity.quotes = [];
        }
        _this3.$refs.uploader.$refs.imageBoxImg.onload = _this3.loadHandler;
        _this3.imageOnLoadHandlerSet = true;
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting puzzle image request' });
        console.error('Error in get single document files query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PuzzleImageIndex',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    adaptUrl: function adaptUrl(url) {
      if (!url) {
        return null;
      }
      if (url[0] === '/') {
        return url.substring(1);
      }
      return url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/puzzles', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.total = response.data.meta.pagination.total;
        _this.perPage = response.data.meta.pagination.per_page;
        var puzzles = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete puzzles.meta;
        _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(puzzles).map(function (e) {
          return puzzles[e];
        });
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_PuzzleGameMixin__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PuzzleImageNew',

  components: {
    PuzzleQuote: __WEBPACK_IMPORTED_MODULE_5__PuzzleQuote_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_PuzzleGameMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      var filelds = [{ name: 'Title', value: this.entity.title, type: 'required' }];
      return this.$_validate(filelds);
    },
    saveRequest: function saveRequest() {
      var postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('levels', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.levels));
      if (this.entity.quotes.length) {
        postFormData.append('quotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.entity.quotes));
      }
      postFormData.append('puzzle', this.entity.image);
      postFormData.append('default_level', this.entity.default_level);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/puzzles', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/puzzle-game-images/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this.$_errorSave(error);
      });
    },
    coverChange: function coverChange(file) {
      var _this2 = this;

      this.imageLoaded = false;
      this.$_coverChange(file);
      if (!this.imageOnLoadHandlerSet) {
        this.$refs.uploader.$refs.imageBoxImg.onload = function () {
          _this2.imageLoaded = true;
        };
        this.imageOnLoadHandlerSet = true;
      }
      if (file) {
        this.imageSelected = true;
        this.entity.image = file;
        return;
      }
      this.imageSelected = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PuzzleQuote',
  props: {
    number: {
      type: Number,
      required: true
    },
    quote: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteQuote: function deleteQuote() {
      this.$emit('deleteQuote', this.number);
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_QuizGameMixin__ = __webpack_require__(105);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizImagesEdit',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_QuizGameMixin__["a" /* default */]],

  mounted: function mounted() {
    this.getSource();
  },


  methods: {
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('question', this.entity.question);
      if (this.entity.answer) {
        postFormData.append('answer', 1);
      } else {
        postFormData.append('answer', 0);
      };
      if (this.entity.explanation) {
        postFormData.append('explanation', this.entity.explanation);
      };
      if (this.entity.more_info) {
        postFormData.append('more_info', this.entity.more_info);
      };
      if (this.entity.link) {
        postFormData.append('link', this.entity.link);
      };
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/quiz/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      this.saveRequest().then(function () {
        _this.$_successSave();
        _this.$parent.getSource();
      }, function (error) {
        console.error('Error in audio create request', error);
        _this.$_errorSave(error);
      });
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var formData = new FormData();
      formData.append('with[]', 'image');
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/quiz/' + this.$route.params.id).then(function (response) {
        var source = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        var clone = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(source);
        _this2.source = source;
        _this2.entity = clone;
        if (!_this2.images.length) {
          return _this2.getAllImages();
        }
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        return null;
      }).then(function (response) {
        if (!response) {
          return;
        }
        var memoryImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        var images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
        _this2.$store.dispatch('quizGame/setImages', images);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting puzzle image request' });
        console.error('Error in get single document files query', error);
      });
    },
    getAllImages: function getAllImages() {
      return this.$apiHttp.get(this.$config.app_api.prefix + 'games/quiz', {
        params: {
          nonpaginated: true
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizImagesIndex',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    EmptyBtns: __WEBPACK_IMPORTED_MODULE_3__global_components_EmptyBtns___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      images: []
    };
  },

  methods: {
    adaptUrl: function adaptUrl(url) {
      if (!url) {
        return null;
      }
      if (url[0] === '/') {
        return url.substring(1);
      }
      return url;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'games/quiz', {
        params: {
          search_string: searchString,
          page: page
        }
      }).then(function (response) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.total = response.data.meta.pagination.total;
        _this.perPage = response.data.meta.pagination.per_page;
        var memoryImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        _this.images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_QuizGameMixin__ = __webpack_require__(105);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QuizImagesNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_DefaultOptionsRequests__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_QuizGameMixin__["a" /* default */]],

  mounted: function mounted() {
    var _this = this;

    if (!this.images.length) {
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.getAllImages().then(function (response) {
        var memoryImages = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete memoryImages.meta;
        var images = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(memoryImages).map(function (e) {
          return memoryImages[e];
        });
        _this.$store.dispatch('quizGame/setImages', images);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      });
    }
  },


  methods: {
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('question', this.entity.question);
      if (this.entity.answer) {
        postFormData.append('answer', 1);
      } else {
        postFormData.append('answer', 0);
      };
      if (this.entity.explanation) {
        postFormData.append('explanation', this.entity.explanation);
      };
      if (this.entity.more_info) {
        postFormData.append('more_info', this.entity.more_info);
      };
      if (this.entity.link) {
        postFormData.append('link', this.entity.link);
      };
      return this.$apiHttp.post(this.$config.app_api.prefix + 'games/quiz', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();

      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        _this2.$parent.getSource();
        window.location.hash = '#/admin/quiz-game-images/edit/' + response.data.id;
      }, function (error) {
        console.error('Error in audio create request', error);
        _this2.$_errorSave(error);
      });
    },
    getAllImages: function getAllImages() {
      return this.$apiHttp.get(this.$config.app_api.prefix + 'games/quiz', {
        params: {
          nonpaginated: true
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_CommonPageMixin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBy__ = __webpack_require__(106);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainSearch',
  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a,
    SearchBar: __WEBPACK_IMPORTED_MODULE_4__SearchBar_vue___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_3__global_components_OpenOnSiteButton___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_CommonPageMixin__["a" /* default */]],
  data: function data() {
    return {
      searchQuery: '',
      searchType: __WEBPACK_IMPORTED_MODULE_5__SearchBy__["a" /* default */].TITLE,
      isLoading: false
    };
  },
  mounted: function mounted() {
    this.perPage = 25;
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      this.isLoading = true;
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = this.searchQuery;

      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;

      var getUrl = this.$config.app_api.prefix + 'search/documents';
      var params = {
        offset: this.offset,
        limit: this.perPage
      };

      switch (this.searchType) {
        case __WEBPACK_IMPORTED_MODULE_5__SearchBy__["a" /* default */].ID:
          {
            if (searchString) {
              params.id = searchString;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_5__SearchBy__["a" /* default */].URL:
          {
            if (searchString) {
              params.url = searchString;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_5__SearchBy__["a" /* default */].BODY:
          {
            if (searchString) {
              params.body = searchString;
            }
            break;
          }
        case __WEBPACK_IMPORTED_MODULE_5__SearchBy__["a" /* default */].TITLE:
        default:
          {
            if (searchString) {
              params.title = searchString;
            }
            break;
          }
      }

      this.$apiHttp.get(getUrl, {
        params: params
      }).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          var data = response.data;

          if (Array.isArray(data)) {
            _this.entities = [];
            _this.total = 0;
            _this.isLoading = false;
            return;
          }
          _this.entities = response.data.hits;
          _this.total = data.total.value;
          _this.isLoading = false;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
        _this.isLoading = false;
      });
    },
    queryChanged: function queryChanged(query) {
      this.searchQuery = query;
    },
    searchTypeChanged: function searchTypeChanged(type) {
      this.searchType = type;
      this.getSource();
    },
    perPageChanged: function perPageChanged(val) {
      this.perPage = val;
      this.getSource();
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchBy__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchBar',
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      searchQuery: '',
      searchType: __WEBPACK_IMPORTED_MODULE_0__SearchBy__["a" /* default */].TITLE,
      SEARCH_BY: __WEBPACK_IMPORTED_MODULE_0__SearchBy__["a" /* default */],
      options: [10, 25, 50, 100, 500],
      perPage: 25
    };
  },
  watch: {
    perPage: function perPage(val) {
      this.$emit('perPageChanged', val);
    }
  },
  methods: {
    onSearchTypeChanged: function onSearchTypeChanged(type) {
      this.searchType = type;
      this.$emit('searchTypeChanged', type);
    },
    queryChanged: function queryChanged(event) {
      this.searchQuery = event.currentTarget.value;
      this.$emit('queryChanged', this.searchQuery);
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_PieChart__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Media',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'pie-chart': __WEBPACK_IMPORTED_MODULE_2__global_components_PieChart__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      pieDataIsReady: false,
      pieDataHasError: false,
      pieOptions: {
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          labels: {
            defaultFontSize: 14
          }
        }
      },
      helthStats: {
        all: 0,
        noInfo: 0,
        helth: 0,
        damaged: 0
      },
      filters: {
        status: '',
        disk: '',
        model_type: ''
      },
      contentTypes: {},
      media: null
    };
  },


  computed: {
    pieData: function pieData() {
      return {
        labels: ['Ok (' + this.helthStats.helth + ')', 'Failed (' + this.helthStats.damaged + ')', 'Unknown (' + this.helthStats.noInfo + ')'],
        datasets: [{
          label: 'File Helth',
          backgroundColor: ['#4dbd74', '#f86c6b', '#5a5a5a'],
          data: [this.helthStats.helth, this.helthStats.damaged, this.helthStats.noInfo]
        }]
      };
    }
  },

  watch: {
    'filters.status': function filtersStatus() {
      this.getSource();
    },
    'filters.disk': function filtersDisk() {
      this.getSource();
    },
    'filters.model_type': function filtersModel_type() {
      this.getSource();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.getPieData();
    this.contentTypes = this.$store.state.contentTypes.list;
    this.$store.watch(function (state) {
      return state.contentTypes.list;
    }, function () {
      _this.contentTypes = _this.$store.state.contentTypes.list;
    }, { deep: true });
  },


  methods: {
    getPieData: function getPieData() {
      var _this2 = this;

      var successFinish = function successFinish(queryCount) {
        if (queryCount === 0) {
          _this2.helthStats.noInfo = _this2.helthStats.all - _this2.helthStats.damaged - _this2.helthStats.helth;
          _this2.pieDataIsReady = true;
          if (_this2.$refs.pieSpinner) {
            _this2.$refs.pieSpinner.hide();
          }
        }
      };
      var queryCount = 3;

      this.pieDataIsReady = false;
      this.pieDataHasError = false;
      if (this.$refs.pieSpinner) {
        this.$refs.pieSpinner.show();
      }

      this.$apiHttp.get(this.$config.app_api.prefix + 'medialibrary').then(function (response) {
        _this2.helthStats.all = response.data.meta.pagination.total;
        queryCount -= 1;
        successFinish(queryCount);
      }).catch(function (error) {
        _this2.pieDataHasError = true;
        console.error(error);
      });
      this.$apiHttp.get(this.$config.app_api.prefix + 'medialibrary?filter_status=ok').then(function (response) {
        _this2.helthStats.helth = response.data.meta.pagination.total;
        queryCount -= 1;
        successFinish(queryCount);
      }).catch(function (error) {
        _this2.pieDataHasError = true;
        console.error(error);
      });
      this.$apiHttp.get(this.$config.app_api.prefix + 'medialibrary?filter_status=failed').then(function (response) {
        _this2.helthStats.damaged = response.data.meta.pagination.total;
        queryCount -= 1;
        successFinish(queryCount);
      }).catch(function (error) {
        _this2.pieDataHasError = true;
        console.error(error);
      });
    },
    getSource: function getSource() {
      var _this3 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'medialibrary', {
        params: {
          search_string: searchString,
          page: page,
          filter_status: this.filters.status,
          filter_disk: this.filters.disk,
          filter_model_type: this.filters.model_type
        }
      }).then(function (response) {
        if (_this3.searchProcessId === searchProcessId) {
          if (_this3.$refs.spinner) {
            _this3.$refs.spinner.hide();
          }
          _this3.total = response.data.meta.pagination.total;
          _this3.perPage = response.data.meta.pagination.per_page;

          var mediaArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete mediaArr.meta;
          _this3.media = mediaArr;
        }
      }).catch(function (error) {
        _this3.$_errorCallback(error);
      });
    },
    updateHealth: function updateHealth(mediaItem) {
      var _this4 = this;

      var $btnsUpdateLoader = $('table.entities tr[data-id="' + mediaItem.id + '"] .table-cell-loader');
      $btnsUpdateLoader.show();
      this.$apiHttp.post(this.$config.app_api.prefix + 'medialibrary/' + mediaItem.id + '/check-health').then(function (response) {
        var key = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findKey(_this4.media, function (item) {
          return mediaItem.id === item.id;
        });
        _this4.media[key].file_health = response.data;
        $btnsUpdateLoader.hide();
        _this4.$store.commit('notifications/setSuccessNotification', 'Updated');
      }).catch(function (error) {
        $btnsUpdateLoader.hide();
        _this4.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in updating media status' });
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuEdit',

  data: function data() {
    return {
      source: null,
      menuName: null,
      menuTree: [],
      menuArray: [],
      saveErrorMessage: 'Error in data saving',
      orderChanged: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    this.getSource();

    $(document).on('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn', function (e) {
      e.stopPropagation();
    });
    $(document).on('click', '.menu-builder__item-btns .btn-delete', function () {
      if (window.confirm('Do you really want to delete this menu item?')) {
        $(this).append('<span class="btn-loader"></span>');
        self.deleteItem($(this).closest('.menu-builder__item-wrap').data('id'));
      }
    });
    $(document).on('click', '.menu-builder__item-btns .btn-edit', function () {
      var menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      var itemIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.menuArray, function (item) {
        return item.id === menuItemId;
      });
      self.editItemPopup(self.menuArray[itemIndex]);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-add', function () {
      var menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      self.addItemInside(menuItemId);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-open', function () {
      var menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      window.open(self.$config.app_api.host + 'menu-item/' + menuItemId, '_blank');
    });
    this.$root.$on('menuItemSaveNewSuccess', function (newContent, spot) {
      var newItem = $('.menu-builder-item-template .menu-builder__item-wrap').clone();
      newItem.data('id', newContent.id);
      newItem.find('.menu-builder__item-img img').attr('src', newContent.image ? newContent.image.public_url : '');
      newItem.find('.menu-builder__item-data-row._id span').text(newContent.id);
      newItem.find('.menu-builder__item-data-row._title span').text(newContent.title);
      newItem.find('.menu-builder__item-data-row._url span').text(newContent.url);
      var $parentItem = $('.menu-builder__item-wrap[data-id="' + newContent.parent_id + '"]');
      if (newContent.parent_id !== 0) {
        if ($parentItem.children('ul').length === 0) {
          _this.createDomForList($parentItem);
        }
        $parentItem.children('ul').append(newItem);
      } else if (spot === 'top') {
        $('.menu-builder-inner > ul').prepend(newItem);
      } else {
        $('.menu-builder-inner > ul').append(newItem);
      }

      _this.menuArray.push(newContent);
      _this.orderChanged = true;
    });
    this.$root.$on('menuItemSaveExistingSuccess', function (item) {
      var menuItem = _this.menuArray.find(function (arrayItem) {
        return arrayItem.id === item.id;
      });
      if (!menuItem) {
        return;
      }
      menuItem.id = item.id;
      menuItem.parent_id = item.parent_id;
      menuItem.order = item.order;
      menuItem.title = item.title;
      menuItem.url = item.url;
      menuItem.tooltip = item.tooltip;
      menuItem.route = item.route;
      menuItem.parameters = item.parameters;
      menuItem.image = item.image;
      menuItem.target = item.target;
      menuItem.path_alias = item.path_alias;
      menuItem.hidden = item.hidden;
      _this.menuTree = _this.listToTree(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(_this.menuArray));
    });
  },
  destroyed: function destroyed() {
    $(document).off('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn');
    $(document).off('click', '.menu-builder__item-btns .btn-delete');
    $(document).off('click', '.menu-builder__item-btns .btn-edit');
    $(document).off('click', '.menu-builder__item-btns .btn-add');
    $(document).off('click', '.menu-builder__item-btns .btn-open');
    this.$root.$off('menuItemSaveNewSuccess');
    this.$root.$off('menuItemSaveExistingSuccess');
    $('#sortableListsBase').remove();
  },


  methods: {
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'menu/' + this.$route.params.id + '?with[]=image&with[]=path_alias').then(function (response) {
        _this2.source = response.data;
        _this2.menuName = response.data.name;
        _this2.menuArray = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data.items);
        _this2.menuTree = _this2.listToTree(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data.items));

        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }

        setTimeout(function () {
          _this2.initSortableList();
        }, 300);
      }).catch(function (error) {
        console.error(error);
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
      });
    },
    listToTree: function listToTree(list) {
      var map = {};
      var roots = [];
      var node = void 0;
      var i = void 0;
      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i;
        list[i].children = [];
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parent_id !== 0) {
          list[map[node.parent_id]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      return roots;
    },
    initSortableList: function initSortableList() {
      var self = this;
      var options = {
        placeholderClass: 'menu-builder__item-placeholder',
        hintClass: 'menu-builder__item-hint',
        ignoreClass: 'btn',
        opener: {
          active: true,
          as: 'html',
          close: '<i class="fa fa-minus"></i>',
          open: '<i class="fa fa-plus"></i>',
          openerClass: 'menu-builder__item-opener'
        },
        onChange: function onChange(cEl) {
          var elementId = cEl.data('id');
          var $parentEl = cEl.parent('ul').parent();
          var parentElId = 0;
          var itemIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.menuArray, function (item) {
            return item.id === elementId;
          });
          if (!$parentEl.hasClass('menu-builder-inner')) {
            parentElId = $parentEl.data('id');
          }
          self.menuArray[itemIndex].parent_id = parentElId;
          $parentEl.children('ul').children('li').each(function (index) {
            var liId = $(this).data('id');
            var liIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.menuArray, function (item) {
              return item.id === liId;
            });
            self.menuArray[liIndex].order = index;
          });
          this.orderChanged = true;
        }
      };
      $('.menu-builder-inner > ul').sortableLists(options);
    },
    createDomForList: function createDomForList($parentItem) {
      $parentItem.append('<ul></ul>');
      $parentItem.children('.menu-builder__item').prepend('<span class="sortableListsOpener menu-builder__item-opener"><i class="fa fa-minus"></i></span>');
      $parentItem.find('.sortableListsOpener').on('mousedown', function () {
        var li = $(this).closest('li');
        if (li.hasClass('sortableListsClosed')) {
          li.children('ul').show();
          li.addClass('sortableListsOpen').removeClass('sortableListsClosed');
          li.children('.menu-builder__item').children('.menu-builder__item-opener').html('<i class="fa fa-minus"></i>');
        } else {
          li.children('ul').hide();
          li.addClass('sortableListsClosed').removeClass('sortableListsOpen');
          li.children('.menu-builder__item').children('.menu-builder__item-opener').html('<i class="fa fa-plus"></i>');
        }
        return false;
      });
    },
    addItemToTop: function addItemToTop() {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.menuArray, function (item) {
        return item.parent_id === 0;
      });
      var minOrderObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.minBy(itemsInParent, function (item) {
        return item.order;
      });
      this.newItemPopup(0, minOrderObj ? minOrderObj.order - 1 : 0, 'top');
    },
    addItemToBottom: function addItemToBottom() {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.menuArray, function (item) {
        return item.parent_id === 0;
      });
      var maxOrderObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.maxBy(itemsInParent, function (item) {
        return item.order;
      });
      this.newItemPopup(0, maxOrderObj ? maxOrderObj.order + 1 : 0, 'bottom');
    },
    addItemInside: function addItemInside(parentId) {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.menuArray, function (item) {
        return item.parent_id === parentId;
      });
      var maxOrderObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.maxBy(itemsInParent, function (item) {
        return item.order;
      });
      this.newItemPopup(parentId, maxOrderObj ? maxOrderObj.order + 1 : 0, 'bottom');
    },
    editItemPopup: function editItemPopup(content) {
      this.$root.$emit('menuItemSetParams', content, 'edit');
    },
    newItemPopup: function newItemPopup(parentId, order, spot) {
      var content = {
        menu_id: this.$route.params.id,
        parent_id: parentId,
        order: order,
        spot: spot
      };
      this.$root.$emit('menuItemSetParams', content, 'new');
    },
    saveAll: function saveAll() {
      var updateMenuItemsComplete = false;
      $('.saving-alerts .alert').hide();
      $('.btn-success.save-menu').append('<span class="btn-loader"></span>');
      this.$apiHttp.post(this.$config.app_api.prefix + 'menu/' + this.$route.params.id + '/menu-items/bulk-update', {
        items: this.menuArray
      }, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function () {
        updateMenuItemsComplete = true;
        if (updateMenuItemsComplete) {
          $('.btn-success.save-menu .btn-loader').remove();
          $('.saving-alerts .alert-success').show();
        }
      }).catch(function (error) {
        updateMenuItemsComplete = true;
        console.error(error);
        if (updateMenuItemsComplete) {
          $('.btn-success.save-menu .btn-loader').remove();
          $('.saving-alerts .alert-danger').show();
        }
      });
    },
    deleteItem: function deleteItem(itemId) {
      var _this3 = this;

      this.$apiHttp.delete(this.$config.app_api.prefix + 'menu/' + this.$route.params.id + '/menu-items/' + itemId).then(function () {
        var arrayRemove = [];
        arrayRemove.push(itemId);
        $('.menu-builder__item-wrap[data-id="' + itemId + '"]').find('.menu-builder__item-wrap').each(function () {
          arrayRemove.push($(this).data('id'));
        });
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(_this3.menuArray, function (item) {
          for (var i = 0; i < arrayRemove.length; i += 1) {
            if (arrayRemove[i] === item.id) {
              return true;
            }
          }
          return false;
        });
        $('.menu-builder__item-wrap[data-id="' + itemId + '"]').remove();
        _this3.$store.commit('notifications/setSuccessNotification', 'Deleted.');
      }).catch(function (error) {
        $('.menu-builder__item-wrap[data-id="' + itemId + '"] .btn-delete .btn-loader').remove();
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting menu item request' });
        console.error('Error in deleteMenu mutation, ', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Menus',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      mainMenu: ''
    };
  },


  watch: {
    '$route.name': function $routeName(newVal) {
      if (newVal === 'Menu') {
        this.getSource();
      }
    }
  },

  mounted: function mounted() {
    this.mainMenu = this.$config.mainMenu;
  },


  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'menu?search_string=' + escape(this.searchQuery) + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;
          var entities = response.data;
          delete entities.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(entities).map(function (e) {
            return entities[e];
          });
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    },
    deleteEntity: function deleteEntity(entityId) {
      var _this2 = this;

      if (window.confirm('Do you really want to delete this menu?')) {
        var $btnDeleteLoader = $('table.entities tr[data-id="' + entityId + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + 'menu/' + entityId).then(function () {
          $btnDeleteLoader.hide();
          _this2.getSource();
          _this2.$store.commit('notifications/setSuccessNotification', 'Deleted.');
        }).catch(function (error) {
          $btnDeleteLoader.hide();
          _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting menu request' });
          console.error('Error in deleteMenu mutation, ', error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuItem',

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      isReady: false,
      entity: {}
    };
  },


  watch: {
    content: function content(val) {
      this.copyContent(val);
    }
  },

  mounted: function mounted() {
    this.copyContent(this.content);
    this.isReady = true;
  },


  methods: {
    copyContent: function copyContent(content) {
      this.entity.id = content.id;
      this.entity.menu_id = content.menu_id;
      this.entity.parent_id = content.parent_id;
      this.entity.order = content.order;
      this.entity.title = content.title;
      this.entity.tooltip = content.tooltip;
      this.entity.target = content.target;
      this.entity.url = content.url;
      this.entity.image = content.image;
      this.entity.hidden = content.hidden;
      this.entity.children = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(content.children, function (item) {
        return item.order;
      });
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      menuName: ''
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.menuName) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.menuName);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'menu', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/menu/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in creating new menu ', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    file: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      urlShown: false
    };
  },

  computed: {
    fileSize: function fileSize() {
      var size = this.file.size;

      if (!size) {
        return 0;
      }
      if (size > 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + 'Mb';
      }
      if (size > 1024) {
        return (size / 1024).toFixed(2) + 'Kb';
      }
      return size.toFixed(2) + 'B';
    }
  },

  methods: {
    deleteFile: function deleteFile() {
      var _this = this;

      if (window.confirm('Do you really want to delete file ' + this.file.path)) {
        $(this.$refs.deleteBtn).find('i').removeClass('fa-times').addClass('fa-refresh rotating');
        this.$apiHttp.post(this.$config.app_api.prefix + 'selectel/delete', { path: this.file.path }).then(function () {
          _this.$emit('fileDeleted', _this.file);
          _this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
        }).catch(function (error) {
          $(_this.$refs.deleteBtn).find('i').addClass('fa-times').removeClass('fa-refresh rotating');
          _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting file request' });
          console.error(error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__File___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__File__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectelFolder',
  components: {
    File: __WEBPACK_IMPORTED_MODULE_0__File___default.a
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    content: {
      type: [Object, Array],
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      opened: false
    };
  },

  methods: {
    onFileDeleted: function onFileDeleted(file) {
      this.$emit('fileDeleted', file);
    },
    onFolderDeleted: function onFolderDeleted(folderName) {
      this.$emit('folderDeleted', folderName);
    },
    deleteFolder: function deleteFolder() {
      var _this = this;

      if (window.confirm('Do you really want to delete folder ' + this.name)) {
        $(this.$refs.deleteBtn).find('i').removeClass('fa-times').addClass('fa-refresh rotating');
        this.$apiHttp.post(this.$config.app_api.prefix + 'selectel/delete', { path: this.path }).then(function () {
          _this.$emit('folderDeleted', _this.path);
          _this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
        }).catch(function (error) {
          $(_this.$refs.deleteBtn).find('i').addClass('fa-times').removeClass('fa-refresh rotating');
          _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in deleting file request' });
          console.error(error);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__File__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__File___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__File__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_constants__ = __webpack_require__(19);










var SUCCESS = __WEBPACK_IMPORTED_MODULE_6__helpers_constants__["b" /* uploadStatus */].SUCCESS;


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    File: __WEBPACK_IMPORTED_MODULE_5__File___default.a
  },

  data: function data() {
    return {
      rootFolders: [],
      rootFiles: [],
      rootTree: null,
      succeedUploads: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('uploadManager', ['publicFilesUploads'])),

  watch: {
    publicFilesUploads: {
      handler: function handler(val) {
        var _this = this;

        var finishedUploads = val.filter(function (item) {
          return item.status === SUCCESS;
        });
        if (!finishedUploads.length) return;
        var newSucceedUploads = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.xorBy(finishedUploads, this.succeedUploads, function (item) {
          return item.id;
        });
        newSucceedUploads.forEach(function (uploadedItem) {
          _this.addUploadedFile(uploadedItem);
          _this.$root.$emit('updateSelectelFolders', _this.extractTreeFolderKeys(_this.rootTree, ''));
        });
        this.succeedUploads = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.succeedUploads), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newSucceedUploads));
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.getFiles();

    this.$root.$on('fileUploaded', function () {
      _this2.silentGetFiles();
    });
  },


  methods: {
    getFiles: function getFiles() {
      var _this3 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'selectel').then(function (response) {
        _this3.rootTree = response.data;
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        _this3.$root.$emit('updateSelectelFolders', _this3.extractTreeFolderKeys(_this3.rootTree, ''));
      }).catch(function (error) {
        if (_this3.$refs.spinner) {
          _this3.$refs.spinner.hide();
        }
        _this3.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting files list request' });
        console.error(error);
      });
    },
    silentGetFiles: function silentGetFiles() {
      var _this4 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'selectel').then(function (response) {
        _this4.rootTree = response.data;
        _this4.$root.$emit('updateSelectelFolders', _this4.extractTreeFolderKeys(_this4.rootTree, ''));
      }).catch(function (error) {
        console.error(error);
      });
    },
    uploadNewFile: function uploadNewFile() {
      $('#selectelUploadModal').modal('show');
    },
    updateFileStructure: function updateFileStructure() {
      this.getFiles();
    },
    addUploadedFile: function addUploadedFile(uploadedItem) {
      var dir = uploadedItem.dir;

      var folders = [];
      if (dir !== '/') {
        folders = dir.split('/');
      }
      var selectedFolder = this.rootTree;
      for (var i = 0; i < folders.length; i++) {
        var currFolderName = folders[i];
        if (!currFolderName) {
          continue;
        }
        var currFolder = selectedFolder.folders[currFolderName];
        if (!currFolder) {
          selectedFolder.folders[currFolderName] = {
            files: [],
            folders: {}
          };
        }
        selectedFolder = selectedFolder.folders[currFolderName];
      }
      selectedFolder.files = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(selectedFolder.files), [{
        basename: uploadedItem.file.name,
        size: uploadedItem.file.size,
        url: uploadedItem.urls[0]
      }]);
      this.rootTree = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.rootTree);
    },
    onFileDeleted: function onFileDeleted(deletedFile) {
      if (!this.deleteFileByPathRecursive(deletedFile, this.rootTree)) {
        var dir = deletedFile.dirname;
        this.deleteFileByDirRecursive(dir, this.rootTree);
        this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
      }
    },
    onFolderDeleted: function onFolderDeleted(folderName) {
      var newTree = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.rootTree);
      this.deleteFolderByName(folderName, newTree);
      this.$set(this.rootTree, 'folders', newTree.folders);
      this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
    },
    deleteFileByPathRecursive: function deleteFileByPathRecursive(deletedFile, nextFolder) {
      var _this5 = this;

      var rootFileIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(nextFolder.files, function (file) {
        return file.path === deletedFile.path;
      });
      if (rootFileIndex !== -1) {
        nextFolder.files.splice(rootFileIndex, 1);
        return true;
      }
      var result = false;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(nextFolder.folders).forEach(function (key) {
        result = result || _this5.deleteFileByPathRecursive(deletedFile, nextFolder.folders[key]);
        if (result) {
          return false;
        }
        return true;
      });
      return result;
    },
    deleteFileByDirRecursive: function deleteFileByDirRecursive(dir, nextFolder) {
      var folders = dir.split('/');
      if (folders.length > 1) {
        var relativePath = folders.slice(0, 1).join('/');
        this.deleteFileByDirRecursive(relativePath, nextFolder.folders[folders[0]]);
      } else {
        var fileIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(nextFolder.folders[dir].files, function (file) {
          return file.path === dir;
        });
        if (fileIndex !== -1) {
          nextFolder.folders[dir].files.splice(fileIndex, 1);
        }
      }
    },
    deleteFolderByName: function deleteFolderByName(folderName, folderTree) {
      var folders = folderName.split('/');
      var foldersObject = folderTree.folders;
      if (folders.length > 1) {
        var nextFolder = void 0;
        for (var i = 0; i < folders.length - 1; i += 1) {
          nextFolder = foldersObject[folders[i]];
          foldersObject = nextFolder.folders;
        }
        delete foldersObject[folders[folders.length - 1]];
      } else if (folders.length === 1) {
        delete foldersObject[folderName];
      }
    },
    extractTreeFolderKeys: function extractTreeFolderKeys(folder, initialName) {
      var _this6 = this;

      var dirs = [];
      if (!folder.folders) {
        return [];
      }
      var folderKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(folder.folders);
      var currentDirectory = '';
      if (initialName !== '') {
        currentDirectory = initialName + '/';
      }
      if (folderKeys.length > 0) {
        folderKeys.forEach(function (key) {
          var nextDir = '' + currentDirectory + key;
          dirs.push(nextDir);
          dirs.splice.apply(dirs, [0, 0].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this6.extractTreeFolderKeys(folder.folders[key], nextDir))));
        });
      }
      return dirs;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RedirectEdit',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      source: null,
      entity: {}
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.source) {
        this.$_errorSave('Source field is required');
        return false;
      }
      if (!this.entity.destination) {
        this.$_errorSave('Destination field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'redirects/' + this.$route.params.id).then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
          _this.source.cover = null;
          _this.entity.cover = null;
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        setTimeout(_this.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.log('Error in get image gallery query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('source', this.entity.source);
      postFormData.append('destination', this.entity.destination);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'redirects/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
        _this2.$parent.getSource();
      }).catch(function (error) {
        _this2.$_showError(error);
        console.error('Error in update redirect query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Redirectes',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'redirects?page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var redirectsArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete redirectsArr.meta;
          _this.entities = redirectsArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RedirectsNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        source: null,
        destination: null
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.source) {
        this.$_showError('Source field is required');
        return false;
      }
      if (!this.entity.destination) {
        this.$_showError('Destination field is required');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('source', this.entity.source);
      postFormData.append('destination', this.entity.destination);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'redirects', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/redirects/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create redirect query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_DefaultOptionsRequests__ = __webpack_require__(14);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RolesEdit',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_EditPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      source: null,
      entity: {}
    };
  },
  mounted: function mounted() {
    this.$_getDefaultPermissions();
  },


  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'roles/' + this.$route.params.id + '?with[]=permissions').then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
          _this.source.avatar = null;
          _this.entity.avatar = null;
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.error(error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.permissions && this.entity.permissions.length) {
        for (var i = 0; i < this.entity.permissions.length; i += 1) {
          postFormData.append('permissions[]', this.entity.permissions[i].id);
        }
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'roles/' + this.$route.params.id, postFormData);
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update user query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RolesList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'roles?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var rolesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete rolesArr.meta;
          _this.entities = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toArray(rolesArr);
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_CreatePageMixin__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_DefaultOptionsRequests__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RolesNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_CreatePageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_DefaultOptionsRequests__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        name: null,
        permissions: []
      }
    };
  },
  mounted: function mounted() {
    this.$_getDefaultPermissions();
  },


  methods: {
    selectAll: function selectAll() {
      this.entity.permissions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.defaultOptions.permissions));
    },
    deselectAll: function deselectAll() {
      this.entity.permissions = [];
    },
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.permissions && this.entity.permissions.length) {
        for (var i = 0; i < this.entity.permissions.length; i += 1) {
          postFormData.append('permissions[]', this.entity.permissions[i].id);
        }
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'roles', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/roles/edit/' + response.data.id;
      }).catch(function (error) {
        console.error('Error in role create query', error);
        _this.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__ = __webpack_require__(12);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SitePagesEdit',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_4__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      source: null,
      entity: {},
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      }
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token,
          Accept: 'application/json'
        },
        method: 'POST',
        paramName: 'files[]',
        url: '' + this.$config.app_api.host + this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id + '/files',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?'
      };
    },
    coverUrl: function coverUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    coverIsChanged: function coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    }
  },

  methods: {
    manuallyAddFiles: function manuallyAddFiles() {
      for (var i = 0; i < this.entity.files.length; i += 1) {
        var file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileUploadedSuccess: function fileUploadedSuccess(file, response) {
      this.entity.files = response;
    },
    fileRemoved: function fileRemoved(file) {
      var _this = this;

      var fileIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.entity.files, function (item) {
        return item.file_name === file.name && item.size === file.size;
      });
      this.$apiHttp.delete(this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id + '/files/' + this.entity.files[fileIndex].id).then(function () {
        _this.entity.files.splice(fileIndex, 1);
      }).catch(function (err) {
        console.error('error in delete file in site page request - ', err);
      });
    },
    changeCover: function changeCover(file) {
      this.entity.cover = file;
    },
    coverRemove: function coverRemove() {
      this.entity.cover = null;
    },
    coverReturnOld: function coverReturnOld() {
      this.entity.cover = this.source.cover;
    },
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.body) {
        this.$_showError('Body field is required');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id + '?with[]=cover&with[]=files&with[]=path_alias').then(function (response) {
        _this2.source = response.data;
        _this2.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
          _this2.source.cover = null;
          _this2.entity.cover = null;
        }
        if (!Object.prototype.hasOwnProperty.call(response.data, 'path_alias')) {
          _this2.source.path_alias = {
            path_alias: ''
          };
          _this2.entity.path_alias = {
            path_alias: ''
          };
        }
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        setTimeout(_this2.manuallyAddFiles, 100);
      }).catch(function (error) {
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
        _this2.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.log('Error in get image gallery query', error);
      });
    },
    deleteCoverRequest: function deleteCoverRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id + '/cover');
    },
    saveCoverRequest: function saveCoverRequest() {
      var postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id + '/cover', postFormData);
    },
    saveRequest: function saveRequest() {
      return this.$apiHttp.post(this.$config.app_api.prefix + 'site-pages/' + this.$route.params.id, {
        title: this.entity.title,
        body: this.entity.body,
        summary: this.entity.summary ? this.entity.summary : '',
        seo_title: this.entity.seo_title,
        seo_description: this.entity.seo_description,
        path_alias: this.entity.path_alias.path_alias
      });
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.coverIsChanged) {
        this.saveRequest().then(function () {
          _this3.$_successSave();
        }).catch(function (error) {
          _this3.$_errorSave(error);
          console.error('Error in update article query', error);
        });
      } else if (!this.entity.cover) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveCoverRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (cover, entity) {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this3.$_successSave();
          } else {
            _this3.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SitePages',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchQuery = encodeURI(this.searchQuery);
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;

      this.$apiHttp.get(this.$config.app_api.prefix + 'site-pages?search_string=' + searchQuery + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var sitePagesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete sitePagesArr.meta;
          _this.entities = sitePagesArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SitePageNew',

  components: {
    dropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        cover: null,
        files: [],
        seo_title: '',
        seo_description: '',
        path_alias: ''
      },
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100
      },
      saveErrorMessage: 'Error in data saving'
    };
  },


  computed: {
    dropzoneOptions: function dropzoneOptions() {
      return {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.user.accessToken.access_token
        },
        url: '/',
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
        accept: function accept() {}
      };
    }
  },

  methods: {
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.body) {
        this.$_showError('Body field is required');
        return false;
      }
      if (this.entity.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    filesChanged: function filesChanged() {
      this.entity.files = this.$refs.dropzone.dropzone.files;
    },
    changeCover: function changeCover(file) {
      this.entity.cover = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.summary) postFormData.append('summary', this.entity.summary);
      if (this.entity.cover) postFormData.append('cover', this.entity.cover);
      for (var i = 0; i < this.entity.files.length; i += 1) {
        postFormData.append('files[]', this.entity.files[i]);
      }
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'site-pages', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/site-pages/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create site page query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_EditPageMixin__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffEdit',
  components: {
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_EditPageMixin__["a" /* default */]],
  data: function data() {
    return {
      source: null,
      entity: {}
    };
  },


  computed: {
    avatarUrl: function avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged: function avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    }
  },

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'staff/' + this.$route.params.id + '?with[]=avatar&with[]=path_alias').then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'path_alias')) {
          _this.source.path_alias = {
            path_alias: ''
          };
          _this.entity.path_alias = {
            path_alias: ''
          };
        }
        if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
          _this.source.avatar = null;
          _this.entity.avatar = null;
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.error(error);
      });
    },
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    changeAvatar: function changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore: function avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove: function avatarRemove() {
      this.entity.avatar = null;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('description', this.entity.description ? this.entity.description : '');
      postFormData.append('path_alias', this.entity.path_alias.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'staff/' + this.$route.params.id, postFormData);
    },
    saveAvatarRequest: function saveAvatarRequest() {
      var postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'staff/' + this.$route.params.id + '/avatar', postFormData);
    },
    deleteAvatarRequest: function deleteAvatarRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'staff/' + this.$route.params.id + '/avatar');
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update staff query', error);
        });
      } else if (!this.entity.avatar) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a,
    'open-on-site': __WEBPACK_IMPORTED_MODULE_2__global_components_OpenOnSiteButton___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'staff?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var staffArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete staffArr.meta;
          _this.entities = staffArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StaffNew',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        title: null,
        description: null,
        avatar: null,
        seo_title: '',
        seo_description: '',
        path_alias: ''
      }
    };
  },


  methods: {
    isEntityValid: function isEntityValid() {
      var validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    avatarUploaded: function avatarUploaded(file) {
      this.entity.avatar = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      if (this.entity.description) postFormData.append('description', this.entity.description);
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'staff', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/staff/edit/' + response.data.id;
      }).catch(function (error) {
        console.error('Error in staff create query', error);
        _this.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermEdit',

  components: {
    'select-remote': __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default.a,
    'vue-select': __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      vocabularyOptionsDefault: [],
      parentOptions: []
    };
  },
  mounted: function mounted() {
    this.getDefaultvocabulary();
  },


  methods: {
    getDefaultvocabulary: function getDefaultvocabulary() {
      var _this = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies', { useCache: true }).then(function (response) {
        var cloneData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete cloneData.meta;
        _this.vocabularyOptionsDefault = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cloneData).map(function (e) {
          return cloneData[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },

    vocabularySearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'vocabularies?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var cloneData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete cloneData.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cloneData).map(function (e) {
          return cloneData[e];
        });
        loading(false);
      }).catch(function (reject) {
        loading(false);
        console.error(reject);
      });
    }, 350),
    onParentSearch: function onParentSearch(search, loading) {
      loading(true);
      this.parentSearch(loading, search, this);
    },

    parentSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'terms', {
        params: {
          vid: vm.entity.vocabulary.id,
          search_string: escape(search)
        }
      }).then(function (response) {
        var cloneData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete cloneData.meta;
        context.parentOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cloneData).map(function (e) {
          return cloneData[e];
        });
        loading(false);
      }).catch(function (reject) {
        console.error(reject);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.vocabulary) {
        this.$_showError('Vocabulary field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'terms/' + this.$route.params.id + '?with[]=vocabulary&with[]=parent').then(function (response) {
        _this2.source = response.data;
        _this2.entity = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        _this2.$watch(function () {
          return _this2.entity.vocabulary;
        }, function (newVal, oldVal) {
          if (!newVal || !oldVal || newVal.id !== oldVal.id) {
            _this2.entity.parent = null;
            _this2.parentOptions = [];
          }
        });
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
      }).catch(function (error) {
        console.error('Error in get single term query', error);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('vid', this.entity.vocabulary.id);
      if (this.entity.parent) postFormData.append('parent_id', this.entity.parent.id);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'terms/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this3.$_successSave();
      }).catch(function (error) {
        _this3.$_errorSave(error);
        console.error('Error in update term query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Terms',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_2__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_CommonPageMixin__["a" /* default */]],

  data: function data() {
    return {
      vocabularies: [],
      searchVocabulary: {
        id: '',
        name: 'Select vocabulary'
      }
    };
  },


  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var vid = this.searchVocabulary.id;
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;

      this.$apiHttp.get(this.$config.app_api.prefix + 'terms?vid=' + vid + '&search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;
          var termsArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete termsArr.meta;
          _this.entities = termsArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });

      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies').then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          var vocabularyArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
          delete vocabularyArr.meta;
          _this.vocabularies = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(vocabularyArr);
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermNew',

  components: {
    'select-remote': __WEBPACK_IMPORTED_MODULE_2__global_components_SelectRemote___default.a,
    'vue-select': __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        name: null,
        vocabulary: null,
        parent: null
      },
      vocabularyOptionsDefault: [],
      parentOptions: []
    };
  },


  watch: {
    'entity.vocabulary': {
      handler: function handler() {
        this.entity.parent = null;
        this.parentOptions = [];
      }
    }
  },

  mounted: function mounted() {
    this.getDefaultvocabulary();
  },


  methods: {
    getDefaultvocabulary: function getDefaultvocabulary() {
      var _this = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies').then(function (response) {
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        _this.vocabularyOptionsDefault = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
      }).catch(function (error) {
        console.error(error);
      });
    },

    vocabularySearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm, searchRequestId) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'vocabularies?search_string=' + escape(search)).then(function (response) {
        if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
        var newDataArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(response.data);
        delete newDataArr.meta;
        context.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newDataArr).map(function (e) {
          return newDataArr[e];
        });
        loading(false);
      }).catch(function (reject) {
        console.error(reject);
      });
    }, 350),
    onParentSearch: function onParentSearch(search, loading) {
      loading(true);
      this.parentSearch(loading, search, this);
    },

    parentSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (loading, search, vm) {
      var context = vm;
      vm.$apiHttp.get(vm.$config.app_api.prefix + 'terms', {
        params: {
          vid: vm.entity.vocabulary.id,
          search_string: escape(search)
        }
      }).then(function (response) {
        var newDataArr = [];
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(response.data, function (value, key) {
          if (key !== 'meta' && value.id !== vm.$route.params.id) {
            newDataArr.push(value);
          }
        });
        context.parentOptions = newDataArr;
        loading(false);
      }).catch(function (reject) {
        console.error(reject);
      });
    }, 350),
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.vocabulary) {
        this.$_showError('Vocabulary field is required');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('vid', this.entity.vocabulary.id);
      if (this.entity.parent) postFormData.append('parent_id', this.entity.parent.id);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'terms', postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this2.$_successSave();
        _this2.$parent.getSource();
        window.location.hash = '#/admin/taxonomy/terms/edit/' + response.data.id;
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in create term query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Terms__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VocabularyEdit',

  components: {
    Terms: __WEBPACK_IMPORTED_MODULE_1__Terms___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_EditPageMixin__["a" /* default */]],

  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies/' + this.$route.params.id).then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.error('Error in get single vocabulary query', error);
      });
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('body', this.entity.body ? this.entity.body : null);

      return this.$apiHttp.post(this.$config.app_api.prefix + 'vocabularies/' + this.$route.params.id, postFormData);
    },
    save: function save() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function () {
        _this2.$_successSave();
      }).catch(function (error) {
        _this2.$_errorSave(error);
        console.error('Error in update vocabulary query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vocabularies',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  methods: {
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies?search_string=' + searchString + '&page=' + page).then(function (response) {
        if (_this.searchProcessId === searchProcessId) {
          if (_this.$refs.spinner) {
            _this.$refs.spinner.hide();
          }
          _this.total = response.data.meta.pagination.total;
          _this.perPage = response.data.meta.pagination.per_page;

          var vocabularyArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete vocabularyArr.meta;
          _this.entities = vocabularyArr;
        }
      }).catch(function (error) {
        _this.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VocabularyNew',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_CreatePageMixin__["a" /* default */]],
  data: function data() {
    return {
      entity: {
        name: null,
        body: null
      }
    };
  },

  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Title field is required');
        return false;
      }
      return true;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.body) postFormData.append('body', this.entity.body);

      return this.$apiHttp.post(this.$config.app_api.prefix + 'vocabularies', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/taxonomy/vocabulary/edit/' + response.data.id;
      }).catch(function (error) {
        _this.$_errorSave(error);
        console.error('Error in create vocabulary query', error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_components_Pager__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VocabularyTerms',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_3__global_components_Pager___default.a
  },

  data: function data() {
    return {
      terms: {
        searchQuery: '',
        isReady: false,
        source: [],
        list: [],
        newTermName: null,
        pager: {
          total: 0,
          offset: 0,
          perPage: 15
        },
        termCreateError: ''
      }
    };
  },


  watch: {
    'terms.searchQuery': __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      this.terms.pager.offset = 0;
      this.getTerms();
    }, 400),
    'terms.pager.offset': function termsPagerOffset() {
      this.getTerms();
    }
  },

  mounted: function mounted() {
    this.getTerms();
  },


  methods: {
    getTerms: function getTerms() {
      var _this = this;

      if (this.$refs.termsSpinner) {
        this.$refs.termsSpinner.show();
      }
      var page = this.terms.pager.offset / this.terms.pager.perPage + 1;
      this.$apiHttp.get(this.$config.app_api.prefix + 'terms', {
        params: {
          vid: this.$route.params.id,
          limit: this.terms.pager.perPage,
          search_string: this.terms.searchQuery,
          page: page
        }
      }).then(function (response) {
        _this.terms.pager.total = response.data.meta.pagination.total;
        _this.terms.pager.perPage = response.data.meta.pagination.per_page;

        var termsArr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(response.data);
        delete termsArr.meta;
        _this.terms.source = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(termsArr).map(function (e) {
          return termsArr[e];
        });
        _this.terms.list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this.terms.source);
        _this.terms.isReady = true;
        if (_this.$refs.termsSpinner) {
          _this.$refs.termsSpinner.hide();
        }
      }).catch(function (error) {
        console.error('Error in get terms of vocabulary query', error);
        if (_this.$refs.termsSpinner) {
          _this.$refs.termsSpinner.hide();
        }
      });
    },
    deleteTerm: function deleteTerm(entity) {
      var _this2 = this;

      if (window.confirm('Do you really want to delete term ' + entity.title + ' with id = ' + entity.id + '?')) {
        var $btnDeleteLoader = $('table.terms-table tr[data-id="' + entity.id + '"] .btn-danger .btn-loader');
        $btnDeleteLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + 'terms/' + entity.id).then(function () {
          console.log('Term ' + entity.title + ' with ID = ' + entity.id + ' has deleted');
          $btnDeleteLoader.hide();
          _this2.getTerms();
        }).catch(function (error) {
          console.error('Error in term delete request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    isNewTermValid: function isNewTermValid() {
      if (!this.terms.newTermName) {
        this.terms.termCreateError = 'Fill new term name';
        return false;
      }
      return true;
    },
    createTerm: function createTerm() {
      var _this3 = this;

      var postFormData = new FormData();
      var $btnCreateTermLoader = $('.btn-term-create .btn-loader');
      if (!this.isNewTermValid()) return;
      this.terms.termCreateError = '';
      $btnCreateTermLoader.show();
      postFormData.append('name', this.terms.newTermName);
      postFormData.append('vid', this.$route.params.id);
      this.$apiHttp.post(this.$config.app_api.prefix + 'terms', postFormData).then(function () {
        _this3.getTerms();
        $btnCreateTermLoader.hide();
        _this3.terms.termCreateError = 'ok';
      }).catch(function (error) {
        console.error('Error in create term query ', error);
        $btnCreateTermLoader.hide();
        if (error.response.data.errors && error.response.data.errors.name) {
          var _error$response$data$ = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(error.response.data.errors.name, 1);

          _this3.terms.termCreateError = _error$response$data$[0];
        } else {
          _this3.terms.termCreateError = 'Server error';
        }
      });
    },
    editTerm: function editTerm(term) {
      var $editTermRow = $('.terms-table tr[data-id="' + term.id + '"]');
      $editTermRow.find('.term-edit-wrap._static').hide();
      $editTermRow.find('.term-edit-wrap._editing').show();
      $editTermRow.find('.term-btn-cancel-edit').show();
      $editTermRow.find('.term-btn-edit').hide();
    },
    cancelEditTerm: function cancelEditTerm(term) {
      var editingTerm = term;
      editingTerm.name = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.terms.source, function (item) {
        return item.id === term.id;
      }).name;
      this.closeEditTerm(term);
    },
    closeEditTerm: function closeEditTerm(term) {
      var $editTermRow = $('.terms-table tr[data-id="' + term.id + '"]');
      $editTermRow.find('.term-edit-wrap._static').show();
      $editTermRow.find('.term-edit-wrap._editing').hide();
      $editTermRow.find('.term-btn-cancel-edit').hide();
      $editTermRow.find('.term-btn-edit').show();
    },
    saveTerm: function saveTerm(term) {
      var _this4 = this;

      var postFormData = new FormData();
      var $btnSaveTermLoader = $('.terms-table tr[data-id="' + term.id + '"] .btn-success .btn-loader');
      if (term.name === '') return;
      $btnSaveTermLoader.show();
      postFormData.append('name', term.name);
      postFormData.append('vid', this.$route.params.id);
      this.$apiHttp.post(this.$config.app_api.prefix + 'terms/' + term.id, postFormData).then(function () {
        $btnSaveTermLoader.hide();
        _this4.closeEditTerm(term);
      }).catch(function (error) {
        console.error('Error in create term query ', error);
        $btnSaveTermLoader.hide();
      });
    },
    changeTermsPage: function changeTermsPage(offset) {
      this.terms.pager.offset = offset;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_libs_jquery_sortable_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermsOrderManager',

  data: function data() {
    return {
      source: null,
      faqTree: [],
      faqArray: [],
      saveErrorMessage: 'Error in data saving',
      orderChanged: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    this.getSource();

    $(document).on('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn', function (e) {
      e.stopPropagation();
    });
    $(document).on('click', '.menu-builder__item-input input', function () {
      $(this).focus();
    });
    $(document).on('click', '.menu-builder__item-btns .btn-delete', function () {
      if (window.confirm('Do you really want to delete this menu item?')) {
        $(this).append('<span class="btn-loader"></span>');
        self.deleteItem($(this).closest('.menu-builder__item-wrap').data('id'));
      }
    });
    $(document).on('click', '.menu-builder__item-btns .btn-edit', function () {
      var menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      var itemIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.faqArray, function (item) {
        return item.id === menuItemId;
      });

      self.editItemPopup(self.faqArray[itemIndex]);
    });
    $(document).on('click', '.menu-builder__item-btns .btn-add', function () {
      var menuItemId = $(this).closest('.menu-builder__item-wrap').data('id');
      self.addItemInside(menuItemId);
    });

    this.$root.$on('termItemSaveExistingSuccess', function (newContent) {
      var itemIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.faqArray, function (item) {
        return item.id === newContent.id;
      });
      self.faqArray[itemIndex] = newContent;
      $('.menu-builder__item-wrap[data-id="' + newContent.id + '"]').children('.menu-builder__item').find('.menu-builder__item-title > span').text(newContent.name);
    });
    this.$root.$on('termItemSaveNewSuccess', function (newContent, spot) {
      var newItem = '<li class="menu-builder__item-wrap" data-id="' + newContent.id + '">\n                      <div class="menu-builder__item">\n                        <div class="menu-builder__item-inner">\n                          <div class="menu-builder__item-title"><span>' + newContent.name + '</span></div>\n                          <div class="menu-builder__item-btns">\n                            <button class="btn btn-primary btn-add">Add item</button>\n                            <button class="btn btn-primary btn-edit">Edit</button>\n                            <button class="btn btn-danger btn-delete">Delete</button>\n                          </div>\n                        </div>\n                      </div>\n                    </li>';
      var $parentItem = $('.menu-builder__item-wrap[data-id="' + newContent.parent_id + '"]');
      if (newContent.parent_id !== 0) {
        if ($parentItem.children('ul').length === 0) {
          $parentItem.append('<ul></ul>');
          $parentItem.children('.menu-builder__item').prepend('<span class="sortableListsOpener menu-builder__item-opener"><i class="fa fa-minus"></i></span>');
          $parentItem.find('.sortableListsOpener').on('mousedown', function () {
            var li = $(this).closest('li');
            if (li.hasClass('sortableListsClosed')) {
              li.children('ul').show();
              li.addClass('sortableListsOpen').removeClass('sortableListsClosed');
              li.children('.menu-builder__item').children('.menu-builder__item-opener').html('<i class="fa fa-minus"></i>');
            } else {
              li.children('ul').hide();
              li.addClass('sortableListsClosed').removeClass('sortableListsOpen');
              li.children('.menu-builder__item').children('.menu-builder__item-opener').html('<i class="fa fa-plus"></i>');
            }
            return false;
          });
        }
        $parentItem.children('ul').append(newItem);
      } else if (spot === 'top') {
        $('.menu-builder-inner > ul').prepend(newItem);
      } else {
        $('.menu-builder-inner > ul').append(newItem);
      }

      _this.faqArray.push(newContent);
    });
  },
  destroyed: function destroyed() {
    $(document).off('click', '.menu-builder__item.has-child .menu-builder__item-btns .btn');
    $(document).off('click', '.menu-builder__item-btns .btn-delete');
    $(document).off('click', '.menu-builder__item-btns .btn-edit');
    $(document).off('click', '.menu-builder__item-btns .btn-add');
    this.$root.$off('termItemSaveNewSuccess');
    this.$root.$off('termItemSaveExistingSuccess');
    $('#sortableListsBase').remove();
  },


  methods: {
    getSource: function getSource() {
      var _this2 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'vocabularies/' + this.$route.params.id + '?with[]=terms&tree=true').then(function (response) {
        _this2.source = response.data;
        _this2.faqTree = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(response.data.terms, 'weight');
        _this2.faqArray = _this2.treeToList(_this2.faqTree);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }

        setTimeout(function () {
          _this2.initSortableList();
        }, 300);
      }).catch(function (error) {
        console.error(error);
        if (_this2.$refs.spinner) {
          _this2.$refs.spinner.hide();
        }
      });
    },
    treeToList: function treeToList(tree) {
      var list = [];
      var treeLevelExecute = function treeLevelExecute(levelArr) {
        for (var i = 0; i < levelArr.length; i += 1) {
          var item = levelArr[i];
          list.push({
            id: item.id,
            name: item.name,
            parent_id: item.parent_id,
            weight: item.weight,
            vocabulary_id: item.vocabulary_id
          });
          if (item.children && item.children.length) {
            treeLevelExecute(item.children);
          }
        }
      };
      treeLevelExecute(tree);
      return list;
    },
    initSortableList: function initSortableList() {
      var self = this;
      var options = {
        placeholderClass: 'menu-builder__item-placeholder',
        hintClass: 'menu-builder__item-hint',
        ignoreClass: 'btn',
        opener: {
          active: true,
          as: 'html',
          close: '<i class="fa fa-minus"></i>',
          open: '<i class="fa fa-plus"></i>',
          openerClass: 'menu-builder__item-opener'
        },
        onChange: function onChange(cEl) {
          var elementId = cEl.data('id');
          var $parentEl = cEl.parent('ul').parent();
          var parentElId = 0;
          var itemIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.faqArray, function (item) {
            return item.id === elementId;
          });
          if (!$parentEl.hasClass('menu-builder-inner')) {
            parentElId = $parentEl.data('id');
          }
          self.faqArray[itemIndex].parent_id = parentElId;
          $parentEl.children('ul').children('li').each(function (index) {
            var liId = $(this).data('id');
            var liIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(self.faqArray, function (item) {
              return item.id === liId;
            });
            self.faqArray[liIndex].weight = index;
          });
          self.orderChanged = true;
        }
      };
      $('.menu-builder-inner > ul').sortableLists(options);
    },
    addItemToTop: function addItemToTop() {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.faqArray, function (item) {
        return item.parent_id === 0;
      });
      var minWeightObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.minBy(itemsInParent, function (item) {
        return item.weight;
      });
      this.newItemPopup(0, minWeightObj ? minWeightObj.weight - 1 : 0, 'top');
    },
    addItemToBottom: function addItemToBottom() {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.faqArray, function (item) {
        return item.parent_id === 0;
      });
      var maxWeightObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.maxBy(itemsInParent, function (item) {
        return item.weight;
      });
      this.newItemPopup(0, maxWeightObj ? maxWeightObj.weight + 1 : 0, 'bottom');
    },
    addItemInside: function addItemInside(parentId) {
      var itemsInParent = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.faqArray, function (item) {
        return item.parent_id === parentId;
      });
      var maxWeightObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.maxBy(itemsInParent, function (item) {
        return item.weight;
      });
      this.newItemPopup(parentId, maxWeightObj ? maxWeightObj.weight + 1 : 0, 'bottom');
    },
    editItemPopup: function editItemPopup(content) {
      this.$root.$emit('termItemSetParams', content, 'edit');
    },
    newItemPopup: function newItemPopup(parentId, weight, spot) {
      var content = {
        parent_id: parentId,
        weight: weight,
        vocabulary_id: this.$route.params.id,
        spot: spot
      };
      this.$root.$emit('termItemSetParams', content, 'new');
    },
    saveAll: function saveAll() {
      var _this3 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success.save-menu').append('<span class="btn-loader"></span>');
      this.$apiHttp.post(this.$config.app_api.prefix + 'terms/' + this.$route.params.id + '/terms/bulk-update', {
        items: this.faqArray
      }, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function () {
        console.log('items saved');
        $('.btn-success.save-menu .btn-loader').remove();
        $('.saving-alerts .alert-success').show();
        _this3.orderChanged = false;
      }).catch(function (error) {
        console.error(error);
        $('.btn-success.save-menu .btn-loader').remove();
        $('.saving-alerts .alert-danger').show();
      });
    },
    deleteItem: function deleteItem(itemId) {
      var self = this;
      this.$apiHttp.delete(this.$config.app_api.prefix + 'terms/' + itemId).then(function () {
        var arrayRemove = [];
        arrayRemove.push(itemId);
        $('.menu-builder__item-wrap[data-id="' + itemId + '"]').find('.menu-builder__item-wrap').each(function () {
          arrayRemove.push($(this).data('id'));
        });
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.remove(self.faqArray, function (item) {
          for (var i = 0; i < arrayRemove.length; i += 1) {
            if (arrayRemove[i] === item.id) {
              return true;
            }
          }
          return false;
        });
        $('.menu-builder__item-wrap[data-id="' + itemId + '"]').remove();
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermItem',

  props: {
    content: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      isReady: false,
      entity: {}
    };
  },
  mounted: function mounted() {
    this.entity.id = this.content.id;
    this.entity.name = this.content.name;
    this.entity.parent_id = this.content.parent_id;
    this.entity.weight = this.content.weight;
    this.entity.children = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.content.children, function (item) {
      return item.weight;
    });
    this.isReady = true;
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__ = __webpack_require__(1008);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',

  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      captchaVerified: false,
      username: '',
      password: '',
      errors: null,
      recaptchaStorageKey: '',
      storeError: this.$store.state.errors.auth.text
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      var tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
    this.recaptchaStorageKey = this.$config.recaptchaStorageKey;
  },


  methods: {
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('' + this.$config.app_api.host + this.$config.app_api.prefix + 're-captcha/verify', {
        'g-recaptcha-response': recaptchaToken
      }).then(function () {
        _this.captchaVerified = true;
      }).catch(function (err) {
        console.error(err);
      });
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.captchaVerified = false;
      if (this.$refs.recaptcha) this.$refs.recaptcha.reset();
    },
    isFormValid: function isFormValid() {
      if (!this.username) {
        this.errors = 'Username field is required.';
        return false;
      }
      if (!this.password) {
        this.errors = 'Password field is required.';
        return false;
      }
      return true;
    },
    login: function login() {
      var _this2 = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('' + this.$config.app_api.host + this.$config.app_api.prefix + 'login', {
        username: this.username,
        password: this.password
      }).then(function (response) {
        if (response.data['google2fa_required']) {
          _this2.$store.commit('user/setTimeData', {
            username: _this2.username,
            password: _this2.password
          });
          _this2.$router.push('two-factor-authentication');
          return;
        }
        if (response.data.access_token) {
          _this2.$store.commit('errors/setAuthError', '');
          localStorage.setItem(_this2.$config.tokenStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          _this2.$store.commit('user/storeAccessToken', response.data.access_token);
          _this2.$assignAxiosHeaders(response.data.access_token);

          var userData = response.data.user;
          userData.roles.forEach(function (element, index) {
            userData.roles[index].permissions = element.permissions.map(function (item) {
              return {
                id: item.id,
                name: item.name
              };
            });
          });
          localStorage.setItem(_this2.$config.userStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          _this2.$store.commit('user/setInfo', userData);
          _this2.$router.push('/admin');
        } else if (response.data.message) {
          _this2.errors = response.data.message;
        } else {
          _this2.errors = 'Server error';
        }
      }).catch(function (e) {
        _this2.errors = e.response.data.message;
        console.error(e.response.data.message);
      }).finally(function () {
        _this2.onCaptchaExpired();
        _this2.loading = false;
      });
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isRequestSuccess: false,
      email: '',
      loading: false,
      errors: null
    };
  },

  mounted: function mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      var tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
  },


  methods: {
    isFormValid: function isFormValid() {
      if (!this.email) {
        this.errors = 'Please pass email field.';
        return false;
      }
      return true;
    },
    resetPassword: function resetPassword() {
      var _this = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + this.$config.app_api.host + this.$config.app_api.prefix + 'password/create', {
        email: this.email
      }, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json'
        }
      }).then(function () {
        _this.errors = null;
        _this.isRequestSuccess = true;
      }).catch(function (e) {
        _this.isRequestSuccess = false;
        _this.errors = e.message;
        console.error(e.message);
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: {
        loading: true,
        status: 'waiting',
        value: null
      },
      email: '',
      newPass: '',
      newPassConfirm: '',
      loading: false,
      errors: null
    };
  },

  mounted: function mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      var tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
    this.checkToken();
  },


  methods: {
    isFormValid: function isFormValid() {
      if (!this.newPass) {
        this.errors = 'Please pass all fields.';
        return false;
      }
      if (!this.newPassConfirm) {
        this.errors = 'Please pass all fields.';
        return false;
      }
      if (this.newPass.length < 6 || this.newPassConfirm.length < 6) {
        this.errors = 'Password should contain at least 6 symbols.';
        return false;
      }
      if (this.newPassConfirm !== this.newPass) {
        this.errors = 'Passwords fields are not equal.';
        return false;
      }
      return true;
    },
    checkToken: function checkToken() {
      var _this = this;

      if (!this.$route.params.token) this.$router.push('login');
      this.token.value = this.$route.params.token;
      this.$refs.spinner.show();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('' + this.$config.app_api.host + this.$config.app_api.prefix + 'password/find/' + this.token.value).then(function (response) {
        _this.token.status = 'ok';
        _this.email = response.data.email;
      }).catch(function (e) {
        _this.token.status = 'invalid';
        console.error(e.message);
      }).finally(function () {
        _this.$refs.spinner.hide();
      });
    },
    resetPassword: function resetPassword() {
      var _this2 = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + this.$config.app_api.host + this.$config.app_api.prefix + 'password/reset', {
        email: this.email,
        password: this.newPass,
        password_confirmation: this.newPassConfirm,
        token: this.token.value
      }, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json'
        }
      }).then(function () {
        _this2.$router.push('/login');
      }).catch(function (e) {
        _this2.errors = e.message;
        console.error(e.message);
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      codeFromGoogle: '',
      loading: false,
      errors: null,
      username: null,
      password: null
    };
  },

  mounted: function mounted() {
    var credentials = this.$store.state.user.timeData;

    if (!credentials.username || !credentials.password) {
      this.$router.push('login');
    }
    this.username = credentials.username;
    this.password = credentials.password;
    this.$store.commit('user/setTimeData', {});
    this.$refs.codeInput.focus();
  },


  methods: {
    isFormValid: function isFormValid() {
      if (!this.codeFromGoogle) {
        this.errors = 'Please enter your code from Google Authenticator app.';
        return false;
      }
      return true;
    },
    login: function login() {
      var _this = this;

      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('' + this.$config.app_api.host + this.$config.app_api.prefix + 'login/auth', {
        username: this.username,
        password: this.password,
        code: this.codeFromGoogle
      }, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (response.data.access_token) {
          _this.$store.commit('errors/setAuthError', '');
          localStorage.setItem(_this.$config.tokenStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          _this.$store.commit('user/storeAccessToken', response.data.access_token);
          _this.$assignAxiosHeaders(response.data.access_token);

          var userData = response.data.user;
          userData.roles.forEach(function (element, index) {
            userData.roles[index].permissions = element.permissions.map(function (item) {
              return {
                id: item.id,
                name: item.name
              };
            });
          });
          localStorage.setItem(_this.$config.userStorage.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          _this.$store.commit('user/setInfo', userData);
          _this.$router.push('/admin');
        } else if (response.data.message) {
          _this.errors = response.data.message;
        } else {
          _this.errors = 'Server error';
        }
      }).catch(function (e) {
        _this.errors = e.response.data.message;
        console.error(e.message);
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnfinishedItem',
  props: {
    filename: {
      type: String,
      required: true
    },
    acceptedFiles: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      fileId: '',
      fileExt: ''
    };
  },

  mounted: function mounted() {
    this.splitFileName(this.filename);
  },


  methods: {
    onClick: function onClick() {
      this.$refs.fileInput.click();
    },
    onRemoveClicked: function onRemoveClicked() {
      this.$emit('remove-clicked');
    },
    onFileChange: function onFileChange(e) {
      if (e.currentTarget.files) {
        this.$emit('file-selected', e.currentTarget.files[0]);
      }
    },
    splitFileName: function splitFileName(name) {
      var lastPoint = name.lastIndexOf('.');
      this.fileId = name.substring(0, lastPoint);
      this.fileExt = name.substring(lastPoint);
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_constants__ = __webpack_require__(19);




var LOADING = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["b" /* uploadStatus */].LOADING,
    ABORTED = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["b" /* uploadStatus */].ABORTED,
    SUCCESS = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["b" /* uploadStatus */].SUCCESS,
    ERROR = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["b" /* uploadStatus */].ERROR,
    PAUSE = __WEBPACK_IMPORTED_MODULE_0__helpers_constants__["b" /* uploadStatus */].PAUSE;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    fileName: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: LOADING
    }
  },
  data: function data() {
    return {
      isStopped: false,
      isPaused: false,
      isFinished: false,
      isSucceed: false,
      fileId: '',
      fileExt: '',
      progressClass: ''
    };
  },
  watch: {
    progress: function progress() {
      this.$forceUpdate();
    },
    fileName: function fileName(val) {
      this.splitFileName(val);
    },
    status: function status(val) {
      this.progressClass = val;
      switch (val) {
        case ERROR:
          {
            this.isFinished = true;
            this.isStopped = false;
            this.isSucceed = false;
            this.isPaused = false;
            break;
          }
        case ABORTED:
          {
            this.isFinished = true;
            this.isStopped = true;
            this.isSucceed = false;
            this.isPaused = false;
            break;
          }
        case SUCCESS:
          {
            this.isFinished = true;
            this.isSucceed = true;
            this.isPaused = false;
            this.isStopped = false;
            break;
          }
        case PAUSE:
          {
            this.isFinished = false;
            this.isSucceed = false;
            this.isStopped = false;
            this.isPaused = true;
            break;
          }
        default:
          {
            this.isFinished = false;
            this.isSucceed = false;
            this.isStopped = false;
            this.isPaused = false;
            break;
          }
      }
    }
  },
  mounted: function mounted() {
    this.splitFileName(this.fileName);
  },

  methods: {
    splitFileName: function splitFileName(name) {
      var lastPoint = name.lastIndexOf('.');
      this.fileId = name.substring(0, lastPoint);
      this.fileExt = name.substring(lastPoint);
    },
    onStopClicked: function onStopClicked() {
      if (confirm('The upload will be stopped. Are you sure?')) {
        this.isStopped = true;
        this.$emit('stop-clicked');
      }
    },
    onResumeClicked: function onResumeClicked() {
      this.isPaused = false;
      this.$emit('resume-clicked');
    },
    onPauseClicked: function onPauseClicked() {
      this.isPaused = true;
      this.$emit('pause-clicked');
    },
    onRetryClicked: function onRetryClicked() {
      this.isStopped = false;
      this.$emit('retry-clicked');
    },
    onRemoveClicked: function onRemoveClicked() {
      this.$emit('remove-clicked');
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ListItem__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnfinishedUploadsList',

  components: {
    ListItem: __WEBPACK_IMPORTED_MODULE_1__ListItem___default.a
  },

  props: {
    unfinishedUploads: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    onHideClicked: function onHideClicked() {
      this.$emit('hide');
    },
    onFileSelected: function onFileSelected(file, item) {
      this.$emit('file-selected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        files: [file]
      }));
    },
    onRemoveClicked: function onRemoveClicked(event, id) {
      this.$emit('remove-clicked', id);
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnfinishedUploadsButton',

  props: {
    buttonText: {
      type: String,
      required: true
    },
    uploadsCount: {
      type: Number,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadManagerButton__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadManagerButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UploadManagerButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnfinishedUploadsButton__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnfinishedUploadsButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UnfinishedUploadsButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadsList__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UploadsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnfinishedList__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnfinishedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UnfinishedList__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadManager',
  components: {
    UploadManagerButton: __WEBPACK_IMPORTED_MODULE_2__UploadManagerButton___default.a,
    UploadsList: __WEBPACK_IMPORTED_MODULE_4__UploadsList___default.a,
    UnfinishedUploadsButton: __WEBPACK_IMPORTED_MODULE_3__UnfinishedUploadsButton___default.a,
    UnfinishedList: __WEBPACK_IMPORTED_MODULE_5__UnfinishedList___default.a
  },

  data: function data() {
    return {
      isUploadsOpen: false,
      uploadsButtonText: 'Show uploading items',
      isUnfinishedUploadsOpen: false,
      unfinishedButtonText: 'Show unfinished uploads'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('uploadManager', ['uploads', 'unfinishedUploads', 'generalProgress', 'generalStatus', 'hasUploadingFiles']), {
    hasUploadingItems: function hasUploadingItems() {
      return this.uploads && this.uploads.length;
    }
  }),

  mounted: function mounted() {
    var _this = this;

    window.addEventListener('beforeunload', function (e) {
      if (_this.hasUploadingFiles) {
        var dialogText = 'You have uploading files. Are you sure you want to close the page?';
        e.returnValue = dialogText;
        return dialogText;
      }
      return null;
    });
  },


  methods: {
    onUploadsButtonClicked: function onUploadsButtonClicked() {
      this.isUploadsOpen = !this.isUploadsOpen;
      if (this.isUploadsOpen) {
        this.uploadsButtonText = 'Hide uploading items';
      } else {
        this.uploadsButtonText = 'Show uploading items';
      }
      this.onUnfinishedHideClicked();
    },
    onUnfinishedButtonClicked: function onUnfinishedButtonClicked() {
      this.isUnfinishedUploadsOpen = !this.isUnfinishedUploadsOpen;
      if (this.isUnfinishedUploadsOpen) {
        this.unfinishedButtonText = 'Hide unfinished uploads';
      } else {
        this.unfinishedButtonText = 'Show unfinished uploads';
      }
      this.onHideClicked();
    },
    onHideClicked: function onHideClicked() {
      this.isUploadsOpen = false;
      this.uploadsButtonText = 'Show uploading items';
    },
    onUnfinishedHideClicked: function onUnfinishedHideClicked() {
      this.isUnfinishedUploadsOpen = false;
      this.unfinishedButtonText = 'Show unfinished uploads';
    },
    onStopUploadClicked: function onStopUploadClicked(id) {
      this.$store.dispatch('uploadManager/stopUpload', id);
    },
    onResumeUploadClicked: function onResumeUploadClicked(id) {
      this.$store.dispatch('uploadManager/resumeUpload', id);
    },
    onPauseUploadClicked: function onPauseUploadClicked(id) {
      this.$store.dispatch('uploadManager/pauseUpload', id);
    },
    onRetryUploadClicked: function onRetryUploadClicked(id) {
      this.$store.dispatch('uploadManager/retryUpload', id);
    },
    onRemoveClicked: function onRemoveClicked(id) {
      this.$store.dispatch('uploadManager/removeUpload', id);
    },
    onFileReselected: function onFileReselected(payload) {
      this.$store.dispatch('uploadManager/restoreUpload', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload.uploadParams, {
        files: payload.files,
        id: payload.id
      }));
      this.$store.dispatch('uploadManager/removeUnfinishedUpload', payload.id);
    },
    onUnfinishedRemoveClicked: function onUnfinishedRemoveClicked(id) {
      this.$store.dispatch('uploadManager/removeUnfinishedUpload', id);
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadManagerButton',

  props: {
    progress: {
      type: Number,
      required: true
    },
    uploadsCount: {
      type: Number,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    generalStatus: {
      type: String,
      required: true
    }
  },

  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressBar__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressBar__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadsList',

  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_0__ProgressBar___default.a
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    uploads: {
      type: Array,
      required: true
    }
  },

  methods: {
    onHideClicked: function onHideClicked() {
      this.$emit('hide');
    },
    onStopUploadClicked: function onStopUploadClicked(event, id) {
      this.$emit('stop', id);
    },
    onResumeUploadClicked: function onResumeUploadClicked(event, id) {
      this.$emit('resume', id);
    },
    onPauseUploadClicked: function onPauseUploadClicked(event, id) {
      this.$emit('pause', id);
    },
    onRetryUploadClicked: function onRetryUploadClicked(event, id) {
      this.$emit('retry', id);
    },
    onRemoveClicked: function onRemoveClicked(event, id) {
      this.$emit('remove', id);
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_EditPageMixin__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UsersEdit',

  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_EditPageMixin__["a" /* default */]],

  data: function data() {
    return {
      source: null,
      entity: {},
      newPassword: null,
      newPasswordConfirmation: null
    };
  },


  computed: {
    rolesList: function rolesList() {
      return this.$store.state.roles.list;
    },
    avatarUrl: function avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged: function avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    }
  },

  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      if (this.newPassword && this.newPassword.length < 6) {
        this.$_showError('New password must be at least 6 characters');
        return false;
      }
      if (this.newPassword && !this.newPasswordConfirmation) {
        this.$_showError('Please confirm new password');
        return false;
      }
      if (!this.entity.roles.length) {
        this.$_showError('Roles field is required');
        return false;
      }
      return true;
    },
    getSource: function getSource() {
      var _this = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(this.$config.app_api.prefix + 'users/' + this.$route.params.id + '?with[]=avatar&with[]=roles').then(function (response) {
        _this.source = response.data;
        _this.entity = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
          _this.source.avatar = null;
          _this.entity.avatar = null;
        }
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
      }).catch(function (error) {
        if (_this.$refs.spinner) {
          _this.$refs.spinner.hide();
        }
        _this.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting data request' });
        console.error(error);
      });
    },
    changeAvatar: function changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore: function avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove: function avatarRemove() {
      this.entity.avatar = null;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('email', this.entity.email);
      if (this.newPassword && this.newPasswordConfirmation) {
        postFormData.append('password', this.newPassword);
        postFormData.append('password_confirmation', this.newPasswordConfirmation);
      }
      if (this.entity.roles && this.entity.roles.length) {
        for (var i = 0; i < this.entity.roles.length; i += 1) {
          postFormData.append('roles[]', this.entity.roles[i].id);
        }
      }
      return this.$apiHttp.post(this.$config.app_api.prefix + 'users/' + this.$route.params.id, postFormData);
    },
    saveAvatarRequest: function saveAvatarRequest() {
      var postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'users/' + this.$route.params.id + '/avatar', postFormData);
    },
    deleteAvatarRequest: function deleteAvatarRequest() {
      return this.$apiHttp.delete(this.$config.app_api.prefix + 'users/' + this.$route.params.id + '/avatar');
    },
    saveEntity: function saveEntity() {
      var _this2 = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(function () {
          _this2.$_successSave();
        }).catch(function (error) {
          _this2.$_errorSave(error);
          console.error('Error in update user query', error);
        });
      } else if (!this.entity.avatar) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.deleteAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.saveAvatarRequest(), this.saveRequest()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (avatar, entity) {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            _this2.$_successSave();
          } else {
            _this2.$_showError('Error in data saving');
          }
        }));
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_components_Pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UsersList',

  components: {
    pager: __WEBPACK_IMPORTED_MODULE_1__global_components_Pager___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListPageMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_CommonPageMixin__["a" /* default */]],

  computed: {
    activeUser: function activeUser() {
      return this.$store.state.user.info;
    }
  },

  mounted: function mounted() {
    this.getRoles();
  },


  methods: {
    disable2fa: function disable2fa(userId) {
      var _this = this;

      if (window.confirm('Do you really want to disable Google 2FA for user with id = ' + userId + '?')) {
        var loader = this.$refs['activeBtnLoader_' + userId][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(this.$config.app_api.prefix + 'users/disable2fa/' + userId).then(function () {
          var userIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(_this.entities, function (user) {
            return user.id === userId;
          });
          _this.entities[userIndex].google2fa_enabled = false;
        }).catch(function (error) {
          console.error(error);
        }).finally(function () {
          loader.style.display = 'none';
        });
      }
    },
    activateUser: function activateUser(userId) {
      var _this2 = this;

      if (window.confirm('Do you really want to activate user with id = ' + userId + '?')) {
        var loader = this.$refs['activeBtnLoader_' + userId][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(this.$config.app_api.prefix + 'users/activate/' + userId).then(function () {
          var userIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(_this2.entities, function (user) {
            return user.id === userId;
          });
          _this2.entities[userIndex].active = true;
        }).catch(function (error) {
          console.error(error);
        }).finally(function () {
          loader.style.display = 'none';
        });
      }
    },
    deactivateUser: function deactivateUser(userId) {
      var _this3 = this;

      if (window.confirm('Do you really want to block user with id = ' + userId + '?')) {
        var loader = this.$refs['activeBtnLoader_' + userId][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(this.$config.app_api.prefix + 'users/block/' + userId).then(function () {
          var userIndex = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(_this3.entities, function (user) {
            return user.id === userId;
          });
          _this3.entities[userIndex].active = false;
        }).catch(function (error) {
          console.error(error);
        }).finally(function () {
          loader.style.display = 'none';
        });
      }
    },
    getRoles: function getRoles() {
      var _this4 = this;

      this.$apiHttp.get(this.$config.app_api.prefix + 'roles').then(function (response) {
        var rolesArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
        delete rolesArr.meta;
        _this4.$store.commit('roles/setRolesList', __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toArray(rolesArr));
      }).catch(function (error) {
        _this4.$store.dispatch('notifications/setHttpError', { error: error, text: 'Error in getting roles request' });
        console.error(error);
      });
    },
    getSource: function getSource() {
      var _this5 = this;

      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      var searchString = encodeURI(this.searchQuery);
      var page = this.perPage ? this.offset / this.perPage + 1 : 1;
      var searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(this.$config.app_api.prefix + 'users?search_string=' + searchString + '&page=' + page + '&with[]=roles').then(function (response) {
        if (_this5.searchProcessId === searchProcessId) {
          if (_this5.$refs.spinner) {
            _this5.$refs.spinner.hide();
          }
          _this5.total = response.data.meta.pagination.total;
          _this5.perPage = response.data.meta.pagination.per_page;

          var usersArr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(response.data);
          delete usersArr.meta;
          _this5.entities = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toArray(usersArr);
        }
      }).catch(function (error) {
        _this5.$_errorCallback(error);
      });
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_CreatePageMixin__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserNew',

  components: {
    'vue-select': __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_CreatePageMixin__["a" /* default */]],

  data: function data() {
    return {
      entity: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        roles: [],
        avatar: null
      }
    };
  },


  computed: {
    rolesList: function rolesList() {
      return this.$store.state.roles.list;
    }
  },

  methods: {
    isEntityValid: function isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      if (!this.entity.password) {
        this.$_showError('Password field is required');
        return false;
      }
      if (this.entity.password.length < 6) {
        this.$_showError('The password must be at least 6 characters');
        return false;
      }
      if (this.entity.password !== this.entity.password_confirmation) {
        this.$_showError('Password confirmation is wrong');
        return false;
      }
      if (!this.entity.roles.length) {
        this.$_showError('Roles field is required');
        return false;
      }
      return true;
    },
    avatarUploaded: function avatarUploaded(file) {
      this.entity.avatar = file;
    },
    saveRequest: function saveRequest() {
      var postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('email', this.entity.email);
      postFormData.append('password', this.entity.password);
      postFormData.append('password_confirmation', this.entity.password_confirmation);
      if (this.entity.roles && this.entity.roles.length) {
        for (var i = 0; i < this.entity.roles.length; i += 1) {
          postFormData.append('roles[]', this.entity.roles[i].id);
        }
      }
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(this.$config.app_api.prefix + 'users', postFormData);
    },
    save: function save() {
      var _this = this;

      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(function (response) {
        _this.$_successSave();
        _this.$parent.getSource();
        window.location.hash = '#/admin/users/edit/' + response.data.id;
      }).catch(function (error) {
        console.error('Error in user create query', error);
        _this.$_errorSave(error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 507 */,
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"],
  props: ['data', 'options'],
  mounted: function mounted() {
    this.renderChart(this.data, this.options);
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Spinner__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_ImageUploader__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_components_ImageUploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_components_ImageUploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Ckeditor__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_components_Ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_components_Ckeditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_menu_MenuItem__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_menu_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_menu_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_taxonomy_vocabulary_TermsOrderItem__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_taxonomy_vocabulary_TermsOrderItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_taxonomy_vocabulary_TermsOrderItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_publicFiles_Folder__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_publicFiles_Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_publicFiles_Folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_components_FileUploader_Folder__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_components_FileUploader_Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__global_components_FileUploader_Folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apiHttp__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_select__);























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('image-uploader', __WEBPACK_IMPORTED_MODULE_6__global_components_ImageUploader___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('ckeditor', __WEBPACK_IMPORTED_MODULE_7__global_components_Ckeditor___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('menu-item', __WEBPACK_IMPORTED_MODULE_8__views_menu_MenuItem___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('term-item', __WEBPACK_IMPORTED_MODULE_9__views_taxonomy_vocabulary_TermsOrderItem___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('SelectelFolder', __WEBPACK_IMPORTED_MODULE_10__views_publicFiles_Folder___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('FileUploaderFolder', __WEBPACK_IMPORTED_MODULE_11__global_components_FileUploader_Folder___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('spinner', __WEBPACK_IMPORTED_MODULE_5__global_components_Spinner___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_17_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyAtKJall6X5HN_b5hJW21Eq345uDsaf92c',
    v: '3',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$apiHttp = __WEBPACK_IMPORTED_MODULE_12__apiHttp__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$logout = function () {
  localStorage.setItem('tokenStorage', '');
  localStorage.setItem('user', '');
  this.$store.commit('user/storeAccessToken', '');
  this.$store.commit('user/setInfo', '');
  this.$store.commit('errors/setAuthError', 'Your access token is expired. Please, log in again');
  this.$router.push('/login');
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$assignAxiosHeaders = function (accessToken) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$apiHttp.defaults, {
    headers: {
      authorization: 'Bearer ' + accessToken,
      Accept: 'application/json'
    }
  });
};

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  config: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_16__App___default.a },
  created: function created() {
    var _this = this;

    this.$apiHttp.interceptors.response.use(null, function (error) {
      if (error.response.status === 401) {
        _this.$logout();
      }
      if (error.response.status === 403) {
        _this.$store.commit('notifications/setDangerNotification', 'Access denied!');
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });

    this.$store.watch(function (state) {
      return state.user.accessToken;
    }, function (newVal) {
      if (newVal.access_token) {
        _this.$assignAxiosHeaders(newVal.access_token);
      }
    }, { deep: true });
  },

  template: '<App/>'
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  list: []
};

var getters = {};

var actions = {};

var mutations = {
  setContentTypesList: function setContentTypesList(state, playload) {
    state.list = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  list: ['je_white_letters', 'incoming_correspondence', 'js_white_letters', 'email', 'correspondence']
};

var getters = {};

var actions = {};

var mutations = {
  setCorrTypesList: function setCorrTypesList(state, playload) {
    state.list = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  auth: {
    text: ''
  }
};

var getters = {};

var actions = {};

var mutations = {
  setAuthError: function setAuthError(state, playload) {
    state.auth.text = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var initialState = {
  images: []
};

var getters = {
  imageList: function imageList(state) {
    return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.images));
  }
};

var mutations = {
  setImageList: function setImageList(state, list) {
    state.images = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(list));
  }
};

var actions = {
  setImages: function setImages(_ref, list) {
    var commit = _ref.commit;

    commit('setImageList', list);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: initialState,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  warning: '',
  danger: '',
  success: ''
};

var getters = {};

var actions = {
  setHttpError: function setHttpError(_ref, _ref2) {
    var commit = _ref.commit;
    var error = _ref2.error,
        text = _ref2.text;
    var status = error.response.status;

    if (status !== 403 && status !== 401) {
      commit('setDangerNotification', text);
    }
  }
};

var mutations = {
  setDangerNotification: function setDangerNotification(state, playload) {
    state.danger = playload;
  },
  setWarningNotification: function setWarningNotification(state, playload) {
    state.warning = playload;
  },
  setSuccessNotification: function setSuccessNotification(state, playload) {
    state.success = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var initialState = {
  images: []
};

var getters = {
  imageList: function imageList(state) {
    return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.images));
  }
};

var mutations = {
  setImageList: function setImageList(state, list) {
    state.images = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(list));
  }
};

var actions = {
  setImages: function setImages(_ref, list) {
    var commit = _ref.commit;

    commit('setImageList', list);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: initialState,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  list: []
};

var getters = {};

var actions = {};

var mutations = {
  setRolesList: function setRolesList(state, playload) {
    state.list = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_resumablejs__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_resumablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_resumablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_constants__ = __webpack_require__(19);










var _window = window,
    localStorage = _window.localStorage;


var uuidv4 = __webpack_require__(606);

var unfinished = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__helpers_constants__["a" /* UPLOADING_FILES */]));

var addUploadingItemToLocalStorage = function addUploadingItemToLocalStorage(file, params) {
  var unfinishedItems = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__helpers_constants__["a" /* UPLOADING_FILES */]));
  var result = unfinishedItems;
  if (!result) {
    result = {};
  }
  result[file.uniqueIdentifier] = {
    filename: file.fileName,
    uploadParams: params
  };
  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__helpers_constants__["a" /* UPLOADING_FILES */], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(result));
};

var removeUploadingItemFromLocalStorage = function removeUploadingItemFromLocalStorage(id) {
  var unfinishedItems = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_8__helpers_constants__["a" /* UPLOADING_FILES */]));
  if (!unfinishedItems) return;
  delete unfinishedItems[id];
  localStorage.setItem(__WEBPACK_IMPORTED_MODULE_8__helpers_constants__["a" /* UPLOADING_FILES */], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(unfinishedItems));
};

var LOADING = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].LOADING,
    ERROR = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].ERROR,
    SUCCESS = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].SUCCESS,
    PAUSE = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].PAUSE,
    ABORTED = __WEBPACK_IMPORTED_MODULE_8__helpers_constants__["b" /* uploadStatus */].ABORTED;


var initialState = {
  uploads: {},
  unfinishedUploads: unfinished
};
var mutations = {
  setFileProgress: function setFileProgress(state, payload) {
    var fileInfo = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, payload);
    state.uploads[payload.id] = fileInfo;
    state.uploads = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.uploads);
  },
  stopUpload: function stopUpload(state, id) {
    var upload = state.uploads[id];
    upload.resumable.cancel();
    upload.status = ABORTED;
    upload.progress = 100;
    state.uploads[id] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, upload);
  },
  resumeUpload: function resumeUpload(state, id) {
    var upload = state.uploads[id];
    upload.resumable.upload();
    upload.status = LOADING;
    state.uploads[id] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, upload);
  },
  pauseUpload: function pauseUpload(state, id) {
    var upload = state.uploads[id];
    upload.resumable.pause();
    upload.status = PAUSE;
    state.uploads[id] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, upload);
  },
  retryUpload: function retryUpload(state, id) {
    var upload = state.uploads[id];
    upload.resumable.removeFile(upload.resumableFile);
    upload.resumable.addFile(upload.file);

    var _upload$resumable$fil = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(upload.resumable.files, 1);

    upload.resumableFile = _upload$resumable$fil[0];

    var newId = upload.resumableFile.uniqueIdentifier;
    upload.id = newId;
    if (upload.status === ERROR) {
      upload.resumableFile.retry();
    } else {
      upload.resumable.upload();
    }
    upload.status = LOADING;
    delete state.uploads[id];
    removeUploadingItemFromLocalStorage(id);
  },
  removeUpload: function removeUpload(state, id) {
    delete state.uploads[id];
    state.uploads = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.uploads);
  },
  removeUnfinishedUpload: function removeUnfinishedUpload(state, id) {
    delete state.unfinishedUploads[id];
    state.unfinishedUploads = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, state.unfinishedUploads);
    removeUploadingItemFromLocalStorage(id);
  }
};
var actions = {
  startUpload: function startUpload(_ref2, _ref) {
    var commit = _ref2.commit;

    var files = _ref.files,
        entityId = _ref.entityId,
        apiPrefix = _ref.apiPrefix,
        apiHost = _ref.apiHost,
        token = _ref.token,
        contentType = _ref.contentType,
        acceptedFiles = _ref.acceptedFiles,
        rest = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['files', 'entityId', 'apiPrefix', 'apiHost', 'token', 'contentType', 'acceptedFiles']);

    var commitProgress = function commitProgress(resumableFile, status, fileProgress, resumable) {
      return commit('setFileProgress', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
        id: resumableFile.uniqueIdentifier,
        entityId: entityId,
        file: resumableFile.file,
        status: status,
        fileProgress: fileProgress,
        resumable: resumable,
        resumableFile: resumableFile,
        contentType: contentType
      }, rest));
    };
    files.forEach(function (fileObj) {
      var query = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, rest);
      if (entityId) {
        query.entity_id = entityId;
      }
      if (contentType) {
        query.content_type = contentType;
      }
      var r = new __WEBPACK_IMPORTED_MODULE_7_resumablejs___default.a({
        target: '' + apiHost + apiPrefix + 'files/chunk-upload',
        chunkSize: 5 * 1024 * 1024,
        simultaneousUploads: 3,
        testChunks: true,
        maxChunkRetries: 5,
        fileParameterName: 'file',
        headers: {
          authorization: token.token_type + ' ' + token.access_token,
          Accept: 'application/json'
        },
        generateUniqueIdentifier: uuidv4,
        query: query
      });

      r.addFile(fileObj);
      r.on('fileAdded', function (file) {
        commitProgress(file, LOADING, 0, r);
        r.upload();
        addUploadingItemToLocalStorage(file, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
          id: file.uniqueIdentifier,
          entityId: entityId,
          apiPrefix: apiPrefix,
          apiHost: apiHost,
          token: token,
          contentType: contentType,
          acceptedFiles: acceptedFiles
        }, rest));
      });
      r.on('fileProgress', function (file) {
        commitProgress(file, LOADING, Math.round(file.progress() * 10000) / 100, r);
      });
      r.on('fileSuccess', function (file, json) {
        if (rest.is_public_file) {
          var urls = JSON.parse(json);
          rest.urls = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(urls.urls));
        }

        commitProgress(file, SUCCESS, Math.round(file.progress() * 10000) / 100, r);
        removeUploadingItemFromLocalStorage(file.uniqueIdentifier);
      });
      r.on('fileError', function (file) {
        commitProgress(file, ERROR, Math.round(file.progress() * 10000) / 100, r);
        removeUploadingItemFromLocalStorage(file.uniqueIdentifier);
      });
    });
  },
  stopUpload: function stopUpload(_ref3, id) {
    var commit = _ref3.commit;

    commit('stopUpload', id);
  },
  resumeUpload: function resumeUpload(_ref4, id) {
    var commit = _ref4.commit;

    commit('resumeUpload', id);
  },
  pauseUpload: function pauseUpload(_ref5, id) {
    var commit = _ref5.commit;

    commit('pauseUpload', id);
  },
  retryUpload: function retryUpload(_ref6, id) {
    var commit = _ref6.commit;

    commit('retryUpload', id);
  },
  removeUpload: function removeUpload(_ref7, id) {
    var commit = _ref7.commit;

    commit('removeUpload', id);
  },
  restoreUpload: function restoreUpload(_ref8, payload) {
    var dispatch = _ref8.dispatch;

    dispatch('startUpload', payload);
  },
  removeUnfinishedUpload: function removeUnfinishedUpload(_ref9, id) {
    var commit = _ref9.commit;

    commit('removeUnfinishedUpload', id);
  }
};
var getters = {
  uploads: function uploads(state) {
    var uploads = state.uploads;

    var uploadsArray = [];
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(uploads).forEach(function (upload) {
      uploadsArray.push({
        id: upload.id,
        fileName: upload.file.name,
        fileProgress: upload.fileProgress,
        status: upload.status
      });
    });
    return uploadsArray;
  },
  unfinishedUploads: function unfinishedUploads(state) {
    var unfinishedUploads = state.unfinishedUploads;

    var result = [];
    if (!unfinishedUploads) {
      return result;
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(unfinishedUploads).forEach(function (id) {
      result.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
        id: id
      }, unfinishedUploads[id]));
    });
    return result;
  },


  getUploadByEntityId: function getUploadByEntityId(state) {
    return function (entityId, contentType, fileType) {
      var uploadingFile = void 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads).forEach(function (item) {
        if (uploadingFile) {
          return;
        }
        if (+item.entityId === +entityId && item.contentType === contentType && fileType === item.file_type) {
          uploadingFile = item;
        }
      });
      if (!uploadingFile) {
        return {};
      }
      return {
        id: uploadingFile.id,
        status: uploadingFile.status,
        file: uploadingFile.file
      };
    };
  },
  getUploadsList: function getUploadsList(state) {
    return function (entityId, contentType, fileType) {
      var uploadingList = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads).forEach(function (item) {
        if (+item.entityId === +entityId && item.contentType === contentType && fileType === item.file_type) {
          uploadingList.push(item);
        }
      });
      return uploadingList;
    };
  },
  generalProgress: function generalProgress(state) {
    var uploads = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads).filter(function (upload) {
      return upload.status !== ABORTED;
    });
    var progressSum = uploads.reduce(function (progress, item) {
      return progress + item.fileProgress;
    }, 0);
    return Math.round(progressSum / uploads.length * 100) / 100;
  },

  publicFilesUploads: function publicFilesUploads(state) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads).filter(function (item) {
      return item.is_public_file;
    });
  },

  generalStatus: function generalStatus(state) {
    var uploads = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads);
    var isLoading = false;
    var isPaused = false;
    var isSuccess = true;
    var hasError = false;
    for (var i = 0; i < uploads.length; i++) {
      var upload = uploads[i];
      switch (upload.status) {
        case LOADING:
          {
            isLoading = true;
            isSuccess = false;
            break;
          }
        case ERROR:
          {
            hasError = true;
            isSuccess = false;
            break;
          }
        case PAUSE:
          {
            isPaused = true;
            isSuccess = false;
            break;
          }
        case SUCCESS:
          {
            break;
          }
        default:
          {
            isSuccess = false;
            break;
          }
      }
    }
    if (hasError) {
      return ERROR;
    }
    if (isPaused) {
      return PAUSE;
    }
    if (isLoading) {
      return LOADING;
    }
    if (isSuccess) {
      return SUCCESS;
    }
    return ABORTED;
  },
  hasUploadingFiles: function hasUploadingFiles(state) {
    var uploads = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.uploads);
    var isThereUploadingFile = false;
    for (var i = 0; i < uploads.length; i++) {
      var upload = uploads[i];
      if (upload.status === LOADING) {
        isThereUploadingFile = true;
        break;
      }
    }
    return isThereUploadingFile;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: initialState
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var initialState = {
  accessToken: {},
  info: {},
  timeData: {}
};

var getters = {
  getPermissions: function getPermissions(state) {
    if (!state.info || !state.info.roles) return [];
    var permissionsArrs = state.info.roles.map(function (role) {
      return role.permissions;
    });
    var permissions = [];
    for (var i = 0; i < permissionsArrs.length; i += 1) {
      permissions = permissions.concat(permissionsArrs[i]);
    }
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqBy(permissions, 'id');
  },
  getPermissionsObject: function getPermissionsObject(state) {
    if (!state.info || !state.info.roles) return [];
    var permissionsArrs = state.info.roles.map(function (role) {
      return role.permissions;
    });
    var permissions = [];
    for (var i = 0; i < permissionsArrs.length; i += 1) {
      permissions = permissions.concat(permissionsArrs[i]);
    }
    var arr = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqBy(permissions, 'id');
    var result = {};
    for (var _i = 0; _i < arr.length; _i += 1) {
      result[arr[_i].id] = arr[_i];
    }
    return result;
  },
  getId: function getId(state) {
    return state.info.id;
  },
  getGoogle2faInfo: function getGoogle2faInfo(state) {
    return state.info.google2fa_enabled;
  }
};

var actions = {};

var mutations = {
  storeAccessToken: function storeAccessToken(state, playload) {
    state.accessToken = playload;
  },
  setInfo: function setInfo(state, playload) {
    state.info = playload;
  },
  setTimeData: function setTimeData(state, playload) {
    state.timeData = playload;
  },
  setGoogle2faInfo: function setGoogle2faInfo(state, playload) {
    state.info.google2fa_enabled = playload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  text: 'Person',
  isPerson: true
}, {
  text: 'Object',
  isPerson: false
}]);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 0,
  type: 'very_easy',
  title: 'Very Easy',
  baseAmounts: [16, 25, 36, 49]
}, {
  id: 1,
  type: 'easy',
  title: 'Easy',
  baseAmounts: [64, 81, 100, 121]
}, {
  id: 2,
  type: 'normal',
  title: 'Normal',
  baseAmounts: [144, 169, 196]
}, {
  id: 3,
  type: 'hard',
  title: 'Hard',
  baseAmounts: [225, 256, 281, 324]
}, {
  id: 4,
  type: 'difficult',
  title: 'Difficult',
  baseAmounts: [361, 400, 441, 484, 576, 676, 841, 1089]
}]);

/***/ }),
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 125,
	"./af.js": 125,
	"./ar": 133,
	"./ar-dz": 126,
	"./ar-dz.js": 126,
	"./ar-kw": 127,
	"./ar-kw.js": 127,
	"./ar-ly": 128,
	"./ar-ly.js": 128,
	"./ar-ma": 129,
	"./ar-ma.js": 129,
	"./ar-ps": 130,
	"./ar-ps.js": 130,
	"./ar-sa": 131,
	"./ar-sa.js": 131,
	"./ar-tn": 132,
	"./ar-tn.js": 132,
	"./ar.js": 133,
	"./az": 134,
	"./az.js": 134,
	"./be": 135,
	"./be.js": 135,
	"./bg": 136,
	"./bg.js": 136,
	"./bm": 137,
	"./bm.js": 137,
	"./bn": 139,
	"./bn-bd": 138,
	"./bn-bd.js": 138,
	"./bn.js": 139,
	"./bo": 140,
	"./bo.js": 140,
	"./br": 141,
	"./br.js": 141,
	"./bs": 142,
	"./bs.js": 142,
	"./ca": 143,
	"./ca.js": 143,
	"./cs": 144,
	"./cs.js": 144,
	"./cv": 145,
	"./cv.js": 145,
	"./cy": 146,
	"./cy.js": 146,
	"./da": 147,
	"./da.js": 147,
	"./de": 150,
	"./de-at": 148,
	"./de-at.js": 148,
	"./de-ch": 149,
	"./de-ch.js": 149,
	"./de.js": 150,
	"./dv": 151,
	"./dv.js": 151,
	"./el": 152,
	"./el.js": 152,
	"./en-au": 153,
	"./en-au.js": 153,
	"./en-ca": 154,
	"./en-ca.js": 154,
	"./en-gb": 155,
	"./en-gb.js": 155,
	"./en-ie": 156,
	"./en-ie.js": 156,
	"./en-il": 157,
	"./en-il.js": 157,
	"./en-in": 158,
	"./en-in.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./en-sg": 160,
	"./en-sg.js": 160,
	"./eo": 161,
	"./eo.js": 161,
	"./es": 165,
	"./es-do": 162,
	"./es-do.js": 162,
	"./es-mx": 163,
	"./es-mx.js": 163,
	"./es-us": 164,
	"./es-us.js": 164,
	"./es.js": 165,
	"./et": 166,
	"./et.js": 166,
	"./eu": 167,
	"./eu.js": 167,
	"./fa": 168,
	"./fa.js": 168,
	"./fi": 169,
	"./fi.js": 169,
	"./fil": 170,
	"./fil.js": 170,
	"./fo": 171,
	"./fo.js": 171,
	"./fr": 174,
	"./fr-ca": 172,
	"./fr-ca.js": 172,
	"./fr-ch": 173,
	"./fr-ch.js": 173,
	"./fr.js": 174,
	"./fy": 175,
	"./fy.js": 175,
	"./ga": 176,
	"./ga.js": 176,
	"./gd": 177,
	"./gd.js": 177,
	"./gl": 178,
	"./gl.js": 178,
	"./gom-deva": 179,
	"./gom-deva.js": 179,
	"./gom-latn": 180,
	"./gom-latn.js": 180,
	"./gu": 181,
	"./gu.js": 181,
	"./he": 182,
	"./he.js": 182,
	"./hi": 183,
	"./hi.js": 183,
	"./hr": 184,
	"./hr.js": 184,
	"./hu": 185,
	"./hu.js": 185,
	"./hy-am": 186,
	"./hy-am.js": 186,
	"./id": 187,
	"./id.js": 187,
	"./is": 188,
	"./is.js": 188,
	"./it": 190,
	"./it-ch": 189,
	"./it-ch.js": 189,
	"./it.js": 190,
	"./ja": 191,
	"./ja.js": 191,
	"./jv": 192,
	"./jv.js": 192,
	"./ka": 193,
	"./ka.js": 193,
	"./kk": 194,
	"./kk.js": 194,
	"./km": 195,
	"./km.js": 195,
	"./kn": 196,
	"./kn.js": 196,
	"./ko": 197,
	"./ko.js": 197,
	"./ku": 199,
	"./ku-kmr": 198,
	"./ku-kmr.js": 198,
	"./ku.js": 199,
	"./ky": 200,
	"./ky.js": 200,
	"./lb": 201,
	"./lb.js": 201,
	"./lo": 202,
	"./lo.js": 202,
	"./lt": 203,
	"./lt.js": 203,
	"./lv": 204,
	"./lv.js": 204,
	"./me": 205,
	"./me.js": 205,
	"./mi": 206,
	"./mi.js": 206,
	"./mk": 207,
	"./mk.js": 207,
	"./ml": 208,
	"./ml.js": 208,
	"./mn": 209,
	"./mn.js": 209,
	"./mr": 210,
	"./mr.js": 210,
	"./ms": 212,
	"./ms-my": 211,
	"./ms-my.js": 211,
	"./ms.js": 212,
	"./mt": 213,
	"./mt.js": 213,
	"./my": 214,
	"./my.js": 214,
	"./nb": 215,
	"./nb.js": 215,
	"./ne": 216,
	"./ne.js": 216,
	"./nl": 218,
	"./nl-be": 217,
	"./nl-be.js": 217,
	"./nl.js": 218,
	"./nn": 219,
	"./nn.js": 219,
	"./oc-lnc": 220,
	"./oc-lnc.js": 220,
	"./pa-in": 221,
	"./pa-in.js": 221,
	"./pl": 222,
	"./pl.js": 222,
	"./pt": 224,
	"./pt-br": 223,
	"./pt-br.js": 223,
	"./pt.js": 224,
	"./ro": 225,
	"./ro.js": 225,
	"./ru": 226,
	"./ru.js": 226,
	"./sd": 227,
	"./sd.js": 227,
	"./se": 228,
	"./se.js": 228,
	"./si": 229,
	"./si.js": 229,
	"./sk": 230,
	"./sk.js": 230,
	"./sl": 231,
	"./sl.js": 231,
	"./sq": 232,
	"./sq.js": 232,
	"./sr": 234,
	"./sr-cyrl": 233,
	"./sr-cyrl.js": 233,
	"./sr.js": 234,
	"./ss": 235,
	"./ss.js": 235,
	"./sv": 236,
	"./sv.js": 236,
	"./sw": 237,
	"./sw.js": 237,
	"./ta": 238,
	"./ta.js": 238,
	"./te": 239,
	"./te.js": 239,
	"./tet": 240,
	"./tet.js": 240,
	"./tg": 241,
	"./tg.js": 241,
	"./th": 242,
	"./th.js": 242,
	"./tk": 243,
	"./tk.js": 243,
	"./tl-ph": 244,
	"./tl-ph.js": 244,
	"./tlh": 245,
	"./tlh.js": 245,
	"./tr": 246,
	"./tr.js": 246,
	"./tzl": 247,
	"./tzl.js": 247,
	"./tzm": 249,
	"./tzm-latn": 248,
	"./tzm-latn.js": 248,
	"./tzm.js": 249,
	"./ug-cn": 250,
	"./ug-cn.js": 250,
	"./uk": 251,
	"./uk.js": 251,
	"./ur": 252,
	"./ur.js": 252,
	"./uz": 254,
	"./uz-latn": 253,
	"./uz-latn.js": 253,
	"./uz.js": 254,
	"./vi": 255,
	"./vi.js": 255,
	"./x-pseudo": 256,
	"./x-pseudo.js": 256,
	"./yo": 257,
	"./yo.js": 257,
	"./zh-cn": 258,
	"./zh-cn.js": 258,
	"./zh-hk": 259,
	"./zh-hk.js": 259,
	"./zh-mo": 260,
	"./zh-mo.js": 260,
	"./zh-tw": 261,
	"./zh-tw.js": 261
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;

/***/ }),
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.7","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_from":"vue-chartjs@2.8.7"}

/***/ }),
/* 621 */,
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(973),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(959),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(860),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(810),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(880),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(883),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(861),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(902),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(903),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(993),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(944),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(806),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(879),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(819),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(968),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(916),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(889),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(928),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(982),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc4f44c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(980),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(908),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(946),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(936),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(970),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(995),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(990),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(996),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(822),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(978),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(901),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(869),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(831),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(965),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(839),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(884),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(979),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(937),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(984),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(932),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(823),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(998),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(809),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(953),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(925),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(941),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(856),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(875),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(934),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(905),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(938),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(915),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(913),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(864),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(974),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(872),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(967),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(833),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(976),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(807),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(1007),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(814),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(988),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(871),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(1003),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(812),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(950),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(881),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(842),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(926),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(920),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(854),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(919),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(977),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(1002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(835),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(918),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(900),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(882),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(850),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(957),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(865),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(805),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(848),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(933),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(886),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(956),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(863),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(811),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(826),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(851),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(853),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(830),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(939),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(803),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(972),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(895),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(820),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(885),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(931),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(949),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(904),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(912),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(868),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(876),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(841),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(808),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(836),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1000),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(963),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(816),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(910),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(966),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(975),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(832),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(942),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(838),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(906),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(922),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(855),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(874),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(964),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(952),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(909),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(891),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(958),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(890),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(867),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(818),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(834),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(991),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(817),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d76d4b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(948),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(827),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(866),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(821),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(917),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(846),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(829),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(804),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(930),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(897),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1006),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(997),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(847),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(843),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(859),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(907),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(986),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(999),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(927),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(828),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(877),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(878),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(989),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(844),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(971),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(969),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(935),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1004),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(870),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(824),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59ae8b6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(888),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(852),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(849),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(954),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(943),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1005),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(892),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(955),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'QaList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Questions and Answers\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/questions_and_answers/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('questions-and-answers')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('questions-and-answers', 'Questions and Answers')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Q&A title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "questions_and_answers",
      "unpublish-empty-endpoint": "questions-and-answers/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('questions-and-answers', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'QaEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'questions_and_answers', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'questions_and_answers', 'QA')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'questions-and-answers/', 'QA')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Source *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.source),
      expression: "entity.source"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "source",
      "type": "text",
      "placeholder": "Enter source"
    },
    domProps: {
      "value": (_vm.entity.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "source", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Destination *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.destination),
      expression: "entity.destination"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "destination",
      "type": "text",
      "placeholder": "Enter destination"
    },
    domProps: {
      "value": (_vm.entity.destination)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "destination", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Redirect has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Redirect")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'NewsList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" News\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/news/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('news')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('news', 'News')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by News title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "news",
      "unpublish-empty-endpoint": "news/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('news', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'NewsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'news', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'news', 'News')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'news/', 'News')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-uploader__dropzone-list"
  }, _vm._l((_vm.qualityArray), function(quality) {
    return _c('div', {
      key: quality,
      staticClass: "file-uploader__dropzone-list-item"
    }, [_c('p', {
      staticClass: "file-uploader__quality-label"
    }, [_vm._v(_vm._s((quality + "p:")))]), _vm._v(" "), _c('div', {
      staticClass: "files-uploader__select-row",
      on: {
        "click": function($event) {
          return _vm.onSelectelUploaderClick(quality)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filesDictionary[quality].type),
        expression: "filesDictionary[quality].type"
      }],
      attrs: {
        "type": "radio",
        "name": ("uploadVideoGroup" + quality)
      },
      domProps: {
        "value": _vm.URL,
        "checked": _vm._q(_vm.filesDictionary[quality].type, _vm.URL)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.filesDictionary[quality], "type", _vm.URL)
        }
      }
    }), _vm._v(" "), _c('SelectelUploader', {
      attrs: {
        "file-link": _vm.filesDictionary[quality].url,
        "selectel-list": _vm.selectelList,
        "selectel-loading": _vm.selectelLoading,
        "link-status": _vm.filesDictionary[quality].linkStatus
      },
      on: {
        "blur": function($event) {
          return _vm.checkLink(quality)
        },
        "file-attached": function($event) {
          return _vm.attachFile($event, quality)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "files-uploader__select-row",
      on: {
        "click": function($event) {
          return _vm.onFileUploaderClick(quality)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filesDictionary[quality].type),
        expression: "filesDictionary[quality].type"
      }],
      attrs: {
        "type": "radio",
        "name": ("uploadVideoGroup" + quality)
      },
      domProps: {
        "value": _vm.FILE,
        "checked": _vm._q(_vm.filesDictionary[quality].type, _vm.FILE)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.filesDictionary[quality], "type", _vm.FILE)
        }
      }
    }), _vm._v(" "), _c('Dropzone', {
      ref: ("dropzone" + quality),
      refInFor: true,
      staticClass: "dropzone-noprogress",
      attrs: {
        "id": ("files-uploader-" + quality),
        "options": _vm.dropzoneOptions
      },
      on: {
        "vdropzone-removed-file": function($event) {
          return _vm.videoRemoved($event, quality)
        },
        "vdropzone-file-added": function($event) {
          return _vm.videoAdded($event, quality)
        }
      }
    })], 1)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'EventList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Events\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/event/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('event')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('event', 'Events')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by event title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "event",
      "unpublish-empty-endpoint": "events/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('event', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'EventEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'event', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'event', 'Event')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'events/', 'Event')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Video Series has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Video Series")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("articles/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Article has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'PersonList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" People\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/person/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('person')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('person', 'People')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by person title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "person",
      "unpublish-empty-endpoint": "people/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('person', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'PersonEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowManageDuplicates) ? _c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "to": {
          name: 'PersonDuplicates',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Duplicates\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'person', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'person', 'Person')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'people/', 'Person')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Image Gallery has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Image Gallery")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.fileRemoved,
      "vdropzone-file-added": _vm.fileAdded
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Pamphlet has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create pamphlet")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("faq/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("FAQ has modified successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-wrap folder",
    class: {
      opened: _vm.opened
    }
  }, [_c('div', {
    staticClass: "file-row",
    on: {
      "dblclick": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "file-btns"
  }, [_c('span', {
    ref: "deleteBtn",
    staticClass: "file-btn file-btn__delete",
    on: {
      "click": _vm.deleteFolder
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "folder-nested"
  }, [_vm._l((_vm.content.folders), function(folderContent, folderName) {
    return _c('SelectelFolder', {
      key: (_vm.name + "/" + folderName),
      attrs: {
        "name": folderName,
        "path": (_vm.path + "/" + folderName),
        "content": folderContent
      },
      on: {
        "folderDeleted": _vm.onFolderDeleted,
        "fileDeleted": _vm.onFileDeleted
      }
    })
  }), _vm._v(" "), _vm._l((_vm.content.files), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "file": file
      },
      on: {
        "fileDeleted": _vm.onFileDeleted
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-type"
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-folder-open"
  })])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "description"
    },
    model: {
      value: (_vm.entity.description),
      callback: function($$v) {
        _vm.$set(_vm.entity, "description", $$v)
      },
      expression: "entity.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.avatarUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.email),
      expression: "entity.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "email", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Director has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Director")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
}]}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-bar"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by dashboard content"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        return _vm.queryChanged($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-10 search-bar__filters"
  }, [_c('label', {
    staticClass: "search-bar__filter"
  }, [_c('span', [_vm._v("Show")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "auto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), (_vm.total) ? _c('span', [_vm._v("of " + _vm._s(_vm.total))]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "search-bar__filter"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.searchType === _vm.SEARCH_BY.TITLE
    },
    on: {
      "change": function($event) {
        return _vm.onSearchTypeChanged(_vm.SEARCH_BY.TITLE)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Search by Title")])]), _vm._v(" "), _c('label', {
    staticClass: "search-bar__filter"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.searchType === _vm.SEARCH_BY.BODY
    },
    on: {
      "change": function($event) {
        return _vm.onSearchTypeChanged(_vm.SEARCH_BY.BODY)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Search by Body")])]), _vm._v(" "), _c('label', {
    staticClass: "search-bar__filter"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.searchType === _vm.SEARCH_BY.ID
    },
    on: {
      "change": function($event) {
        return _vm.onSearchTypeChanged(_vm.SEARCH_BY.ID)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Search by ID")])]), _vm._v(" "), _c('label', {
    staticClass: "search-bar__filter"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.searchType === _vm.SEARCH_BY.URL
    },
    on: {
      "change": function($event) {
        return _vm.onSearchTypeChanged(_vm.SEARCH_BY.URL)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Search by URL")])])])])])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Quiz Game') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Quiz Game\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/quiz-game-images/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by quiz game question"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Question")]), _vm._v(" "), _c('th', [_vm._v("Answer")]), _vm._v(" "), _c('th', [_vm._v("Explanation")]), _vm._v(" "), _c('th', [_vm._v("More Info")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.images), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_vm._v("\n                    " + _vm._s(item.id) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.question) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_vm._v("\n                    " + _vm._s(item.answer) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.explanation) + "\n                  ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blanc"
      }
    }, [_vm._v("\n                      " + _vm._s(item.more_info) + "\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/quiz-game-images/edit/" + (item.id))
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'games/quiz/', 'Quiz Game')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder__item-modal modal fade",
    attrs: {
      "id": "menuItemModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTitle",
      "type": "text",
      "data-validation": "true"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.url),
      expression: "entity.url"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemUrl",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "url", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.tooltip),
      expression: "entity.tooltip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTooltip",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.tooltip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "tooltip", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.target),
      expression: "entity.target"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemTarget"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "target", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "_self"
    }
  }, [_vm._v("In current tab")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "_blank"
    }
  }, [_vm._v("In new tab")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.route),
      expression: "entity.route"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemContentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "route", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.entityTypesList), function(value) {
    return _c('option', {
      key: value.name,
      domProps: {
        "value": value.value
      }
    }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemPathAlias",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-1 d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.hidden),
      expression: "entity.hidden"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "menuItemPathAlias",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.hidden) ? _vm._i(_vm.entity.hidden, null) > -1 : (_vm.entity.hidden)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.hidden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "hidden", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "hidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "hidden", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), (_vm.entity.route) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('vue-select', {
    attrs: {
      "label": "title",
      "filterable": false,
      "options": _vm.selectOptions
    },
    on: {
      "search": _vm.vueSelectOnSearch
    },
    model: {
      value: (_vm.entity.parameters),
      callback: function($$v) {
        _vm.$set(_vm.entity, "parameters", $$v)
      },
      expression: "entity.parameters"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.entity.image ? _vm.entity.image.public_url : '',
      "removable": true
    },
    on: {
      "changeFile": _vm.imageChange,
      "returnedOldFile": _vm.imageReturnedOld,
      "existingFileRemoved": _vm.imageRemove
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-modal-error",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n          Save changes\n          "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Menu item")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTitle"
    }
  }, [_vm._v("Title*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemUrl"
    }
  }, [_vm._v("Url")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTooltip"
    }
  }, [_vm._v("Tooltip")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemTooltip"
    }
  }, [_vm._v("Open page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemContentType"
    }
  }, [_vm._v("Entity Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemPathAlias"
    }
  }, [_vm._v("Page Path Alias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "menuItemPathAlias"
    }
  }, [_vm._v("Hidden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Image")])])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("topics/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter menu name"
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Menu has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create menu")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.entity.sections) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-main-about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-main-about"
    },
    model: {
      value: (_vm.entity.boxes.box1.text),
      callback: function($$v) {
        _vm.$set(_vm.entity.boxes.box1, "text", $$v)
      },
      expression: "entity.boxes.box1.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box1-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box1.show_images_slider),
      expression: "entity.boxes.box1.show_images_slider"
    }],
    attrs: {
      "id": "box1-include-slider",
      "type": "checkbox",
      "disabled": _vm.isImagesSliderSelected && !_vm.entity.boxes.box1.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box1.show_images_slider) ? _vm._i(_vm.entity.boxes.box1.show_images_slider, null) > -1 : (_vm.entity.boxes.box1.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box1.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isImagesSliderSelected && !_vm.entity.boxes.box1.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one image slider\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.boxes.box1.show_images_slider),
      expression: "entity.boxes.box1.show_images_slider"
    }],
    staticClass: "col-md-12 mt-2"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select Images\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-main-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-main-info"
    },
    model: {
      value: (_vm.entity.boxes.box2.text),
      callback: function($$v) {
        _vm.$set(_vm.entity.boxes.box2, "text", $$v)
      },
      expression: "entity.boxes.box2.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-show-news-notes"
    }
  }, [_vm._v("Show News Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_news_notes),
      expression: "entity.boxes.box3.show_news_notes"
    }],
    attrs: {
      "id": "box3-show-news-notes",
      "type": "checkbox",
      "disabled": _vm.entity.boxes.box3.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_news_notes) ? _vm._i(_vm.entity.boxes.box3.show_news_notes, null) > -1 : (_vm.entity.boxes.box3.show_news_notes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_news_notes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-show-announcements"
    }
  }, [_vm._v("Show Announcements")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_announcements),
      expression: "entity.boxes.box3.show_announcements"
    }],
    attrs: {
      "id": "box3-show-announcements",
      "type": "checkbox",
      "disabled": (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box3.show_announcements) ||
        _vm.entity.boxes.box3.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_announcements) ? _vm._i(_vm.entity.boxes.box3.show_announcements, null) > -1 : (_vm.entity.boxes.box3.show_announcements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_announcements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_announcements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_announcements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_announcements", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box3.show_announcements) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one announcements list\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_images_slider),
      expression: "entity.boxes.box3.show_images_slider"
    }],
    attrs: {
      "id": "box3-include-slider",
      "type": "checkbox",
      "disabled": (_vm.isImagesSliderSelected && !_vm.entity.boxes.box3.show_images_slider) ||
        _vm.entity.boxes.box3.show_announcements || _vm.entity.boxes.box3.show_news_notes
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_images_slider) ? _vm._i(_vm.entity.boxes.box3.show_images_slider, null) > -1 : (_vm.entity.boxes.box3.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isImagesSliderSelected && !_vm.entity.boxes.box3.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one image slider\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noteShown),
      expression: "noteShown"
    }],
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "saving-alerts"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.noteShown = !_vm.noteShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('strong', [_vm._v("Note:")]), _vm._v(" "), _c('p', [_vm._v("Please use a valid link")]), _vm._v(" "), _c('strong', [_vm._v("Example:")]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "facebookLink"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.facebook),
      expression: "entity.boxes.box4.socials.facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "facebookLink",
      "type": "text",
      "placeholder": "Enter Facebook link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "facebook", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "instaLink"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.instagram),
      expression: "entity.boxes.box4.socials.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "instaLink",
      "type": "text",
      "placeholder": "Enter Instagram link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "instagram", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "twitterLink"
    }
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.twitter),
      expression: "entity.boxes.box4.socials.twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "twitterLink",
      "type": "text",
      "placeholder": "Enter Twitter link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "twitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "pinterestLink"
    }
  }, [_vm._v("Pinterest")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.pinterest),
      expression: "entity.boxes.box4.socials.pinterest"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pinterestLink",
      "type": "text",
      "placeholder": "Enter Pinterest link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.pinterest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "pinterest", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink1"
    }
  }, [_vm._v("Youtube Video or Playlist 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube1),
      expression: "entity.boxes.box4.socials.youtube1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink1",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink2"
    }
  }, [_vm._v("Youtube Video or Playlist 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube2),
      expression: "entity.boxes.box4.socials.youtube2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink2",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink3"
    }
  }, [_vm._v("Youtube Video or Playlist 3")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube3),
      expression: "entity.boxes.box4.socials.youtube3"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink3",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box4-show-announcements"
    }
  }, [_vm._v("Show Announcements")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.show_announcements),
      expression: "entity.boxes.box4.show_announcements"
    }],
    attrs: {
      "id": "box4-show-announcements",
      "type": "checkbox",
      "disabled": (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box4.show_announcements) ||
        _vm.entity.boxes.box4.show_images_slider ||
        _vm.socialsExist
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box4.show_announcements) ? _vm._i(_vm.entity.boxes.box4.show_announcements, null) > -1 : (_vm.entity.boxes.box4.show_announcements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box4.show_announcements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box4, "show_announcements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box4, "show_announcements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box4, "show_announcements", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.entity.boxes.box4.show_announcements) ? _c('div', {
    staticClass: "col-md-12 mt-2"
  }) : _vm._e(), _vm._v(" "), (_vm.socialsExist) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Use either socials or announcements\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.isAnnouncementsSelected &&
    !_vm.entity.boxes.box4.show_announcements) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Please use one announcements list\n                                ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box4-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.show_images_slider),
      expression: "entity.boxes.box4.show_images_slider"
    }],
    attrs: {
      "id": "box4-include-slider",
      "type": "checkbox",
      "disabled": (_vm.isImagesSliderSelected && !_vm.entity.boxes.box4.show_images_slider) ||
        _vm.entity.boxes.box4.show_announcements ||
        _vm.socialsExist
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box4.show_images_slider) ? _vm._i(_vm.entity.boxes.box4.show_images_slider, null) > -1 : (_vm.entity.boxes.box4.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box4.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.socialsExist) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Use either socials or image slider\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.isImagesSliderSelected &&
    !_vm.entity.boxes.box4.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Please use one image slider\n                                ")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])])]) : _c('div', [_vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 1")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 2")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 3")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 4")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                              For url\n                              "), _c('strong', [_vm._v(" https://www.facebook.com/ellenwhiteestate ")]), _vm._v("\n                              a valid link is "), _c('strong', [_vm._v("ellenwhiteestate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("There are no sections for this branch yet.")])])])
}]}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Collection *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audioCollections,
      "search-function": _vm.collectionSearch,
      "label": "name"
    },
    model: {
      value: (_vm.entity.collection),
      callback: function($$v) {
        _vm.$set(_vm.entity, "collection", $$v)
      },
      expression: "entity.collection"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Audio Album has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Audio Album")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unfinished-item"
  }, [_c('div', {
    staticClass: "unfinished-item__file"
  }, [_c('p', {
    staticClass: "unfinished-item__file-name"
  }, [_vm._v(_vm._s(_vm.fileId))]), _vm._v(" "), _c('p', {
    staticClass: "unfinished-item__file-extension"
  }, [_vm._v(_vm._s(_vm.fileExt))])]), _vm._v(" "), _c('div', {
    staticClass: "file-info__controls"
  }, [_c('button', {
    staticClass: "button unfinished-item__file-check",
    on: {
      "click": _vm.onClick
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button unfinished-item__file-check",
    on: {
      "click": _vm.onRemoveClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticClass: "unfinished-item__hidden-input",
    attrs: {
      "type": "file",
      "accept": _vm.acceptedFiles
    },
    on: {
      "change": _vm.onFileChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "pagination-wrap text-left"
  }, [((_vm.totalPages > 1)) ? _c('ul', {
    staticClass: "pagination"
  }, [(_vm.hasPrev()) ? _c('li', {
    staticClass: "pagination__left",
    class: {
      disabled: !_vm.hasPrev()
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.prevPage)
      }
    }
  }, [_vm._v("Prev")])]) : _vm._e(), _vm._v(" "), (_vm.hasFirst()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("1")])]) : _vm._e(), _vm._v(" "), (_vm.hasFirst()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      key: page,
      class: {
        active: _vm.currentPage == page
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page) + "\n      ")])])
  }), _vm._v(" "), (_vm.hasLast()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.hasLast()) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.totalPages)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.totalPages) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pagination__right"
  }, [(_vm.hasNext()) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.nextPage)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title",
      "title": "CMS specific field. This will appear on a search page as a snippet title."
    }
  }, [_vm._v("\n                  Content type title*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "salutation"
    }
  }, [_vm._v("Salutation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.salutation),
      expression: "entity.name.salutation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "salutation",
      "type": "text",
      "placeholder": "Enter salutation"
    },
    domProps: {
      "value": (_vm.entity.name.salutation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "salutation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.first_name),
      expression: "entity.name.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "first_name",
      "type": "text",
      "placeholder": "Enter first name"
    },
    domProps: {
      "value": (_vm.entity.name.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "middle_name"
    }
  }, [_vm._v("Middle name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.middle_name),
      expression: "entity.name.middle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "middle_name",
      "type": "text",
      "placeholder": "Enter middle name"
    },
    domProps: {
      "value": (_vm.entity.name.middle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "middle_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.last_name),
      expression: "entity.name.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "last_name",
      "type": "text",
      "placeholder": "Enter last name"
    },
    domProps: {
      "value": (_vm.entity.name.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "maiden_name"
    }
  }, [_vm._v("Maiden name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.maiden_name),
      expression: "entity.name.maiden_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "maiden_name",
      "type": "text",
      "placeholder": "Enter maiden name"
    },
    domProps: {
      "value": (_vm.entity.name.maiden_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "maiden_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "maiden_name"
    }
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.suffix),
      expression: "entity.name.suffix"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "suffix",
      "type": "text",
      "placeholder": "Enter suffix"
    },
    domProps: {
      "value": (_vm.entity.name.suffix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "suffix", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "full_name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.full_name),
      expression: "entity.name.full_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "full_name",
      "type": "text",
      "placeholder": "Enter full name"
    },
    domProps: {
      "value": (_vm.entity.name.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "full_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "generic_name"
    }
  }, [_vm._v("Nickname")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.generic_name),
      expression: "entity.name.generic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "generic_name",
      "type": "text",
      "placeholder": "Enter generic name"
    },
    domProps: {
      "value": (_vm.entity.name.generic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "generic_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.gender),
      expression: "entity.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.genderOptions), function(item, index) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                      " + _vm._s(index) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Birthday date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('birthday_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.birthday_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "birthday_date", $$v)
      },
      expression: "entity.birthday_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Death date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('death_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.death_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "death_date", $$v)
      },
      expression: "entity.death_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Marriage date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('marriage_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.marriage_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "marriage_date", $$v)
      },
      expression: "entity.marriage_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "degree"
    }
  }, [_vm._v("Academic degree")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.position.degree),
      expression: "entity.position.degree"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "degree",
      "type": "text",
      "placeholder": "Enter academic degree"
    },
    domProps: {
      "value": (_vm.entity.position.degree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.position, "degree", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "institution"
    }
  }, [_vm._v("Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.position.institution),
      expression: "entity.position.institution"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "institution",
      "type": "text",
      "placeholder": "Enter institution"
    },
    domProps: {
      "value": (_vm.entity.position.institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.position, "institution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Bio")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "bio"
    },
    model: {
      value: (_vm.entity.bio),
      callback: function($$v) {
        _vm.$set(_vm.entity, "bio", $$v)
      },
      expression: "entity.bio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.avatarUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Person has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create person")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent menu-edit-wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.source.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuName),
      expression: "menuName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter menu name",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.menuName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.menuName = $event.target.value
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.orderChanged) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Items order changed. Don't forget to save it!\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-builder"
  }, [_c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToTop
    }
  }, [_vm._v("Add item")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-builder-inner"
  }, [_c('ul', _vm._l((_vm.menuTree), function(item) {
    return _c('menu-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1)]), _vm._v(" "), (_vm.menuTree.length > 5) ? _c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToBottom
    }
  }, [_vm._v("Add item")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success save-menu",
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Data saved successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.saveErrorMessage))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Builder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder-item-template",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": ""
    }
  }, [_c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-img"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data"
  }, [_c('div', {
    staticClass: "menu-builder__item-data-row _id"
  }, [_c('b', [_vm._v("ID:")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _title"
  }, [_c('b', [_vm._v("Title:")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _url"
  }, [_c('b', [_vm._v("Url:")]), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-open"
  }, [_vm._v("Open")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])])])])])
}]}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Vocabulary *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.vocabularyOptionsDefault,
      "search-function": _vm.vocabularySearch,
      "label": "name"
    },
    model: {
      value: (_vm.entity.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "vocabulary", $$v)
      },
      expression: "entity.vocabulary"
    }
  })], 1)]), _vm._v(" "), (_vm.entity.vocabulary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Parent Term")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "filterable": false,
      "options": _vm.parentOptions
    },
    on: {
      "search": _vm.onParentSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }], null, false, 2548199629),
    model: {
      value: (_vm.entity.parent),
      callback: function($$v) {
        _vm.$set(_vm.entity, "parent", $$v)
      },
      expression: "entity.parent"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n                      No results. Type to search...\n                    ")])], 2)], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Term has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Term")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Redirects') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Redirects\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/redirects/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.destination))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'RedirectsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'redirects/', 'Redirect')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Destination")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Documents")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'QaManageDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Manage Documents\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                  Documents which will add to Questions and Answers:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedDocs), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteDoc(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by document title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceDocs), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.shortTitle(item.title)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addDoc(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                      There are no items on your request\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Docs\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Docs have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Questions and Answers")])])])])
}]}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "news-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-news-body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select File\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-publish"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.publish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "publish_date", $$v)
      },
      expression: "entity.publish_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-unpublish"
    }
  }, [_vm._v("Unpublish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.unpublish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "unpublish_date", $$v)
      },
      expression: "entity.unpublish_date"
    }
  })], 1)])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          News modified successfully!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Edit News Notes")])])
}]}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-parent"
  }, [(_vm.$route.name == 'Editors Picks') ? _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.picks), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": item.url
      }
    }, [_vm._v("\n                    Edit\n                  ")])], 1)])
  }), 0)])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Editor's Picks")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "text"
    },
    model: {
      value: (_vm.entity.text),
      callback: function($$v) {
        _vm.$set(_vm.entity, "text", $$v)
      },
      expression: "entity.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("File *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.fileChanged,
      "vdropzone-file-added": _vm.fileChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Document Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.df,
      "search-function": _vm.docFilesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.document_files),
      callback: function($$v) {
        _vm.$set(_vm.entity, "document_files", $$v)
      },
      expression: "entity.document_files"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Questions and Answers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.qa,
      "search-function": _vm.qaSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.questions_and_answers),
      callback: function($$v) {
        _vm.$set(_vm.entity, "questions_and_answers", $$v)
      },
      expression: "entity.questions_and_answers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "author"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.peopleSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.author),
      callback: function($$v) {
        _vm.$set(_vm.entity, "author", $$v)
      },
      expression: "entity.author"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "author"
    }
  }, [_vm._v("Receiver")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.peopleSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receiver),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receiver", $$v)
      },
      expression: "entity.receiver"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Document has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Document")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Question *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.question),
      expression: "entity.question"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter question"
    },
    domProps: {
      "value": (_vm.entity.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "question", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Answer *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.answer),
      expression: "entity.answer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "answer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n                      True\n                    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n                      False\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Explanation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.explanation),
      expression: "entity.explanation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter explanation"
    },
    domProps: {
      "value": (_vm.entity.explanation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "explanation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("More Info Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.more_info),
      expression: "entity.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter text"
    },
    domProps: {
      "value": (_vm.entity.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "more_info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("More Info Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.link),
      expression: "entity.link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.entity.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "link", $event.target.value)
      }
    }
  })])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Quiz question added successfully!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Add quiz question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("letterbooks/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Pdf")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptionsPdf) ? _c('dropzone', {
    ref: "dropzonePdf",
    attrs: {
      "id": "pdf-uploader",
      "options": _vm.dropzoneOptionsPdf,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.pdfAdded,
      "vdropzone-removed-file": _vm.pdfRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Pdf transcription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptionsPdfText) ? _c('dropzone', {
    ref: "dropzonePdfText",
    attrs: {
      "id": "pdf-text-uploader",
      "options": _vm.dropzoneOptionsPdfText,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.pdfTextAdded,
      "vdropzone-removed-file": _vm.pdfTextRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Letterbook has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Order Video")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesManageVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Video\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('SlickList', {
    staticClass: "slicksort-wrap",
    attrs: {
      "lock-axis": "y"
    },
    model: {
      value: (_vm.tracks),
      callback: function($$v) {
        _vm.tracks = $$v
      },
      expression: "tracks"
    }
  }, _vm._l((_vm.tracks), function(track, index) {
    return _c('SlickItem', {
      key: index,
      staticClass: "slicksort-item",
      attrs: {
        "index": index
      }
    }, [_vm._v("\n            " + _vm._s(track.title) + "\n          ")])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    ref: "saveBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Order has changed successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Video Series")])])])
}]}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": _vm.content.id
    }
  }, [(_vm.isReady) ? _c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.entity.name))])]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.entity.children && _vm.entity.children.length) ? _c('ul', _vm._l((_vm.content.children), function(item) {
    return _c('term-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])
}]}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sectionsList), function(sectionName, index) {
    return _c('home-section', {
      key: sectionName,
      attrs: {
        "id": index + 1,
        "name": sectionName,
        "content-props": _vm.contentList[index + 1],
        "loading": _vm.isLoading
      }
    })
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Featured Content")])])])
}]}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "news-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-news-body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                        Select File\n                      ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-publish"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    ref: "datePckr",
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.publish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "publish_date", $$v)
      },
      expression: "entity.publish_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news-unpublish"
    }
  }, [_vm._v("Unpublish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.unpublish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "unpublish_date", $$v)
      },
      expression: "entity.unpublish_date"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n      "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        News modified successfully!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.saveErrorMessage) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Create News Notes")])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Robots file content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.data),
      expression: "entity.data"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "robots_text",
      "rows": "30"
    },
    domProps: {
      "value": (_vm.entity.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "data", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Robots file was changed\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Robots Settings")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage Videos")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'VideoSeriesAddVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Add new Video\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'VideoSeriesOrderVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Order Videos\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Back to General\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Video title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.total) ? _c('tbody', _vm._l((_vm.videos), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('img', {
      staticStyle: {
        "max-height": "150px"
      },
      attrs: {
        "src": item.thumbnail,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'VideoEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.detachVideo(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0) : _c('tbody', [_vm._m(2)])])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Video Series")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    There are no video yet. Go to 'Add New Video' to add new ones.\n                  ")])])
}]}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Media *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    attrs: {
      "check-type": "media_image",
      "path-prefix": "img",
      "dropzone-options": _vm.dropzoneOptions
    },
    model: {
      value: (_vm.imageFile),
      callback: function($$v) {
        _vm.imageFile = $$v
      },
      expression: "imageFile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Galleries")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.galleries,
      "search-function": _vm.galleriesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.galleries),
      callback: function($$v) {
        _vm.$set(_vm.entity, "galleries", $$v)
      },
      expression: "entity.galleries"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Image has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.summary),
      expression: "entity.summary"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "summary",
      "placeholder": "Enter summary"
    },
    domProps: {
      "value": (_vm.entity.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "summary", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.changeCover
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.filesChanged,
      "vdropzone-file-added": _vm.filesChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Image Gallery has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Site Page")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vocabulary-terms-component"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Terms in vocabulary")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VocabularyOrder',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n        Manage order\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal spinner-parent"
  }, [_c('spinner', {
    ref: "termsSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.terms.isReady) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms.searchQuery),
      expression: "terms.searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by term title"
    },
    domProps: {
      "value": (_vm.terms.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.terms, "searchQuery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "terms-table table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), (_vm.terms.list.length) ? _c('tbody', _vm._l((_vm.terms.list), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "term-edit-wrap _static"
    }, [_c('span', {
      staticClass: "term-edit-span"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "term-edit-wrap _editing",
      staticStyle: {
        "display": "none"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "term-edit-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.saveTerm(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          return _vm.saveTerm(item)
        }
      }
    }, [_vm._v("\n                        Save "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary term-btn-edit",
      on: {
        "click": function($event) {
          return _vm.editTerm(item)
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary term-btn-cancel-edit",
      staticStyle: {
        "display": "none"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEditTerm(item)
        }
      }
    }, [_vm._v("\n                      Cancel Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteTerm(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0) : _c('tbody', [_vm._m(1)])]), _vm._v(" "), (_vm.terms.total === 0) ? _c('div', [_vm._v("There are no Terms")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.terms.pager.total,
      "offset": _vm.terms.pager.offset,
      "size": _vm.terms.pager.perPage
    },
    on: {
      "page-changed": _vm.changeTermsPage
    }
  })], 1)])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms.newTermName),
      expression: "terms.newTermName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "new_term",
      "type": "text",
      "placeholder": "Enter term name"
    },
    domProps: {
      "value": (_vm.terms.newTermName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.terms, "newTermName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-term-create",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createTerm
    }
  }, [_vm._v("\n                Create\n                "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "terms-saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.terms.termCreateError === 'ok') ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                  Term has created successful!\n                ")]) : (_vm.terms.termCreateError !== '') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                  " + _vm._s(_vm.terms.termCreateError) + "\n                ")]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("There are no content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Create new term in vocabulary")])])
}]}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$parent.allowPublishing || (_vm.showIndexBtn && _vm.$parent.allowSearchAdministration) || _vm.$parent.allowDeleting) ? _c('div', {
    staticClass: "card-block small-paddings bulk-btns"
  }, [(_vm.$parent.allowPublishing) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.unpublishEmpty
    }
  }, [_vm._v("\n    Unpublish Empty "), _c('span', {
    ref: "unpublishEmptyLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-area"
  }, [(_vm.$parent.allowPublishing) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("\n      Publish Choosen "), _c('span', {
    ref: "bulkPublishLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$parent.allowPublishing) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.unpublish
    }
  }, [_vm._v("\n      Unpublish Choosen "), _c('span', {
    ref: "bulkUnpublishLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showIndexBtn && _vm.$parent.allowSearchAdministration) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.addToIndex
    }
  }, [_vm._v("\n      Add to Index "), _c('span', {
    ref: "bulkSearchIndexLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$parent.allowDeleting) ? _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": _vm.deleteEntities
    }
  }, [_vm._v("\n      Delete Choosen "), _c('span', {
    ref: "bulkDeleteLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit redirect with id " + _vm._s(_vm.source.id))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Source *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.source),
      expression: "entity.source"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "source",
      "type": "text",
      "placeholder": "Enter source"
    },
    domProps: {
      "value": (_vm.entity.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "source", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Destination *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.destination),
      expression: "entity.destination"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "destination",
      "type": "text",
      "placeholder": "Enter destination"
    },
    domProps: {
      "value": (_vm.entity.destination)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "destination", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Redirect has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'SitePages') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Site Pages\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/site-pages/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Image Gallery title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'SitePagesEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'site-pages/', 'Site Page')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Short title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.short_title),
      expression: "entity.short_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "short_title",
      "type": "text",
      "placeholder": "Enter short title"
    },
    domProps: {
      "value": (_vm.entity.short_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "short_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.filesChanged,
      "vdropzone-file-added": _vm.filesChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("News has created successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create News")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "upload__button-row"
  }, [_c('UploadManagerButton', {
    attrs: {
      "progress": _vm.generalProgress,
      "uploads-count": _vm.uploads.length,
      "button-text": _vm.uploadsButtonText,
      "is-open": _vm.isUploadsOpen,
      "general-status": _vm.generalStatus
    },
    on: {
      "click": _vm.onUploadsButtonClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-upload open__text-icon mr-20",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.unfinishedUploads.length || _vm.isUnfinishedUploadsOpen) ? _c('UnfinishedUploadsButton', {
    attrs: {
      "uploads-count": _vm.unfinishedUploads.length,
      "button-text": _vm.unfinishedButtonText,
      "is-open": _vm.isUnfinishedUploadsOpen
    },
    on: {
      "click": _vm.onUnfinishedButtonClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "upload__lists-wrap"
  }, [_c('UploadsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploadsOpen),
      expression: "isUploadsOpen"
    }],
    attrs: {
      "uploads": _vm.uploads,
      "is-open": _vm.isUploadsOpen
    },
    on: {
      "stop": _vm.onStopUploadClicked,
      "resume": _vm.onResumeUploadClicked,
      "pause": _vm.onPauseUploadClicked,
      "retry": _vm.onRetryUploadClicked,
      "remove": _vm.onRemoveClicked,
      "hide": _vm.onHideClicked
    }
  }), _vm._v(" "), _c('UnfinishedList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUnfinishedUploadsOpen),
      expression: "isUnfinishedUploadsOpen"
    }],
    attrs: {
      "is-open": _vm.isUnfinishedUploadsOpen,
      "unfinished-uploads": _vm.unfinishedUploads
    },
    on: {
      "file-selected": _vm.onFileReselected,
      "hide": _vm.onUnfinishedHideClicked,
      "remove-clicked": _vm.onUnfinishedRemoveClicked
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'LocationList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Locations\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/location/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('location')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('location', 'Locations')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by location title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "location",
      "unpublish-empty-endpoint": "locations/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('location', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'LocationEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'location', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'location', 'Location')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'locations/', 'Location')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'PublicationList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Publications\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/publication/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('publication')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('publication', 'Publications')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by publication title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "publication",
      "unpublish-empty-endpoint": "publications/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('publication', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'PublicationEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'publication', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'publication', 'Publication')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'publications/', 'Publication')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-button"
  }, [_c('button', {
    staticClass: "button open danger",
    on: {
      "click": _vm.onClick
    }
  }, [_c('p', {
    staticClass: "open__text"
  }, [_vm._t("default"), _vm._v("\n      " + _vm._s((_vm.buttonText + " (" + _vm.uploadsCount + ")")) + "\n      "), (_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-caret-up open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Publication has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Publication")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Issues and Answer has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Issue And Answer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Memory Game') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Memory Game\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/memory-game-images/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by memory game image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.images), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.adaptUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/memory-game-images/edit/" + (item.id))
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'games/memory/', 'Memory Game')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'AudioList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Audio\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_audio/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('media_audio')
      }
    }
  }, [_vm._v("\n            Add all to search index "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_audio', 'Audio')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by audio title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_audio",
      "unpublish-empty-endpoint": "media/audio/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.validateUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('media_audio', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'AudioEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_audio', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_audio', 'Audio')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/audio/', 'Audio')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_audio')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_audio')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "form-control datepicker-input",
    class: {
      'with-reset-button': _vm.clearButton
    },
    style: ({
      width: _vm.width
    }),
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "click": _vm.inputClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar datepicker-calendar",
    on: {
      "click": _vm.inputClick
    }
  })]), _vm._v(" "), (_vm.clearButton && _vm.val) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.val = ''
      }
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayDayView),
      expression: "displayDayView"
    }],
    staticClass: "datepicker-popup"
  }, [_c('div', {
    staticClass: "datepicker-inner"
  }, [_c('div', {
    staticClass: "datepicker-body"
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    class: _vm.preBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextMonthClick(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.nextBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextMonthClick(1)
      }
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.switchMonthView
    }
  }, [_vm._v(_vm._s(_vm.stringifyDayHeader(_vm.currDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "datepicker-weekRange"
  }, _vm._l((_vm.text.daysOfWeek), function(w) {
    return _c('span', {
      key: w
    }, [_vm._v(_vm._s(w))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "datepicker-dateRange"
  }, _vm._l((_vm.dateRange), function(d) {
    return _c('span', {
      key: d.date.getTime(),
      class: d.sclass,
      on: {
        "click": function($event) {
          return _vm.daySelect(d)
        }
      }
    }, [_vm._v("\n            " + _vm._s(d.text) + "\n          ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayMonthView),
      expression: "displayMonthView"
    }],
    staticClass: "datepicker-popup"
  }, [_c('div', {
    staticClass: "datepicker-inner"
  }, [_c('div', {
    staticClass: "datepicker-body"
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    class: _vm.preBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextYearClick(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.nextBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextYearClick(1)
      }
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.switchDecadeView
    }
  }, [_vm._v(_vm._s(_vm.stringifyYearHeader(_vm.currDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "datepicker-monthRange"
  }, [_vm._l((_vm.text.months), function(m, index) {
    return [_c('span', {
      key: m,
      class: {
        'datepicker-dateRange-item-active': (_vm.text.months[_vm.parse(_vm.val).getMonth()] === m) &&
          _vm.currDate.getFullYear() === _vm.parse(_vm.val).getFullYear()
      },
      domProps: {
        "textContent": _vm._s(m.substr(0, 3))
      },
      on: {
        "click": function($event) {
          return _vm.monthSelect(index)
        }
      }
    })]
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayYearView),
      expression: "displayYearView"
    }],
    staticClass: "datepicker-popup"
  }, [_c('div', {
    staticClass: "datepicker-inner"
  }, [_c('div', {
    staticClass: "datepicker-body"
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    class: _vm.preBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextDecadeClick(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.nextBtnClasses,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.preNextDecadeClick(1)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.stringifyDecadeHeader(_vm.currDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "datepicker-monthRange decadeRange"
  }, [_vm._l((_vm.decadeRange), function(decade) {
    return [_c('span', {
      key: decade.text,
      class: {
        'datepicker-dateRange-item-active': _vm.parse(_vm.val).getFullYear() === decade.text
      },
      domProps: {
        "textContent": _vm._s(decade.text)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.yearSelect(decade.text)
        }
      }
    })]
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.content.basename
    }
  }, [_vm._v(_vm._s(_vm.content.basename))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link",
    on: {
      "click": _vm.attachFile
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.title) + "\n            "), _c('open-on-site', {
    attrs: {
      "source-route": 'staff#' + _vm.source.id
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "Description"
    },
    model: {
      value: (_vm.entity.description),
      callback: function($$v) {
        _vm.$set(_vm.entity, "description", $$v)
      },
      expression: "entity.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.avatarUrl
    },
    on: {
      "changeFile": _vm.changeAvatar,
      "returnedOldFile": _vm.avatarRestore,
      "existingFileRemoved": _vm.avatarRemove
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Data saved successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.saveErrorMessage))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "http://coreui.io"
    }
  }, [_vm._v("\n    CoreUI\n  ")]), _vm._v("\n  © " + _vm._s(_vm.getYear()) + " creativeLabs.\n  "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-right"
  }, [_vm._v("\n    Powered by\n    "), _c('a', {
    attrs: {
      "href": "http://coreui.io"
    }
  }, [_vm._v("\n      CoreUI\n    ")])])
}]}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.choosen.terms && _vm.choosen.terms.length) ? _c('div', {
    staticClass: "terms-list"
  }, _vm._l((_vm.choosen.vocabularies), function(vocabulary) {
    return _c('div', {
      key: vocabulary.id,
      staticClass: "terms-group form-group clearfix"
    }, [_c('label', {
      staticClass: "terms-group-name pull-left"
    }, [_vm._v("\n                Vocabulary\n                "), _c('strong', [_vm._v("\"" + _vm._s(vocabulary.name) + "\":")])]), _vm._v(" "), _vm._l((_vm.choosen.terms), function(term) {
      return [(term.vocabularyId === vocabulary.id) ? _c('span', {
        key: term.id,
        staticClass: "terms-badge badge badge-pill badge-info"
      }, [_vm._v("\n                  " + _vm._s(term.name) + "\n                  "), _c('span', {
        staticClass: "badge-delete-icon terms-badge-close",
        on: {
          "click": function($event) {
            return _vm.deleteTerm(term.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])]) : _vm._e()]
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Vocabulary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.vocabulariesOptionsDefault,
      "search-function": _vm.vocabularySearch,
      "label": "name"
    },
    model: {
      value: (_vm.newTerm.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.newTerm, "vocabulary", $$v)
      },
      expression: "newTerm.vocabulary"
    }
  })], 1)]), _vm._v(" "), (_vm.newTerm.vocabulary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Terms")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.termsLoading) ? _c('spinner', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "sm"
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-select', {
    ref: "refTermsModel",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.newTerm.termsOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onTermsSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n                  " + _vm._s(option.name) + "\n                ")]
      }
    }], null, false, 3155861965),
    model: {
      value: (_vm.newTerm.terms),
      callback: function($$v) {
        _vm.$set(_vm.newTerm, "terms", $$v)
      },
      expression: "newTerm.terms"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n                  type to search...\n                ")])], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.newTerm.vocabulary && _vm.newTerm.terms && _vm.newTerm.terms.length) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addNewTerms
    }
  }, [_vm._v("Add")])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Taxonomy")])])
}]}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title",
      "title": "CMS specific field. This will appear on a search page as a snippet title."
    }
  }, [_vm._v("\n                  Content type title*\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "salutation"
    }
  }, [_vm._v("Salutation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.salutation),
      expression: "entity.name.salutation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "salutation",
      "type": "text",
      "placeholder": "Enter salutation"
    },
    domProps: {
      "value": (_vm.entity.name.salutation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "salutation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.first_name),
      expression: "entity.name.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "first_name",
      "type": "text",
      "placeholder": "Enter first name"
    },
    domProps: {
      "value": (_vm.entity.name.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "middle_name"
    }
  }, [_vm._v("Middle name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.middle_name),
      expression: "entity.name.middle_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "middle_name",
      "type": "text",
      "placeholder": "Enter middle name"
    },
    domProps: {
      "value": (_vm.entity.name.middle_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "middle_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.last_name),
      expression: "entity.name.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "last_name",
      "type": "text",
      "placeholder": "Enter last name"
    },
    domProps: {
      "value": (_vm.entity.name.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "maiden_name"
    }
  }, [_vm._v("Maiden name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.maiden_name),
      expression: "entity.name.maiden_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "maiden_name",
      "type": "text",
      "placeholder": "Enter maiden name"
    },
    domProps: {
      "value": (_vm.entity.name.maiden_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "maiden_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "maiden_name"
    }
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.suffix),
      expression: "entity.name.suffix"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "suffix",
      "type": "text",
      "placeholder": "Enter suffix"
    },
    domProps: {
      "value": (_vm.entity.name.suffix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "suffix", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "full_name"
    }
  }, [_vm._v("Full name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.full_name),
      expression: "entity.name.full_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "full_name",
      "type": "text",
      "placeholder": "Enter full name"
    },
    domProps: {
      "value": (_vm.entity.name.full_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "full_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "generic_name"
    }
  }, [_vm._v("Nickname")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name.generic_name),
      expression: "entity.name.generic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "generic_name",
      "type": "text",
      "placeholder": "Enter generic name"
    },
    domProps: {
      "value": (_vm.entity.name.generic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.name, "generic_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.gender),
      expression: "entity.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.genderOptions), function(item, index) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                      " + _vm._s(index) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Birthday date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('birthday_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.birthday_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "birthday_date", $$v)
      },
      expression: "entity.birthday_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Death date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('death_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.death_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "death_date", $$v)
      },
      expression: "entity.death_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Marriage date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('marriage_date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.marriage_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "marriage_date", $$v)
      },
      expression: "entity.marriage_date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "degree"
    }
  }, [_vm._v("Academic degree")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.position.degree),
      expression: "entity.position.degree"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "degree",
      "type": "text",
      "placeholder": "Enter academic degree"
    },
    domProps: {
      "value": (_vm.entity.position.degree)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.position, "degree", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "institution"
    }
  }, [_vm._v("Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.position.institution),
      expression: "entity.position.institution"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "institution",
      "type": "text",
      "placeholder": "Enter institution"
    },
    domProps: {
      "value": (_vm.entity.position.institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.position, "institution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Bio")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "bio"
    },
    model: {
      value: (_vm.entity.bio),
      callback: function($$v) {
        _vm.$set(_vm.entity, "bio", $$v)
      },
      expression: "entity.bio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.avatarUrl
    },
    on: {
      "changeFile": _vm.changeAvatar,
      "returnedOldFile": _vm.avatarRestore,
      "existingFileRemoved": _vm.avatarRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("people/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'DocumentFilesList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Document Files\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/document_files/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('documentFiles')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('documentFiles', 'Document Files')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by document files title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "document_files",
      "unpublish-empty-endpoint": "media/document-files/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("File Number")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.file_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('documentFiles', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'DocumentFilesEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'document_files', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'document_files', 'Document files')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/document-files/', 'Document files')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("news/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Short title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.teaser.short_title),
      expression: "entity.teaser.short_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "short_title",
      "type": "text",
      "placeholder": "Enter short title"
    },
    domProps: {
      "value": (_vm.entity.teaser.short_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.teaser, "short_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          News has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Menu') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Menus\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": {
        name: 'MenuNew',
        params: {
          isNew: true
        }
      }
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Menu name"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'MenuEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), (item.name !== _vm.mainMenu) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteEntity(item.id)
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Question *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.question),
      expression: "entity.question"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter question"
    },
    domProps: {
      "value": (_vm.entity.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "question", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Answer *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.answer),
      expression: "entity.answer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "answer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n                      True\n                    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n                      False\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Explanation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.explanation),
      expression: "entity.explanation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter explanation"
    },
    domProps: {
      "value": (_vm.entity.explanation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "explanation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("More Info Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.more_info),
      expression: "entity.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter text"
    },
    domProps: {
      "value": (_vm.entity.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "more_info", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("More Info Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.link),
      expression: "entity.link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.entity.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "link", $event.target.value)
      }
    }
  })])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Quiz question updated successfully!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit quiz question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/video-series/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesManageVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Videos\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl,
      "removable": false
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Video Series has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "announcement-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-announcement-body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                        Select File\n                      ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-publish"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.publish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "publish_date", $$v)
      },
      expression: "entity.publish_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-unpublish"
    }
  }, [_vm._v("Unpublish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.unpublish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "unpublish_date", $$v)
      },
      expression: "entity.unpublish_date"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n      "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        Announcements modified successfully!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.saveErrorMessage) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Create Announcements")])])
}]}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('h1', [_vm._v("Two Factor Authentication")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Enter the pin from Google Authenticator app:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeFromGoogle),
      expression: "codeFromGoogle"
    }],
    ref: "codeInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "One Time Password"
    },
    domProps: {
      "value": (_vm.codeFromGoogle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeFromGoogle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                    Login\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-envelope"
  })])
}]}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'GalleryList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Image Galleries\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_image_gallery/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_image_gallery', 'Image Galleries')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Image Gallery title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_image_gallery",
      "unpublish-empty-endpoint": "media/image-galleries/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'GalleryEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_image_gallery', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_image_gallery', 'Image Gallery')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/image-galleries/', 'Image Gallery')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "file_number"
    }
  }, [_vm._v("File Number *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.file_number),
      expression: "entity.file_number"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "file_number",
      "type": "text",
      "placeholder": "Enter file number"
    },
    domProps: {
      "value": (_vm.entity.file_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "file_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Document Files has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Document Files")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Choosen references")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('table', {
    staticClass: "references-table table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.choosenRefs.length) ? _c('tbody', _vm._l((_vm.choosenRefs), function(item) {
    return _c('tr', {
      key: item.type + item.id,
      attrs: {
        "data-id": item.type + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteRef(item)
        }
      }
    }, [_vm._v("Delete")])])])
  }), 0) : _c('tbody', [_vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Reference type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "options": _vm.refTypeOptions
    },
    model: {
      value: (_vm.refType),
      callback: function($$v) {
        _vm.refType = $$v
      },
      expression: "refType"
    }
  })], 1)]), _vm._v(" "), (_vm.refType) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Reference entity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    ref: "refEntityModel",
    attrs: {
      "multiple": "",
      "filterable": false,
      "options": _vm.refEntityOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onEntitySearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }], null, false, 1467187853),
    model: {
      value: (_vm.refEntity),
      callback: function($$v) {
        _vm.refEntity = $$v
      },
      expression: "refEntity"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n              type to search...\n            ")])], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.refType && _vm.refEntity && _vm.refEntity.length) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addRef
    }
  }, [_vm._v("Add")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("References")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Title")]), _vm._v(" "), _c('td', [_vm._v("Type")]), _vm._v(" "), _c('td', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("There are no content")])])
}]}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.is_person),
      expression: "entity.is_person"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "is_person", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.personTypes), function(type, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": type.isPerson
      }
    }, [_vm._v("\n                      " + _vm._s(type.text) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Reference Image")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.ref_id),
      expression: "entity.ref_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "ref_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('option', {
      key: image.id,
      domProps: {
        "value": image.id
      }
    }, [_vm._v("\n                      " + _vm._s(((image.id) + " " + (image.title))) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('MemoryQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Memory image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Add memory image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Years")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.date),
      expression: "entity.date"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "text",
      "placeholder": "Enter date years"
    },
    domProps: {
      "value": (_vm.entity.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Audio file *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    ref: "fileUploader",
    attrs: {
      "check-type": "media_audio",
      "path-prefix": "aud",
      "dropzone-options": _vm.dropzoneOptions
    },
    model: {
      value: (_vm.audioFile),
      callback: function($$v) {
        _vm.audioFile = $$v
      },
      expression: "audioFile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audioAlbums,
      "search-function": _vm.albumSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.album),
      callback: function($$v) {
        _vm.$set(_vm.entity, "album", $$v)
      },
      expression: "entity.album"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Transcription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.transcriptionSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.transcription),
      callback: function($$v) {
        _vm.$set(_vm.entity, "transcription", $$v)
      },
      expression: "entity.transcription"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Audio has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create audio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'VideoSeriesList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Video Series\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_video_series/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_video_series', 'Video Series')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Video Series title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_video_series",
      "unpublish-empty-endpoint": "media/video-series/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'VideoSeriesEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_video_series', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_video_series', 'Video Series')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/video-series/', 'Video Series')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.name) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save Vocabulary\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                    Vocabulary has modified successful!\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.saveErrorMessage) + "\n                  ")])])])])])])])]), _vm._v(" "), _c('Terms')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Vocabulary') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Vocabularies\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/taxonomy/vocabulary/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by vocabulary title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'VocabularyEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'vocabularies/', 'Vocabulary')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "smart-image"
  }, [_c('img', {
    staticClass: "load",
    attrs: {
      "src": "/static/img/loading.gif",
      "alt": "",
      "height": "30"
    }
  })])
}]}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'ImageList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Images\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_image/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('media_image')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_image', 'Images')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_image",
      "unpublish-empty-endpoint": "media/images/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.thumbnail) ? _c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('media_image', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'ImageEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_image', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_image', 'Image')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/images/', 'Image')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_image')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_image')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("locations/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.description),
      expression: "entity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Enter description"
    },
    domProps: {
      "value": (_vm.entity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.country),
      expression: "entity.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter country"
    },
    domProps: {
      "value": (_vm.entity.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.state),
      expression: "entity.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter state"
    },
    domProps: {
      "value": (_vm.entity.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.city),
      expression: "entity.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter city"
    },
    domProps: {
      "value": (_vm.entity.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address),
      expression: "entity.address.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "address",
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.entity.address.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "postal_code"
    }
  }, [_vm._v("Zip/Postal code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.postal_code),
      expression: "entity.address.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "postal_code",
      "type": "text",
      "placeholder": "Enter postal code"
    },
    domProps: {
      "value": (_vm.entity.address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "postal_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "organisation_name"
    }
  }, [_vm._v("Organisation name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.organisation_name),
      expression: "entity.address.organisation_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "organisation_name",
      "type": "text",
      "placeholder": "Enter organisation name"
    },
    domProps: {
      "value": (_vm.entity.address.organisation_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "organisation_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax),
      expression: "entity.contacts.fax"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email),
      expression: "entity.contacts.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone),
      expression: "entity.contacts.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [(_vm.entity.geocode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lat),
      expression: "entity.geocode.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lat", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.entity.geocode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lon),
      expression: "entity.geocode.lon"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lon", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.geocode) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.sourceMapData.center,
      "zoom": _vm.sourceMapData.zoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [_c('button', {
    staticClass: "pull-right btn btn-primary mt-2",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setOldGeocode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Return old geocode\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Location has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.path,
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.isContentPage) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      List of available content\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.contentTypes.children), function(type) {
    return _c('router-link', {
      key: type.name,
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "to": type.url
      }
    }, [_c('i', {
      class: type.icon
    }), _vm._v(" " + _vm._s(type.name) + "\n        ")])
  }), 1)])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'TopicList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Topics\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/topic/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('topic')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('topic', 'Topics')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by topic title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "topic",
      "unpublish-empty-endpoint": "topics/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('topic', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'TopicEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'topic', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'topic', 'Topic')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'topics/', 'Topic')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'PamphletList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Pamphlets\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/pamphlet/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('pamphlet')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('pamphlet', 'Pamphlets')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by pamphlet title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "pamphlet",
      "unpublish-empty-endpoint": "pamphlets/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('pamphlet', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'PamphletEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'pamphlet', 'Pamphlet')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'pamphlets/', 'Pamphlet')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      staticClass: "disabled",
      attrs: {
        "source-route": '/'
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block small-paddings empty-btns"
  }, [(!_vm.emptySearch) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.showEmpty
    }
  }, [_vm._v("\n    Search for Empty Entities "), _c('span', {
    ref: "showEmptyLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.showAll
    }
  }, [_vm._v("\n    Search for All Entities "), _c('span', {
    ref: "showAllLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "uploads__list unfinished-uploads__list"
  }, [_c('button', {
    staticClass: "button hide",
    on: {
      "click": _vm.onHideClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "unfinished-uploads__title"
  }, [_vm._v("Unfinished uploads list")]), _vm._v(" "), _c('p', {
    staticClass: "unfinished-uploads__info"
  }, [_vm._v("\n    You have unfinished uploads.\n    Probably, your browser was crashed or you're closed the page during file uploading.\n    Please, select file to continue upload or remove them from the list.\n  ")]), _vm._v(" "), (_vm.unfinishedUploads.length) ? _vm._l((_vm.unfinishedUploads), function(unfinishedItem) {
    return _c('ListItem', {
      key: unfinishedItem.id,
      attrs: {
        "filename": unfinishedItem.filename,
        "accepted-files": unfinishedItem.uploadParams.acceptedFiles || ''
      },
      on: {
        "file-selected": function($event) {
          return _vm.onFileSelected($event, unfinishedItem)
        },
        "remove-clicked": function($event) {
          return _vm.onRemoveClicked($event, unfinishedItem.id)
        }
      }
    })
  }) : _c('p', {
    staticClass: "unfinished-uploads__resolved"
  }, [_vm._v("All unfinished uploads are resolved.")])], 2)
},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      Dashboard content\n    ")]), _vm._v(" "), (_vm.menu) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.name,
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "item": item,
        "to": {
          path: ("" + (item.url))
        }
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n        ")])
  }), 1)]) : _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n      Content is empty for current user.\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), (_vm.imageLoaded) ? [_vm._l((_vm.presets), function(preset) {
    return _c('div', {
      key: preset.id,
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": preset.type
      }
    }, [_vm._v(_vm._s(preset.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.levels[preset.type]),
        expression: "entity.levels[preset.type]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ((preset.type) + "*")
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.entity.levels, preset.type, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.makeOptions(preset)), function(item, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])
    }), 0)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.default_level),
      expression: "entity.default_level"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "default_level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.presets), function(preset, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": preset.type
      }
    }, [_vm._v("\n                        " + _vm._s(preset.title) + "\n                      ")])
  }), 0)])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('PuzzleQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Puzzle image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Add puzzle image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.entity.puzzle.public_url,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), (_vm.imageLoaded) ? [_vm._l((_vm.presets), function(preset) {
    return _c('div', {
      key: preset.id,
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": preset.type
      }
    }, [_vm._v(_vm._s(preset.title) + " *")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.levels[preset.type]),
        expression: "entity.levels[preset.type]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ((preset.type) + "*")
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.entity.levels, preset.type, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.makeOptions(preset)), function(item, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                        " + _vm._s(item.text) + "\n                      ")])
    }), 0)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Default *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.default_level),
      expression: "entity.default_level"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "default_level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.presets), function(preset, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": preset.type
      }
    }, [_vm._v("\n                        " + _vm._s(preset.title) + "\n                      ")])
  }), 0)])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('PuzzleQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Puzzle image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit puzzle image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Users') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Users\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/users/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by person title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.roles.map(function (item) { return item.name; }).join(', ')))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(item.google2fa_enabled && _vm.activeUser.id !== item.id) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.disable2fa(item.id)
        }
      }
    }, [_vm._v("\n                      Disable2FA\n                      "), _c('span', {
      ref: ("activeBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (item.active && _vm.activeUser.id !== item.id) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.deactivateUser(item.id)
        }
      }
    }, [_vm._v("\n                      Block\n                      "), _c('span', {
      ref: ("activeBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (!item.active && _vm.activeUser.id !== item.id) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.activateUser(item.id)
        }
      }
    }, [_vm._v("\n                      Activate\n                      "), _c('span', {
      ref: ("activeBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'UsersEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), (_vm.activeUser.id !== item.id) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'users/', 'User')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Roles")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-warning btn-sm",
    attrs: {
      "href": _vm.formLink(),
      "target": "_blank"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.linkMessage) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    on: {
      "dblclick": _vm.bdlClick
    }
  }, [(_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-folder-open"
  }) : _c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), (_vm.isOpen) ? _c('ul', _vm._l((_vm.content), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "content": file
      },
      on: {
        "attach-file": _vm.attachFile
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("File Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.file_number),
      expression: "entity.file_number"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "file_number",
      "type": "text",
      "placeholder": "Enter file number"
    },
    domProps: {
      "value": (_vm.entity.file_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "file_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          QA has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create QA")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    class: ['spinner spinner-gritcode', _vm.spinnerSize, {
      'spinner-fixed': _vm.fixed
    }]
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('div', {
    staticClass: "spinner-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Roles') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Roles\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/roles/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by person title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'RolesEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'roles/', 'User')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    ref: "multiselect",
    attrs: {
      "options": _vm.options,
      "label": _vm.label
    },
    on: {
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }]),
    model: {
      value: (_vm.valueData),
      callback: function($$v) {
        _vm.valueData = $$v
      },
      expression: "valueData"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row memory-quote"
  }, [_c('label', {
    staticClass: "painting-quote__quote-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Quote " + _vm._s(_vm.number + 1))]), _vm._v(" "), _c('button', {
    staticClass: "painting-quote__close-btn col-md-10",
    on: {
      "click": _vm.deleteQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "painting-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.text),
      expression: "quote.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "3",
      "placeholder": "Enter quote text"
    },
    domProps: {
      "value": (_vm.quote.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "painting-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.more_info),
      expression: "quote.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "2",
      "placeholder": "Enter more info"
    },
    domProps: {
      "value": (_vm.quote.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "more_info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "painting-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.link),
      expression: "quote.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("title-" + _vm.number),
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.quote.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "link", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Pdf")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzonePdf",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.pdfChanged,
      "vdropzone-file-added": _vm.pdfChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Pdf transcription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzonePdfText",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.pdfTextChanged,
      "vdropzone-file-added": _vm.pdfTextChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Letterbook has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Letterbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.mode === 1) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "pull-right btn btn-success btn-sm btn-branch",
    attrs: {
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.mode = 3
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entities.length),
      expression: "entities.length"
    }],
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.publish_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unpublish_date))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'announcements/', 'Announcement')
        }
      }
    }, [_vm._v("\n                        Delete\n                        "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (!_vm.entities.length) ? _c('div', {
    staticClass: "text-center mt-2"
  }, [_c('strong', [_vm._v("There are no announcements yet")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mode === 2) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm mt-0 btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n              Back\n            ")])])]), _vm._v(" "), _c('edit', {
    attrs: {
      "item-to-edit": _vm.itemToEdit
    },
    on: {
      "changeMode": _vm.setMode
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 3) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "btn btn-success btn-sm btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back\n            ")])])]), _vm._v(" "), _c('new', {
    on: {
      "changeModeOnCreate": _vm.setModeOnCreate
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Publish_date")]), _vm._v(" "), _c('th', [_vm._v("Unpublish date")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n    ☰\n  ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none mr-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("\n        ☰\n      ")])])]), _vm._v(" "), _c('UploadManager')], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-wrap",
    attrs: {
      "id": "notifications"
    }
  }, [_c('div', {
    staticClass: "notifications-danger"
  }, [(_vm.notifications.danger) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.danger) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeDanger.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notifications-warning"
  }, [(_vm.notifications.warning) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.warning) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeWarning.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notifications-success"
  }, [(_vm.notifications.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.success) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeSuccess.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'VideoList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Video\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_video/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('media_video')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_video', 'Video')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by video title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_video",
      "unpublish-empty-endpoint": "media/video/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.validateUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow table-list__videos"
    }, [_c('div', [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('media_video', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'VideoEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_video', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_video', 'Video')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/video/', 'Video')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('div', [_c('v-select', {
      staticClass: "btn btn-success v-select-video",
      attrs: {
        "options": _vm.videoSeries,
        "label": "title",
        "placeholder": "Add to series"
      },
      on: {
        "change": function($event) {
          return _vm.selectVideoSeries(item.id, _vm.selectedVideoSeries[item.id])
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function(option) {
          return [_c('span', [_vm._v(_vm._s(option.title))])]
        }
      }], null, true),
      model: {
        value: (_vm.selectedVideoSeries[item.id]),
        callback: function($$v) {
          _vm.$set(_vm.selectedVideoSeries, item.id, $$v)
        },
        expression: "selectedVideoSeries[item.id]"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      ref: ("videoSeriesBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none",
        "margin-top": "5px"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_video')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_video')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'CorrespondenceList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Correspondence\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/correspondence/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('correspondence')
      }
    }
  }, [_vm._v("\n            Add all to search index "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('correspondence', 'Correspondence')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by correspondence title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('label', [_vm._v("Filter by type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterChoosenCorrType),
      expression: "filterChoosenCorrType"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "auto"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterChoosenCorrType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeFilterChoosenCorrType]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-all-")]), _vm._v(" "), _vm._l((_vm.corrTypes), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(_vm.parsedCorrType(item)))])
  })], 2)])]), _vm._v(" "), (_vm.allowPublishing) ? _c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Publish/Unpublish by correspondence type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publishChoosenCorrType),
      expression: "publishChoosenCorrType"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "auto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.publishChoosenCorrType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.corrTypes), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(_vm.parsedCorrType(item)))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        return _vm.changeCorrTypePublished(true)
      }
    }
  }, [_vm._v("\n            Publish\n            "), _c('span', {
    ref: "publishGroupLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        return _vm.changeCorrTypePublished(false)
      }
    }
  }, [_vm._v("\n            Unpublish\n            "), _c('span', {
    ref: "unpublishGroupLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "correspondence",
      "unpublish-empty-endpoint": "correspondence/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.validateUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('div', [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('correspondence', item.id)
        }
      }
    }, [_vm._v("\n                        Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'CorrespondenceEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'correspondence', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'correspondence', 'Correspondence')
        }
      }
    }, [_vm._v("\n                        Reg. thumb\n                        "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt_4"
    }, [(_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'correspondence/', 'Correspondence')
        }
      }
    }, [_vm._v("\n                        Delete\n                        "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'correspondence')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'correspondence')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by media file name"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.source_file))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.disk))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.files))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _c('tr', [(!_vm.total) ? _c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("There are no items on your request")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Media files\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Disk")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Files")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Staff') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Staff\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/staff/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by person title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'StaffEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'staff/', 'Staff')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('router-link', {
    staticClass: "list-group-item list-group-item-action active",
    attrs: {
      "to": '/admin/account-settings/set-up-google2fa'
    }
  }, [_vm._v("\n          Set Up Google2FA\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Account Settings\n    ")])
}]}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('PaintingQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Painting image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Add painting image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6 spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                Articles for Editors Picks:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "editors-picks__list"
  }, [(!_vm.selectedPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                  Please select items to add\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title"
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.deleteEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by article title or url"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.onPageChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__list editors-picks__list_with-search"
  }, [_vm._l((_vm.filteredPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title",
      attrs: {
        "title": item.title
      }
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.addEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.filteredPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                    There are no items for your request\n                  ")]) : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Picks\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Editor's Picks have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit Editor's Picks For Articles")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Article")])])
}]}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrap"
  }, [_c('div', {
    staticClass: "file-info"
  }, [_c('div', {
    staticClass: "file-info__name"
  }, [_c('span', {
    staticClass: "file-info__id"
  }, [_vm._v(_vm._s(_vm.fileId))]), _vm._v(" "), _c('span', {
    staticClass: "file-info__extension"
  }, [_vm._v(_vm._s(_vm.fileExt))])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [(_vm.isPaused) ? _c('div', {
    staticClass: "file-info__progress"
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : (_vm.isStopped) ? _c('div', {
    staticClass: "file-info__progress"
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('div', {
    staticClass: "file-info__progress"
  }, [_vm._v(_vm._s((_vm.progress + "%")))]), _vm._v(" "), _c('div', {
    class: ("progress-bar " + _vm.progressClass),
    style: (("width: " + _vm.progress + "%;"))
  })])]), _vm._v(" "), _c('div', {
    staticClass: "file-info__controls"
  }, [(_vm.isFinished && !_vm.isSucceed) ? _c('button', {
    staticClass: "button retry",
    on: {
      "click": _vm.onRetryClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isFinished) ? [(!_vm.isStopped) ? _c('button', {
    staticClass: "button stop",
    on: {
      "click": _vm.onStopClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isStopped && _vm.isPaused) ? _c('button', {
    staticClass: "button resume",
    on: {
      "click": _vm.onResumeClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('button', {
    staticClass: "button pause",
    on: {
      "click": _vm.onPauseClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    }
  })])] : _c('button', {
    staticClass: "button remove",
    on: {
      "click": _vm.onRemoveClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new video")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VideoSeriesManageVideos',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Manage Video\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                  Videos which will add to gallery:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedVideos), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteVideo(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by video title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceVideos), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.shortTitle(item.title)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addVideo(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                      There are no items on your request\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Videos\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Videos have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Video Series")])])])])
}]}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/document-files/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'DocumentFilesManageDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Documents\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "file_number"
    }
  }, [_vm._v("File Number *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.file_number),
      expression: "entity.file_number"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "file_number",
      "type": "text",
      "placeholder": "Enter file number"
    },
    domProps: {
      "value": (_vm.entity.file_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "file_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Document files have modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row memory-quote"
  }, [_c('label', {
    staticClass: "memory-quote__quote-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Quote " + _vm._s(_vm.number + 1))]), _vm._v(" "), _c('button', {
    staticClass: "memory-quote__close-btn col-md-10",
    on: {
      "click": _vm.deleteQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "memory-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.text),
      expression: "quote.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "3",
      "placeholder": "Enter quote text"
    },
    domProps: {
      "value": (_vm.quote.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "memory-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.more_info),
      expression: "quote.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "2",
      "placeholder": "Enter more info"
    },
    domProps: {
      "value": (_vm.quote.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "more_info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "memory-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.link),
      expression: "quote.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("title-" + _vm.number),
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.quote.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "link", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Documents")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'DocumentFilesManageDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Manage Documents\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                  Documents which will add to Document files:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedDocs), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteDoc(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by document title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceDocs), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.shortTitle(item.title)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addDoc(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                      There are no items on your request\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Docs\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Docs have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Document Files")])])])])
}]}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder__item-modal modal fade",
    attrs: {
      "id": "termItemModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "termItemName",
      "type": "text",
      "data-validation": "true"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-modal-error",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n          Save changes\n          "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Term item")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "termItemName"
    }
  }, [_vm._v("Name *")])])
}]}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v("Public Files")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary",
    on: {
      "click": _vm.uploadNewFile
    }
  }, [_vm._v("\n            Upload file\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary",
    on: {
      "click": _vm.updateFileStructure
    }
  }, [_vm._v("\n            Update list\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.rootTree) ? _c('div', {
    staticClass: "file-manager"
  }, [_vm._l((_vm.rootTree.folders), function(content, name) {
    return _c('SelectelFolder', {
      key: name,
      attrs: {
        "name": name,
        "path": name,
        "content": content
      },
      on: {
        "folderDeleted": _vm.onFolderDeleted,
        "fileDeleted": _vm.onFileDeleted
      }
    })
  }), _vm._v(" "), _vm._l((_vm.rootTree.files), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "file": file
      },
      on: {
        "fileDeleted": _vm.onFileDeleted
      }
    })
  })], 2) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'LetterbookList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Letterbooks\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/book/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('book')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('book', 'Letterbooks')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Letterbook title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "book",
      "unpublish-empty-endpoint": "letterbooks/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('book', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'LetterbookEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'book', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'book', 'Letterbook')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'letterbooks/', 'Letterbook')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("lessons/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Lessons plan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.lesson_plans),
      callback: function($$v) {
        _vm.$set(_vm.entity, "lesson_plans", $$v)
      },
      expression: "entity.lesson_plans"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Teacher's key")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.teachers_keys),
      callback: function($$v) {
        _vm.$set(_vm.entity, "teachers_keys", $$v)
      },
      expression: "entity.teachers_keys"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Activities/Worksheets")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.activities),
      callback: function($$v) {
        _vm.$set(_vm.entity, "activities", $$v)
      },
      expression: "entity.activities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Audio")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audio,
      "search-function": _vm.audioSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.audio),
      callback: function($$v) {
        _vm.$set(_vm.entity, "audio", $$v)
      },
      expression: "entity.audio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.overviews),
      callback: function($$v) {
        _vm.$set(_vm.entity, "overviews", $$v)
      },
      expression: "entity.overviews"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Books")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.books),
      callback: function($$v) {
        _vm.$set(_vm.entity, "books", $$v)
      },
      expression: "entity.books"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Chapter Study Guides")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.chapter_study_guides),
      callback: function($$v) {
        _vm.$set(_vm.entity, "chapter_study_guides", $$v)
      },
      expression: "entity.chapter_study_guides"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Coloring Sheets")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.coloring_sheets),
      callback: function($$v) {
        _vm.$set(_vm.entity, "coloring_sheets", $$v)
      },
      expression: "entity.coloring_sheets"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Lesson has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'IssuesAndAnswersList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Issues and Answers\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/issues_and_answers/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('issues-and-answers')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('issues-and-answers', 'Issues and Answers')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by I&A title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "issues_and_answers",
      "unpublish-empty-endpoint": "issues-and-answers/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('issues-and-answers', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'IssuesAndAnswersEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'issues_and_answers', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'issues_and_answers', 'IA')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'issues-and-answers/', 'IA')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-wrap"
  }, [_c('div', {
    staticClass: "file-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v("\n      " + _vm._s(_vm.file.basename) + " (" + _vm._s(_vm.fileSize) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "file-btns"
  }, [(_vm.file.url) ? _c('span', {
    staticClass: "file-btn file-btn__url",
    on: {
      "click": function($event) {
        _vm.urlShown = !_vm.urlShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "deleteBtn",
    staticClass: "file-btn file-btn__delete",
    on: {
      "click": _vm.deleteFile
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), (_vm.file.url) ? _c('div', {
    staticClass: "file-link-tooltip",
    class: {
      opened: _vm.urlShown
    }
  }, [_vm._v("\n        " + _vm._s(_vm.file.url) + "\n        "), _c('div', {
    staticClass: "file-link-tooltip__close-wrap"
  }, [_c('button', {
    staticClass: "file-btn file-link-tooltip__close",
    on: {
      "click": function($event) {
        _vm.urlShown = !_vm.urlShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-type"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])
}]}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "default"
    }
  }, [_vm._v("Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.is_person),
      expression: "entity.is_person"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "is_person", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.personTypes), function(type, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": type.isPerson
      }
    }, [_vm._v("\n                      " + _vm._s(type.text) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Reference Image")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('v-select', {
    staticClass: "v-select-game",
    class: _vm.vsGame,
    attrs: {
      "options": _vm.images,
      "label": "title",
      "id": "default",
      "placeholder": _vm.entity.reference.title
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('img', {
          attrs: {
            "src": option.thumbnail
          }
        }), _vm._v(" "), (option.title) ? _c('span', [_vm._v(_vm._s(option.title))]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selected_ref_id),
      callback: function($$v) {
        _vm.selected_ref_id = $$v
      },
      expression: "selected_ref_id"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('MemoryQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Memory image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit memory image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": _vm.content.id
    }
  }, [(_vm.isReady) ? _c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.entity.image ? _vm.entity.image.public_url : '',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data"
  }, [_c('div', {
    staticClass: "menu-builder__item-data-row _id"
  }, [_c('b', [_vm._v("ID:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.id))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _title"
  }, [_c('b', [_vm._v("Title:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.title))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _url"
  }, [_c('b', [_vm._v("Url:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.url))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [(_vm.entity.hidden) ? _c('i', {
    staticClass: "fa fa-2x fa-eye-slash disabled",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-open"
  }, [_vm._v("Open")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])])]) : _vm._e(), _vm._v(" "), (_vm.entity.children && _vm.entity.children.length) ? _c('ul', _vm._l((_vm.content.children), function(item) {
    return _c('menu-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.filesChanged,
      "vdropzone-file-added": _vm.filesChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Article has created successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create article")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("issues-and-answers/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Entity has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn taxonomy"
  }, [(_vm.$route.name == 'Terms') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Terms\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/taxonomy/terms/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vocabulary_dropdown"
  }, [_c('v-select', {
    staticClass: "v-select-game",
    attrs: {
      "options": _vm.vocabularies,
      "label": "name"
    },
    on: {
      "change": _vm.getSource
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [(option.name) ? _c('span', [_vm._v(_vm._s(option.name))]) : _vm._e()]
      }
    }], null, false, 3103874680),
    model: {
      value: (_vm.searchVocabulary),
      callback: function($$v) {
        _vm.searchVocabulary = $$v
      },
      expression: "searchVocabulary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by term title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'TermsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'terms/', 'Term')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Search Index Settings\n          "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-danger delete-index-all",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.deleteIndexForAll
    }
  }, [_vm._v("\n            Delete index for all type\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-success update-index-all",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.updateIndexForAll
    }
  }, [_vm._v("\n            Create index for all type\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary reload-source",
    on: {
      "click": _vm.reloadSource
    }
  }, [_vm._v("\n            Update index data\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.types), function(item) {
    return _c('tr', {
      key: item.type,
      attrs: {
        "data-type": item.type
      }
    }, [_c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.documents_count))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.updateIndexForType(item.type)
        }
      }
    }, [_vm._v("\n                      Update index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteIndexForType(item.type)
        }
      }
    }, [_vm._v("\n                      Delete index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0)])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-uploader"
  }, [(_vm.checkType === 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "vimeo"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "vimeo")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "vimeo"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vimeoLink),
      expression: "vimeoLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to vimeo"
    },
    domProps: {
      "value": (_vm.vimeoLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vimeoLink = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType === 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "youtube"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "youtube")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "youtube"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.youtubeLink),
      expression: "youtubeLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to youtube"
    },
    domProps: {
      "value": (_vm.youtubeLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.youtubeLink = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkType !== 'media_video') ? _c('div', {
    staticClass: "file-uploader__input",
    on: {
      "click": _vm.onFileuploaderClicked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "url")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "url"
      }
    }
  }), _vm._v(" "), (_vm.pathPrefix) ? _c('SelectelUploader', {
    attrs: {
      "file-link": _vm.fileLink,
      "selectel-list": _vm.selectelList,
      "selectel-loading": _vm.selectelLoading,
      "link-status": _vm.linkStatus
    },
    on: {
      "blur": _vm.checkLink,
      "file-attached": _vm.attachFile
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "file-uploader__dropzone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadType),
      expression: "uploadType"
    }],
    attrs: {
      "type": "radio",
      "value": "file"
    },
    domProps: {
      "checked": _vm._q(_vm.uploadType, "file")
    },
    on: {
      "change": function($event) {
        _vm.uploadType = "file"
      }
    }
  }), _vm._v(" "), (_vm.checkType !== 'media_video' || _vm.defaultFile) ? _c('Dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.fileChanged,
      "vdropzone-file-added": _vm.fileChanged
    }
  }) : _c('div', {
    staticClass: "file-uploader__multiple-dropzone"
  }, [_c('VideoQualityUploader', {
    attrs: {
      "check-type": _vm.checkType,
      "quality-array": _vm.qualityArray,
      "dropzone-options": _vm.dropzoneOptions,
      "selectel-list": _vm.selectelList,
      "selectel-loading": _vm.selectelLoading,
      "default-files": _vm.defaultFiles,
      "uploaded-files": _vm.uploadedFilesDictionary
    },
    on: {
      "content-change": _vm.onContentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.name) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Permissions")]), _vm._v(" "), (_vm.defaultOptionsLoaders.permissions) ? _c('div', {
    staticClass: "col-md-10 spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  })], 1) : _c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "column-count": "3"
    }
  }, _vm._l((_vm.defaultOptions.permissions), function(permission) {
    return _c('div', {
      key: permission.id
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.permissions),
        expression: "entity.permissions"
      }],
      attrs: {
        "id": permission.id,
        "type": "checkbox"
      },
      domProps: {
        "value": permission,
        "checked": Array.isArray(_vm.entity.permissions) ? _vm._i(_vm.entity.permissions, permission) > -1 : (_vm.entity.permissions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.entity.permissions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = permission,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.entity, "permissions", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.entity, "permissions", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.entity, "permissions", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(permission.name) + "\n                    ")])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Topic has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create topic")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage Audio Tracks")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'AlbumAddTracks',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Add new Audio Tracks\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'AlbumOrderTracks',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Order tracks\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'AlbumEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Back to General\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Audio Tracks title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.total) ? _c('tbody', _vm._l((_vm.tracks), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteAudioTrack(item)
        }
      }
    }, [_vm._v("\n                    Delete\n                    "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0) : _c('tbody', [_vm._m(2)])])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Audio Tracks")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                  There are no audio tracks yet. Go to 'Add new Audio Tracks' to add new ones.\n                ")])])
}]}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _vm._v(" "), _c('open-on-site', {
    staticClass: "disabled",
    attrs: {
      "source-route": '/'
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("pamphlets/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Pamphlet has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("correspondence/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.type),
      expression: "entity.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.corrTypesList), function(entityType) {
    return _c('option', {
      key: entityType,
      domProps: {
        "value": entityType
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatCorrType(entityType)) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.entity.hasOwnProperty('date')) ? _c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Receivers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.personSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receivers),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receivers", $$v)
      },
      expression: "entity.receivers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Receiver location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.locations,
      "search-function": _vm.locationSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receiver_location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receiver_location", $$v)
      },
      expression: "entity.receiver_location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Senders")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.personSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.senders),
      callback: function($$v) {
        _vm.$set(_vm.entity, "senders", $$v)
      },
      expression: "entity.senders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Sender location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.locations,
      "search-function": _vm.locationSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.sender_location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "sender_location", $$v)
      },
      expression: "entity.sender_location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "text"
    },
    model: {
      value: (_vm.entity.text),
      callback: function($$v) {
        _vm.$set(_vm.entity, "text", $$v)
      },
      expression: "entity.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Correspondence has updated successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.resetPassword
    }
  }, [_c('h1', [_vm._v("Reset password")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Type your email to get reset password link")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n                    Send email\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.isRequestSuccess) ? _c('div', {
    staticClass: "card card-inverse card-success"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Thank you\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            Please check your inbox for password reser link\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-envelope"
  })])
}]}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'BranchOffices') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Offices\n          "), (_vm.allowedToCreateAndDelete) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/branch-offices/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Office title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.domain))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.typeOptions(item.type)))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'BranchOfficesEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), (_vm.allowedToCreateAndDelete) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'branch-offices/', 'Branch Office')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Domain")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/audio-albums/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'AlbumManageTracks',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Tracks\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.source.cover ? _vm.source.cover.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.coverRemove,
      "existingFileRemoved": _vm.coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Collection *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audioCollections,
      "search-function": _vm.collectionSearch,
      "label": "name",
      "start-val": _vm.entity.collection
    },
    model: {
      value: (_vm.entity.collection),
      callback: function($$v) {
        _vm.$set(_vm.entity, "collection", $$v)
      },
      expression: "entity.collection"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Audio Album has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.type),
      expression: "entity.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.corrTypesList), function(corrType) {
    return _c('option', {
      key: corrType,
      domProps: {
        "value": corrType
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.formatCorrType(corrType)) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Receivers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.personSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receivers),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receivers", $$v)
      },
      expression: "entity.receivers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Receiver location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.locations,
      "search-function": _vm.locationSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receivers_location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receivers_location", $$v)
      },
      expression: "entity.receivers_location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Senders")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.personSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.senders),
      callback: function($$v) {
        _vm.$set(_vm.entity, "senders", $$v)
      },
      expression: "entity.senders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Sender location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.locations,
      "search-function": _vm.locationSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.senders_location),
      callback: function($$v) {
        _vm.$set(_vm.entity, "senders_location", $$v)
      },
      expression: "entity.senders_location"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "text"
    },
    model: {
      value: (_vm.entity.text),
      callback: function($$v) {
        _vm.$set(_vm.entity, "text", $$v)
      },
      expression: "entity.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("PDF")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.fileChanged,
      "vdropzone-file-added": _vm.fileChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Correspondence has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create correspondence")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("questions-and-answers/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'QaManageDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Documents\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "file_number"
    }
  }, [_vm._v("File Number *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.file_number),
      expression: "entity.file_number"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "file_number",
      "type": "text",
      "placeholder": "Enter File Number"
    },
    domProps: {
      "value": (_vm.entity.file_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "file_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          QA has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row puzzle-quote"
  }, [_c('label', {
    staticClass: "puzzle-quote__quote-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Quote " + _vm._s(_vm.number + 1))]), _vm._v(" "), _c('button', {
    staticClass: "puzzle-quote__close-btn col-md-10",
    on: {
      "click": _vm.deleteQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.text),
      expression: "quote.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "3",
      "placeholder": "Enter quote text"
    },
    domProps: {
      "value": (_vm.quote.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.more_info),
      expression: "quote.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "2",
      "placeholder": "Enter more info"
    },
    domProps: {
      "value": (_vm.quote.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "more_info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.link),
      expression: "quote.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("title-" + _vm.number),
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.quote.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "link", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), (_vm.$_allowDeleting(_vm.source)) ? _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/audio/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Years")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.date),
      expression: "entity.date"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "text",
      "placeholder": "Enter date years"
    },
    domProps: {
      "value": (_vm.entity.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Audio file *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    attrs: {
      "check-type": "media_audio",
      "path-prefix": "aud",
      "default-file": _vm.source.mediaFile,
      "dropzone-options": _vm.dropzoneOptions,
      "uploading-file": _vm.uploadingFile || null
    },
    model: {
      value: (_vm.audioFile),
      callback: function($$v) {
        _vm.audioFile = $$v
      },
      expression: "audioFile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audioAlbums,
      "search-function": _vm.albumSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.album),
      callback: function($$v) {
        _vm.$set(_vm.entity, "album", $$v)
      },
      expression: "entity.album"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Transcription")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.transcriptionSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.transcription),
      callback: function($$v) {
        _vm.$set(_vm.entity, "transcription", $$v)
      },
      expression: "entity.transcription"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Audio has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.currentContent.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No featured content for this section")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentContent), function(item) {
    return _c('tr', {
      key: ((item.type) + "_" + (item.id)),
      attrs: {
        "id": ("article" + (item.id))
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/content/" + (item.type) + "/edit/" + (item.id)),
        "exact": ""
      }
    }, [_vm._v("\n                Edit\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.dettachContent(item)
        }
      }
    }, [_vm._v("\n                Dettach\n                "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Add Url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContentUrl),
      expression: "newContentUrl"
    }],
    staticClass: "form-control mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newContentUrl)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewUrl.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newContentUrl = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newContentUrl) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addNewUrl
    }
  }, [_vm._v("\n              Add\n              "), (_vm.newUrlLoader) ? _c('span', {
    ref: "addUrlLoader",
    staticClass: "btn-loader"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveUrlErrorMessage),
      expression: "saveUrlErrorMessage"
    }],
    staticClass: "saving-alerts"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.saveUrlErrorMessage) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Add Content")]), _vm._v(" "), _c('vue-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.contentTypeOptions
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  }), _vm._v(" "), (_vm.contentType) ? _c('vue-select', {
    ref: "contentEntityModel",
    staticClass: "mb-3",
    attrs: {
      "filterable": false,
      "options": _vm.contentEntityOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onEntitySearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }], null, false, 1467187853),
    model: {
      value: (_vm.contentEntity),
      callback: function($$v) {
        _vm.contentEntity = $$v
      },
      expression: "contentEntity"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n              type to search...\n            ")])], 2) : _vm._e(), _vm._v(" "), (_vm.contentEntity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n              Add\n              "), (_vm.newContentLoader) ? _c('span', {
    ref: "addContentLoader",
    staticClass: "btn-loader"
  }) : _vm._e()])]) : _vm._e()], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Content type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "uploads__list upload-progress"
  }, [_c('button', {
    staticClass: "button hide",
    on: {
      "click": _vm.onHideClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "upload-progress__header"
  }, [_vm._v("Current uploads")]), _vm._v(" "), (_vm.uploads.length) ? _vm._l((_vm.uploads), function(upload) {
    return _c('ProgressBar', {
      key: upload.id,
      attrs: {
        "file-name": upload.fileName,
        "progress": upload.fileProgress,
        "status": upload.status
      },
      on: {
        "stop-clicked": function($event) {
          return _vm.onStopUploadClicked($event, upload.id)
        },
        "resume-clicked": function($event) {
          return _vm.onResumeUploadClicked($event, upload.id)
        },
        "pause-clicked": function($event) {
          return _vm.onPauseUploadClicked($event, upload.id)
        },
        "retry-clicked": function($event) {
          return _vm.onRetryUploadClicked($event, upload.id)
        },
        "remove-clicked": function($event) {
          return _vm.onRemoveClicked($event, upload.id)
        }
      }
    })
  }) : _c('p', {
    staticClass: "upload-progress__no-uploads"
  }, [_vm._v("No uploading files")])], 2)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1), _vm._v(" "), _c('Notifications')], 1)], 1), _vm._v(" "), _c('AppFooter'), _vm._v(" "), _c('Modals')], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          FAQ has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create FAQ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent branch-offices-page"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('a', {
    class: [_vm.activetab === 1 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 1
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 2 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 2
      }
    }
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 3 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 3
      }
    }
  }, [_vm._v("News Notes")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 4 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 4
      }
    }
  }, [_vm._v("Announcements")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 6 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 6
      }
    }
  }, [_vm._v("Main Page")]), _vm._v(" "), _c('a', {
    class: [_vm.activetab === 7 ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.activetab = 7
      }
    }
  }, [_vm._v("Center Page")])]), _vm._v(" "), (_vm.activetab === 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('about', {
    attrs: {
      "entity": _vm.entity
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 2) ? _c('div', [_vm._m(1), _vm._v(" "), _c('contacts', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 3) ? _c('div', [_vm._m(2), _vm._v(" "), _c('news')], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 4) ? _c('div', [_vm._m(3), _vm._v(" "), _c('announcements')], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 6) ? _c('div', [_vm._m(4), _vm._v(" "), _c('main-page', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activetab === 7) ? _c('div', [_vm._m(5), _vm._v(" "), _c('center-page', {
    attrs: {
      "entity": _vm.entity,
      "source": _vm.source
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("About")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Contacts")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("News Notes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Announcements")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Main Page")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Center Page")])])])
}]}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.$route.params.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by media file name"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "pie-wrap"
  }, [_c('spinner', {
    ref: "pieSpinner",
    attrs: {
      "size": "md",
      "text": "Loading chart data"
    }
  }), _vm._v(" "), (_vm.pieDataHasError) ? _c('div', {
    staticClass: "pie-error-wrap"
  }, [_vm._v("\n                Server error. Try to reload chart\n              ")]) : _vm._e(), _vm._v(" "), (_vm.pieDataIsReady) ? _c('pie-chart', {
    attrs: {
      "data": _vm.pieData,
      "options": _vm.pieOptions,
      "width": 500,
      "height": 250
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mt-3",
    on: {
      "click": _vm.getPieData
    }
  }, [_vm._v("Reload chart")])], 1)]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.model_type),
      expression: "filters.model_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "model_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _vm._l((_vm.contentTypes), function(value, key) {
    return _c('option', {
      key: value.namespace,
      domProps: {
        "value": value.namespace
      }
    }, [_vm._v("\n                        " + _vm._s(key) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.disk),
      expression: "filters.disk"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "disk", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "media"
    }
  }, [_vm._v("media")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "selectel"
    }
  }, [_vm._v("selectel")])])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.status),
      expression: "filters.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ok"
    }
  }, [_vm._v("ok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "failed"
    }
  }, [_vm._v("failed")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._l((_vm.media), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model_type))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.public_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(item.file_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.disk))]), _vm._v(" "), _c('td', {
      staticClass: "text-center table-cell-loader-parent"
    }, [(!item.file_health) ? _c('span', [_vm._v("null")]) : (item.file_health.status === 'ok') ? _c('i', {
      staticClass: "fa fa-check text-success"
    }) : (item.file_health.status === 'failed') ? _c('i', {
      staticClass: "fa fa-times text-danger"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "table-cell-loader-parent"
    }, [_vm._v("\n                    " + _vm._s(item.file_health ? item.file_health.date : '') + "\n                    "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "table-cell-loader-parent"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-update",
      on: {
        "click": function($event) {
          return _vm.updateHealth(item)
        }
      }
    }, [_vm._v("\n                      Update status\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "table-cell-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), _vm._v(" "), _c('tr', [(!_vm.total) ? _c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("There are no items on your request")]) : _vm._e()])], 2)])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v("\n          Media files\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Media ID")]), _vm._v(" "), _c('th', [_vm._v("Media Type")]), _vm._v(" "), _c('th', [_vm._v("File name")]), _vm._v(" "), _c('th', [_vm._v("Disk")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Last Check")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/video/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("File/Link *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    attrs: {
      "check-type": "media_video",
      "path-prefix": "vid",
      "default-file": _vm.entity.mediaFile,
      "default-files": _vm.defaultFiles,
      "dropzone-options": _vm.dropzoneOptions,
      "vimeo": _vm.source.vimeo_link ? _vm.source.vimeo_link.link : '',
      "youtube": _vm.source.youtube_link ? _vm.source.youtube_link.link : '',
      "start-type": _vm.startVideoType,
      "uploaded-files-dictionary": _vm.uploadedFilesDictionary
    },
    model: {
      value: (_vm.videoFile),
      callback: function($$v) {
        _vm.videoFile = $$v
      },
      expression: "videoFile"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.coverUrl
    },
    on: {
      "changeFile": _vm.changeCover,
      "returnedOldFile": _vm.coverRestore,
      "existingFileRemoved": _vm.coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Video Series")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.series,
      "search-function": _vm.seriesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.series),
      callback: function($$v) {
        _vm.$set(_vm.entity, "series", $$v)
      },
      expression: "entity.series"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Video has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/images/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Media *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    attrs: {
      "check-type": "media_image",
      "path-prefix": "img",
      "default-file": _vm.source.mediaFile,
      "dropzone-options": _vm.dropzoneOptions,
      "uploading-file": _vm.uploadingFile || null
    },
    model: {
      value: (_vm.imageFile),
      callback: function($$v) {
        _vm.imageFile = $$v
      },
      expression: "imageFile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Galleries")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.galleries,
      "search-function": _vm.galleriesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.galleries),
      callback: function($$v) {
        _vm.$set(_vm.entity, "galleries", $$v)
      },
      expression: "entity.galleries"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Image has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("publications/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Publication has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Painting Game') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Painting Game\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/painting-game-images/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by memory game image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.images), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.adaptUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/painting-game-images/edit/" + (item.id))
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'games/painting/', 'Painting Game')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'ArticleList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Articles\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/article/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('article')
      }
    }
  }, [_vm._v("\n            Add all to search index "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('article', 'Articles')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by article title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "article",
      "unpublish-empty-endpoint": "articles/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('article', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'ArticleEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'article', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'article', 'Article')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'articles/', 'Article')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'article')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'article')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-button"
  }, [_c('div', {
    staticClass: "general-progress"
  }, [_c('button', {
    staticClass: "button open",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: ("progress-bar " + _vm.generalStatus),
    style: (("width: " + (_vm.progress || 0) + "%;"))
  }), _vm._v(" "), _c('p', {
    staticClass: "open__text"
  }, [_vm._t("default"), _vm._v("\n          " + _vm._s((_vm.buttonText + " (" + _vm.uploadsCount + ") ")) + "\n          "), (_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-caret-up open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Email *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.email),
      expression: "entity.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Password *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.password),
      expression: "entity.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.entity.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Password Confirmation *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.password_confirmation),
      expression: "entity.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.entity.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "password_confirmation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Roles")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "multiple": "",
      "options": _vm.rolesList,
      "label": "name"
    },
    model: {
      value: (_vm.entity.roles),
      callback: function($$v) {
        _vm.$set(_vm.entity, "roles", $$v)
      },
      expression: "entity.roles"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Avatar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.avatarUploaded
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          User has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create User ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'PersonDuplicates') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" People\n          "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'People'
      }
    }
  }, [_vm._v("\n            Return to People list\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by string"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.people), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedEntities),
        expression: "selectedEntities"
      }],
      attrs: {
        "id": item.id,
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.selectedEntities) ? _vm._i(_vm.selectedEntities, item.id) > -1 : (_vm.selectedEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'PersonEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-sm btn-merge",
      on: {
        "click": function($event) {
          return _vm.mergeItem(item)
        }
      }
    }, [_vm._v("\n                      Merge\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no obvious duplicates for this person.\n            Try to search something more particular\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  }), _vm._v(" "), (_vm.selectedEntities.length) ? _c('button', {
    staticClass: "btn btn-success btn-sm btn-merge-all",
    on: {
      "click": _vm.mergeItems
    }
  }, [_vm._v("\n              Merge Selected\n              "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Merge successed!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Check")]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.description),
      expression: "entity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Enter description"
    },
    domProps: {
      "value": (_vm.entity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.country),
      expression: "entity.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter country"
    },
    domProps: {
      "value": (_vm.entity.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.state),
      expression: "entity.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter state"
    },
    domProps: {
      "value": (_vm.entity.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.city),
      expression: "entity.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter city"
    },
    domProps: {
      "value": (_vm.entity.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address),
      expression: "entity.address.address"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "address",
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.entity.address.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "postal_code"
    }
  }, [_vm._v("Zip/Postal code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.postal_code),
      expression: "entity.address.postal_code"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "postal_code",
      "type": "text",
      "placeholder": "Enter postal code"
    },
    domProps: {
      "value": (_vm.entity.address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "postal_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "organisation_name"
    }
  }, [_vm._v("Organisation name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.organisation_name),
      expression: "entity.address.organisation_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "organisation_name",
      "type": "text",
      "placeholder": "Enter organisation name"
    },
    domProps: {
      "value": (_vm.entity.address.organisation_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "organisation_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax),
      expression: "entity.contacts.fax"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email),
      expression: "entity.contacts.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone),
      expression: "entity.contacts.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lat),
      expression: "entity.geocode.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.geocode.lon),
      expression: "entity.geocode.lon"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.geocode.lon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.geocode, "lon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.geocode) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Location has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Location")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Puzzle Game') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Puzzle Game\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/puzzle-game-images/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by puzzle game image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.adaptUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/puzzle-game-images/edit/" + (item.id))
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'games/puzzles/', 'Puzzle Game')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e()], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-uploader"
  }, [_c('input', {
    ref: "imageUploader",
    staticClass: "image-uploader__input-hidden",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "hidden": ""
    },
    on: {
      "change": _vm.changeFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader__box",
    on: {
      "click": _vm.chooseFileTrigger
    }
  }, [_c('img', {
    ref: "imageBoxImg",
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-uploader__new"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.chooseFileTrigger
    }
  }, [_vm._v("\n      Choose new\n      "), (_vm.imageIsLoading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])]), _vm._v(" "), (_vm.imageChanged && _vm.uploadedImgUrl) ? _c('div', {
    staticClass: "image-uploader__old"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.returnOldImage
    }
  }, [_vm._v("Return old")])]) : _vm._e(), _vm._v(" "), (_vm.imageExist && _vm.removable) ? _c('div', {
    staticClass: "image-uploader__remove"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Remove image")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    ref: "multiselect",
    attrs: {
      "multiple": "",
      "label": _vm.label,
      "options": _vm.options
    },
    on: {
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }]),
    model: {
      value: (_vm.valueData),
      callback: function($$v) {
        _vm.valueData = $$v
      },
      expression: "valueData"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new images")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'GalleryManageImages',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Manage Images\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                  Images which will add to gallery:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedImages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteImage(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceImages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.shortTitle(item.title)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addImage(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                      There are no items on your request\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Images\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Images have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Image Gallery")])])])])
}]}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'Directors') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Directors\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/directors/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by person title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'DirectorsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'directors/', 'Director')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Order")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Image *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    ref: "uploader",
    attrs: {
      "uploaded-img-url": _vm.source.image ? _vm.source.image.public_url : null,
      "removable": false
    },
    on: {
      "changeFile": _vm.coverChange
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.entity.quotes), function(quote, key) {
    return [_c('PaintingQuote', {
      key: key,
      attrs: {
        "quote": quote,
        "number": key
      },
      on: {
        "deleteQuote": _vm.onDeleteQuote
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addQuote
    }
  }, [_vm._v("\n                Add Quote\n              ")])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Painting image has added successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit painting image")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.mode === 1) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "pull-right btn btn-success btn-sm btn-branch",
    attrs: {
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.mode = 3
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entities.length),
      expression: "entities.length"
    }],
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.publish_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unpublish_date))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'news-notes/', 'News Note')
        }
      }
    }, [_vm._v("\n                        Delete\n                        "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (!_vm.entities.length) ? _c('div', {
    staticClass: "text-center mt-2"
  }, [_c('strong', [_vm._v("There are no news notes yet")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mode === 2) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm mt-0 btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n              Back\n            ")])])]), _vm._v(" "), _c('edit', {
    attrs: {
      "item-to-edit": _vm.itemToEdit
    },
    on: {
      "changeMode": _vm.setMode
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 3) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "btn btn-success btn-sm btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back\n            ")])])]), _vm._v(" "), _c('new', {
    on: {
      "changeModeOnCreate": _vm.setModeOnCreate
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Publish_date")]), _vm._v(" "), _c('th', [_vm._v("Unpublish date")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6 spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                Documents for Editors Picks:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "editors-picks__list"
  }, [(!_vm.selectedPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                  Please select items to add\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title"
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.deleteEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by document title or url"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.onPageChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__list editors-picks__list_with-search"
  }, [_vm._l((_vm.filteredPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title",
      attrs: {
        "title": item.title
      }
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.addEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.filteredPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                    There are no items for your request\n                  ")]) : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Picks\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Editor's Picks have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit Editor's Picks For Documents")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Document")])])
}]}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/documents/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("\n                  Title *\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "text"
    },
    model: {
      value: (_vm.entity.text),
      callback: function($$v) {
        _vm.$set(_vm.entity, "text", $$v)
      },
      expression: "entity.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("File *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileAdded,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Document Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.df,
      "search-function": _vm.docFilesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.document_files),
      callback: function($$v) {
        _vm.$set(_vm.entity, "document_files", $$v)
      },
      expression: "entity.document_files"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Questions and Answers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.qa,
      "search-function": _vm.qaSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.questions_and_answers),
      callback: function($$v) {
        _vm.$set(_vm.entity, "questions_and_answers", $$v)
      },
      expression: "entity.questions_and_answers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date", $$v)
      },
      expression: "entity.date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "author"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.peopleSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.author),
      callback: function($$v) {
        _vm.$set(_vm.entity, "author", $$v)
      },
      expression: "entity.author"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "author"
    }
  }, [_vm._v("Receiver")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.people,
      "search-function": _vm.peopleSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.receiver),
      callback: function($$v) {
        _vm.$set(_vm.entity, "receiver", $$v)
      },
      expression: "entity.receiver"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Document has changed successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-manager__modal modal fade",
    attrs: {
      "id": "selectelUploadModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    ref: "selectelUploadFile",
    attrs: {
      "id": "selectelUploadFile",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.changeFile
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.directory),
      expression: "directory"
    }],
    attrs: {
      "id": "selectelUploadPlace"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.directory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "/"
    }
  }, [_vm._v("Root Folder")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "new"
    }
  }, [_vm._v("New Folder")]), _vm._v(" "), _vm._l((_vm.foldersList), function(folder) {
    return _c('option', {
      key: folder,
      domProps: {
        "value": folder
      }
    }, [_vm._v("\n                  " + _vm._s(folder) + "\n                ")])
  })], 2)])])]), _vm._v(" "), (_vm.directory !== '/') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFolder),
      expression: "newFolder"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectelUploadNewFolder",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFolder = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-modal-error",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("\n          Save changes\n          "), _c('span', {
    ref: "saveBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Upload file (max size 500 Mb)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "selectelUploadFile"
    }
  }, [_vm._v("File")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "selectelUploadPlace"
    }
  }, [_vm._v("Directory")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-4"
  }, [_c('label', {
    attrs: {
      "for": "selectelUploadNewFolder"
    }
  }, [_vm._v("New Folder or Path")])])
}]}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.storeError) ? _c('div', {
    staticClass: "card card-inverse card-warning"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Warning\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.storeError) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.recaptchaStorageKey) ? _c('div', {
    staticClass: "input-group mb-4"
  }, [_c('VueRecaptcha', {
    ref: "recaptcha",
    attrs: {
      "size": "normal",
      "sitekey": _vm.recaptchaStorageKey,
      "load-recaptcha-script": true
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                    Login\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errors)
    }
  })])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-4"
  }, [_c('a', {
    attrs: {
      "href": "/#/password/reset"
    }
  }, [_vm._v("Forgot Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-inverse card-primary py-5 d-md-down-none",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', [_c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('p', [_vm._v("Admin dashboard for the Ellen G. White Estate services.")])])])])
}]}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Institution *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "abbreviation"
    }
  }, [_vm._v("Subdomain *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.domain),
      expression: "entity.domain"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "abbreviation",
      "type": "text",
      "placeholder": "Enter abbreviation"
    },
    domProps: {
      "value": (_vm.entity.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "domain", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "localname"
    }
  }, [_vm._v("Institution Local Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.local_institution),
      expression: "entity.local_institution"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "localname",
      "type": "text",
      "placeholder": "Enter Institution Local Name"
    },
    domProps: {
      "value": (_vm.entity.local_institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "local_institution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.type),
      expression: "entity.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.typeOptions), function(value, key) {
    return _c('option', {
      key: value,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(value) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "library"
    }
  }, [_vm._v("Organisation Library")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.library),
      expression: "entity.library"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "library",
      "type": "text",
      "placeholder": "Enter Organisation Library"
    },
    domProps: {
      "value": (_vm.entity.library)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "library", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.country),
      expression: "entity.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.state),
      expression: "entity.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.city),
      expression: "entity.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.zip),
      expression: "entity.address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "zip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.street1),
      expression: "entity.address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.street2),
      expression: "entity.address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.country),
      expression: "entity.mail_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.mail_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.state),
      expression: "entity.mail_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.mail_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.city),
      expression: "entity.mail_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.mail_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.zip),
      expression: "entity.mail_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.mail_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.street1),
      expression: "entity.mail_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.mail_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mail_address.street2),
      expression: "entity.mail_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.mail_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.mail_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.country),
      expression: "entity.alt_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.alt_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.state),
      expression: "entity.alt_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.alt_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.city),
      expression: "entity.alt_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.alt_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.zip),
      expression: "entity.alt_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.alt_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.street1),
      expression: "entity.alt_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.alt_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.alt_address.street2),
      expression: "entity.alt_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.alt_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.alt_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "director"
    }
  }, [_vm._v("Director")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_name),
      expression: "entity.contacts.director_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "director",
      "type": "text",
      "placeholder": "Enter Director Name"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone1),
      expression: "entity.contacts.phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter Phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone2),
      expression: "entity.contacts.phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone2",
      "type": "text",
      "placeholder": "Enter Phone 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax1),
      expression: "entity.contacts.fax1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter Fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax2),
      expression: "entity.contacts.fax2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax2",
      "type": "text",
      "placeholder": "Enter Fax 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "officeEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email1),
      expression: "entity.contacts.email1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail",
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email2),
      expression: "entity.contacts.email2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail2",
      "type": "text",
      "placeholder": "Enter Email 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.email2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter Website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "directorEmail"
    }
  }, [_vm._v("Director Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_email),
      expression: "entity.contacts.director_email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "directorEmail",
      "type": "text",
      "placeholder": "Enter Director Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_email", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Google Maps link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.gmap_link),
      expression: "entity.location.gmap_link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleLink",
      "type": "text",
      "placeholder": "Enter Google Maps link"
    },
    domProps: {
      "value": (_vm.entity.location.gmap_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "gmap_link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lat),
      expression: "entity.location.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.location.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lng),
      expression: "entity.location.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.location.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.location) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [(_vm.entity.location.lat && _vm.entity.location.lng) ? _c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Office has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Branch Office of Research Center")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Alternative Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Contact info")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
}]}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent menu-edit-wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Manage terms order in vocabulary " + _vm._s(_vm.source.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Builder")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'VocabularyEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Edit vocabulary\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.orderChanged) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Items order changed. Don't forget to save it!\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-builder"
  }, [_c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToTop
    }
  }, [_vm._v("Add item")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder-inner"
  }, [(_vm.faqTree.length) ? _c('ul', _vm._m(0), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__btns"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addItemToBottom
    }
  }, [_vm._v("\n                    Add item\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success save-menu",
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.faqTree), function(item) {
    return _c('term-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  })
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage QA")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'QaAddDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Add new QA\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'QaEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Back to General\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by QA title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (!_vm.total) ? _c('tbody', [_vm._m(2)]) : _c('tbody', _vm._l((_vm.docs), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteMediaDoc(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Questions and Answers")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    There are no qa yet. Go to 'Add new QA' to add new ones.\n                  ")])])
}]}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage Documents")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'DocumentFilesAddDocs',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Add new Documents\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'DocumentFilesEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Back to General\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Documents title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (!_vm.total) ? _c('tbody', [_vm._m(2)]) : _c('tbody', _vm._l((_vm.docs), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteMediaDoc(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Document Files")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    There are no documents yet. Go to 'Add new Documents' to add new ones.\n                  ")])])
}]}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6 spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                FAQ for Editors Picks:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "editors-picks__list"
  }, [(!_vm.selectedPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                  Please select items to add\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title"
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.deleteEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by FAQ title or url"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.onPageChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__list editors-picks__list_with-search"
  }, [_vm._l((_vm.filteredPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title",
      attrs: {
        "title": item.title
      }
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.addEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.filteredPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                    There are no items for your request\n                  ")]) : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Picks\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Editor's Picks have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit Editor's Picks For FAQ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new FAQ")])])
}]}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("events/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Start date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date_start),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date_start", $$v)
      },
      expression: "entity.date_start"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Finish date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date_end),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date_end", $$v)
      },
      expression: "entity.date_end"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$config.app_api.host) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Event has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'LessonList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Lessons\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/lesson/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('lesson')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('lesson', 'Lessons')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Lesson title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "lesson",
      "unpublish-empty-endpoint": "lessons/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('lesson', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'LessonEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'lesson', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'lesson', 'Lesson')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'lessons/', 'Lesson')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'lesson')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'lesson')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "announcement-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-announcement-body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore,
      "existingFileRemoved": _vm.$_coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select File\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-publish"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.publish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "publish_date", $$v)
      },
      expression: "entity.publish_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-unpublish"
    }
  }, [_vm._v("Unpublish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.unpublish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "unpublish_date", $$v)
      },
      expression: "entity.unpublish_date"
    }
  })], 1)])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Announcements modified successfully!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Edit Announcement")])])
}]}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Audio Tracks")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'AlbumManageTracks',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Audio Tracks\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                Audio tracks which will add to Audio album:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedTracks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteTrack(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by audio track title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceTracks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('smart-image', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.shortTitle(item.title)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addTrack(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                    There are no items on your request\n                  ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Tracks\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Tracks have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Audio Album")])])])
}]}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h6', [_vm._v("Two-factor authentication (2FA) strengthens access security by requiring two methods (also referred to as factors) to verify your identity.")]), _vm._v(" "), _c('h6', [_vm._v("It protects against phishing, social engineering, and password brute force attacks and secures your logins from attackers exploiting weak or stolen credentials.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(!_vm.getGoogle2faInfo && !_vm.secret_key) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.generateSecret
    }
  }, [_vm._v("\n            Generate Secret Key to Enable 2FA\n            "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.getGoogle2faInfo && _vm.secret_key) ? _c('EnableGoogle2FA', {
    attrs: {
      "secret-key": _vm.secret_key,
      "qr-code": _vm.qr_code
    },
    on: {
      "getErrors": _vm.setErrors
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGoogle2faInfo) ? _c('DisableGoogle2FA', {
    on: {
      "getErrors": _vm.setErrors,
      "resetSecretKey": _vm.resetSecretKey
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      Errors\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Set Up Google 2FA\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You can install Google Authenticator application using these links: "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v("Android")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/ru/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v("iOS")])])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("If you are looking to disable Two Factor Authentication, please confirm your password and Click Disable 2FA Button.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Current Password",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.disableGoogle2fa
    }
  }, [_vm._v("\n    Disable 2FA\n    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("File/Link *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('FileUploader', {
    attrs: {
      "check-type": "media_video",
      "path-prefix": "vid",
      "dropzone-options": _vm.dropzoneOptions
    },
    model: {
      value: (_vm.videoFile),
      callback: function($$v) {
        _vm.videoFile = $$v
      },
      expression: "videoFile"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.coverUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Video Series")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.series,
      "search-function": _vm.seriesSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.series),
      callback: function($$v) {
        _vm.$set(_vm.entity, "series", $$v)
      },
      expression: "entity.series"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Video has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Video")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'AlbumList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Audio Albums\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_audio_album/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_audio_album', 'Audio Albums')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Audio Album title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_audio_album",
      "unpublish-empty-endpoint": "media/audio-albums/unpublish-empty",
      "choosen-entities": _vm.choosenEntities
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'AlbumEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_audio_album', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_audio_album', 'Audio Album')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/audio-albums/', 'Audio Album')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'DocumentList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Documents\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/media_doc/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('media_doc')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('media_doc', 'Documents')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by document title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "media_doc",
      "unpublish-empty-endpoint": "media/documents/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": _vm.validateUrl(item.thumbnail),
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('media_doc', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'DocumentEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'media_doc', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'media_doc', 'Document')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'media/documents/', 'Document')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_doc')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'media_doc')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "description"
    },
    model: {
      value: (_vm.entity.description),
      callback: function($$v) {
        _vm.$set(_vm.entity, "description", $$v)
      },
      expression: "entity.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.avatarUploaded
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Staff has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create staff")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'FaqList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" FAQ\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/faq/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('faq')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('faq', 'FAQ')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by faq title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "faq",
      "unpublish-empty-endpoint": "faq/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")]), _vm._v(" "), _c('th', [_vm._v("Included in Picks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('faq', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'FaqEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'faq', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'faq', 'FAQ')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'faq/', 'FAQ')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [(item.included_in_picks) ? _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'faq')
        }
      }
    }) : _c('input', {
      staticClass: "add-to-picks",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id
      },
      on: {
        "change": function($event) {
          return _vm.$_sendPicks($event, item.id, 'faq')
        }
      }
    }), _vm._v(" "), _c('span', {
      ref: ("pickBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.source.title) + "\n          "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        return _vm.$_deleteEntity(("media/image-galleries/" + (_vm.source.id)))
      }
    }
  }, [_vm._v("\n            Delete\n            "), _c('span', {
    ref: "deleteBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'GalleryManageImages',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Images\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.$_coverUrl,
      "removable": false
    },
    on: {
      "changeFile": _vm.$_coverChange,
      "returnedOldFile": _vm.$_coverRestore
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured.section_id),
      expression: "entity.featured.section_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity.featured, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured.section_id && _vm.entity.featured.section_id > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featured.featured_body),
      callback: function($$v) {
        _vm.$set(_vm.entity.featured, "featured_body", $$v)
      },
      expression: "entity.featured.featured_body"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    attrs: {
      "already-choosen-refs": _vm.entity.loadedReferences
    },
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    attrs: {
      "already-choosen-terms": _vm.entity.terms
    },
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Image Gallery has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Vocabulary has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Vocabulary")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.entity.sections) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "welcome-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.welcome.title),
      expression: "entity.sections.welcome.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "welcome-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.welcome.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.welcome, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-welcome"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-welcome"
    },
    model: {
      value: (_vm.entity.sections.welcome.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.welcome, "description", $$v)
      },
      expression: "entity.sections.welcome.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Images Slider")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-slider"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    attrs: {
      "id": "public-slider",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.images_slider.show) ? _vm._i(_vm.entity.sections.images_slider.show, null) > -1 : (_vm.entity.sections.images_slider.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.images_slider.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.images_slider, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    attrs: {
      "id": "include-slider",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.images_slider.show) ? _vm._i(_vm.entity.sections.images_slider.show, null) > -1 : (_vm.entity.sections.images_slider.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.images_slider.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.images_slider, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.images_slider, "show", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.sections.images_slider.show),
      expression: "entity.sections.images_slider.show"
    }],
    staticClass: "col-md-12 mt-2"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select Images\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "about-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.about.title),
      expression: "entity.sections.about.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "about-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.about.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.about, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-about"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-about"
    },
    model: {
      value: (_vm.entity.sections.about.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.about, "description", $$v)
      },
      expression: "entity.sections.about.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Announcements")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-announcements"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.announcements.show),
      expression: "entity.sections.announcements.show"
    }],
    attrs: {
      "id": "public-announcements",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.announcements.show) ? _vm._i(_vm.entity.sections.announcements.show, null) > -1 : (_vm.entity.sections.announcements.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.announcements.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.announcements, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.announcements, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.announcements, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcements-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.announcements.title),
      expression: "entity.sections.announcements.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "announcements-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.announcements.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.announcements, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("News Notes")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-news-notes"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.news_notes.show),
      expression: "entity.sections.news_notes.show"
    }],
    attrs: {
      "id": "public-news-notes",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.news_notes.show) ? _vm._i(_vm.entity.sections.news_notes.show, null) > -1 : (_vm.entity.sections.news_notes.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.news_notes.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.news_notes, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.news_notes, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.news_notes, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "news_notes-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.news_notes.title),
      expression: "entity.sections.news_notes.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "news_notes-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.news_notes.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.news_notes, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Contact")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-contact"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.contact.show),
      expression: "entity.sections.contact.show"
    }],
    attrs: {
      "id": "public-contact",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.contact.show) ? _vm._i(_vm.entity.sections.contact.show, null) > -1 : (_vm.entity.sections.contact.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.contact.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.contact, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.contact, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.contact, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "contact-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.contact.title),
      expression: "entity.sections.contact.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contact-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.contact.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.contact, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-center-contact"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-center-contact"
    },
    model: {
      value: (_vm.entity.sections.contact.description),
      callback: function($$v) {
        _vm.$set(_vm.entity.sections.contact, "description", $$v)
      },
      expression: "entity.sections.contact.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Location")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-location"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.show),
      expression: "entity.sections.location.show"
    }],
    attrs: {
      "id": "public-location",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.location.show) ? _vm._i(_vm.entity.sections.location.show, null) > -1 : (_vm.entity.sections.location.show)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.location.show,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.location, "show", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.location, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.location, "show", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Name of Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.title),
      expression: "entity.sections.location.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleLink",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.sections.location.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.sections.location, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lat),
      expression: "entity.location.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.location.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lng),
      expression: "entity.location.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.location.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.location) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.sourceMapData.center,
      "zoom": _vm.sourceMapData.zoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [(_vm.entity.location.lat && _vm.entity.location.lng) ? _c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "include-slider"
    }
  }, [_vm._v("Show Contact Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.sections.location.show_contact_info),
      expression: "entity.sections.location.show_contact_info"
    }],
    attrs: {
      "id": "show-contact-info",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.sections.location.show_contact_info) ? _vm._i(_vm.entity.sections.location.show_contact_info, null) > -1 : (_vm.entity.sections.location.show_contact_info)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.sections.location.show_contact_info,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.sections.location, "show_contact_info", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.sections.location, "show_contact_info", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.sections.location, "show_contact_info", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])])]) : _c('div', [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("Welcome")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-welcome"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "public-welcome",
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("About")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "m-0 mr-1",
    attrs: {
      "for": "public-about"
    }
  }, [_vm._v("Public")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "public-about",
      "type": "checkbox",
      "checked": "",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("There are no sections for this branch yet.")])])])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Dashboard Search")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('SearchBar', {
    attrs: {
      "total": _vm.total
    },
    on: {
      "queryChanged": _vm.queryChanged,
      "searchTypeChanged": _vm.searchTypeChanged,
      "perPageChanged": _vm.perPageChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item._id + item._source.snippet.type,
      attrs: {
        "data-id": item._id + item._source.snippet.type
      }
    }, [_c('td', [_vm._v(_vm._s(item._source.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": item._source.snippet.thumb,
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item._source.snippet.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item._source.snippet.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("content/" + (item._source.type) + "/edit/" + (item._source.id))
      }
    }, [_vm._v("\n                  Edit\n                ")]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item._source.snippet.url
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && !_vm.searchQuery && _vm.total === 0) ? _c('div', [_vm._v("Your results will be displayed here")]) : (!_vm.isLoading && _vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectel-uploader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileLink),
      expression: "fileLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Place link to selectel"
    },
    domProps: {
      "value": (_vm.fileLink)
    },
    on: {
      "blur": _vm.checkLink,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-uploader__folder"
  }, [_c('i', {
    staticClass: "fa fa-folder-open",
    on: {
      "click": function($event) {
        _vm.showSelectelList = !_vm.showSelectelList
      }
    }
  }), _vm._v(" "), (_vm.showSelectelList) ? _c('div', {
    staticClass: "file-uploader__list-popup spinner-parent"
  }, [(_vm.selectelLoading) ? _c('spinner', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }) : _c('div', {
    staticClass: "file-uploader__list"
  }, [(_vm.selectelList) ? _c('ul', [_vm._l((_vm.selectelList.folders), function(folder, name) {
    return _c('FileUploaderFolder', {
      key: name,
      attrs: {
        "name": name,
        "content": folder
      },
      on: {
        "attach-file": _vm.attachFile
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectelList.files), function(file) {
    return _c('File', {
      key: file.basename,
      on: {
        "attach-file": _vm.attachFile
      }
    })
  })], 2) : _c('div', [_vm._v("Container is empty")])])], 1) : _vm._e()]), _vm._v(" "), (_vm.fileLink && _vm.linkStatus) ? _c('div', {
    staticClass: "file-uploader__check"
  }, [(_vm.linkStatus === 'loading') ? _c('div', {
    staticClass: "check-status check-loader",
    attrs: {
      "title": "Link is checking..."
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.linkStatus === 'ok') ? _c('div', {
    staticClass: "check-status check-ok",
    attrs: {
      "title": "Link is correct"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e(), _vm._v(" "), (_vm.linkStatus === 'error') ? _c('div', {
    staticClass: "check-status check-error",
    attrs: {
      "title": "Link is incorrect"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_vm._l((_vm.menu), function(li) {
    return [(!li.permissions || _vm.checkAccess(li)) ? _c('li', {
      key: li.name,
      class: ("nav-item " + (li.children ? 'nav-dropdown' : ''))
    }, [(!li.children) ? _c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": li.url
      }
    }, [_c('i', {
      class: li.icon
    }), _vm._v(" " + _vm._s(li.name) + "\n          ")]) : [_c('div', {
      staticClass: "nav-link nav-dropdown-toggle",
      on: {
        "click": _vm.handleClick
      }
    }, [_c('i', {
      class: li.icon
    }), _vm._v(" " + _vm._s(li.name) + "\n            ")]), _vm._v(" "), _c('ul', {
      staticClass: "nav-dropdown-items"
    }, [_vm._l((li.children), function(nestedLi) {
      return [(_vm.checkNestedAccess(nestedLi, li)) ? _c('li', {
        key: nestedLi.name,
        staticClass: "nav-item"
      }, [_c('router-link', {
        staticClass: "nav-link",
        attrs: {
          "to": nestedLi.url
        }
      }, [_c('i', {
        class: nestedLi.icon
      }), _vm._v(" " + _vm._s(nestedLi.name) + "\n                  ")])], 1) : _vm._e()]
    })], 2)]], 2) : _vm._e()]
  }), _vm._v(" "), _c('li', {
    key: "signout",
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signOut.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Sign out\n        ")])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("1. Scan this QR code with your Google Authenticator App. Alternatively, you can use the code: "), _c('code', [_vm._v(_vm._s(_vm.secretKey))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": 'data:image/png;base64,' + _vm.qrCode,
      "alt": "qrcode"
    }
  }), _vm._v(" "), _c('p', [_vm._v("2. Enter the pin from Google Authenticator app:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "code"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control col-md-4",
    attrs: {
      "id": "code",
      "type": "password",
      "placeholder": "Authenticator Code",
      "name": "code",
      "required": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.enableGoogle2fa
    }
  }, [_vm._v("\n    Enable 2FA\n    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Institution *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "abbreviation"
    }
  }, [_vm._v("Subdomain *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.domain),
      expression: "entity.domain"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "abbreviation",
      "type": "text",
      "placeholder": "Enter abbreviation"
    },
    domProps: {
      "value": (_vm.entity.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "domain", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "localname"
    }
  }, [_vm._v("Institution Local Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.local_institution),
      expression: "entity.local_institution"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "localname",
      "type": "text",
      "placeholder": "Enter Institution Local Name"
    },
    domProps: {
      "value": (_vm.entity.local_institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "local_institution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.type),
      expression: "entity.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.typeOptions), function(value, key) {
    return _c('option', {
      key: value,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                    " + _vm._s(value) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "library"
    }
  }, [_vm._v("Organisation Library")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.library),
      expression: "entity.library"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "library",
      "type": "text",
      "placeholder": "Enter Organisation Library"
    },
    domProps: {
      "value": (_vm.entity.library)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "library", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-office-description"
    },
    model: {
      value: (_vm.entity.description),
      callback: function($$v) {
        _vm.$set(_vm.entity, "description", $$v)
      },
      expression: "entity.description"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                    Select Images\n                  ")])])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-1",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n      "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Images")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Publication")])])
}]}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.country),
      expression: "entity.address.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.address.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.state),
      expression: "entity.address.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.address.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.city),
      expression: "entity.address.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "city",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.address.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.zip),
      expression: "entity.address.address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "zip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.address.address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.street1),
      expression: "entity.address.address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "streetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.address.street2),
      expression: "entity.address.address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "streetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.country),
      expression: "entity.address.mail_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.state),
      expression: "entity.address.mail_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.city),
      expression: "entity.address.mail_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.zip),
      expression: "entity.address.mail_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.street1),
      expression: "entity.address.mail_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "mailStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.mail_address.street2),
      expression: "entity.address.mail_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.mail_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.mail_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCountry"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.country),
      expression: "entity.address.alt_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCountry",
      "type": "text",
      "placeholder": "Enter Country"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altState"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.state),
      expression: "entity.address.alt_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altState",
      "type": "text",
      "placeholder": "Enter State"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altCity"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.city),
      expression: "entity.address.alt_address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altCity",
      "type": "text",
      "placeholder": "Enter City"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altZip"
    }
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.zip),
      expression: "entity.address.alt_address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altZip",
      "type": "text",
      "placeholder": "Enter Zip code"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress1"
    }
  }, [_vm._v("Street Address 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.street1),
      expression: "entity.address.alt_address.street1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altStreetAddress1",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.street1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "street1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "altStreetAddress2"
    }
  }, [_vm._v("Street Address 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.address.alt_address.street2),
      expression: "entity.address.alt_address.street2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "altStreetAddress2",
      "type": "text",
      "placeholder": "Enter Street Address"
    },
    domProps: {
      "value": (_vm.entity.address.alt_address.street2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.address.alt_address, "street2", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "director"
    }
  }, [_vm._v("Director")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_name),
      expression: "entity.contacts.director_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "director",
      "type": "text",
      "placeholder": "Enter Director Name"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone1),
      expression: "entity.contacts.phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "type": "text",
      "placeholder": "Enter Phone"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.phone2),
      expression: "entity.contacts.phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone2",
      "type": "text",
      "placeholder": "Enter Phone 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "fax"
    }
  }, [_vm._v("Fax")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax1),
      expression: "entity.contacts.fax1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax",
      "type": "text",
      "placeholder": "Enter Fax"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.fax2),
      expression: "entity.contacts.fax2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fax2",
      "type": "text",
      "placeholder": "Enter Fax 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.fax2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "fax2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "officeEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email1),
      expression: "entity.contacts.email1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail",
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.email2),
      expression: "entity.contacts.email2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "officeEmail2",
      "type": "text",
      "placeholder": "Enter Email 2"
    },
    domProps: {
      "value": (_vm.entity.contacts.email2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "email2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.website),
      expression: "entity.contacts.website"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "website",
      "type": "text",
      "placeholder": "Enter Website"
    },
    domProps: {
      "value": (_vm.entity.contacts.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "directorEmail"
    }
  }, [_vm._v("Director Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contacts.director_email),
      expression: "entity.contacts.director_email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "directorEmail",
      "type": "text",
      "placeholder": "Enter Director Email"
    },
    domProps: {
      "value": (_vm.entity.contacts.director_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.contacts, "director_email", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Google Maps link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.gmap_link),
      expression: "entity.location.gmap_link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleLink",
      "type": "text",
      "placeholder": "Enter Google Maps link"
    },
    domProps: {
      "value": (_vm.entity.location.gmap_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "gmap_link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "googleLink"
    }
  }, [_vm._v("Google Direction link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.direction_link),
      expression: "entity.location.direction_link"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "googleDirectionLink",
      "type": "text",
      "placeholder": "Enter Google Direction link"
    },
    domProps: {
      "value": (_vm.entity.location.direction_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "direction_link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Geocode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lat),
      expression: "entity.location.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter latitude"
    },
    domProps: {
      "value": (_vm.entity.location.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.lng),
      expression: "entity.location.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter longitude"
    },
    domProps: {
      "value": (_vm.entity.location.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 offset-md-2"
  }, [(_vm.entity.location) ? _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "350px",
      "margin-top": "20px"
    },
    attrs: {
      "center": _vm.sourceMapData.center,
      "zoom": _vm.sourceMapData.zoom
    },
    on: {
      "click": _vm.mapClick
    }
  }, [(_vm.entity.location.lat && _vm.entity.location.lng) ? _c('gmap-marker', {
    attrs: {
      "position": _vm.entityMapCenter
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n      "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Alternative Address")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Contact info")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
}]}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.title) + "\n            "), _c('open-on-site', {
    attrs: {
      "source-route": _vm.source.route
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.summary),
      expression: "entity.summary"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "summary"
    },
    domProps: {
      "value": (_vm.entity.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "summary", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.coverUrl
    },
    on: {
      "changeFile": _vm.changeCover,
      "returnedOldFile": _vm.coverReturnOld,
      "existingFileRemoved": _vm.coverRemove
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-success": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias.path_alias),
      expression: "entity.path_alias.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.path_alias, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Site page has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Order Audio Tracks")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'AlbumManageTracks',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Manage Audio Tracks\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('SlickList', {
    staticClass: "slicksort-wrap",
    attrs: {
      "lock-axis": "y"
    },
    model: {
      value: (_vm.tracks),
      callback: function($$v) {
        _vm.tracks = $$v
      },
      expression: "tracks"
    }
  }, _vm._l((_vm.tracks), function(track, index) {
    return _c('SlickItem', {
      key: index,
      staticClass: "slicksort-item",
      attrs: {
        "index": index
      }
    }, [_vm._v("\n            " + _vm._s(track.title) + "\n          ")])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    ref: "saveBtnLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Order has changed successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Audio Tracks")])])])
}]}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.name) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Vocabulary *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select-remote', {
    attrs: {
      "default-options": _vm.vocabularyOptionsDefault,
      "search-function": _vm.vocabularySearch,
      "label": "name"
    },
    model: {
      value: (_vm.entity.vocabulary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "vocabulary", $$v)
      },
      expression: "entity.vocabulary"
    }
  })], 1)]), _vm._v(" "), (_vm.entity.vocabulary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Parent Term")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "label": "name",
      "filterable": false,
      "options": _vm.parentOptions
    },
    on: {
      "search": _vm.onParentSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }], null, false, 2548199629),
    model: {
      value: (_vm.entity.parent),
      callback: function($$v) {
        _vm.$set(_vm.entity, "parent", $$v)
      },
      expression: "entity.parent"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n                      No results. Type to search...\n                    ")])], 2)], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Term has modified successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.title) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "Description"
    },
    model: {
      value: (_vm.entity.description),
      callback: function($$v) {
        _vm.$set(_vm.entity, "description", $$v)
      },
      expression: "entity.description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "order"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.order),
      expression: "entity.order"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "order",
      "type": "number",
      "placeholder": "Enter Order"
    },
    domProps: {
      "value": (_vm.entity.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "order", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.email),
      expression: "entity.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.entity.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.avatarUrl
    },
    on: {
      "changeFile": _vm.changeAvatar,
      "returnedOldFile": _vm.avatarRestore,
      "existingFileRemoved": _vm.avatarRemove
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("Data saved successful!")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.saveErrorMessage))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
}]}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modals-container"
  }, [_c('MenuItemModal'), _vm._v(" "), _c('TermItemModal'), _vm._v(" "), _c('SelectelUploadModal')], 1)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    staticClass: "dropzone-noprogress",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.filesChanged,
      "vdropzone-file-added": _vm.filesChanged
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Lessons plan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.lesson_plans),
      callback: function($$v) {
        _vm.$set(_vm.entity, "lesson_plans", $$v)
      },
      expression: "entity.lesson_plans"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Teacher's key")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.teachers_keys),
      callback: function($$v) {
        _vm.$set(_vm.entity, "teachers_keys", $$v)
      },
      expression: "entity.teachers_keys"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Activities/Worksheets")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.activities),
      callback: function($$v) {
        _vm.$set(_vm.entity, "activities", $$v)
      },
      expression: "entity.activities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Audio")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.audio,
      "search-function": _vm.audioSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.audio),
      callback: function($$v) {
        _vm.$set(_vm.entity, "audio", $$v)
      },
      expression: "entity.audio"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.overviews),
      callback: function($$v) {
        _vm.$set(_vm.entity, "overviews", $$v)
      },
      expression: "entity.overviews"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Books")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.books),
      callback: function($$v) {
        _vm.$set(_vm.entity, "books", $$v)
      },
      expression: "entity.books"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Chapter Study Guides")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.chapter_study_guides),
      callback: function($$v) {
        _vm.$set(_vm.entity, "chapter_study_guides", $$v)
      },
      expression: "entity.chapter_study_guides"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Coloring Sheets")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect-remote', {
    attrs: {
      "default-options": _vm.defaultOptions.docs,
      "search-function": _vm.documentSearch,
      "label": "title"
    },
    model: {
      value: (_vm.entity.coloring_sheets),
      callback: function($$v) {
        _vm.$set(_vm.entity, "coloring_sheets", $$v)
      },
      expression: "entity.coloring_sheets"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Lesson has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Lesson")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Manage Images")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "to": {
        name: 'GalleryAddImages',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Add new Images\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'GalleryEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Back to General\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by Image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(1), _vm._v(" "), (_vm.total) ? _c('tbody', _vm._l((_vm.images), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('img', {
      staticStyle: {
        "max-height": "150px"
      },
      attrs: {
        "src": item.thumbnail,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'ImageEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteImage(item)
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0) : _c('tbody', [_vm._m(2)])])]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Image Gallery")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    There are no images yet. Go to 'Add new images' to add new ones.\n                  ")])])
}]}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "fixed": "",
      "text": "Checking token"
    }
  }), _vm._v(" "), (_vm.token.status === 'invalid') ? _c('div', {
    staticClass: "card-block"
  }, [_c('h2', [_vm._v("Token is expired or invalid")])]) : _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.resetPassword
    }
  }, [_c('h1', [_vm._v("Reset password")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Type your new password to reset it")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass),
      expression: "newPass"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New password"
    },
    domProps: {
      "value": (_vm.newPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassConfirm),
      expression: "newPassConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm new password"
    },
    domProps: {
      "value": (_vm.newPassConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassConfirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n                    Reset\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])], 1)]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm.source.name) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Email *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.email),
      expression: "entity.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.entity.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newPassword",
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.newPassword) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("New Password Confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswordConfirmation),
      expression: "newPasswordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newPasswordConfirmation",
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.newPasswordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPasswordConfirmation = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Roles")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('vue-select', {
    attrs: {
      "multiple": "",
      "options": _vm.rolesList,
      "label": "name"
    },
    model: {
      value: (_vm.entity.roles),
      callback: function($$v) {
        _vm.$set(_vm.entity, "roles", $$v)
      },
      expression: "entity.roles"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Avatar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    attrs: {
      "uploaded-img-url": _vm.avatarUrl
    },
    on: {
      "changeFile": _vm.changeAvatar,
      "returnedOldFile": _vm.avatarRestore,
      "existingFileRemoved": _vm.avatarRemove
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.saveEntity
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Data saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Permissions")]), _vm._v(" "), (_vm.defaultOptionsLoaders.permissions) ? _c('div', {
    staticClass: "col-md-10 spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  })], 1) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.deselectAll
    }
  }, [_vm._v("Deselect all")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "column-count": "3"
    }
  }, _vm._l((_vm.defaultOptions.permissions), function(permission) {
    return _c('div', {
      key: permission.id
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.permissions),
        expression: "entity.permissions"
      }],
      attrs: {
        "id": permission.id,
        "type": "checkbox"
      },
      domProps: {
        "value": permission,
        "checked": Array.isArray(_vm.entity.permissions) ? _vm._i(_vm.entity.permissions, permission) > -1 : (_vm.entity.permissions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.entity.permissions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = permission,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.entity, "permissions", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.entity, "permissions", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.entity, "permissions", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(permission.name) + "\n                      ")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Role has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Role ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text",
      "placeholder": "Enter title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Start date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date_start),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date_start", $$v)
      },
      expression: "entity.date_start"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Finish date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.date_end),
      callback: function($$v) {
        _vm.$set(_vm.entity, "date_end", $$v)
      },
      expression: "entity.date_end"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Body *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "summary"
    },
    model: {
      value: (_vm.entity.summary),
      callback: function($$v) {
        _vm.$set(_vm.entity, "summary", $$v)
      },
      expression: "entity.summary"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "published"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.published),
      expression: "entity.published"
    }],
    attrs: {
      "id": "published",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.published) ? _vm._i(_vm.entity.published, null) > -1 : (_vm.entity.published)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.published,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "published", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "published", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "published", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "featured"
    }
  }, [_vm._v("Featured Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.featured),
      expression: "entity.featured"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "featured",
      "name": "featured"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "featured", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$_featuredBlocksList), function(item, key) {
    return _c('option', {
      key: item,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.entity.featured) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Featured Summary")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "featured_body"
    },
    model: {
      value: (_vm.entity.featuredBody),
      callback: function($$v) {
        _vm.$set(_vm.entity, "featuredBody", $$v)
      },
      expression: "entity.featuredBody"
    }
  })], 1)]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "seo_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_title),
      expression: "entity.seo_title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_title",
      "type": "text",
      "placeholder": "Enter SEO title"
    },
    domProps: {
      "value": (_vm.entity.seo_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.seo_description),
      expression: "entity.seo_description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "seo_desc"
    },
    domProps: {
      "value": (_vm.entity.seo_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "seo_description", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('referencer', {
    on: {
      "changeRefs": _vm.$_changeRefs
    }
  }), _vm._v(" "), _c('terms', {
    on: {
      "changeTerms": _vm.$_changeTerms
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "path_alias"
    }
  }, [_vm._v(_vm._s(_vm.$config.app_api.host))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.path_alias),
      expression: "entity.path_alias"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "path_alias",
      "type": "text",
      "placeholder": "Enter path alias"
    },
    domProps: {
      "value": (_vm.entity.path_alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "path_alias", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Event has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create event")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("SEO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Path Alias")])])
}]}

/***/ }),
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[509]);


// WEBPACK FOOTER //
// static/js/app.3225091ea34dd0c6f9c5.js